var wg = Object.defineProperty;
var kg = (e, t, n) => (t in e ? wg(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : (e[t] = n));
var Rs = (e, t, n) => (kg(e, typeof t != 'symbol' ? t + '' : t, n), n);
function Sg(e, t) {
  for (var n = 0; n < t.length; n++) {
    const i = t[n];
    if (typeof i != 'string' && !Array.isArray(i)) {
      for (const r in i)
        if (r !== 'default' && !(r in e)) {
          const o = Object.getOwnPropertyDescriptor(i, r);
          o && Object.defineProperty(e, r, o.get ? o : { enumerable: !0, get: () => i[r] });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }));
}
(function () {
  const t = document.createElement('link').relList;
  if (t && t.supports && t.supports('modulepreload')) return;
  for (const r of document.querySelectorAll('link[rel="modulepreload"]')) i(r);
  new MutationObserver((r) => {
    for (const o of r)
      if (o.type === 'childList')
        for (const a of o.addedNodes) a.tagName === 'LINK' && a.rel === 'modulepreload' && i(a);
  }).observe(document, { childList: !0, subtree: !0 });
  function n(r) {
    const o = {};
    return (
      r.integrity && (o.integrity = r.integrity),
      r.referrerpolicy && (o.referrerPolicy = r.referrerpolicy),
      r.crossorigin === 'use-credentials'
        ? (o.credentials = 'include')
        : r.crossorigin === 'anonymous'
          ? (o.credentials = 'omit')
          : (o.credentials = 'same-origin'),
      o
    );
  }
  function i(r) {
    if (r.ep) return;
    r.ep = !0;
    const o = n(r);
    fetch(r.href, o);
  }
})();
var bg =
  typeof globalThis < 'u'
    ? globalThis
    : typeof window < 'u'
      ? window
      : typeof global < 'u'
        ? global
        : typeof self < 'u'
          ? self
          : {};
function Mg(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, 'default') ? e.default : e;
}
var $ = { exports: {} },
  K = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var oo = Symbol.for('react.element'),
  Tg = Symbol.for('react.portal'),
  Rg = Symbol.for('react.fragment'),
  Pg = Symbol.for('react.strict_mode'),
  Cg = Symbol.for('react.profiler'),
  Ng = Symbol.for('react.provider'),
  Ig = Symbol.for('react.context'),
  Dg = Symbol.for('react.forward_ref'),
  Og = Symbol.for('react.suspense'),
  Lg = Symbol.for('react.memo'),
  Hg = Symbol.for('react.lazy'),
  Yu = Symbol.iterator;
function Fg(e) {
  return e === null || typeof e != 'object'
    ? null
    : ((e = (Yu && e[Yu]) || e['@@iterator']), typeof e == 'function' ? e : null);
}
var Yp = {
    isMounted: function () {
      return !1;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {},
  },
  eh = Object.assign,
  th = {};
function ir(e, t, n) {
  (this.props = e), (this.context = t), (this.refs = th), (this.updater = n || Yp);
}
ir.prototype.isReactComponent = {};
ir.prototype.setState = function (e, t) {
  if (typeof e != 'object' && typeof e != 'function' && e != null)
    throw Error(
      'setState(...): takes an object of state variables to update or a function which returns an object of state variables.',
    );
  this.updater.enqueueSetState(this, e, t, 'setState');
};
ir.prototype.forceUpdate = function (e) {
  this.updater.enqueueForceUpdate(this, e, 'forceUpdate');
};
function nh() {}
nh.prototype = ir.prototype;
function Ec(e, t, n) {
  (this.props = e), (this.context = t), (this.refs = th), (this.updater = n || Yp);
}
var yc = (Ec.prototype = new nh());
yc.constructor = Ec;
eh(yc, ir.prototype);
yc.isPureReactComponent = !0;
var ed = Array.isArray,
  ih = Object.prototype.hasOwnProperty,
  Ac = { current: null },
  rh = { key: !0, ref: !0, __self: !0, __source: !0 };
function oh(e, t, n) {
  var i,
    r = {},
    o = null,
    a = null;
  if (t != null)
    for (i in (t.ref !== void 0 && (a = t.ref), t.key !== void 0 && (o = '' + t.key), t))
      ih.call(t, i) && !rh.hasOwnProperty(i) && (r[i] = t[i]);
  var s = arguments.length - 2;
  if (s === 1) r.children = n;
  else if (1 < s) {
    for (var l = Array(s), c = 0; c < s; c++) l[c] = arguments[c + 2];
    r.children = l;
  }
  if (e && e.defaultProps) for (i in ((s = e.defaultProps), s)) r[i] === void 0 && (r[i] = s[i]);
  return { $$typeof: oo, type: e, key: o, ref: a, props: r, _owner: Ac.current };
}
function jg(e, t) {
  return { $$typeof: oo, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
}
function wc(e) {
  return typeof e == 'object' && e !== null && e.$$typeof === oo;
}
function zg(e) {
  var t = { '=': '=0', ':': '=2' };
  return (
    '$' +
    e.replace(/[=:]/g, function (n) {
      return t[n];
    })
  );
}
var td = /\/+/g;
function Ps(e, t) {
  return typeof e == 'object' && e !== null && e.key != null ? zg('' + e.key) : t.toString(36);
}
function $o(e, t, n, i, r) {
  var o = typeof e;
  (o === 'undefined' || o === 'boolean') && (e = null);
  var a = !1;
  if (e === null) a = !0;
  else
    switch (o) {
      case 'string':
      case 'number':
        a = !0;
        break;
      case 'object':
        switch (e.$$typeof) {
          case oo:
          case Tg:
            a = !0;
        }
    }
  if (a)
    return (
      (a = e),
      (r = r(a)),
      (e = i === '' ? '.' + Ps(a, 0) : i),
      ed(r)
        ? ((n = ''),
          e != null && (n = e.replace(td, '$&/') + '/'),
          $o(r, t, n, '', function (c) {
            return c;
          }))
        : r != null &&
          (wc(r) &&
            (r = jg(r, n + (!r.key || (a && a.key === r.key) ? '' : ('' + r.key).replace(td, '$&/') + '/') + e)),
          t.push(r)),
      1
    );
  if (((a = 0), (i = i === '' ? '.' : i + ':'), ed(e)))
    for (var s = 0; s < e.length; s++) {
      o = e[s];
      var l = i + Ps(o, s);
      a += $o(o, t, n, l, r);
    }
  else if (((l = Fg(e)), typeof l == 'function'))
    for (e = l.call(e), s = 0; !(o = e.next()).done; ) (o = o.value), (l = i + Ps(o, s++)), (a += $o(o, t, n, l, r));
  else if (o === 'object')
    throw (
      ((t = String(e)),
      Error(
        'Objects are not valid as a React child (found: ' +
          (t === '[object Object]' ? 'object with keys {' + Object.keys(e).join(', ') + '}' : t) +
          '). If you meant to render a collection of children, use an array instead.',
      ))
    );
  return a;
}
function wo(e, t, n) {
  if (e == null) return e;
  var i = [],
    r = 0;
  return (
    $o(e, i, '', '', function (o) {
      return t.call(n, o, r++);
    }),
    i
  );
}
function Bg(e) {
  if (e._status === -1) {
    var t = e._result;
    (t = t()),
      t.then(
        function (n) {
          (e._status === 0 || e._status === -1) && ((e._status = 1), (e._result = n));
        },
        function (n) {
          (e._status === 0 || e._status === -1) && ((e._status = 2), (e._result = n));
        },
      ),
      e._status === -1 && ((e._status = 0), (e._result = t));
  }
  if (e._status === 1) return e._result.default;
  throw e._result;
}
var at = { current: null },
  Go = { transition: null },
  Ug = { ReactCurrentDispatcher: at, ReactCurrentBatchConfig: Go, ReactCurrentOwner: Ac };
K.Children = {
  map: wo,
  forEach: function (e, t, n) {
    wo(
      e,
      function () {
        t.apply(this, arguments);
      },
      n,
    );
  },
  count: function (e) {
    var t = 0;
    return (
      wo(e, function () {
        t++;
      }),
      t
    );
  },
  toArray: function (e) {
    return (
      wo(e, function (t) {
        return t;
      }) || []
    );
  },
  only: function (e) {
    if (!wc(e)) throw Error('React.Children.only expected to receive a single React element child.');
    return e;
  },
};
K.Component = ir;
K.Fragment = Rg;
K.Profiler = Cg;
K.PureComponent = Ec;
K.StrictMode = Pg;
K.Suspense = Og;
K.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ug;
K.cloneElement = function (e, t, n) {
  if (e == null)
    throw Error('React.cloneElement(...): The argument must be a React element, but you passed ' + e + '.');
  var i = eh({}, e.props),
    r = e.key,
    o = e.ref,
    a = e._owner;
  if (t != null) {
    if (
      (t.ref !== void 0 && ((o = t.ref), (a = Ac.current)),
      t.key !== void 0 && (r = '' + t.key),
      e.type && e.type.defaultProps)
    )
      var s = e.type.defaultProps;
    for (l in t) ih.call(t, l) && !rh.hasOwnProperty(l) && (i[l] = t[l] === void 0 && s !== void 0 ? s[l] : t[l]);
  }
  var l = arguments.length - 2;
  if (l === 1) i.children = n;
  else if (1 < l) {
    s = Array(l);
    for (var c = 0; c < l; c++) s[c] = arguments[c + 2];
    i.children = s;
  }
  return { $$typeof: oo, type: e.type, key: r, ref: o, props: i, _owner: a };
};
K.createContext = function (e) {
  return (
    (e = {
      $$typeof: Ig,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null,
      _defaultValue: null,
      _globalName: null,
    }),
    (e.Provider = { $$typeof: Ng, _context: e }),
    (e.Consumer = e)
  );
};
K.createElement = oh;
K.createFactory = function (e) {
  var t = oh.bind(null, e);
  return (t.type = e), t;
};
K.createRef = function () {
  return { current: null };
};
K.forwardRef = function (e) {
  return { $$typeof: Dg, render: e };
};
K.isValidElement = wc;
K.lazy = function (e) {
  return { $$typeof: Hg, _payload: { _status: -1, _result: e }, _init: Bg };
};
K.memo = function (e, t) {
  return { $$typeof: Lg, type: e, compare: t === void 0 ? null : t };
};
K.startTransition = function (e) {
  var t = Go.transition;
  Go.transition = {};
  try {
    e();
  } finally {
    Go.transition = t;
  }
};
K.unstable_act = function () {
  throw Error('act(...) is not supported in production builds of React.');
};
K.useCallback = function (e, t) {
  return at.current.useCallback(e, t);
};
K.useContext = function (e) {
  return at.current.useContext(e);
};
K.useDebugValue = function () {};
K.useDeferredValue = function (e) {
  return at.current.useDeferredValue(e);
};
K.useEffect = function (e, t) {
  return at.current.useEffect(e, t);
};
K.useId = function () {
  return at.current.useId();
};
K.useImperativeHandle = function (e, t, n) {
  return at.current.useImperativeHandle(e, t, n);
};
K.useInsertionEffect = function (e, t) {
  return at.current.useInsertionEffect(e, t);
};
K.useLayoutEffect = function (e, t) {
  return at.current.useLayoutEffect(e, t);
};
K.useMemo = function (e, t) {
  return at.current.useMemo(e, t);
};
K.useReducer = function (e, t, n) {
  return at.current.useReducer(e, t, n);
};
K.useRef = function (e) {
  return at.current.useRef(e);
};
K.useState = function (e) {
  return at.current.useState(e);
};
K.useSyncExternalStore = function (e, t, n) {
  return at.current.useSyncExternalStore(e, t, n);
};
K.useTransition = function () {
  return at.current.useTransition();
};
K.version = '18.2.0';
(function (e) {
  e.exports = K;
})($);
const kc = Mg($.exports),
  hl = Sg({ __proto__: null, default: kc }, [$.exports]);
var ah = { exports: {} },
  wt = {},
  sh = { exports: {} },
  lh = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ (function (e) {
  function t(O, P) {
    var q = O.length;
    O.push(P);
    e: for (; 0 < q; ) {
      var ee = (q - 1) >>> 1,
        ve = O[ee];
      if (0 < r(ve, P)) (O[ee] = P), (O[q] = ve), (q = ee);
      else break e;
    }
  }
  function n(O) {
    return O.length === 0 ? null : O[0];
  }
  function i(O) {
    if (O.length === 0) return null;
    var P = O[0],
      q = O.pop();
    if (q !== P) {
      O[0] = q;
      e: for (var ee = 0, ve = O.length, Ut = ve >>> 1; ee < Ut; ) {
        var lt = 2 * (ee + 1) - 1,
          Jn = O[lt],
          vt = lt + 1,
          _n = O[vt];
        if (0 > r(Jn, q))
          vt < ve && 0 > r(_n, Jn) ? ((O[ee] = _n), (O[vt] = q), (ee = vt)) : ((O[ee] = Jn), (O[lt] = q), (ee = lt));
        else if (vt < ve && 0 > r(_n, q)) (O[ee] = _n), (O[vt] = q), (ee = vt);
        else break e;
      }
    }
    return P;
  }
  function r(O, P) {
    var q = O.sortIndex - P.sortIndex;
    return q !== 0 ? q : O.id - P.id;
  }
  if (typeof performance == 'object' && typeof performance.now == 'function') {
    var o = performance;
    e.unstable_now = function () {
      return o.now();
    };
  } else {
    var a = Date,
      s = a.now();
    e.unstable_now = function () {
      return a.now() - s;
    };
  }
  var l = [],
    c = [],
    u = 1,
    m = null,
    h = 3,
    v = !1,
    x = !1,
    f = !1,
    D = typeof setTimeout == 'function' ? setTimeout : null,
    p = typeof clearTimeout == 'function' ? clearTimeout : null,
    d = typeof setImmediate < 'u' ? setImmediate : null;
  typeof navigator < 'u' &&
    navigator.scheduling !== void 0 &&
    navigator.scheduling.isInputPending !== void 0 &&
    navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function g(O) {
    for (var P = n(c); P !== null; ) {
      if (P.callback === null) i(c);
      else if (P.startTime <= O) i(c), (P.sortIndex = P.expirationTime), t(l, P);
      else break;
      P = n(c);
    }
  }
  function y(O) {
    if (((f = !1), g(O), !x))
      if (n(l) !== null) (x = !0), tn(b);
      else {
        var P = n(c);
        P !== null && re(y, P.startTime - O);
      }
  }
  function b(O, P) {
    (x = !1), f && ((f = !1), p(z), (z = -1)), (v = !0);
    var q = h;
    try {
      for (g(P), m = n(l); m !== null && (!(m.expirationTime > P) || (O && !Ne())); ) {
        var ee = m.callback;
        if (typeof ee == 'function') {
          (m.callback = null), (h = m.priorityLevel);
          var ve = ee(m.expirationTime <= P);
          (P = e.unstable_now()), typeof ve == 'function' ? (m.callback = ve) : m === n(l) && i(l), g(P);
        } else i(l);
        m = n(l);
      }
      if (m !== null) var Ut = !0;
      else {
        var lt = n(c);
        lt !== null && re(y, lt.startTime - P), (Ut = !1);
      }
      return Ut;
    } finally {
      (m = null), (h = q), (v = !1);
    }
  }
  var C = !1,
    R = null,
    z = -1,
    Y = 5,
    W = -1;
  function Ne() {
    return !(e.unstable_now() - W < Y);
  }
  function Ae() {
    if (R !== null) {
      var O = e.unstable_now();
      W = O;
      var P = !0;
      try {
        P = R(!0, O);
      } finally {
        P ? nt() : ((C = !1), (R = null));
      }
    } else C = !1;
  }
  var nt;
  if (typeof d == 'function')
    nt = function () {
      d(Ae);
    };
  else if (typeof MessageChannel < 'u') {
    var fi = new MessageChannel(),
      Te = fi.port2;
    (fi.port1.onmessage = Ae),
      (nt = function () {
        Te.postMessage(null);
      });
  } else
    nt = function () {
      D(Ae, 0);
    };
  function tn(O) {
    (R = O), C || ((C = !0), nt());
  }
  function re(O, P) {
    z = D(function () {
      O(e.unstable_now());
    }, P);
  }
  (e.unstable_IdlePriority = 5),
    (e.unstable_ImmediatePriority = 1),
    (e.unstable_LowPriority = 4),
    (e.unstable_NormalPriority = 3),
    (e.unstable_Profiling = null),
    (e.unstable_UserBlockingPriority = 2),
    (e.unstable_cancelCallback = function (O) {
      O.callback = null;
    }),
    (e.unstable_continueExecution = function () {
      x || v || ((x = !0), tn(b));
    }),
    (e.unstable_forceFrameRate = function (O) {
      0 > O || 125 < O
        ? console.error(
            'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported',
          )
        : (Y = 0 < O ? Math.floor(1e3 / O) : 5);
    }),
    (e.unstable_getCurrentPriorityLevel = function () {
      return h;
    }),
    (e.unstable_getFirstCallbackNode = function () {
      return n(l);
    }),
    (e.unstable_next = function (O) {
      switch (h) {
        case 1:
        case 2:
        case 3:
          var P = 3;
          break;
        default:
          P = h;
      }
      var q = h;
      h = P;
      try {
        return O();
      } finally {
        h = q;
      }
    }),
    (e.unstable_pauseExecution = function () {}),
    (e.unstable_requestPaint = function () {}),
    (e.unstable_runWithPriority = function (O, P) {
      switch (O) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          O = 3;
      }
      var q = h;
      h = O;
      try {
        return P();
      } finally {
        h = q;
      }
    }),
    (e.unstable_scheduleCallback = function (O, P, q) {
      var ee = e.unstable_now();
      switch (
        (typeof q == 'object' && q !== null
          ? ((q = q.delay), (q = typeof q == 'number' && 0 < q ? ee + q : ee))
          : (q = ee),
        O)
      ) {
        case 1:
          var ve = -1;
          break;
        case 2:
          ve = 250;
          break;
        case 5:
          ve = 1073741823;
          break;
        case 4:
          ve = 1e4;
          break;
        default:
          ve = 5e3;
      }
      return (
        (ve = q + ve),
        (O = { id: u++, callback: P, priorityLevel: O, startTime: q, expirationTime: ve, sortIndex: -1 }),
        q > ee
          ? ((O.sortIndex = q),
            t(c, O),
            n(l) === null && O === n(c) && (f ? (p(z), (z = -1)) : (f = !0), re(y, q - ee)))
          : ((O.sortIndex = ve), t(l, O), x || v || ((x = !0), tn(b))),
        O
      );
    }),
    (e.unstable_shouldYield = Ne),
    (e.unstable_wrapCallback = function (O) {
      var P = h;
      return function () {
        var q = h;
        h = P;
        try {
          return O.apply(this, arguments);
        } finally {
          h = q;
        }
      };
    });
})(lh);
(function (e) {
  e.exports = lh;
})(sh);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ch = $.exports,
  At = sh.exports;
function S(e) {
  for (var t = 'https://reactjs.org/docs/error-decoder.html?invariant=' + e, n = 1; n < arguments.length; n++)
    t += '&args[]=' + encodeURIComponent(arguments[n]);
  return (
    'Minified React error #' +
    e +
    '; visit ' +
    t +
    ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
  );
}
var uh = new Set(),
  Ur = {};
function pi(e, t) {
  Wi(e, t), Wi(e + 'Capture', t);
}
function Wi(e, t) {
  for (Ur[e] = t, e = 0; e < t.length; e++) uh.add(t[e]);
}
var dn = !(typeof window > 'u' || typeof window.document > 'u' || typeof window.document.createElement > 'u'),
  ml = Object.prototype.hasOwnProperty,
  $g =
    /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
  nd = {},
  id = {};
function Gg(e) {
  return ml.call(id, e) ? !0 : ml.call(nd, e) ? !1 : $g.test(e) ? (id[e] = !0) : ((nd[e] = !0), !1);
}
function Jg(e, t, n, i) {
  if (n !== null && n.type === 0) return !1;
  switch (typeof t) {
    case 'function':
    case 'symbol':
      return !0;
    case 'boolean':
      return i
        ? !1
        : n !== null
          ? !n.acceptsBooleans
          : ((e = e.toLowerCase().slice(0, 5)), e !== 'data-' && e !== 'aria-');
    default:
      return !1;
  }
}
function Vg(e, t, n, i) {
  if (t === null || typeof t > 'u' || Jg(e, t, n, i)) return !0;
  if (i) return !1;
  if (n !== null)
    switch (n.type) {
      case 3:
        return !t;
      case 4:
        return t === !1;
      case 5:
        return isNaN(t);
      case 6:
        return isNaN(t) || 1 > t;
    }
  return !1;
}
function st(e, t, n, i, r, o, a) {
  (this.acceptsBooleans = t === 2 || t === 3 || t === 4),
    (this.attributeName = i),
    (this.attributeNamespace = r),
    (this.mustUseProperty = n),
    (this.propertyName = e),
    (this.type = t),
    (this.sanitizeURL = o),
    (this.removeEmptyString = a);
}
var Ge = {};
'children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style'
  .split(' ')
  .forEach(function (e) {
    Ge[e] = new st(e, 0, !1, e, null, !1, !1);
  });
[
  ['acceptCharset', 'accept-charset'],
  ['className', 'class'],
  ['htmlFor', 'for'],
  ['httpEquiv', 'http-equiv'],
].forEach(function (e) {
  var t = e[0];
  Ge[t] = new st(t, 1, !1, e[1], null, !1, !1);
});
['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (e) {
  Ge[e] = new st(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (e) {
  Ge[e] = new st(e, 2, !1, e, null, !1, !1);
});
'allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope'
  .split(' ')
  .forEach(function (e) {
    Ge[e] = new st(e, 3, !1, e.toLowerCase(), null, !1, !1);
  });
['checked', 'multiple', 'muted', 'selected'].forEach(function (e) {
  Ge[e] = new st(e, 3, !0, e, null, !1, !1);
});
['capture', 'download'].forEach(function (e) {
  Ge[e] = new st(e, 4, !1, e, null, !1, !1);
});
['cols', 'rows', 'size', 'span'].forEach(function (e) {
  Ge[e] = new st(e, 6, !1, e, null, !1, !1);
});
['rowSpan', 'start'].forEach(function (e) {
  Ge[e] = new st(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var Sc = /[\-:]([a-z])/g;
function bc(e) {
  return e[1].toUpperCase();
}
'accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height'
  .split(' ')
  .forEach(function (e) {
    var t = e.replace(Sc, bc);
    Ge[t] = new st(t, 1, !1, e, null, !1, !1);
  });
'xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type'.split(' ').forEach(function (e) {
  var t = e.replace(Sc, bc);
  Ge[t] = new st(t, 1, !1, e, 'http://www.w3.org/1999/xlink', !1, !1);
});
['xml:base', 'xml:lang', 'xml:space'].forEach(function (e) {
  var t = e.replace(Sc, bc);
  Ge[t] = new st(t, 1, !1, e, 'http://www.w3.org/XML/1998/namespace', !1, !1);
});
['tabIndex', 'crossOrigin'].forEach(function (e) {
  Ge[e] = new st(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
Ge.xlinkHref = new st('xlinkHref', 1, !1, 'xlink:href', 'http://www.w3.org/1999/xlink', !0, !1);
['src', 'href', 'action', 'formAction'].forEach(function (e) {
  Ge[e] = new st(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function Mc(e, t, n, i) {
  var r = Ge.hasOwnProperty(t) ? Ge[t] : null;
  (r !== null
    ? r.type !== 0
    : i || !(2 < t.length) || (t[0] !== 'o' && t[0] !== 'O') || (t[1] !== 'n' && t[1] !== 'N')) &&
    (Vg(t, n, r, i) && (n = null),
    i || r === null
      ? Gg(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, '' + n))
      : r.mustUseProperty
        ? (e[r.propertyName] = n === null ? (r.type === 3 ? !1 : '') : n)
        : ((t = r.attributeName),
          (i = r.attributeNamespace),
          n === null
            ? e.removeAttribute(t)
            : ((r = r.type),
              (n = r === 3 || (r === 4 && n === !0) ? '' : '' + n),
              i ? e.setAttributeNS(i, t, n) : e.setAttribute(t, n))));
}
var vn = ch.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  ko = Symbol.for('react.element'),
  Ti = Symbol.for('react.portal'),
  Ri = Symbol.for('react.fragment'),
  Tc = Symbol.for('react.strict_mode'),
  fl = Symbol.for('react.profiler'),
  dh = Symbol.for('react.provider'),
  ph = Symbol.for('react.context'),
  Rc = Symbol.for('react.forward_ref'),
  gl = Symbol.for('react.suspense'),
  vl = Symbol.for('react.suspense_list'),
  Pc = Symbol.for('react.memo'),
  Sn = Symbol.for('react.lazy'),
  hh = Symbol.for('react.offscreen'),
  rd = Symbol.iterator;
function vr(e) {
  return e === null || typeof e != 'object'
    ? null
    : ((e = (rd && e[rd]) || e['@@iterator']), typeof e == 'function' ? e : null);
}
var Ee = Object.assign,
  Cs;
function Mr(e) {
  if (Cs === void 0)
    try {
      throw Error();
    } catch (n) {
      var t = n.stack.trim().match(/\n( *(at )?)/);
      Cs = (t && t[1]) || '';
    }
  return (
    `
` +
    Cs +
    e
  );
}
var Ns = !1;
function Is(e, t) {
  if (!e || Ns) return '';
  Ns = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t)
      if (
        ((t = function () {
          throw Error();
        }),
        Object.defineProperty(t.prototype, 'props', {
          set: function () {
            throw Error();
          },
        }),
        typeof Reflect == 'object' && Reflect.construct)
      ) {
        try {
          Reflect.construct(t, []);
        } catch (c) {
          var i = c;
        }
        Reflect.construct(e, [], t);
      } else {
        try {
          t.call();
        } catch (c) {
          i = c;
        }
        e.call(t.prototype);
      }
    else {
      try {
        throw Error();
      } catch (c) {
        i = c;
      }
      e();
    }
  } catch (c) {
    if (c && i && typeof c.stack == 'string') {
      for (
        var r = c.stack.split(`
`),
          o = i.stack.split(`
`),
          a = r.length - 1,
          s = o.length - 1;
        1 <= a && 0 <= s && r[a] !== o[s];

      )
        s--;
      for (; 1 <= a && 0 <= s; a--, s--)
        if (r[a] !== o[s]) {
          if (a !== 1 || s !== 1)
            do
              if ((a--, s--, 0 > s || r[a] !== o[s])) {
                var l =
                  `
` + r[a].replace(' at new ', ' at ');
                return e.displayName && l.includes('<anonymous>') && (l = l.replace('<anonymous>', e.displayName)), l;
              }
            while (1 <= a && 0 <= s);
          break;
        }
    }
  } finally {
    (Ns = !1), (Error.prepareStackTrace = n);
  }
  return (e = e ? e.displayName || e.name : '') ? Mr(e) : '';
}
function qg(e) {
  switch (e.tag) {
    case 5:
      return Mr(e.type);
    case 16:
      return Mr('Lazy');
    case 13:
      return Mr('Suspense');
    case 19:
      return Mr('SuspenseList');
    case 0:
    case 2:
    case 15:
      return (e = Is(e.type, !1)), e;
    case 11:
      return (e = Is(e.type.render, !1)), e;
    case 1:
      return (e = Is(e.type, !0)), e;
    default:
      return '';
  }
}
function _l(e) {
  if (e == null) return null;
  if (typeof e == 'function') return e.displayName || e.name || null;
  if (typeof e == 'string') return e;
  switch (e) {
    case Ri:
      return 'Fragment';
    case Ti:
      return 'Portal';
    case fl:
      return 'Profiler';
    case Tc:
      return 'StrictMode';
    case gl:
      return 'Suspense';
    case vl:
      return 'SuspenseList';
  }
  if (typeof e == 'object')
    switch (e.$$typeof) {
      case ph:
        return (e.displayName || 'Context') + '.Consumer';
      case dh:
        return (e._context.displayName || 'Context') + '.Provider';
      case Rc:
        var t = e.render;
        return (
          (e = e.displayName),
          e || ((e = t.displayName || t.name || ''), (e = e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')),
          e
        );
      case Pc:
        return (t = e.displayName || null), t !== null ? t : _l(e.type) || 'Memo';
      case Sn:
        (t = e._payload), (e = e._init);
        try {
          return _l(e(t));
        } catch {}
    }
  return null;
}
function Qg(e) {
  var t = e.type;
  switch (e.tag) {
    case 24:
      return 'Cache';
    case 9:
      return (t.displayName || 'Context') + '.Consumer';
    case 10:
      return (t._context.displayName || 'Context') + '.Provider';
    case 18:
      return 'DehydratedFragment';
    case 11:
      return (
        (e = t.render),
        (e = e.displayName || e.name || ''),
        t.displayName || (e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')
      );
    case 7:
      return 'Fragment';
    case 5:
      return t;
    case 4:
      return 'Portal';
    case 3:
      return 'Root';
    case 6:
      return 'Text';
    case 16:
      return _l(t);
    case 8:
      return t === Tc ? 'StrictMode' : 'Mode';
    case 22:
      return 'Offscreen';
    case 12:
      return 'Profiler';
    case 21:
      return 'Scope';
    case 13:
      return 'Suspense';
    case 19:
      return 'SuspenseList';
    case 25:
      return 'TracingMarker';
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof t == 'function') return t.displayName || t.name || null;
      if (typeof t == 'string') return t;
  }
  return null;
}
function jn(e) {
  switch (typeof e) {
    case 'boolean':
    case 'number':
    case 'string':
    case 'undefined':
      return e;
    case 'object':
      return e;
    default:
      return '';
  }
}
function mh(e) {
  var t = e.type;
  return (e = e.nodeName) && e.toLowerCase() === 'input' && (t === 'checkbox' || t === 'radio');
}
function Wg(e) {
  var t = mh(e) ? 'checked' : 'value',
    n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
    i = '' + e[t];
  if (!e.hasOwnProperty(t) && typeof n < 'u' && typeof n.get == 'function' && typeof n.set == 'function') {
    var r = n.get,
      o = n.set;
    return (
      Object.defineProperty(e, t, {
        configurable: !0,
        get: function () {
          return r.call(this);
        },
        set: function (a) {
          (i = '' + a), o.call(this, a);
        },
      }),
      Object.defineProperty(e, t, { enumerable: n.enumerable }),
      {
        getValue: function () {
          return i;
        },
        setValue: function (a) {
          i = '' + a;
        },
        stopTracking: function () {
          (e._valueTracker = null), delete e[t];
        },
      }
    );
  }
}
function So(e) {
  e._valueTracker || (e._valueTracker = Wg(e));
}
function fh(e) {
  if (!e) return !1;
  var t = e._valueTracker;
  if (!t) return !0;
  var n = t.getValue(),
    i = '';
  return e && (i = mh(e) ? (e.checked ? 'true' : 'false') : e.value), (e = i), e !== n ? (t.setValue(e), !0) : !1;
}
function ia(e) {
  if (((e = e || (typeof document < 'u' ? document : void 0)), typeof e > 'u')) return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function xl(e, t) {
  var n = t.checked;
  return Ee({}, t, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: n != null ? n : e._wrapperState.initialChecked,
  });
}
function od(e, t) {
  var n = t.defaultValue == null ? '' : t.defaultValue,
    i = t.checked != null ? t.checked : t.defaultChecked;
  (n = jn(t.value != null ? t.value : n)),
    (e._wrapperState = {
      initialChecked: i,
      initialValue: n,
      controlled: t.type === 'checkbox' || t.type === 'radio' ? t.checked != null : t.value != null,
    });
}
function gh(e, t) {
  (t = t.checked), t != null && Mc(e, 'checked', t, !1);
}
function El(e, t) {
  gh(e, t);
  var n = jn(t.value),
    i = t.type;
  if (n != null)
    i === 'number'
      ? ((n === 0 && e.value === '') || e.value != n) && (e.value = '' + n)
      : e.value !== '' + n && (e.value = '' + n);
  else if (i === 'submit' || i === 'reset') {
    e.removeAttribute('value');
    return;
  }
  t.hasOwnProperty('value') ? yl(e, t.type, n) : t.hasOwnProperty('defaultValue') && yl(e, t.type, jn(t.defaultValue)),
    t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
}
function ad(e, t, n) {
  if (t.hasOwnProperty('value') || t.hasOwnProperty('defaultValue')) {
    var i = t.type;
    if (!((i !== 'submit' && i !== 'reset') || (t.value !== void 0 && t.value !== null))) return;
    (t = '' + e._wrapperState.initialValue), n || t === e.value || (e.value = t), (e.defaultValue = t);
  }
  (n = e.name),
    n !== '' && (e.name = ''),
    (e.defaultChecked = !!e._wrapperState.initialChecked),
    n !== '' && (e.name = n);
}
function yl(e, t, n) {
  (t !== 'number' || ia(e.ownerDocument) !== e) &&
    (n == null
      ? (e.defaultValue = '' + e._wrapperState.initialValue)
      : e.defaultValue !== '' + n && (e.defaultValue = '' + n));
}
var Tr = Array.isArray;
function Ui(e, t, n, i) {
  if (((e = e.options), t)) {
    t = {};
    for (var r = 0; r < n.length; r++) t['$' + n[r]] = !0;
    for (n = 0; n < e.length; n++)
      (r = t.hasOwnProperty('$' + e[n].value)),
        e[n].selected !== r && (e[n].selected = r),
        r && i && (e[n].defaultSelected = !0);
  } else {
    for (n = '' + jn(n), t = null, r = 0; r < e.length; r++) {
      if (e[r].value === n) {
        (e[r].selected = !0), i && (e[r].defaultSelected = !0);
        return;
      }
      t !== null || e[r].disabled || (t = e[r]);
    }
    t !== null && (t.selected = !0);
  }
}
function Al(e, t) {
  if (t.dangerouslySetInnerHTML != null) throw Error(S(91));
  return Ee({}, t, { value: void 0, defaultValue: void 0, children: '' + e._wrapperState.initialValue });
}
function sd(e, t) {
  var n = t.value;
  if (n == null) {
    if (((n = t.children), (t = t.defaultValue), n != null)) {
      if (t != null) throw Error(S(92));
      if (Tr(n)) {
        if (1 < n.length) throw Error(S(93));
        n = n[0];
      }
      t = n;
    }
    t == null && (t = ''), (n = t);
  }
  e._wrapperState = { initialValue: jn(n) };
}
function vh(e, t) {
  var n = jn(t.value),
    i = jn(t.defaultValue);
  n != null &&
    ((n = '' + n),
    n !== e.value && (e.value = n),
    t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)),
    i != null && (e.defaultValue = '' + i);
}
function ld(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && t !== '' && t !== null && (e.value = t);
}
function _h(e) {
  switch (e) {
    case 'svg':
      return 'http://www.w3.org/2000/svg';
    case 'math':
      return 'http://www.w3.org/1998/Math/MathML';
    default:
      return 'http://www.w3.org/1999/xhtml';
  }
}
function wl(e, t) {
  return e == null || e === 'http://www.w3.org/1999/xhtml'
    ? _h(t)
    : e === 'http://www.w3.org/2000/svg' && t === 'foreignObject'
      ? 'http://www.w3.org/1999/xhtml'
      : e;
}
var bo,
  xh = (function (e) {
    return typeof MSApp < 'u' && MSApp.execUnsafeLocalFunction
      ? function (t, n, i, r) {
          MSApp.execUnsafeLocalFunction(function () {
            return e(t, n, i, r);
          });
        }
      : e;
  })(function (e, t) {
    if (e.namespaceURI !== 'http://www.w3.org/2000/svg' || 'innerHTML' in e) e.innerHTML = t;
    else {
      for (
        bo = bo || document.createElement('div'),
          bo.innerHTML = '<svg>' + t.valueOf().toString() + '</svg>',
          t = bo.firstChild;
        e.firstChild;

      )
        e.removeChild(e.firstChild);
      for (; t.firstChild; ) e.appendChild(t.firstChild);
    }
  });
function $r(e, t) {
  if (t) {
    var n = e.firstChild;
    if (n && n === e.lastChild && n.nodeType === 3) {
      n.nodeValue = t;
      return;
    }
  }
  e.textContent = t;
}
var Nr = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0,
  },
  Kg = ['Webkit', 'ms', 'Moz', 'O'];
Object.keys(Nr).forEach(function (e) {
  Kg.forEach(function (t) {
    (t = t + e.charAt(0).toUpperCase() + e.substring(1)), (Nr[t] = Nr[e]);
  });
});
function Eh(e, t, n) {
  return t == null || typeof t == 'boolean' || t === ''
    ? ''
    : n || typeof t != 'number' || t === 0 || (Nr.hasOwnProperty(e) && Nr[e])
      ? ('' + t).trim()
      : t + 'px';
}
function yh(e, t) {
  e = e.style;
  for (var n in t)
    if (t.hasOwnProperty(n)) {
      var i = n.indexOf('--') === 0,
        r = Eh(n, t[n], i);
      n === 'float' && (n = 'cssFloat'), i ? e.setProperty(n, r) : (e[n] = r);
    }
}
var Xg = Ee(
  { menuitem: !0 },
  {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0,
  },
);
function kl(e, t) {
  if (t) {
    if (Xg[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(S(137, e));
    if (t.dangerouslySetInnerHTML != null) {
      if (t.children != null) throw Error(S(60));
      if (typeof t.dangerouslySetInnerHTML != 'object' || !('__html' in t.dangerouslySetInnerHTML)) throw Error(S(61));
    }
    if (t.style != null && typeof t.style != 'object') throw Error(S(62));
  }
}
function Sl(e, t) {
  if (e.indexOf('-') === -1) return typeof t.is == 'string';
  switch (e) {
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return !1;
    default:
      return !0;
  }
}
var bl = null;
function Cc(e) {
  return (
    (e = e.target || e.srcElement || window),
    e.correspondingUseElement && (e = e.correspondingUseElement),
    e.nodeType === 3 ? e.parentNode : e
  );
}
var Ml = null,
  $i = null,
  Gi = null;
function cd(e) {
  if ((e = lo(e))) {
    if (typeof Ml != 'function') throw Error(S(280));
    var t = e.stateNode;
    t && ((t = Da(t)), Ml(e.stateNode, e.type, t));
  }
}
function Ah(e) {
  $i ? (Gi ? Gi.push(e) : (Gi = [e])) : ($i = e);
}
function wh() {
  if ($i) {
    var e = $i,
      t = Gi;
    if (((Gi = $i = null), cd(e), t)) for (e = 0; e < t.length; e++) cd(t[e]);
  }
}
function kh(e, t) {
  return e(t);
}
function Sh() {}
var Ds = !1;
function bh(e, t, n) {
  if (Ds) return e(t, n);
  Ds = !0;
  try {
    return kh(e, t, n);
  } finally {
    (Ds = !1), ($i !== null || Gi !== null) && (Sh(), wh());
  }
}
function Gr(e, t) {
  var n = e.stateNode;
  if (n === null) return null;
  var i = Da(n);
  if (i === null) return null;
  n = i[t];
  e: switch (t) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
    case 'onMouseEnter':
      (i = !i.disabled) ||
        ((e = e.type), (i = !(e === 'button' || e === 'input' || e === 'select' || e === 'textarea'))),
        (e = !i);
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (n && typeof n != 'function') throw Error(S(231, t, typeof n));
  return n;
}
var Tl = !1;
if (dn)
  try {
    var _r = {};
    Object.defineProperty(_r, 'passive', {
      get: function () {
        Tl = !0;
      },
    }),
      window.addEventListener('test', _r, _r),
      window.removeEventListener('test', _r, _r);
  } catch {
    Tl = !1;
  }
function Zg(e, t, n, i, r, o, a, s, l) {
  var c = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(n, c);
  } catch (u) {
    this.onError(u);
  }
}
var Ir = !1,
  ra = null,
  oa = !1,
  Rl = null,
  Yg = {
    onError: function (e) {
      (Ir = !0), (ra = e);
    },
  };
function ev(e, t, n, i, r, o, a, s, l) {
  (Ir = !1), (ra = null), Zg.apply(Yg, arguments);
}
function tv(e, t, n, i, r, o, a, s, l) {
  if ((ev.apply(this, arguments), Ir)) {
    if (Ir) {
      var c = ra;
      (Ir = !1), (ra = null);
    } else throw Error(S(198));
    oa || ((oa = !0), (Rl = c));
  }
}
function hi(e) {
  var t = e,
    n = e;
  if (e.alternate) for (; t.return; ) t = t.return;
  else {
    e = t;
    do (t = e), (t.flags & 4098) !== 0 && (n = t.return), (e = t.return);
    while (e);
  }
  return t.tag === 3 ? n : null;
}
function Mh(e) {
  if (e.tag === 13) {
    var t = e.memoizedState;
    if ((t === null && ((e = e.alternate), e !== null && (t = e.memoizedState)), t !== null)) return t.dehydrated;
  }
  return null;
}
function ud(e) {
  if (hi(e) !== e) throw Error(S(188));
}
function nv(e) {
  var t = e.alternate;
  if (!t) {
    if (((t = hi(e)), t === null)) throw Error(S(188));
    return t !== e ? null : e;
  }
  for (var n = e, i = t; ; ) {
    var r = n.return;
    if (r === null) break;
    var o = r.alternate;
    if (o === null) {
      if (((i = r.return), i !== null)) {
        n = i;
        continue;
      }
      break;
    }
    if (r.child === o.child) {
      for (o = r.child; o; ) {
        if (o === n) return ud(r), e;
        if (o === i) return ud(r), t;
        o = o.sibling;
      }
      throw Error(S(188));
    }
    if (n.return !== i.return) (n = r), (i = o);
    else {
      for (var a = !1, s = r.child; s; ) {
        if (s === n) {
          (a = !0), (n = r), (i = o);
          break;
        }
        if (s === i) {
          (a = !0), (i = r), (n = o);
          break;
        }
        s = s.sibling;
      }
      if (!a) {
        for (s = o.child; s; ) {
          if (s === n) {
            (a = !0), (n = o), (i = r);
            break;
          }
          if (s === i) {
            (a = !0), (i = o), (n = r);
            break;
          }
          s = s.sibling;
        }
        if (!a) throw Error(S(189));
      }
    }
    if (n.alternate !== i) throw Error(S(190));
  }
  if (n.tag !== 3) throw Error(S(188));
  return n.stateNode.current === n ? e : t;
}
function Th(e) {
  return (e = nv(e)), e !== null ? Rh(e) : null;
}
function Rh(e) {
  if (e.tag === 5 || e.tag === 6) return e;
  for (e = e.child; e !== null; ) {
    var t = Rh(e);
    if (t !== null) return t;
    e = e.sibling;
  }
  return null;
}
var Ph = At.unstable_scheduleCallback,
  dd = At.unstable_cancelCallback,
  iv = At.unstable_shouldYield,
  rv = At.unstable_requestPaint,
  ke = At.unstable_now,
  ov = At.unstable_getCurrentPriorityLevel,
  Nc = At.unstable_ImmediatePriority,
  Ch = At.unstable_UserBlockingPriority,
  aa = At.unstable_NormalPriority,
  av = At.unstable_LowPriority,
  Nh = At.unstable_IdlePriority,
  Pa = null,
  Xt = null;
function sv(e) {
  if (Xt && typeof Xt.onCommitFiberRoot == 'function')
    try {
      Xt.onCommitFiberRoot(Pa, e, void 0, (e.current.flags & 128) === 128);
    } catch {}
}
var Ft = Math.clz32 ? Math.clz32 : uv,
  lv = Math.log,
  cv = Math.LN2;
function uv(e) {
  return (e >>>= 0), e === 0 ? 32 : (31 - ((lv(e) / cv) | 0)) | 0;
}
var Mo = 64,
  To = 4194304;
function Rr(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function sa(e, t) {
  var n = e.pendingLanes;
  if (n === 0) return 0;
  var i = 0,
    r = e.suspendedLanes,
    o = e.pingedLanes,
    a = n & 268435455;
  if (a !== 0) {
    var s = a & ~r;
    s !== 0 ? (i = Rr(s)) : ((o &= a), o !== 0 && (i = Rr(o)));
  } else (a = n & ~r), a !== 0 ? (i = Rr(a)) : o !== 0 && (i = Rr(o));
  if (i === 0) return 0;
  if (t !== 0 && t !== i && (t & r) === 0 && ((r = i & -i), (o = t & -t), r >= o || (r === 16 && (o & 4194240) !== 0)))
    return t;
  if (((i & 4) !== 0 && (i |= n & 16), (t = e.entangledLanes), t !== 0))
    for (e = e.entanglements, t &= i; 0 < t; ) (n = 31 - Ft(t)), (r = 1 << n), (i |= e[n]), (t &= ~r);
  return i;
}
function dv(e, t) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return t + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return t + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function pv(e, t) {
  for (var n = e.suspendedLanes, i = e.pingedLanes, r = e.expirationTimes, o = e.pendingLanes; 0 < o; ) {
    var a = 31 - Ft(o),
      s = 1 << a,
      l = r[a];
    l === -1 ? ((s & n) === 0 || (s & i) !== 0) && (r[a] = dv(s, t)) : l <= t && (e.expiredLanes |= s), (o &= ~s);
  }
}
function Pl(e) {
  return (e = e.pendingLanes & -1073741825), e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
}
function Ih() {
  var e = Mo;
  return (Mo <<= 1), (Mo & 4194240) === 0 && (Mo = 64), e;
}
function Os(e) {
  for (var t = [], n = 0; 31 > n; n++) t.push(e);
  return t;
}
function ao(e, t, n) {
  (e.pendingLanes |= t),
    t !== 536870912 && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
    (e = e.eventTimes),
    (t = 31 - Ft(t)),
    (e[t] = n);
}
function hv(e, t) {
  var n = e.pendingLanes & ~t;
  (e.pendingLanes = t),
    (e.suspendedLanes = 0),
    (e.pingedLanes = 0),
    (e.expiredLanes &= t),
    (e.mutableReadLanes &= t),
    (e.entangledLanes &= t),
    (t = e.entanglements);
  var i = e.eventTimes;
  for (e = e.expirationTimes; 0 < n; ) {
    var r = 31 - Ft(n),
      o = 1 << r;
    (t[r] = 0), (i[r] = -1), (e[r] = -1), (n &= ~o);
  }
}
function Ic(e, t) {
  var n = (e.entangledLanes |= t);
  for (e = e.entanglements; n; ) {
    var i = 31 - Ft(n),
      r = 1 << i;
    (r & t) | (e[i] & t) && (e[i] |= t), (n &= ~r);
  }
}
var se = 0;
function Dh(e) {
  return (e &= -e), 1 < e ? (4 < e ? ((e & 268435455) !== 0 ? 16 : 536870912) : 4) : 1;
}
var Oh,
  Dc,
  Lh,
  Hh,
  Fh,
  Cl = !1,
  Ro = [],
  Cn = null,
  Nn = null,
  In = null,
  Jr = new Map(),
  Vr = new Map(),
  Mn = [],
  mv =
    'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit'.split(
      ' ',
    );
function pd(e, t) {
  switch (e) {
    case 'focusin':
    case 'focusout':
      Cn = null;
      break;
    case 'dragenter':
    case 'dragleave':
      Nn = null;
      break;
    case 'mouseover':
    case 'mouseout':
      In = null;
      break;
    case 'pointerover':
    case 'pointerout':
      Jr.delete(t.pointerId);
      break;
    case 'gotpointercapture':
    case 'lostpointercapture':
      Vr.delete(t.pointerId);
  }
}
function xr(e, t, n, i, r, o) {
  return e === null || e.nativeEvent !== o
    ? ((e = { blockedOn: t, domEventName: n, eventSystemFlags: i, nativeEvent: o, targetContainers: [r] }),
      t !== null && ((t = lo(t)), t !== null && Dc(t)),
      e)
    : ((e.eventSystemFlags |= i), (t = e.targetContainers), r !== null && t.indexOf(r) === -1 && t.push(r), e);
}
function fv(e, t, n, i, r) {
  switch (t) {
    case 'focusin':
      return (Cn = xr(Cn, e, t, n, i, r)), !0;
    case 'dragenter':
      return (Nn = xr(Nn, e, t, n, i, r)), !0;
    case 'mouseover':
      return (In = xr(In, e, t, n, i, r)), !0;
    case 'pointerover':
      var o = r.pointerId;
      return Jr.set(o, xr(Jr.get(o) || null, e, t, n, i, r)), !0;
    case 'gotpointercapture':
      return (o = r.pointerId), Vr.set(o, xr(Vr.get(o) || null, e, t, n, i, r)), !0;
  }
  return !1;
}
function jh(e) {
  var t = Zn(e.target);
  if (t !== null) {
    var n = hi(t);
    if (n !== null) {
      if (((t = n.tag), t === 13)) {
        if (((t = Mh(n)), t !== null)) {
          (e.blockedOn = t),
            Fh(e.priority, function () {
              Lh(n);
            });
          return;
        }
      } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function Jo(e) {
  if (e.blockedOn !== null) return !1;
  for (var t = e.targetContainers; 0 < t.length; ) {
    var n = Nl(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (n === null) {
      n = e.nativeEvent;
      var i = new n.constructor(n.type, n);
      (bl = i), n.target.dispatchEvent(i), (bl = null);
    } else return (t = lo(n)), t !== null && Dc(t), (e.blockedOn = n), !1;
    t.shift();
  }
  return !0;
}
function hd(e, t, n) {
  Jo(e) && n.delete(t);
}
function gv() {
  (Cl = !1),
    Cn !== null && Jo(Cn) && (Cn = null),
    Nn !== null && Jo(Nn) && (Nn = null),
    In !== null && Jo(In) && (In = null),
    Jr.forEach(hd),
    Vr.forEach(hd);
}
function Er(e, t) {
  e.blockedOn === t &&
    ((e.blockedOn = null), Cl || ((Cl = !0), At.unstable_scheduleCallback(At.unstable_NormalPriority, gv)));
}
function qr(e) {
  function t(r) {
    return Er(r, e);
  }
  if (0 < Ro.length) {
    Er(Ro[0], e);
    for (var n = 1; n < Ro.length; n++) {
      var i = Ro[n];
      i.blockedOn === e && (i.blockedOn = null);
    }
  }
  for (
    Cn !== null && Er(Cn, e), Nn !== null && Er(Nn, e), In !== null && Er(In, e), Jr.forEach(t), Vr.forEach(t), n = 0;
    n < Mn.length;
    n++
  )
    (i = Mn[n]), i.blockedOn === e && (i.blockedOn = null);
  for (; 0 < Mn.length && ((n = Mn[0]), n.blockedOn === null); ) jh(n), n.blockedOn === null && Mn.shift();
}
var Ji = vn.ReactCurrentBatchConfig,
  la = !0;
function vv(e, t, n, i) {
  var r = se,
    o = Ji.transition;
  Ji.transition = null;
  try {
    (se = 1), Oc(e, t, n, i);
  } finally {
    (se = r), (Ji.transition = o);
  }
}
function _v(e, t, n, i) {
  var r = se,
    o = Ji.transition;
  Ji.transition = null;
  try {
    (se = 4), Oc(e, t, n, i);
  } finally {
    (se = r), (Ji.transition = o);
  }
}
function Oc(e, t, n, i) {
  if (la) {
    var r = Nl(e, t, n, i);
    if (r === null) Js(e, t, i, ca, n), pd(e, i);
    else if (fv(r, e, t, n, i)) i.stopPropagation();
    else if ((pd(e, i), t & 4 && -1 < mv.indexOf(e))) {
      for (; r !== null; ) {
        var o = lo(r);
        if ((o !== null && Oh(o), (o = Nl(e, t, n, i)), o === null && Js(e, t, i, ca, n), o === r)) break;
        r = o;
      }
      r !== null && i.stopPropagation();
    } else Js(e, t, i, null, n);
  }
}
var ca = null;
function Nl(e, t, n, i) {
  if (((ca = null), (e = Cc(i)), (e = Zn(e)), e !== null))
    if (((t = hi(e)), t === null)) e = null;
    else if (((n = t.tag), n === 13)) {
      if (((e = Mh(t)), e !== null)) return e;
      e = null;
    } else if (n === 3) {
      if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
      e = null;
    } else t !== e && (e = null);
  return (ca = e), null;
}
function zh(e) {
  switch (e) {
    case 'cancel':
    case 'click':
    case 'close':
    case 'contextmenu':
    case 'copy':
    case 'cut':
    case 'auxclick':
    case 'dblclick':
    case 'dragend':
    case 'dragstart':
    case 'drop':
    case 'focusin':
    case 'focusout':
    case 'input':
    case 'invalid':
    case 'keydown':
    case 'keypress':
    case 'keyup':
    case 'mousedown':
    case 'mouseup':
    case 'paste':
    case 'pause':
    case 'play':
    case 'pointercancel':
    case 'pointerdown':
    case 'pointerup':
    case 'ratechange':
    case 'reset':
    case 'resize':
    case 'seeked':
    case 'submit':
    case 'touchcancel':
    case 'touchend':
    case 'touchstart':
    case 'volumechange':
    case 'change':
    case 'selectionchange':
    case 'textInput':
    case 'compositionstart':
    case 'compositionend':
    case 'compositionupdate':
    case 'beforeblur':
    case 'afterblur':
    case 'beforeinput':
    case 'blur':
    case 'fullscreenchange':
    case 'focus':
    case 'hashchange':
    case 'popstate':
    case 'select':
    case 'selectstart':
      return 1;
    case 'drag':
    case 'dragenter':
    case 'dragexit':
    case 'dragleave':
    case 'dragover':
    case 'mousemove':
    case 'mouseout':
    case 'mouseover':
    case 'pointermove':
    case 'pointerout':
    case 'pointerover':
    case 'scroll':
    case 'toggle':
    case 'touchmove':
    case 'wheel':
    case 'mouseenter':
    case 'mouseleave':
    case 'pointerenter':
    case 'pointerleave':
      return 4;
    case 'message':
      switch (ov()) {
        case Nc:
          return 1;
        case Ch:
          return 4;
        case aa:
        case av:
          return 16;
        case Nh:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var Rn = null,
  Lc = null,
  Vo = null;
function Bh() {
  if (Vo) return Vo;
  var e,
    t = Lc,
    n = t.length,
    i,
    r = 'value' in Rn ? Rn.value : Rn.textContent,
    o = r.length;
  for (e = 0; e < n && t[e] === r[e]; e++);
  var a = n - e;
  for (i = 1; i <= a && t[n - i] === r[o - i]; i++);
  return (Vo = r.slice(e, 1 < i ? 1 - i : void 0));
}
function qo(e) {
  var t = e.keyCode;
  return (
    'charCode' in e ? ((e = e.charCode), e === 0 && t === 13 && (e = 13)) : (e = t),
    e === 10 && (e = 13),
    32 <= e || e === 13 ? e : 0
  );
}
function Po() {
  return !0;
}
function md() {
  return !1;
}
function kt(e) {
  function t(n, i, r, o, a) {
    (this._reactName = n),
      (this._targetInst = r),
      (this.type = i),
      (this.nativeEvent = o),
      (this.target = a),
      (this.currentTarget = null);
    for (var s in e) e.hasOwnProperty(s) && ((n = e[s]), (this[s] = n ? n(o) : o[s]));
    return (
      (this.isDefaultPrevented = (o.defaultPrevented != null ? o.defaultPrevented : o.returnValue === !1) ? Po : md),
      (this.isPropagationStopped = md),
      this
    );
  }
  return (
    Ee(t.prototype, {
      preventDefault: function () {
        this.defaultPrevented = !0;
        var n = this.nativeEvent;
        n &&
          (n.preventDefault ? n.preventDefault() : typeof n.returnValue != 'unknown' && (n.returnValue = !1),
          (this.isDefaultPrevented = Po));
      },
      stopPropagation: function () {
        var n = this.nativeEvent;
        n &&
          (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != 'unknown' && (n.cancelBubble = !0),
          (this.isPropagationStopped = Po));
      },
      persist: function () {},
      isPersistent: Po,
    }),
    t
  );
}
var rr = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function (e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0,
  },
  Hc = kt(rr),
  so = Ee({}, rr, { view: 0, detail: 0 }),
  xv = kt(so),
  Ls,
  Hs,
  yr,
  Ca = Ee({}, so, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Fc,
    button: 0,
    buttons: 0,
    relatedTarget: function (e) {
      return e.relatedTarget === void 0
        ? e.fromElement === e.srcElement
          ? e.toElement
          : e.fromElement
        : e.relatedTarget;
    },
    movementX: function (e) {
      return 'movementX' in e
        ? e.movementX
        : (e !== yr &&
            (yr && e.type === 'mousemove'
              ? ((Ls = e.screenX - yr.screenX), (Hs = e.screenY - yr.screenY))
              : (Hs = Ls = 0),
            (yr = e)),
          Ls);
    },
    movementY: function (e) {
      return 'movementY' in e ? e.movementY : Hs;
    },
  }),
  fd = kt(Ca),
  Ev = Ee({}, Ca, { dataTransfer: 0 }),
  yv = kt(Ev),
  Av = Ee({}, so, { relatedTarget: 0 }),
  Fs = kt(Av),
  wv = Ee({}, rr, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
  kv = kt(wv),
  Sv = Ee({}, rr, {
    clipboardData: function (e) {
      return 'clipboardData' in e ? e.clipboardData : window.clipboardData;
    },
  }),
  bv = kt(Sv),
  Mv = Ee({}, rr, { data: 0 }),
  gd = kt(Mv),
  Tv = {
    Esc: 'Escape',
    Spacebar: ' ',
    Left: 'ArrowLeft',
    Up: 'ArrowUp',
    Right: 'ArrowRight',
    Down: 'ArrowDown',
    Del: 'Delete',
    Win: 'OS',
    Menu: 'ContextMenu',
    Apps: 'ContextMenu',
    Scroll: 'ScrollLock',
    MozPrintableKey: 'Unidentified',
  },
  Rv = {
    8: 'Backspace',
    9: 'Tab',
    12: 'Clear',
    13: 'Enter',
    16: 'Shift',
    17: 'Control',
    18: 'Alt',
    19: 'Pause',
    20: 'CapsLock',
    27: 'Escape',
    32: ' ',
    33: 'PageUp',
    34: 'PageDown',
    35: 'End',
    36: 'Home',
    37: 'ArrowLeft',
    38: 'ArrowUp',
    39: 'ArrowRight',
    40: 'ArrowDown',
    45: 'Insert',
    46: 'Delete',
    112: 'F1',
    113: 'F2',
    114: 'F3',
    115: 'F4',
    116: 'F5',
    117: 'F6',
    118: 'F7',
    119: 'F8',
    120: 'F9',
    121: 'F10',
    122: 'F11',
    123: 'F12',
    144: 'NumLock',
    145: 'ScrollLock',
    224: 'Meta',
  },
  Pv = { Alt: 'altKey', Control: 'ctrlKey', Meta: 'metaKey', Shift: 'shiftKey' };
function Cv(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : (e = Pv[e]) ? !!t[e] : !1;
}
function Fc() {
  return Cv;
}
var Nv = Ee({}, so, {
    key: function (e) {
      if (e.key) {
        var t = Tv[e.key] || e.key;
        if (t !== 'Unidentified') return t;
      }
      return e.type === 'keypress'
        ? ((e = qo(e)), e === 13 ? 'Enter' : String.fromCharCode(e))
        : e.type === 'keydown' || e.type === 'keyup'
          ? Rv[e.keyCode] || 'Unidentified'
          : '';
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Fc,
    charCode: function (e) {
      return e.type === 'keypress' ? qo(e) : 0;
    },
    keyCode: function (e) {
      return e.type === 'keydown' || e.type === 'keyup' ? e.keyCode : 0;
    },
    which: function (e) {
      return e.type === 'keypress' ? qo(e) : e.type === 'keydown' || e.type === 'keyup' ? e.keyCode : 0;
    },
  }),
  Iv = kt(Nv),
  Dv = Ee({}, Ca, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0,
  }),
  vd = kt(Dv),
  Ov = Ee({}, so, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Fc,
  }),
  Lv = kt(Ov),
  Hv = Ee({}, rr, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
  Fv = kt(Hv),
  jv = Ee({}, Ca, {
    deltaX: function (e) {
      return 'deltaX' in e ? e.deltaX : 'wheelDeltaX' in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function (e) {
      return 'deltaY' in e ? e.deltaY : 'wheelDeltaY' in e ? -e.wheelDeltaY : 'wheelDelta' in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0,
  }),
  zv = kt(jv),
  Bv = [9, 13, 27, 32],
  jc = dn && 'CompositionEvent' in window,
  Dr = null;
dn && 'documentMode' in document && (Dr = document.documentMode);
var Uv = dn && 'TextEvent' in window && !Dr,
  Uh = dn && (!jc || (Dr && 8 < Dr && 11 >= Dr)),
  _d = String.fromCharCode(32),
  xd = !1;
function $h(e, t) {
  switch (e) {
    case 'keyup':
      return Bv.indexOf(t.keyCode) !== -1;
    case 'keydown':
      return t.keyCode !== 229;
    case 'keypress':
    case 'mousedown':
    case 'focusout':
      return !0;
    default:
      return !1;
  }
}
function Gh(e) {
  return (e = e.detail), typeof e == 'object' && 'data' in e ? e.data : null;
}
var Pi = !1;
function $v(e, t) {
  switch (e) {
    case 'compositionend':
      return Gh(t);
    case 'keypress':
      return t.which !== 32 ? null : ((xd = !0), _d);
    case 'textInput':
      return (e = t.data), e === _d && xd ? null : e;
    default:
      return null;
  }
}
function Gv(e, t) {
  if (Pi) return e === 'compositionend' || (!jc && $h(e, t)) ? ((e = Bh()), (Vo = Lc = Rn = null), (Pi = !1), e) : null;
  switch (e) {
    case 'paste':
      return null;
    case 'keypress':
      if (!(t.ctrlKey || t.altKey || t.metaKey) || (t.ctrlKey && t.altKey)) {
        if (t.char && 1 < t.char.length) return t.char;
        if (t.which) return String.fromCharCode(t.which);
      }
      return null;
    case 'compositionend':
      return Uh && t.locale !== 'ko' ? null : t.data;
    default:
      return null;
  }
}
var Jv = {
  color: !0,
  date: !0,
  datetime: !0,
  'datetime-local': !0,
  email: !0,
  month: !0,
  number: !0,
  password: !0,
  range: !0,
  search: !0,
  tel: !0,
  text: !0,
  time: !0,
  url: !0,
  week: !0,
};
function Ed(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t === 'input' ? !!Jv[e.type] : t === 'textarea';
}
function Jh(e, t, n, i) {
  Ah(i),
    (t = ua(t, 'onChange')),
    0 < t.length && ((n = new Hc('onChange', 'change', null, n, i)), e.push({ event: n, listeners: t }));
}
var Or = null,
  Qr = null;
function Vv(e) {
  nm(e, 0);
}
function Na(e) {
  var t = Ii(e);
  if (fh(t)) return e;
}
function qv(e, t) {
  if (e === 'change') return t;
}
var Vh = !1;
if (dn) {
  var js;
  if (dn) {
    var zs = 'oninput' in document;
    if (!zs) {
      var yd = document.createElement('div');
      yd.setAttribute('oninput', 'return;'), (zs = typeof yd.oninput == 'function');
    }
    js = zs;
  } else js = !1;
  Vh = js && (!document.documentMode || 9 < document.documentMode);
}
function Ad() {
  Or && (Or.detachEvent('onpropertychange', qh), (Qr = Or = null));
}
function qh(e) {
  if (e.propertyName === 'value' && Na(Qr)) {
    var t = [];
    Jh(t, Qr, e, Cc(e)), bh(Vv, t);
  }
}
function Qv(e, t, n) {
  e === 'focusin' ? (Ad(), (Or = t), (Qr = n), Or.attachEvent('onpropertychange', qh)) : e === 'focusout' && Ad();
}
function Wv(e) {
  if (e === 'selectionchange' || e === 'keyup' || e === 'keydown') return Na(Qr);
}
function Kv(e, t) {
  if (e === 'click') return Na(t);
}
function Xv(e, t) {
  if (e === 'input' || e === 'change') return Na(t);
}
function Zv(e, t) {
  return (e === t && (e !== 0 || 1 / e === 1 / t)) || (e !== e && t !== t);
}
var zt = typeof Object.is == 'function' ? Object.is : Zv;
function Wr(e, t) {
  if (zt(e, t)) return !0;
  if (typeof e != 'object' || e === null || typeof t != 'object' || t === null) return !1;
  var n = Object.keys(e),
    i = Object.keys(t);
  if (n.length !== i.length) return !1;
  for (i = 0; i < n.length; i++) {
    var r = n[i];
    if (!ml.call(t, r) || !zt(e[r], t[r])) return !1;
  }
  return !0;
}
function wd(e) {
  for (; e && e.firstChild; ) e = e.firstChild;
  return e;
}
function kd(e, t) {
  var n = wd(e);
  e = 0;
  for (var i; n; ) {
    if (n.nodeType === 3) {
      if (((i = e + n.textContent.length), e <= t && i >= t)) return { node: n, offset: t - e };
      e = i;
    }
    e: {
      for (; n; ) {
        if (n.nextSibling) {
          n = n.nextSibling;
          break e;
        }
        n = n.parentNode;
      }
      n = void 0;
    }
    n = wd(n);
  }
}
function Qh(e, t) {
  return e && t
    ? e === t
      ? !0
      : e && e.nodeType === 3
        ? !1
        : t && t.nodeType === 3
          ? Qh(e, t.parentNode)
          : 'contains' in e
            ? e.contains(t)
            : e.compareDocumentPosition
              ? !!(e.compareDocumentPosition(t) & 16)
              : !1
    : !1;
}
function Wh() {
  for (var e = window, t = ia(); t instanceof e.HTMLIFrameElement; ) {
    try {
      var n = typeof t.contentWindow.location.href == 'string';
    } catch {
      n = !1;
    }
    if (n) e = t.contentWindow;
    else break;
    t = ia(e.document);
  }
  return t;
}
function zc(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return (
    t &&
    ((t === 'input' &&
      (e.type === 'text' || e.type === 'search' || e.type === 'tel' || e.type === 'url' || e.type === 'password')) ||
      t === 'textarea' ||
      e.contentEditable === 'true')
  );
}
function Yv(e) {
  var t = Wh(),
    n = e.focusedElem,
    i = e.selectionRange;
  if (t !== n && n && n.ownerDocument && Qh(n.ownerDocument.documentElement, n)) {
    if (i !== null && zc(n)) {
      if (((t = i.start), (e = i.end), e === void 0 && (e = t), 'selectionStart' in n))
        (n.selectionStart = t), (n.selectionEnd = Math.min(e, n.value.length));
      else if (((e = ((t = n.ownerDocument || document) && t.defaultView) || window), e.getSelection)) {
        e = e.getSelection();
        var r = n.textContent.length,
          o = Math.min(i.start, r);
        (i = i.end === void 0 ? o : Math.min(i.end, r)),
          !e.extend && o > i && ((r = i), (i = o), (o = r)),
          (r = kd(n, o));
        var a = kd(n, i);
        r &&
          a &&
          (e.rangeCount !== 1 ||
            e.anchorNode !== r.node ||
            e.anchorOffset !== r.offset ||
            e.focusNode !== a.node ||
            e.focusOffset !== a.offset) &&
          ((t = t.createRange()),
          t.setStart(r.node, r.offset),
          e.removeAllRanges(),
          o > i ? (e.addRange(t), e.extend(a.node, a.offset)) : (t.setEnd(a.node, a.offset), e.addRange(t)));
      }
    }
    for (t = [], e = n; (e = e.parentNode); )
      e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
    for (typeof n.focus == 'function' && n.focus(), n = 0; n < t.length; n++)
      (e = t[n]), (e.element.scrollLeft = e.left), (e.element.scrollTop = e.top);
  }
}
var e_ = dn && 'documentMode' in document && 11 >= document.documentMode,
  Ci = null,
  Il = null,
  Lr = null,
  Dl = !1;
function Sd(e, t, n) {
  var i = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
  Dl ||
    Ci == null ||
    Ci !== ia(i) ||
    ((i = Ci),
    'selectionStart' in i && zc(i)
      ? (i = { start: i.selectionStart, end: i.selectionEnd })
      : ((i = ((i.ownerDocument && i.ownerDocument.defaultView) || window).getSelection()),
        (i = {
          anchorNode: i.anchorNode,
          anchorOffset: i.anchorOffset,
          focusNode: i.focusNode,
          focusOffset: i.focusOffset,
        })),
    (Lr && Wr(Lr, i)) ||
      ((Lr = i),
      (i = ua(Il, 'onSelect')),
      0 < i.length &&
        ((t = new Hc('onSelect', 'select', null, t, n)), e.push({ event: t, listeners: i }), (t.target = Ci))));
}
function Co(e, t) {
  var n = {};
  return (n[e.toLowerCase()] = t.toLowerCase()), (n['Webkit' + e] = 'webkit' + t), (n['Moz' + e] = 'moz' + t), n;
}
var Ni = {
    animationend: Co('Animation', 'AnimationEnd'),
    animationiteration: Co('Animation', 'AnimationIteration'),
    animationstart: Co('Animation', 'AnimationStart'),
    transitionend: Co('Transition', 'TransitionEnd'),
  },
  Bs = {},
  Kh = {};
dn &&
  ((Kh = document.createElement('div').style),
  'AnimationEvent' in window ||
    (delete Ni.animationend.animation, delete Ni.animationiteration.animation, delete Ni.animationstart.animation),
  'TransitionEvent' in window || delete Ni.transitionend.transition);
function Ia(e) {
  if (Bs[e]) return Bs[e];
  if (!Ni[e]) return e;
  var t = Ni[e],
    n;
  for (n in t) if (t.hasOwnProperty(n) && n in Kh) return (Bs[e] = t[n]);
  return e;
}
var Xh = Ia('animationend'),
  Zh = Ia('animationiteration'),
  Yh = Ia('animationstart'),
  em = Ia('transitionend'),
  tm = new Map(),
  bd =
    'abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
      ' ',
    );
function Bn(e, t) {
  tm.set(e, t), pi(t, [e]);
}
for (var Us = 0; Us < bd.length; Us++) {
  var $s = bd[Us],
    t_ = $s.toLowerCase(),
    n_ = $s[0].toUpperCase() + $s.slice(1);
  Bn(t_, 'on' + n_);
}
Bn(Xh, 'onAnimationEnd');
Bn(Zh, 'onAnimationIteration');
Bn(Yh, 'onAnimationStart');
Bn('dblclick', 'onDoubleClick');
Bn('focusin', 'onFocus');
Bn('focusout', 'onBlur');
Bn(em, 'onTransitionEnd');
Wi('onMouseEnter', ['mouseout', 'mouseover']);
Wi('onMouseLeave', ['mouseout', 'mouseover']);
Wi('onPointerEnter', ['pointerout', 'pointerover']);
Wi('onPointerLeave', ['pointerout', 'pointerover']);
pi('onChange', 'change click focusin focusout input keydown keyup selectionchange'.split(' '));
pi('onSelect', 'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(' '));
pi('onBeforeInput', ['compositionend', 'keypress', 'textInput', 'paste']);
pi('onCompositionEnd', 'compositionend focusout keydown keypress keyup mousedown'.split(' '));
pi('onCompositionStart', 'compositionstart focusout keydown keypress keyup mousedown'.split(' '));
pi('onCompositionUpdate', 'compositionupdate focusout keydown keypress keyup mousedown'.split(' '));
var Pr =
    'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
      ' ',
    ),
  i_ = new Set('cancel close invalid load scroll toggle'.split(' ').concat(Pr));
function Md(e, t, n) {
  var i = e.type || 'unknown-event';
  (e.currentTarget = n), tv(i, t, void 0, e), (e.currentTarget = null);
}
function nm(e, t) {
  t = (t & 4) !== 0;
  for (var n = 0; n < e.length; n++) {
    var i = e[n],
      r = i.event;
    i = i.listeners;
    e: {
      var o = void 0;
      if (t)
        for (var a = i.length - 1; 0 <= a; a--) {
          var s = i[a],
            l = s.instance,
            c = s.currentTarget;
          if (((s = s.listener), l !== o && r.isPropagationStopped())) break e;
          Md(r, s, c), (o = l);
        }
      else
        for (a = 0; a < i.length; a++) {
          if (
            ((s = i[a]), (l = s.instance), (c = s.currentTarget), (s = s.listener), l !== o && r.isPropagationStopped())
          )
            break e;
          Md(r, s, c), (o = l);
        }
    }
  }
  if (oa) throw ((e = Rl), (oa = !1), (Rl = null), e);
}
function he(e, t) {
  var n = t[jl];
  n === void 0 && (n = t[jl] = new Set());
  var i = e + '__bubble';
  n.has(i) || (im(t, e, 2, !1), n.add(i));
}
function Gs(e, t, n) {
  var i = 0;
  t && (i |= 4), im(n, e, i, t);
}
var No = '_reactListening' + Math.random().toString(36).slice(2);
function Kr(e) {
  if (!e[No]) {
    (e[No] = !0),
      uh.forEach(function (n) {
        n !== 'selectionchange' && (i_.has(n) || Gs(n, !1, e), Gs(n, !0, e));
      });
    var t = e.nodeType === 9 ? e : e.ownerDocument;
    t === null || t[No] || ((t[No] = !0), Gs('selectionchange', !1, t));
  }
}
function im(e, t, n, i) {
  switch (zh(t)) {
    case 1:
      var r = vv;
      break;
    case 4:
      r = _v;
      break;
    default:
      r = Oc;
  }
  (n = r.bind(null, t, n, e)),
    (r = void 0),
    !Tl || (t !== 'touchstart' && t !== 'touchmove' && t !== 'wheel') || (r = !0),
    i
      ? r !== void 0
        ? e.addEventListener(t, n, { capture: !0, passive: r })
        : e.addEventListener(t, n, !0)
      : r !== void 0
        ? e.addEventListener(t, n, { passive: r })
        : e.addEventListener(t, n, !1);
}
function Js(e, t, n, i, r) {
  var o = i;
  if ((t & 1) === 0 && (t & 2) === 0 && i !== null)
    e: for (;;) {
      if (i === null) return;
      var a = i.tag;
      if (a === 3 || a === 4) {
        var s = i.stateNode.containerInfo;
        if (s === r || (s.nodeType === 8 && s.parentNode === r)) break;
        if (a === 4)
          for (a = i.return; a !== null; ) {
            var l = a.tag;
            if (
              (l === 3 || l === 4) &&
              ((l = a.stateNode.containerInfo), l === r || (l.nodeType === 8 && l.parentNode === r))
            )
              return;
            a = a.return;
          }
        for (; s !== null; ) {
          if (((a = Zn(s)), a === null)) return;
          if (((l = a.tag), l === 5 || l === 6)) {
            i = o = a;
            continue e;
          }
          s = s.parentNode;
        }
      }
      i = i.return;
    }
  bh(function () {
    var c = o,
      u = Cc(n),
      m = [];
    e: {
      var h = tm.get(e);
      if (h !== void 0) {
        var v = Hc,
          x = e;
        switch (e) {
          case 'keypress':
            if (qo(n) === 0) break e;
          case 'keydown':
          case 'keyup':
            v = Iv;
            break;
          case 'focusin':
            (x = 'focus'), (v = Fs);
            break;
          case 'focusout':
            (x = 'blur'), (v = Fs);
            break;
          case 'beforeblur':
          case 'afterblur':
            v = Fs;
            break;
          case 'click':
            if (n.button === 2) break e;
          case 'auxclick':
          case 'dblclick':
          case 'mousedown':
          case 'mousemove':
          case 'mouseup':
          case 'mouseout':
          case 'mouseover':
          case 'contextmenu':
            v = fd;
            break;
          case 'drag':
          case 'dragend':
          case 'dragenter':
          case 'dragexit':
          case 'dragleave':
          case 'dragover':
          case 'dragstart':
          case 'drop':
            v = yv;
            break;
          case 'touchcancel':
          case 'touchend':
          case 'touchmove':
          case 'touchstart':
            v = Lv;
            break;
          case Xh:
          case Zh:
          case Yh:
            v = kv;
            break;
          case em:
            v = Fv;
            break;
          case 'scroll':
            v = xv;
            break;
          case 'wheel':
            v = zv;
            break;
          case 'copy':
          case 'cut':
          case 'paste':
            v = bv;
            break;
          case 'gotpointercapture':
          case 'lostpointercapture':
          case 'pointercancel':
          case 'pointerdown':
          case 'pointermove':
          case 'pointerout':
          case 'pointerover':
          case 'pointerup':
            v = vd;
        }
        var f = (t & 4) !== 0,
          D = !f && e === 'scroll',
          p = f ? (h !== null ? h + 'Capture' : null) : h;
        f = [];
        for (var d = c, g; d !== null; ) {
          g = d;
          var y = g.stateNode;
          if (
            (g.tag === 5 && y !== null && ((g = y), p !== null && ((y = Gr(d, p)), y != null && f.push(Xr(d, y, g)))),
            D)
          )
            break;
          d = d.return;
        }
        0 < f.length && ((h = new v(h, x, null, n, u)), m.push({ event: h, listeners: f }));
      }
    }
    if ((t & 7) === 0) {
      e: {
        if (
          ((h = e === 'mouseover' || e === 'pointerover'),
          (v = e === 'mouseout' || e === 'pointerout'),
          h && n !== bl && (x = n.relatedTarget || n.fromElement) && (Zn(x) || x[pn]))
        )
          break e;
        if (
          (v || h) &&
          ((h = u.window === u ? u : (h = u.ownerDocument) ? h.defaultView || h.parentWindow : window),
          v
            ? ((x = n.relatedTarget || n.toElement),
              (v = c),
              (x = x ? Zn(x) : null),
              x !== null && ((D = hi(x)), x !== D || (x.tag !== 5 && x.tag !== 6)) && (x = null))
            : ((v = null), (x = c)),
          v !== x)
        ) {
          if (
            ((f = fd),
            (y = 'onMouseLeave'),
            (p = 'onMouseEnter'),
            (d = 'mouse'),
            (e === 'pointerout' || e === 'pointerover') &&
              ((f = vd), (y = 'onPointerLeave'), (p = 'onPointerEnter'), (d = 'pointer')),
            (D = v == null ? h : Ii(v)),
            (g = x == null ? h : Ii(x)),
            (h = new f(y, d + 'leave', v, n, u)),
            (h.target = D),
            (h.relatedTarget = g),
            (y = null),
            Zn(u) === c && ((f = new f(p, d + 'enter', x, n, u)), (f.target = g), (f.relatedTarget = D), (y = f)),
            (D = y),
            v && x)
          )
            t: {
              for (f = v, p = x, d = 0, g = f; g; g = Mi(g)) d++;
              for (g = 0, y = p; y; y = Mi(y)) g++;
              for (; 0 < d - g; ) (f = Mi(f)), d--;
              for (; 0 < g - d; ) (p = Mi(p)), g--;
              for (; d--; ) {
                if (f === p || (p !== null && f === p.alternate)) break t;
                (f = Mi(f)), (p = Mi(p));
              }
              f = null;
            }
          else f = null;
          v !== null && Td(m, h, v, f, !1), x !== null && D !== null && Td(m, D, x, f, !0);
        }
      }
      e: {
        if (
          ((h = c ? Ii(c) : window),
          (v = h.nodeName && h.nodeName.toLowerCase()),
          v === 'select' || (v === 'input' && h.type === 'file'))
        )
          var b = qv;
        else if (Ed(h))
          if (Vh) b = Xv;
          else {
            b = Wv;
            var C = Qv;
          }
        else
          (v = h.nodeName) && v.toLowerCase() === 'input' && (h.type === 'checkbox' || h.type === 'radio') && (b = Kv);
        if (b && (b = b(e, c))) {
          Jh(m, b, n, u);
          break e;
        }
        C && C(e, h, c),
          e === 'focusout' && (C = h._wrapperState) && C.controlled && h.type === 'number' && yl(h, 'number', h.value);
      }
      switch (((C = c ? Ii(c) : window), e)) {
        case 'focusin':
          (Ed(C) || C.contentEditable === 'true') && ((Ci = C), (Il = c), (Lr = null));
          break;
        case 'focusout':
          Lr = Il = Ci = null;
          break;
        case 'mousedown':
          Dl = !0;
          break;
        case 'contextmenu':
        case 'mouseup':
        case 'dragend':
          (Dl = !1), Sd(m, n, u);
          break;
        case 'selectionchange':
          if (e_) break;
        case 'keydown':
        case 'keyup':
          Sd(m, n, u);
      }
      var R;
      if (jc)
        e: {
          switch (e) {
            case 'compositionstart':
              var z = 'onCompositionStart';
              break e;
            case 'compositionend':
              z = 'onCompositionEnd';
              break e;
            case 'compositionupdate':
              z = 'onCompositionUpdate';
              break e;
          }
          z = void 0;
        }
      else
        Pi ? $h(e, n) && (z = 'onCompositionEnd') : e === 'keydown' && n.keyCode === 229 && (z = 'onCompositionStart');
      z &&
        (Uh &&
          n.locale !== 'ko' &&
          (Pi || z !== 'onCompositionStart'
            ? z === 'onCompositionEnd' && Pi && (R = Bh())
            : ((Rn = u), (Lc = 'value' in Rn ? Rn.value : Rn.textContent), (Pi = !0))),
        (C = ua(c, z)),
        0 < C.length &&
          ((z = new gd(z, e, null, n, u)),
          m.push({ event: z, listeners: C }),
          R ? (z.data = R) : ((R = Gh(n)), R !== null && (z.data = R)))),
        (R = Uv ? $v(e, n) : Gv(e, n)) &&
          ((c = ua(c, 'onBeforeInput')),
          0 < c.length &&
            ((u = new gd('onBeforeInput', 'beforeinput', null, n, u)),
            m.push({ event: u, listeners: c }),
            (u.data = R)));
    }
    nm(m, t);
  });
}
function Xr(e, t, n) {
  return { instance: e, listener: t, currentTarget: n };
}
function ua(e, t) {
  for (var n = t + 'Capture', i = []; e !== null; ) {
    var r = e,
      o = r.stateNode;
    r.tag === 5 &&
      o !== null &&
      ((r = o), (o = Gr(e, n)), o != null && i.unshift(Xr(e, o, r)), (o = Gr(e, t)), o != null && i.push(Xr(e, o, r))),
      (e = e.return);
  }
  return i;
}
function Mi(e) {
  if (e === null) return null;
  do e = e.return;
  while (e && e.tag !== 5);
  return e || null;
}
function Td(e, t, n, i, r) {
  for (var o = t._reactName, a = []; n !== null && n !== i; ) {
    var s = n,
      l = s.alternate,
      c = s.stateNode;
    if (l !== null && l === i) break;
    s.tag === 5 &&
      c !== null &&
      ((s = c),
      r
        ? ((l = Gr(n, o)), l != null && a.unshift(Xr(n, l, s)))
        : r || ((l = Gr(n, o)), l != null && a.push(Xr(n, l, s)))),
      (n = n.return);
  }
  a.length !== 0 && e.push({ event: t, listeners: a });
}
var r_ = /\r\n?/g,
  o_ = /\u0000|\uFFFD/g;
function Rd(e) {
  return (typeof e == 'string' ? e : '' + e)
    .replace(
      r_,
      `
`,
    )
    .replace(o_, '');
}
function Io(e, t, n) {
  if (((t = Rd(t)), Rd(e) !== t && n)) throw Error(S(425));
}
function da() {}
var Ol = null,
  Ll = null;
function Hl(e, t) {
  return (
    e === 'textarea' ||
    e === 'noscript' ||
    typeof t.children == 'string' ||
    typeof t.children == 'number' ||
    (typeof t.dangerouslySetInnerHTML == 'object' &&
      t.dangerouslySetInnerHTML !== null &&
      t.dangerouslySetInnerHTML.__html != null)
  );
}
var Fl = typeof setTimeout == 'function' ? setTimeout : void 0,
  a_ = typeof clearTimeout == 'function' ? clearTimeout : void 0,
  Pd = typeof Promise == 'function' ? Promise : void 0,
  s_ =
    typeof queueMicrotask == 'function'
      ? queueMicrotask
      : typeof Pd < 'u'
        ? function (e) {
            return Pd.resolve(null).then(e).catch(l_);
          }
        : Fl;
function l_(e) {
  setTimeout(function () {
    throw e;
  });
}
function Vs(e, t) {
  var n = t,
    i = 0;
  do {
    var r = n.nextSibling;
    if ((e.removeChild(n), r && r.nodeType === 8))
      if (((n = r.data), n === '/$')) {
        if (i === 0) {
          e.removeChild(r), qr(t);
          return;
        }
        i--;
      } else (n !== '$' && n !== '$?' && n !== '$!') || i++;
    n = r;
  } while (n);
  qr(t);
}
function Dn(e) {
  for (; e != null; e = e.nextSibling) {
    var t = e.nodeType;
    if (t === 1 || t === 3) break;
    if (t === 8) {
      if (((t = e.data), t === '$' || t === '$!' || t === '$?')) break;
      if (t === '/$') return null;
    }
  }
  return e;
}
function Cd(e) {
  e = e.previousSibling;
  for (var t = 0; e; ) {
    if (e.nodeType === 8) {
      var n = e.data;
      if (n === '$' || n === '$!' || n === '$?') {
        if (t === 0) return e;
        t--;
      } else n === '/$' && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var or = Math.random().toString(36).slice(2),
  Kt = '__reactFiber$' + or,
  Zr = '__reactProps$' + or,
  pn = '__reactContainer$' + or,
  jl = '__reactEvents$' + or,
  c_ = '__reactListeners$' + or,
  u_ = '__reactHandles$' + or;
function Zn(e) {
  var t = e[Kt];
  if (t) return t;
  for (var n = e.parentNode; n; ) {
    if ((t = n[pn] || n[Kt])) {
      if (((n = t.alternate), t.child !== null || (n !== null && n.child !== null)))
        for (e = Cd(e); e !== null; ) {
          if ((n = e[Kt])) return n;
          e = Cd(e);
        }
      return t;
    }
    (e = n), (n = e.parentNode);
  }
  return null;
}
function lo(e) {
  return (e = e[Kt] || e[pn]), !e || (e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3) ? null : e;
}
function Ii(e) {
  if (e.tag === 5 || e.tag === 6) return e.stateNode;
  throw Error(S(33));
}
function Da(e) {
  return e[Zr] || null;
}
var zl = [],
  Di = -1;
function Un(e) {
  return { current: e };
}
function fe(e) {
  0 > Di || ((e.current = zl[Di]), (zl[Di] = null), Di--);
}
function pe(e, t) {
  Di++, (zl[Di] = e.current), (e.current = t);
}
var zn = {},
  et = Un(zn),
  ht = Un(!1),
  ai = zn;
function Ki(e, t) {
  var n = e.type.contextTypes;
  if (!n) return zn;
  var i = e.stateNode;
  if (i && i.__reactInternalMemoizedUnmaskedChildContext === t) return i.__reactInternalMemoizedMaskedChildContext;
  var r = {},
    o;
  for (o in n) r[o] = t[o];
  return (
    i &&
      ((e = e.stateNode),
      (e.__reactInternalMemoizedUnmaskedChildContext = t),
      (e.__reactInternalMemoizedMaskedChildContext = r)),
    r
  );
}
function mt(e) {
  return (e = e.childContextTypes), e != null;
}
function pa() {
  fe(ht), fe(et);
}
function Nd(e, t, n) {
  if (et.current !== zn) throw Error(S(168));
  pe(et, t), pe(ht, n);
}
function rm(e, t, n) {
  var i = e.stateNode;
  if (((t = t.childContextTypes), typeof i.getChildContext != 'function')) return n;
  i = i.getChildContext();
  for (var r in i) if (!(r in t)) throw Error(S(108, Qg(e) || 'Unknown', r));
  return Ee({}, n, i);
}
function ha(e) {
  return (
    (e = ((e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext) || zn),
    (ai = et.current),
    pe(et, e),
    pe(ht, ht.current),
    !0
  );
}
function Id(e, t, n) {
  var i = e.stateNode;
  if (!i) throw Error(S(169));
  n ? ((e = rm(e, t, ai)), (i.__reactInternalMemoizedMergedChildContext = e), fe(ht), fe(et), pe(et, e)) : fe(ht),
    pe(ht, n);
}
var sn = null,
  Oa = !1,
  qs = !1;
function om(e) {
  sn === null ? (sn = [e]) : sn.push(e);
}
function d_(e) {
  (Oa = !0), om(e);
}
function $n() {
  if (!qs && sn !== null) {
    qs = !0;
    var e = 0,
      t = se;
    try {
      var n = sn;
      for (se = 1; e < n.length; e++) {
        var i = n[e];
        do i = i(!0);
        while (i !== null);
      }
      (sn = null), (Oa = !1);
    } catch (r) {
      throw (sn !== null && (sn = sn.slice(e + 1)), Ph(Nc, $n), r);
    } finally {
      (se = t), (qs = !1);
    }
  }
  return null;
}
var Oi = [],
  Li = 0,
  ma = null,
  fa = 0,
  Mt = [],
  Tt = 0,
  si = null,
  ln = 1,
  cn = '';
function Kn(e, t) {
  (Oi[Li++] = fa), (Oi[Li++] = ma), (ma = e), (fa = t);
}
function am(e, t, n) {
  (Mt[Tt++] = ln), (Mt[Tt++] = cn), (Mt[Tt++] = si), (si = e);
  var i = ln;
  e = cn;
  var r = 32 - Ft(i) - 1;
  (i &= ~(1 << r)), (n += 1);
  var o = 32 - Ft(t) + r;
  if (30 < o) {
    var a = r - (r % 5);
    (o = (i & ((1 << a) - 1)).toString(32)),
      (i >>= a),
      (r -= a),
      (ln = (1 << (32 - Ft(t) + r)) | (n << r) | i),
      (cn = o + e);
  } else (ln = (1 << o) | (n << r) | i), (cn = e);
}
function Bc(e) {
  e.return !== null && (Kn(e, 1), am(e, 1, 0));
}
function Uc(e) {
  for (; e === ma; ) (ma = Oi[--Li]), (Oi[Li] = null), (fa = Oi[--Li]), (Oi[Li] = null);
  for (; e === si; )
    (si = Mt[--Tt]), (Mt[Tt] = null), (cn = Mt[--Tt]), (Mt[Tt] = null), (ln = Mt[--Tt]), (Mt[Tt] = null);
}
var yt = null,
  Et = null,
  ge = !1,
  Ht = null;
function sm(e, t) {
  var n = Rt(5, null, null, 0);
  (n.elementType = 'DELETED'),
    (n.stateNode = t),
    (n.return = e),
    (t = e.deletions),
    t === null ? ((e.deletions = [n]), (e.flags |= 16)) : t.push(n);
}
function Dd(e, t) {
  switch (e.tag) {
    case 5:
      var n = e.type;
      return (
        (t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t),
        t !== null ? ((e.stateNode = t), (yt = e), (Et = Dn(t.firstChild)), !0) : !1
      );
    case 6:
      return (
        (t = e.pendingProps === '' || t.nodeType !== 3 ? null : t),
        t !== null ? ((e.stateNode = t), (yt = e), (Et = null), !0) : !1
      );
    case 13:
      return (
        (t = t.nodeType !== 8 ? null : t),
        t !== null
          ? ((n = si !== null ? { id: ln, overflow: cn } : null),
            (e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }),
            (n = Rt(18, null, null, 0)),
            (n.stateNode = t),
            (n.return = e),
            (e.child = n),
            (yt = e),
            (Et = null),
            !0)
          : !1
      );
    default:
      return !1;
  }
}
function Bl(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function Ul(e) {
  if (ge) {
    var t = Et;
    if (t) {
      var n = t;
      if (!Dd(e, t)) {
        if (Bl(e)) throw Error(S(418));
        t = Dn(n.nextSibling);
        var i = yt;
        t && Dd(e, t) ? sm(i, n) : ((e.flags = (e.flags & -4097) | 2), (ge = !1), (yt = e));
      }
    } else {
      if (Bl(e)) throw Error(S(418));
      (e.flags = (e.flags & -4097) | 2), (ge = !1), (yt = e);
    }
  }
}
function Od(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; ) e = e.return;
  yt = e;
}
function Do(e) {
  if (e !== yt) return !1;
  if (!ge) return Od(e), (ge = !0), !1;
  var t;
  if (
    ((t = e.tag !== 3) &&
      !(t = e.tag !== 5) &&
      ((t = e.type), (t = t !== 'head' && t !== 'body' && !Hl(e.type, e.memoizedProps))),
    t && (t = Et))
  ) {
    if (Bl(e)) throw (lm(), Error(S(418)));
    for (; t; ) sm(e, t), (t = Dn(t.nextSibling));
  }
  if ((Od(e), e.tag === 13)) {
    if (((e = e.memoizedState), (e = e !== null ? e.dehydrated : null), !e)) throw Error(S(317));
    e: {
      for (e = e.nextSibling, t = 0; e; ) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === '/$') {
            if (t === 0) {
              Et = Dn(e.nextSibling);
              break e;
            }
            t--;
          } else (n !== '$' && n !== '$!' && n !== '$?') || t++;
        }
        e = e.nextSibling;
      }
      Et = null;
    }
  } else Et = yt ? Dn(e.stateNode.nextSibling) : null;
  return !0;
}
function lm() {
  for (var e = Et; e; ) e = Dn(e.nextSibling);
}
function Xi() {
  (Et = yt = null), (ge = !1);
}
function $c(e) {
  Ht === null ? (Ht = [e]) : Ht.push(e);
}
var p_ = vn.ReactCurrentBatchConfig;
function Ot(e, t) {
  if (e && e.defaultProps) {
    (t = Ee({}, t)), (e = e.defaultProps);
    for (var n in e) t[n] === void 0 && (t[n] = e[n]);
    return t;
  }
  return t;
}
var ga = Un(null),
  va = null,
  Hi = null,
  Gc = null;
function Jc() {
  Gc = Hi = va = null;
}
function Vc(e) {
  var t = ga.current;
  fe(ga), (e._currentValue = t);
}
function $l(e, t, n) {
  for (; e !== null; ) {
    var i = e.alternate;
    if (
      ((e.childLanes & t) !== t
        ? ((e.childLanes |= t), i !== null && (i.childLanes |= t))
        : i !== null && (i.childLanes & t) !== t && (i.childLanes |= t),
      e === n)
    )
      break;
    e = e.return;
  }
}
function Vi(e, t) {
  (va = e),
    (Gc = Hi = null),
    (e = e.dependencies),
    e !== null && e.firstContext !== null && ((e.lanes & t) !== 0 && (pt = !0), (e.firstContext = null));
}
function Ct(e) {
  var t = e._currentValue;
  if (Gc !== e)
    if (((e = { context: e, memoizedValue: t, next: null }), Hi === null)) {
      if (va === null) throw Error(S(308));
      (Hi = e), (va.dependencies = { lanes: 0, firstContext: e });
    } else Hi = Hi.next = e;
  return t;
}
var Yn = null;
function qc(e) {
  Yn === null ? (Yn = [e]) : Yn.push(e);
}
function cm(e, t, n, i) {
  var r = t.interleaved;
  return r === null ? ((n.next = n), qc(t)) : ((n.next = r.next), (r.next = n)), (t.interleaved = n), hn(e, i);
}
function hn(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; )
    (e.childLanes |= t), (n = e.alternate), n !== null && (n.childLanes |= t), (n = e), (e = e.return);
  return n.tag === 3 ? n.stateNode : null;
}
var bn = !1;
function Qc(e) {
  e.updateQueue = {
    baseState: e.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: { pending: null, interleaved: null, lanes: 0 },
    effects: null,
  };
}
function um(e, t) {
  (e = e.updateQueue),
    t.updateQueue === e &&
      (t.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        effects: e.effects,
      });
}
function un(e, t) {
  return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
}
function On(e, t, n) {
  var i = e.updateQueue;
  if (i === null) return null;
  if (((i = i.shared), (te & 2) !== 0)) {
    var r = i.pending;
    return r === null ? (t.next = t) : ((t.next = r.next), (r.next = t)), (i.pending = t), hn(e, n);
  }
  return (
    (r = i.interleaved),
    r === null ? ((t.next = t), qc(i)) : ((t.next = r.next), (r.next = t)),
    (i.interleaved = t),
    hn(e, n)
  );
}
function Qo(e, t, n) {
  if (((t = t.updateQueue), t !== null && ((t = t.shared), (n & 4194240) !== 0))) {
    var i = t.lanes;
    (i &= e.pendingLanes), (n |= i), (t.lanes = n), Ic(e, n);
  }
}
function Ld(e, t) {
  var n = e.updateQueue,
    i = e.alternate;
  if (i !== null && ((i = i.updateQueue), n === i)) {
    var r = null,
      o = null;
    if (((n = n.firstBaseUpdate), n !== null)) {
      do {
        var a = {
          eventTime: n.eventTime,
          lane: n.lane,
          tag: n.tag,
          payload: n.payload,
          callback: n.callback,
          next: null,
        };
        o === null ? (r = o = a) : (o = o.next = a), (n = n.next);
      } while (n !== null);
      o === null ? (r = o = t) : (o = o.next = t);
    } else r = o = t;
    (n = { baseState: i.baseState, firstBaseUpdate: r, lastBaseUpdate: o, shared: i.shared, effects: i.effects }),
      (e.updateQueue = n);
    return;
  }
  (e = n.lastBaseUpdate), e === null ? (n.firstBaseUpdate = t) : (e.next = t), (n.lastBaseUpdate = t);
}
function _a(e, t, n, i) {
  var r = e.updateQueue;
  bn = !1;
  var o = r.firstBaseUpdate,
    a = r.lastBaseUpdate,
    s = r.shared.pending;
  if (s !== null) {
    r.shared.pending = null;
    var l = s,
      c = l.next;
    (l.next = null), a === null ? (o = c) : (a.next = c), (a = l);
    var u = e.alternate;
    u !== null &&
      ((u = u.updateQueue),
      (s = u.lastBaseUpdate),
      s !== a && (s === null ? (u.firstBaseUpdate = c) : (s.next = c), (u.lastBaseUpdate = l)));
  }
  if (o !== null) {
    var m = r.baseState;
    (a = 0), (u = c = l = null), (s = o);
    do {
      var h = s.lane,
        v = s.eventTime;
      if ((i & h) === h) {
        u !== null &&
          (u = u.next = { eventTime: v, lane: 0, tag: s.tag, payload: s.payload, callback: s.callback, next: null });
        e: {
          var x = e,
            f = s;
          switch (((h = t), (v = n), f.tag)) {
            case 1:
              if (((x = f.payload), typeof x == 'function')) {
                m = x.call(v, m, h);
                break e;
              }
              m = x;
              break e;
            case 3:
              x.flags = (x.flags & -65537) | 128;
            case 0:
              if (((x = f.payload), (h = typeof x == 'function' ? x.call(v, m, h) : x), h == null)) break e;
              m = Ee({}, m, h);
              break e;
            case 2:
              bn = !0;
          }
        }
        s.callback !== null &&
          s.lane !== 0 &&
          ((e.flags |= 64), (h = r.effects), h === null ? (r.effects = [s]) : h.push(s));
      } else
        (v = { eventTime: v, lane: h, tag: s.tag, payload: s.payload, callback: s.callback, next: null }),
          u === null ? ((c = u = v), (l = m)) : (u = u.next = v),
          (a |= h);
      if (((s = s.next), s === null)) {
        if (((s = r.shared.pending), s === null)) break;
        (h = s), (s = h.next), (h.next = null), (r.lastBaseUpdate = h), (r.shared.pending = null);
      }
    } while (1);
    if (
      (u === null && (l = m),
      (r.baseState = l),
      (r.firstBaseUpdate = c),
      (r.lastBaseUpdate = u),
      (t = r.shared.interleaved),
      t !== null)
    ) {
      r = t;
      do (a |= r.lane), (r = r.next);
      while (r !== t);
    } else o === null && (r.shared.lanes = 0);
    (ci |= a), (e.lanes = a), (e.memoizedState = m);
  }
}
function Hd(e, t, n) {
  if (((e = t.effects), (t.effects = null), e !== null))
    for (t = 0; t < e.length; t++) {
      var i = e[t],
        r = i.callback;
      if (r !== null) {
        if (((i.callback = null), (i = n), typeof r != 'function')) throw Error(S(191, r));
        r.call(i);
      }
    }
}
var dm = new ch.Component().refs;
function Gl(e, t, n, i) {
  (t = e.memoizedState),
    (n = n(i, t)),
    (n = n == null ? t : Ee({}, t, n)),
    (e.memoizedState = n),
    e.lanes === 0 && (e.updateQueue.baseState = n);
}
var La = {
  isMounted: function (e) {
    return (e = e._reactInternals) ? hi(e) === e : !1;
  },
  enqueueSetState: function (e, t, n) {
    e = e._reactInternals;
    var i = ot(),
      r = Hn(e),
      o = un(i, r);
    (o.payload = t), n != null && (o.callback = n), (t = On(e, o, r)), t !== null && (jt(t, e, r, i), Qo(t, e, r));
  },
  enqueueReplaceState: function (e, t, n) {
    e = e._reactInternals;
    var i = ot(),
      r = Hn(e),
      o = un(i, r);
    (o.tag = 1),
      (o.payload = t),
      n != null && (o.callback = n),
      (t = On(e, o, r)),
      t !== null && (jt(t, e, r, i), Qo(t, e, r));
  },
  enqueueForceUpdate: function (e, t) {
    e = e._reactInternals;
    var n = ot(),
      i = Hn(e),
      r = un(n, i);
    (r.tag = 2), t != null && (r.callback = t), (t = On(e, r, i)), t !== null && (jt(t, e, i, n), Qo(t, e, i));
  },
};
function Fd(e, t, n, i, r, o, a) {
  return (
    (e = e.stateNode),
    typeof e.shouldComponentUpdate == 'function'
      ? e.shouldComponentUpdate(i, o, a)
      : t.prototype && t.prototype.isPureReactComponent
        ? !Wr(n, i) || !Wr(r, o)
        : !0
  );
}
function pm(e, t, n) {
  var i = !1,
    r = zn,
    o = t.contextType;
  return (
    typeof o == 'object' && o !== null
      ? (o = Ct(o))
      : ((r = mt(t) ? ai : et.current), (i = t.contextTypes), (o = (i = i != null) ? Ki(e, r) : zn)),
    (t = new t(n, o)),
    (e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null),
    (t.updater = La),
    (e.stateNode = t),
    (t._reactInternals = e),
    i &&
      ((e = e.stateNode),
      (e.__reactInternalMemoizedUnmaskedChildContext = r),
      (e.__reactInternalMemoizedMaskedChildContext = o)),
    t
  );
}
function jd(e, t, n, i) {
  (e = t.state),
    typeof t.componentWillReceiveProps == 'function' && t.componentWillReceiveProps(n, i),
    typeof t.UNSAFE_componentWillReceiveProps == 'function' && t.UNSAFE_componentWillReceiveProps(n, i),
    t.state !== e && La.enqueueReplaceState(t, t.state, null);
}
function Jl(e, t, n, i) {
  var r = e.stateNode;
  (r.props = n), (r.state = e.memoizedState), (r.refs = dm), Qc(e);
  var o = t.contextType;
  typeof o == 'object' && o !== null ? (r.context = Ct(o)) : ((o = mt(t) ? ai : et.current), (r.context = Ki(e, o))),
    (r.state = e.memoizedState),
    (o = t.getDerivedStateFromProps),
    typeof o == 'function' && (Gl(e, t, o, n), (r.state = e.memoizedState)),
    typeof t.getDerivedStateFromProps == 'function' ||
      typeof r.getSnapshotBeforeUpdate == 'function' ||
      (typeof r.UNSAFE_componentWillMount != 'function' && typeof r.componentWillMount != 'function') ||
      ((t = r.state),
      typeof r.componentWillMount == 'function' && r.componentWillMount(),
      typeof r.UNSAFE_componentWillMount == 'function' && r.UNSAFE_componentWillMount(),
      t !== r.state && La.enqueueReplaceState(r, r.state, null),
      _a(e, n, r, i),
      (r.state = e.memoizedState)),
    typeof r.componentDidMount == 'function' && (e.flags |= 4194308);
}
function Ar(e, t, n) {
  if (((e = n.ref), e !== null && typeof e != 'function' && typeof e != 'object')) {
    if (n._owner) {
      if (((n = n._owner), n)) {
        if (n.tag !== 1) throw Error(S(309));
        var i = n.stateNode;
      }
      if (!i) throw Error(S(147, e));
      var r = i,
        o = '' + e;
      return t !== null && t.ref !== null && typeof t.ref == 'function' && t.ref._stringRef === o
        ? t.ref
        : ((t = function (a) {
            var s = r.refs;
            s === dm && (s = r.refs = {}), a === null ? delete s[o] : (s[o] = a);
          }),
          (t._stringRef = o),
          t);
    }
    if (typeof e != 'string') throw Error(S(284));
    if (!n._owner) throw Error(S(290, e));
  }
  return e;
}
function Oo(e, t) {
  throw (
    ((e = Object.prototype.toString.call(t)),
    Error(S(31, e === '[object Object]' ? 'object with keys {' + Object.keys(t).join(', ') + '}' : e)))
  );
}
function zd(e) {
  var t = e._init;
  return t(e._payload);
}
function hm(e) {
  function t(p, d) {
    if (e) {
      var g = p.deletions;
      g === null ? ((p.deletions = [d]), (p.flags |= 16)) : g.push(d);
    }
  }
  function n(p, d) {
    if (!e) return null;
    for (; d !== null; ) t(p, d), (d = d.sibling);
    return null;
  }
  function i(p, d) {
    for (p = new Map(); d !== null; ) d.key !== null ? p.set(d.key, d) : p.set(d.index, d), (d = d.sibling);
    return p;
  }
  function r(p, d) {
    return (p = Fn(p, d)), (p.index = 0), (p.sibling = null), p;
  }
  function o(p, d, g) {
    return (
      (p.index = g),
      e
        ? ((g = p.alternate), g !== null ? ((g = g.index), g < d ? ((p.flags |= 2), d) : g) : ((p.flags |= 2), d))
        : ((p.flags |= 1048576), d)
    );
  }
  function a(p) {
    return e && p.alternate === null && (p.flags |= 2), p;
  }
  function s(p, d, g, y) {
    return d === null || d.tag !== 6 ? ((d = el(g, p.mode, y)), (d.return = p), d) : ((d = r(d, g)), (d.return = p), d);
  }
  function l(p, d, g, y) {
    var b = g.type;
    return b === Ri
      ? u(p, d, g.props.children, y, g.key)
      : d !== null &&
          (d.elementType === b || (typeof b == 'object' && b !== null && b.$$typeof === Sn && zd(b) === d.type))
        ? ((y = r(d, g.props)), (y.ref = Ar(p, d, g)), (y.return = p), y)
        : ((y = ea(g.type, g.key, g.props, null, p.mode, y)), (y.ref = Ar(p, d, g)), (y.return = p), y);
  }
  function c(p, d, g, y) {
    return d === null ||
      d.tag !== 4 ||
      d.stateNode.containerInfo !== g.containerInfo ||
      d.stateNode.implementation !== g.implementation
      ? ((d = tl(g, p.mode, y)), (d.return = p), d)
      : ((d = r(d, g.children || [])), (d.return = p), d);
  }
  function u(p, d, g, y, b) {
    return d === null || d.tag !== 7
      ? ((d = ii(g, p.mode, y, b)), (d.return = p), d)
      : ((d = r(d, g)), (d.return = p), d);
  }
  function m(p, d, g) {
    if ((typeof d == 'string' && d !== '') || typeof d == 'number')
      return (d = el('' + d, p.mode, g)), (d.return = p), d;
    if (typeof d == 'object' && d !== null) {
      switch (d.$$typeof) {
        case ko:
          return (g = ea(d.type, d.key, d.props, null, p.mode, g)), (g.ref = Ar(p, null, d)), (g.return = p), g;
        case Ti:
          return (d = tl(d, p.mode, g)), (d.return = p), d;
        case Sn:
          var y = d._init;
          return m(p, y(d._payload), g);
      }
      if (Tr(d) || vr(d)) return (d = ii(d, p.mode, g, null)), (d.return = p), d;
      Oo(p, d);
    }
    return null;
  }
  function h(p, d, g, y) {
    var b = d !== null ? d.key : null;
    if ((typeof g == 'string' && g !== '') || typeof g == 'number') return b !== null ? null : s(p, d, '' + g, y);
    if (typeof g == 'object' && g !== null) {
      switch (g.$$typeof) {
        case ko:
          return g.key === b ? l(p, d, g, y) : null;
        case Ti:
          return g.key === b ? c(p, d, g, y) : null;
        case Sn:
          return (b = g._init), h(p, d, b(g._payload), y);
      }
      if (Tr(g) || vr(g)) return b !== null ? null : u(p, d, g, y, null);
      Oo(p, g);
    }
    return null;
  }
  function v(p, d, g, y, b) {
    if ((typeof y == 'string' && y !== '') || typeof y == 'number') return (p = p.get(g) || null), s(d, p, '' + y, b);
    if (typeof y == 'object' && y !== null) {
      switch (y.$$typeof) {
        case ko:
          return (p = p.get(y.key === null ? g : y.key) || null), l(d, p, y, b);
        case Ti:
          return (p = p.get(y.key === null ? g : y.key) || null), c(d, p, y, b);
        case Sn:
          var C = y._init;
          return v(p, d, g, C(y._payload), b);
      }
      if (Tr(y) || vr(y)) return (p = p.get(g) || null), u(d, p, y, b, null);
      Oo(d, y);
    }
    return null;
  }
  function x(p, d, g, y) {
    for (var b = null, C = null, R = d, z = (d = 0), Y = null; R !== null && z < g.length; z++) {
      R.index > z ? ((Y = R), (R = null)) : (Y = R.sibling);
      var W = h(p, R, g[z], y);
      if (W === null) {
        R === null && (R = Y);
        break;
      }
      e && R && W.alternate === null && t(p, R),
        (d = o(W, d, z)),
        C === null ? (b = W) : (C.sibling = W),
        (C = W),
        (R = Y);
    }
    if (z === g.length) return n(p, R), ge && Kn(p, z), b;
    if (R === null) {
      for (; z < g.length; z++)
        (R = m(p, g[z], y)), R !== null && ((d = o(R, d, z)), C === null ? (b = R) : (C.sibling = R), (C = R));
      return ge && Kn(p, z), b;
    }
    for (R = i(p, R); z < g.length; z++)
      (Y = v(R, p, z, g[z], y)),
        Y !== null &&
          (e && Y.alternate !== null && R.delete(Y.key === null ? z : Y.key),
          (d = o(Y, d, z)),
          C === null ? (b = Y) : (C.sibling = Y),
          (C = Y));
    return (
      e &&
        R.forEach(function (Ne) {
          return t(p, Ne);
        }),
      ge && Kn(p, z),
      b
    );
  }
  function f(p, d, g, y) {
    var b = vr(g);
    if (typeof b != 'function') throw Error(S(150));
    if (((g = b.call(g)), g == null)) throw Error(S(151));
    for (var C = (b = null), R = d, z = (d = 0), Y = null, W = g.next(); R !== null && !W.done; z++, W = g.next()) {
      R.index > z ? ((Y = R), (R = null)) : (Y = R.sibling);
      var Ne = h(p, R, W.value, y);
      if (Ne === null) {
        R === null && (R = Y);
        break;
      }
      e && R && Ne.alternate === null && t(p, R),
        (d = o(Ne, d, z)),
        C === null ? (b = Ne) : (C.sibling = Ne),
        (C = Ne),
        (R = Y);
    }
    if (W.done) return n(p, R), ge && Kn(p, z), b;
    if (R === null) {
      for (; !W.done; z++, W = g.next())
        (W = m(p, W.value, y)), W !== null && ((d = o(W, d, z)), C === null ? (b = W) : (C.sibling = W), (C = W));
      return ge && Kn(p, z), b;
    }
    for (R = i(p, R); !W.done; z++, W = g.next())
      (W = v(R, p, z, W.value, y)),
        W !== null &&
          (e && W.alternate !== null && R.delete(W.key === null ? z : W.key),
          (d = o(W, d, z)),
          C === null ? (b = W) : (C.sibling = W),
          (C = W));
    return (
      e &&
        R.forEach(function (Ae) {
          return t(p, Ae);
        }),
      ge && Kn(p, z),
      b
    );
  }
  function D(p, d, g, y) {
    if (
      (typeof g == 'object' && g !== null && g.type === Ri && g.key === null && (g = g.props.children),
      typeof g == 'object' && g !== null)
    ) {
      switch (g.$$typeof) {
        case ko:
          e: {
            for (var b = g.key, C = d; C !== null; ) {
              if (C.key === b) {
                if (((b = g.type), b === Ri)) {
                  if (C.tag === 7) {
                    n(p, C.sibling), (d = r(C, g.props.children)), (d.return = p), (p = d);
                    break e;
                  }
                } else if (
                  C.elementType === b ||
                  (typeof b == 'object' && b !== null && b.$$typeof === Sn && zd(b) === C.type)
                ) {
                  n(p, C.sibling), (d = r(C, g.props)), (d.ref = Ar(p, C, g)), (d.return = p), (p = d);
                  break e;
                }
                n(p, C);
                break;
              } else t(p, C);
              C = C.sibling;
            }
            g.type === Ri
              ? ((d = ii(g.props.children, p.mode, y, g.key)), (d.return = p), (p = d))
              : ((y = ea(g.type, g.key, g.props, null, p.mode, y)), (y.ref = Ar(p, d, g)), (y.return = p), (p = y));
          }
          return a(p);
        case Ti:
          e: {
            for (C = g.key; d !== null; ) {
              if (d.key === C)
                if (
                  d.tag === 4 &&
                  d.stateNode.containerInfo === g.containerInfo &&
                  d.stateNode.implementation === g.implementation
                ) {
                  n(p, d.sibling), (d = r(d, g.children || [])), (d.return = p), (p = d);
                  break e;
                } else {
                  n(p, d);
                  break;
                }
              else t(p, d);
              d = d.sibling;
            }
            (d = tl(g, p.mode, y)), (d.return = p), (p = d);
          }
          return a(p);
        case Sn:
          return (C = g._init), D(p, d, C(g._payload), y);
      }
      if (Tr(g)) return x(p, d, g, y);
      if (vr(g)) return f(p, d, g, y);
      Oo(p, g);
    }
    return (typeof g == 'string' && g !== '') || typeof g == 'number'
      ? ((g = '' + g),
        d !== null && d.tag === 6
          ? (n(p, d.sibling), (d = r(d, g)), (d.return = p), (p = d))
          : (n(p, d), (d = el(g, p.mode, y)), (d.return = p), (p = d)),
        a(p))
      : n(p, d);
  }
  return D;
}
var Zi = hm(!0),
  mm = hm(!1),
  co = {},
  Zt = Un(co),
  Yr = Un(co),
  eo = Un(co);
function ei(e) {
  if (e === co) throw Error(S(174));
  return e;
}
function Wc(e, t) {
  switch ((pe(eo, t), pe(Yr, e), pe(Zt, co), (e = t.nodeType), e)) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : wl(null, '');
      break;
    default:
      (e = e === 8 ? t.parentNode : t), (t = e.namespaceURI || null), (e = e.tagName), (t = wl(t, e));
  }
  fe(Zt), pe(Zt, t);
}
function Yi() {
  fe(Zt), fe(Yr), fe(eo);
}
function fm(e) {
  ei(eo.current);
  var t = ei(Zt.current),
    n = wl(t, e.type);
  t !== n && (pe(Yr, e), pe(Zt, n));
}
function Kc(e) {
  Yr.current === e && (fe(Zt), fe(Yr));
}
var _e = Un(0);
function xa(e) {
  for (var t = e; t !== null; ) {
    if (t.tag === 13) {
      var n = t.memoizedState;
      if (n !== null && ((n = n.dehydrated), n === null || n.data === '$?' || n.data === '$!')) return t;
    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
      if ((t.flags & 128) !== 0) return t;
    } else if (t.child !== null) {
      (t.child.return = t), (t = t.child);
      continue;
    }
    if (t === e) break;
    for (; t.sibling === null; ) {
      if (t.return === null || t.return === e) return null;
      t = t.return;
    }
    (t.sibling.return = t.return), (t = t.sibling);
  }
  return null;
}
var Qs = [];
function Xc() {
  for (var e = 0; e < Qs.length; e++) Qs[e]._workInProgressVersionPrimary = null;
  Qs.length = 0;
}
var Wo = vn.ReactCurrentDispatcher,
  Ws = vn.ReactCurrentBatchConfig,
  li = 0,
  xe = null,
  Pe = null,
  He = null,
  Ea = !1,
  Hr = !1,
  to = 0,
  h_ = 0;
function Ke() {
  throw Error(S(321));
}
function Zc(e, t) {
  if (t === null) return !1;
  for (var n = 0; n < t.length && n < e.length; n++) if (!zt(e[n], t[n])) return !1;
  return !0;
}
function Yc(e, t, n, i, r, o) {
  if (
    ((li = o),
    (xe = t),
    (t.memoizedState = null),
    (t.updateQueue = null),
    (t.lanes = 0),
    (Wo.current = e === null || e.memoizedState === null ? v_ : __),
    (e = n(i, r)),
    Hr)
  ) {
    o = 0;
    do {
      if (((Hr = !1), (to = 0), 25 <= o)) throw Error(S(301));
      (o += 1), (He = Pe = null), (t.updateQueue = null), (Wo.current = x_), (e = n(i, r));
    } while (Hr);
  }
  if (((Wo.current = ya), (t = Pe !== null && Pe.next !== null), (li = 0), (He = Pe = xe = null), (Ea = !1), t))
    throw Error(S(300));
  return e;
}
function eu() {
  var e = to !== 0;
  return (to = 0), e;
}
function Vt() {
  var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  return He === null ? (xe.memoizedState = He = e) : (He = He.next = e), He;
}
function Nt() {
  if (Pe === null) {
    var e = xe.alternate;
    e = e !== null ? e.memoizedState : null;
  } else e = Pe.next;
  var t = He === null ? xe.memoizedState : He.next;
  if (t !== null) (He = t), (Pe = e);
  else {
    if (e === null) throw Error(S(310));
    (Pe = e),
      (e = {
        memoizedState: Pe.memoizedState,
        baseState: Pe.baseState,
        baseQueue: Pe.baseQueue,
        queue: Pe.queue,
        next: null,
      }),
      He === null ? (xe.memoizedState = He = e) : (He = He.next = e);
  }
  return He;
}
function no(e, t) {
  return typeof t == 'function' ? t(e) : t;
}
function Ks(e) {
  var t = Nt(),
    n = t.queue;
  if (n === null) throw Error(S(311));
  n.lastRenderedReducer = e;
  var i = Pe,
    r = i.baseQueue,
    o = n.pending;
  if (o !== null) {
    if (r !== null) {
      var a = r.next;
      (r.next = o.next), (o.next = a);
    }
    (i.baseQueue = r = o), (n.pending = null);
  }
  if (r !== null) {
    (o = r.next), (i = i.baseState);
    var s = (a = null),
      l = null,
      c = o;
    do {
      var u = c.lane;
      if ((li & u) === u)
        l !== null &&
          (l = l.next =
            { lane: 0, action: c.action, hasEagerState: c.hasEagerState, eagerState: c.eagerState, next: null }),
          (i = c.hasEagerState ? c.eagerState : e(i, c.action));
      else {
        var m = { lane: u, action: c.action, hasEagerState: c.hasEagerState, eagerState: c.eagerState, next: null };
        l === null ? ((s = l = m), (a = i)) : (l = l.next = m), (xe.lanes |= u), (ci |= u);
      }
      c = c.next;
    } while (c !== null && c !== o);
    l === null ? (a = i) : (l.next = s),
      zt(i, t.memoizedState) || (pt = !0),
      (t.memoizedState = i),
      (t.baseState = a),
      (t.baseQueue = l),
      (n.lastRenderedState = i);
  }
  if (((e = n.interleaved), e !== null)) {
    r = e;
    do (o = r.lane), (xe.lanes |= o), (ci |= o), (r = r.next);
    while (r !== e);
  } else r === null && (n.lanes = 0);
  return [t.memoizedState, n.dispatch];
}
function Xs(e) {
  var t = Nt(),
    n = t.queue;
  if (n === null) throw Error(S(311));
  n.lastRenderedReducer = e;
  var i = n.dispatch,
    r = n.pending,
    o = t.memoizedState;
  if (r !== null) {
    n.pending = null;
    var a = (r = r.next);
    do (o = e(o, a.action)), (a = a.next);
    while (a !== r);
    zt(o, t.memoizedState) || (pt = !0),
      (t.memoizedState = o),
      t.baseQueue === null && (t.baseState = o),
      (n.lastRenderedState = o);
  }
  return [o, i];
}
function gm() {}
function vm(e, t) {
  var n = xe,
    i = Nt(),
    r = t(),
    o = !zt(i.memoizedState, r);
  if (
    (o && ((i.memoizedState = r), (pt = !0)),
    (i = i.queue),
    tu(Em.bind(null, n, i, e), [e]),
    i.getSnapshot !== t || o || (He !== null && He.memoizedState.tag & 1))
  ) {
    if (((n.flags |= 2048), io(9, xm.bind(null, n, i, r, t), void 0, null), Fe === null)) throw Error(S(349));
    (li & 30) !== 0 || _m(n, t, r);
  }
  return r;
}
function _m(e, t, n) {
  (e.flags |= 16384),
    (e = { getSnapshot: t, value: n }),
    (t = xe.updateQueue),
    t === null
      ? ((t = { lastEffect: null, stores: null }), (xe.updateQueue = t), (t.stores = [e]))
      : ((n = t.stores), n === null ? (t.stores = [e]) : n.push(e));
}
function xm(e, t, n, i) {
  (t.value = n), (t.getSnapshot = i), ym(t) && Am(e);
}
function Em(e, t, n) {
  return n(function () {
    ym(t) && Am(e);
  });
}
function ym(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !zt(e, n);
  } catch {
    return !0;
  }
}
function Am(e) {
  var t = hn(e, 1);
  t !== null && jt(t, e, 1, -1);
}
function Bd(e) {
  var t = Vt();
  return (
    typeof e == 'function' && (e = e()),
    (t.memoizedState = t.baseState = e),
    (e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: no, lastRenderedState: e }),
    (t.queue = e),
    (e = e.dispatch = g_.bind(null, xe, e)),
    [t.memoizedState, e]
  );
}
function io(e, t, n, i) {
  return (
    (e = { tag: e, create: t, destroy: n, deps: i, next: null }),
    (t = xe.updateQueue),
    t === null
      ? ((t = { lastEffect: null, stores: null }), (xe.updateQueue = t), (t.lastEffect = e.next = e))
      : ((n = t.lastEffect),
        n === null ? (t.lastEffect = e.next = e) : ((i = n.next), (n.next = e), (e.next = i), (t.lastEffect = e))),
    e
  );
}
function wm() {
  return Nt().memoizedState;
}
function Ko(e, t, n, i) {
  var r = Vt();
  (xe.flags |= e), (r.memoizedState = io(1 | t, n, void 0, i === void 0 ? null : i));
}
function Ha(e, t, n, i) {
  var r = Nt();
  i = i === void 0 ? null : i;
  var o = void 0;
  if (Pe !== null) {
    var a = Pe.memoizedState;
    if (((o = a.destroy), i !== null && Zc(i, a.deps))) {
      r.memoizedState = io(t, n, o, i);
      return;
    }
  }
  (xe.flags |= e), (r.memoizedState = io(1 | t, n, o, i));
}
function Ud(e, t) {
  return Ko(8390656, 8, e, t);
}
function tu(e, t) {
  return Ha(2048, 8, e, t);
}
function km(e, t) {
  return Ha(4, 2, e, t);
}
function Sm(e, t) {
  return Ha(4, 4, e, t);
}
function bm(e, t) {
  if (typeof t == 'function')
    return (
      (e = e()),
      t(e),
      function () {
        t(null);
      }
    );
  if (t != null)
    return (
      (e = e()),
      (t.current = e),
      function () {
        t.current = null;
      }
    );
}
function Mm(e, t, n) {
  return (n = n != null ? n.concat([e]) : null), Ha(4, 4, bm.bind(null, t, e), n);
}
function nu() {}
function Tm(e, t) {
  var n = Nt();
  t = t === void 0 ? null : t;
  var i = n.memoizedState;
  return i !== null && t !== null && Zc(t, i[1]) ? i[0] : ((n.memoizedState = [e, t]), e);
}
function Rm(e, t) {
  var n = Nt();
  t = t === void 0 ? null : t;
  var i = n.memoizedState;
  return i !== null && t !== null && Zc(t, i[1]) ? i[0] : ((e = e()), (n.memoizedState = [e, t]), e);
}
function Pm(e, t, n) {
  return (li & 21) === 0
    ? (e.baseState && ((e.baseState = !1), (pt = !0)), (e.memoizedState = n))
    : (zt(n, t) || ((n = Ih()), (xe.lanes |= n), (ci |= n), (e.baseState = !0)), t);
}
function m_(e, t) {
  var n = se;
  (se = n !== 0 && 4 > n ? n : 4), e(!0);
  var i = Ws.transition;
  Ws.transition = {};
  try {
    e(!1), t();
  } finally {
    (se = n), (Ws.transition = i);
  }
}
function Cm() {
  return Nt().memoizedState;
}
function f_(e, t, n) {
  var i = Hn(e);
  if (((n = { lane: i, action: n, hasEagerState: !1, eagerState: null, next: null }), Nm(e))) Im(t, n);
  else if (((n = cm(e, t, n, i)), n !== null)) {
    var r = ot();
    jt(n, e, i, r), Dm(n, t, i);
  }
}
function g_(e, t, n) {
  var i = Hn(e),
    r = { lane: i, action: n, hasEagerState: !1, eagerState: null, next: null };
  if (Nm(e)) Im(t, r);
  else {
    var o = e.alternate;
    if (e.lanes === 0 && (o === null || o.lanes === 0) && ((o = t.lastRenderedReducer), o !== null))
      try {
        var a = t.lastRenderedState,
          s = o(a, n);
        if (((r.hasEagerState = !0), (r.eagerState = s), zt(s, a))) {
          var l = t.interleaved;
          l === null ? ((r.next = r), qc(t)) : ((r.next = l.next), (l.next = r)), (t.interleaved = r);
          return;
        }
      } catch {
      } finally {
      }
    (n = cm(e, t, r, i)), n !== null && ((r = ot()), jt(n, e, i, r), Dm(n, t, i));
  }
}
function Nm(e) {
  var t = e.alternate;
  return e === xe || (t !== null && t === xe);
}
function Im(e, t) {
  Hr = Ea = !0;
  var n = e.pending;
  n === null ? (t.next = t) : ((t.next = n.next), (n.next = t)), (e.pending = t);
}
function Dm(e, t, n) {
  if ((n & 4194240) !== 0) {
    var i = t.lanes;
    (i &= e.pendingLanes), (n |= i), (t.lanes = n), Ic(e, n);
  }
}
var ya = {
    readContext: Ct,
    useCallback: Ke,
    useContext: Ke,
    useEffect: Ke,
    useImperativeHandle: Ke,
    useInsertionEffect: Ke,
    useLayoutEffect: Ke,
    useMemo: Ke,
    useReducer: Ke,
    useRef: Ke,
    useState: Ke,
    useDebugValue: Ke,
    useDeferredValue: Ke,
    useTransition: Ke,
    useMutableSource: Ke,
    useSyncExternalStore: Ke,
    useId: Ke,
    unstable_isNewReconciler: !1,
  },
  v_ = {
    readContext: Ct,
    useCallback: function (e, t) {
      return (Vt().memoizedState = [e, t === void 0 ? null : t]), e;
    },
    useContext: Ct,
    useEffect: Ud,
    useImperativeHandle: function (e, t, n) {
      return (n = n != null ? n.concat([e]) : null), Ko(4194308, 4, bm.bind(null, t, e), n);
    },
    useLayoutEffect: function (e, t) {
      return Ko(4194308, 4, e, t);
    },
    useInsertionEffect: function (e, t) {
      return Ko(4, 2, e, t);
    },
    useMemo: function (e, t) {
      var n = Vt();
      return (t = t === void 0 ? null : t), (e = e()), (n.memoizedState = [e, t]), e;
    },
    useReducer: function (e, t, n) {
      var i = Vt();
      return (
        (t = n !== void 0 ? n(t) : t),
        (i.memoizedState = i.baseState = t),
        (e = {
          pending: null,
          interleaved: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: e,
          lastRenderedState: t,
        }),
        (i.queue = e),
        (e = e.dispatch = f_.bind(null, xe, e)),
        [i.memoizedState, e]
      );
    },
    useRef: function (e) {
      var t = Vt();
      return (e = { current: e }), (t.memoizedState = e);
    },
    useState: Bd,
    useDebugValue: nu,
    useDeferredValue: function (e) {
      return (Vt().memoizedState = e);
    },
    useTransition: function () {
      var e = Bd(!1),
        t = e[0];
      return (e = m_.bind(null, e[1])), (Vt().memoizedState = e), [t, e];
    },
    useMutableSource: function () {},
    useSyncExternalStore: function (e, t, n) {
      var i = xe,
        r = Vt();
      if (ge) {
        if (n === void 0) throw Error(S(407));
        n = n();
      } else {
        if (((n = t()), Fe === null)) throw Error(S(349));
        (li & 30) !== 0 || _m(i, t, n);
      }
      r.memoizedState = n;
      var o = { value: n, getSnapshot: t };
      return (
        (r.queue = o),
        Ud(Em.bind(null, i, o, e), [e]),
        (i.flags |= 2048),
        io(9, xm.bind(null, i, o, n, t), void 0, null),
        n
      );
    },
    useId: function () {
      var e = Vt(),
        t = Fe.identifierPrefix;
      if (ge) {
        var n = cn,
          i = ln;
        (n = (i & ~(1 << (32 - Ft(i) - 1))).toString(32) + n),
          (t = ':' + t + 'R' + n),
          (n = to++),
          0 < n && (t += 'H' + n.toString(32)),
          (t += ':');
      } else (n = h_++), (t = ':' + t + 'r' + n.toString(32) + ':');
      return (e.memoizedState = t);
    },
    unstable_isNewReconciler: !1,
  },
  __ = {
    readContext: Ct,
    useCallback: Tm,
    useContext: Ct,
    useEffect: tu,
    useImperativeHandle: Mm,
    useInsertionEffect: km,
    useLayoutEffect: Sm,
    useMemo: Rm,
    useReducer: Ks,
    useRef: wm,
    useState: function () {
      return Ks(no);
    },
    useDebugValue: nu,
    useDeferredValue: function (e) {
      var t = Nt();
      return Pm(t, Pe.memoizedState, e);
    },
    useTransition: function () {
      var e = Ks(no)[0],
        t = Nt().memoizedState;
      return [e, t];
    },
    useMutableSource: gm,
    useSyncExternalStore: vm,
    useId: Cm,
    unstable_isNewReconciler: !1,
  },
  x_ = {
    readContext: Ct,
    useCallback: Tm,
    useContext: Ct,
    useEffect: tu,
    useImperativeHandle: Mm,
    useInsertionEffect: km,
    useLayoutEffect: Sm,
    useMemo: Rm,
    useReducer: Xs,
    useRef: wm,
    useState: function () {
      return Xs(no);
    },
    useDebugValue: nu,
    useDeferredValue: function (e) {
      var t = Nt();
      return Pe === null ? (t.memoizedState = e) : Pm(t, Pe.memoizedState, e);
    },
    useTransition: function () {
      var e = Xs(no)[0],
        t = Nt().memoizedState;
      return [e, t];
    },
    useMutableSource: gm,
    useSyncExternalStore: vm,
    useId: Cm,
    unstable_isNewReconciler: !1,
  };
function er(e, t) {
  try {
    var n = '',
      i = t;
    do (n += qg(i)), (i = i.return);
    while (i);
    var r = n;
  } catch (o) {
    r =
      `
Error generating stack: ` +
      o.message +
      `
` +
      o.stack;
  }
  return { value: e, source: t, stack: r, digest: null };
}
function Zs(e, t, n) {
  return { value: e, source: null, stack: n != null ? n : null, digest: t != null ? t : null };
}
function Vl(e, t) {
  try {
    console.error(t.value);
  } catch (n) {
    setTimeout(function () {
      throw n;
    });
  }
}
var E_ = typeof WeakMap == 'function' ? WeakMap : Map;
function Om(e, t, n) {
  (n = un(-1, n)), (n.tag = 3), (n.payload = { element: null });
  var i = t.value;
  return (
    (n.callback = function () {
      wa || ((wa = !0), (nc = i)), Vl(e, t);
    }),
    n
  );
}
function Lm(e, t, n) {
  (n = un(-1, n)), (n.tag = 3);
  var i = e.type.getDerivedStateFromError;
  if (typeof i == 'function') {
    var r = t.value;
    (n.payload = function () {
      return i(r);
    }),
      (n.callback = function () {
        Vl(e, t);
      });
  }
  var o = e.stateNode;
  return (
    o !== null &&
      typeof o.componentDidCatch == 'function' &&
      (n.callback = function () {
        Vl(e, t), typeof i != 'function' && (Ln === null ? (Ln = new Set([this])) : Ln.add(this));
        var a = t.stack;
        this.componentDidCatch(t.value, { componentStack: a !== null ? a : '' });
      }),
    n
  );
}
function $d(e, t, n) {
  var i = e.pingCache;
  if (i === null) {
    i = e.pingCache = new E_();
    var r = new Set();
    i.set(t, r);
  } else (r = i.get(t)), r === void 0 && ((r = new Set()), i.set(t, r));
  r.has(n) || (r.add(n), (e = D_.bind(null, e, t, n)), t.then(e, e));
}
function Gd(e) {
  do {
    var t;
    if (((t = e.tag === 13) && ((t = e.memoizedState), (t = t !== null ? t.dehydrated !== null : !0)), t)) return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function Jd(e, t, n, i, r) {
  return (e.mode & 1) === 0
    ? (e === t
        ? (e.flags |= 65536)
        : ((e.flags |= 128),
          (n.flags |= 131072),
          (n.flags &= -52805),
          n.tag === 1 && (n.alternate === null ? (n.tag = 17) : ((t = un(-1, 1)), (t.tag = 2), On(n, t, 1))),
          (n.lanes |= 1)),
      e)
    : ((e.flags |= 65536), (e.lanes = r), e);
}
var y_ = vn.ReactCurrentOwner,
  pt = !1;
function rt(e, t, n, i) {
  t.child = e === null ? mm(t, null, n, i) : Zi(t, e.child, n, i);
}
function Vd(e, t, n, i, r) {
  n = n.render;
  var o = t.ref;
  return (
    Vi(t, r),
    (i = Yc(e, t, n, i, o, r)),
    (n = eu()),
    e !== null && !pt
      ? ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~r), mn(e, t, r))
      : (ge && n && Bc(t), (t.flags |= 1), rt(e, t, i, r), t.child)
  );
}
function qd(e, t, n, i, r) {
  if (e === null) {
    var o = n.type;
    return typeof o == 'function' &&
      !uu(o) &&
      o.defaultProps === void 0 &&
      n.compare === null &&
      n.defaultProps === void 0
      ? ((t.tag = 15), (t.type = o), Hm(e, t, o, i, r))
      : ((e = ea(n.type, null, i, t, t.mode, r)), (e.ref = t.ref), (e.return = t), (t.child = e));
  }
  if (((o = e.child), (e.lanes & r) === 0)) {
    var a = o.memoizedProps;
    if (((n = n.compare), (n = n !== null ? n : Wr), n(a, i) && e.ref === t.ref)) return mn(e, t, r);
  }
  return (t.flags |= 1), (e = Fn(o, i)), (e.ref = t.ref), (e.return = t), (t.child = e);
}
function Hm(e, t, n, i, r) {
  if (e !== null) {
    var o = e.memoizedProps;
    if (Wr(o, i) && e.ref === t.ref)
      if (((pt = !1), (t.pendingProps = i = o), (e.lanes & r) !== 0)) (e.flags & 131072) !== 0 && (pt = !0);
      else return (t.lanes = e.lanes), mn(e, t, r);
  }
  return ql(e, t, n, i, r);
}
function Fm(e, t, n) {
  var i = t.pendingProps,
    r = i.children,
    o = e !== null ? e.memoizedState : null;
  if (i.mode === 'hidden')
    if ((t.mode & 1) === 0)
      (t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }), pe(ji, xt), (xt |= n);
    else {
      if ((n & 1073741824) === 0)
        return (
          (e = o !== null ? o.baseLanes | n : n),
          (t.lanes = t.childLanes = 1073741824),
          (t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }),
          (t.updateQueue = null),
          pe(ji, xt),
          (xt |= e),
          null
        );
      (t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
        (i = o !== null ? o.baseLanes : n),
        pe(ji, xt),
        (xt |= i);
    }
  else o !== null ? ((i = o.baseLanes | n), (t.memoizedState = null)) : (i = n), pe(ji, xt), (xt |= i);
  return rt(e, t, r, n), t.child;
}
function jm(e, t) {
  var n = t.ref;
  ((e === null && n !== null) || (e !== null && e.ref !== n)) && ((t.flags |= 512), (t.flags |= 2097152));
}
function ql(e, t, n, i, r) {
  var o = mt(n) ? ai : et.current;
  return (
    (o = Ki(t, o)),
    Vi(t, r),
    (n = Yc(e, t, n, i, o, r)),
    (i = eu()),
    e !== null && !pt
      ? ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~r), mn(e, t, r))
      : (ge && i && Bc(t), (t.flags |= 1), rt(e, t, n, r), t.child)
  );
}
function Qd(e, t, n, i, r) {
  if (mt(n)) {
    var o = !0;
    ha(t);
  } else o = !1;
  if ((Vi(t, r), t.stateNode === null)) Xo(e, t), pm(t, n, i), Jl(t, n, i, r), (i = !0);
  else if (e === null) {
    var a = t.stateNode,
      s = t.memoizedProps;
    a.props = s;
    var l = a.context,
      c = n.contextType;
    typeof c == 'object' && c !== null ? (c = Ct(c)) : ((c = mt(n) ? ai : et.current), (c = Ki(t, c)));
    var u = n.getDerivedStateFromProps,
      m = typeof u == 'function' || typeof a.getSnapshotBeforeUpdate == 'function';
    m ||
      (typeof a.UNSAFE_componentWillReceiveProps != 'function' && typeof a.componentWillReceiveProps != 'function') ||
      ((s !== i || l !== c) && jd(t, a, i, c)),
      (bn = !1);
    var h = t.memoizedState;
    (a.state = h),
      _a(t, i, a, r),
      (l = t.memoizedState),
      s !== i || h !== l || ht.current || bn
        ? (typeof u == 'function' && (Gl(t, n, u, i), (l = t.memoizedState)),
          (s = bn || Fd(t, n, s, i, h, l, c))
            ? (m ||
                (typeof a.UNSAFE_componentWillMount != 'function' && typeof a.componentWillMount != 'function') ||
                (typeof a.componentWillMount == 'function' && a.componentWillMount(),
                typeof a.UNSAFE_componentWillMount == 'function' && a.UNSAFE_componentWillMount()),
              typeof a.componentDidMount == 'function' && (t.flags |= 4194308))
            : (typeof a.componentDidMount == 'function' && (t.flags |= 4194308),
              (t.memoizedProps = i),
              (t.memoizedState = l)),
          (a.props = i),
          (a.state = l),
          (a.context = c),
          (i = s))
        : (typeof a.componentDidMount == 'function' && (t.flags |= 4194308), (i = !1));
  } else {
    (a = t.stateNode),
      um(e, t),
      (s = t.memoizedProps),
      (c = t.type === t.elementType ? s : Ot(t.type, s)),
      (a.props = c),
      (m = t.pendingProps),
      (h = a.context),
      (l = n.contextType),
      typeof l == 'object' && l !== null ? (l = Ct(l)) : ((l = mt(n) ? ai : et.current), (l = Ki(t, l)));
    var v = n.getDerivedStateFromProps;
    (u = typeof v == 'function' || typeof a.getSnapshotBeforeUpdate == 'function') ||
      (typeof a.UNSAFE_componentWillReceiveProps != 'function' && typeof a.componentWillReceiveProps != 'function') ||
      ((s !== m || h !== l) && jd(t, a, i, l)),
      (bn = !1),
      (h = t.memoizedState),
      (a.state = h),
      _a(t, i, a, r);
    var x = t.memoizedState;
    s !== m || h !== x || ht.current || bn
      ? (typeof v == 'function' && (Gl(t, n, v, i), (x = t.memoizedState)),
        (c = bn || Fd(t, n, c, i, h, x, l) || !1)
          ? (u ||
              (typeof a.UNSAFE_componentWillUpdate != 'function' && typeof a.componentWillUpdate != 'function') ||
              (typeof a.componentWillUpdate == 'function' && a.componentWillUpdate(i, x, l),
              typeof a.UNSAFE_componentWillUpdate == 'function' && a.UNSAFE_componentWillUpdate(i, x, l)),
            typeof a.componentDidUpdate == 'function' && (t.flags |= 4),
            typeof a.getSnapshotBeforeUpdate == 'function' && (t.flags |= 1024))
          : (typeof a.componentDidUpdate != 'function' ||
              (s === e.memoizedProps && h === e.memoizedState) ||
              (t.flags |= 4),
            typeof a.getSnapshotBeforeUpdate != 'function' ||
              (s === e.memoizedProps && h === e.memoizedState) ||
              (t.flags |= 1024),
            (t.memoizedProps = i),
            (t.memoizedState = x)),
        (a.props = i),
        (a.state = x),
        (a.context = l),
        (i = c))
      : (typeof a.componentDidUpdate != 'function' ||
          (s === e.memoizedProps && h === e.memoizedState) ||
          (t.flags |= 4),
        typeof a.getSnapshotBeforeUpdate != 'function' ||
          (s === e.memoizedProps && h === e.memoizedState) ||
          (t.flags |= 1024),
        (i = !1));
  }
  return Ql(e, t, n, i, o, r);
}
function Ql(e, t, n, i, r, o) {
  jm(e, t);
  var a = (t.flags & 128) !== 0;
  if (!i && !a) return r && Id(t, n, !1), mn(e, t, o);
  (i = t.stateNode), (y_.current = t);
  var s = a && typeof n.getDerivedStateFromError != 'function' ? null : i.render();
  return (
    (t.flags |= 1),
    e !== null && a ? ((t.child = Zi(t, e.child, null, o)), (t.child = Zi(t, null, s, o))) : rt(e, t, s, o),
    (t.memoizedState = i.state),
    r && Id(t, n, !0),
    t.child
  );
}
function zm(e) {
  var t = e.stateNode;
  t.pendingContext ? Nd(e, t.pendingContext, t.pendingContext !== t.context) : t.context && Nd(e, t.context, !1),
    Wc(e, t.containerInfo);
}
function Wd(e, t, n, i, r) {
  return Xi(), $c(r), (t.flags |= 256), rt(e, t, n, i), t.child;
}
var Wl = { dehydrated: null, treeContext: null, retryLane: 0 };
function Kl(e) {
  return { baseLanes: e, cachePool: null, transitions: null };
}
function Bm(e, t, n) {
  var i = t.pendingProps,
    r = _e.current,
    o = !1,
    a = (t.flags & 128) !== 0,
    s;
  if (
    ((s = a) || (s = e !== null && e.memoizedState === null ? !1 : (r & 2) !== 0),
    s ? ((o = !0), (t.flags &= -129)) : (e === null || e.memoizedState !== null) && (r |= 1),
    pe(_e, r & 1),
    e === null)
  )
    return (
      Ul(t),
      (e = t.memoizedState),
      e !== null && ((e = e.dehydrated), e !== null)
        ? ((t.mode & 1) === 0 ? (t.lanes = 1) : e.data === '$!' ? (t.lanes = 8) : (t.lanes = 1073741824), null)
        : ((a = i.children),
          (e = i.fallback),
          o
            ? ((i = t.mode),
              (o = t.child),
              (a = { mode: 'hidden', children: a }),
              (i & 1) === 0 && o !== null ? ((o.childLanes = 0), (o.pendingProps = a)) : (o = za(a, i, 0, null)),
              (e = ii(e, i, n, null)),
              (o.return = t),
              (e.return = t),
              (o.sibling = e),
              (t.child = o),
              (t.child.memoizedState = Kl(n)),
              (t.memoizedState = Wl),
              e)
            : iu(t, a))
    );
  if (((r = e.memoizedState), r !== null && ((s = r.dehydrated), s !== null))) return A_(e, t, a, i, s, r, n);
  if (o) {
    (o = i.fallback), (a = t.mode), (r = e.child), (s = r.sibling);
    var l = { mode: 'hidden', children: i.children };
    return (
      (a & 1) === 0 && t.child !== r
        ? ((i = t.child), (i.childLanes = 0), (i.pendingProps = l), (t.deletions = null))
        : ((i = Fn(r, l)), (i.subtreeFlags = r.subtreeFlags & 14680064)),
      s !== null ? (o = Fn(s, o)) : ((o = ii(o, a, n, null)), (o.flags |= 2)),
      (o.return = t),
      (i.return = t),
      (i.sibling = o),
      (t.child = i),
      (i = o),
      (o = t.child),
      (a = e.child.memoizedState),
      (a = a === null ? Kl(n) : { baseLanes: a.baseLanes | n, cachePool: null, transitions: a.transitions }),
      (o.memoizedState = a),
      (o.childLanes = e.childLanes & ~n),
      (t.memoizedState = Wl),
      i
    );
  }
  return (
    (o = e.child),
    (e = o.sibling),
    (i = Fn(o, { mode: 'visible', children: i.children })),
    (t.mode & 1) === 0 && (i.lanes = n),
    (i.return = t),
    (i.sibling = null),
    e !== null && ((n = t.deletions), n === null ? ((t.deletions = [e]), (t.flags |= 16)) : n.push(e)),
    (t.child = i),
    (t.memoizedState = null),
    i
  );
}
function iu(e, t) {
  return (t = za({ mode: 'visible', children: t }, e.mode, 0, null)), (t.return = e), (e.child = t);
}
function Lo(e, t, n, i) {
  return (
    i !== null && $c(i),
    Zi(t, e.child, null, n),
    (e = iu(t, t.pendingProps.children)),
    (e.flags |= 2),
    (t.memoizedState = null),
    e
  );
}
function A_(e, t, n, i, r, o, a) {
  if (n)
    return t.flags & 256
      ? ((t.flags &= -257), (i = Zs(Error(S(422)))), Lo(e, t, a, i))
      : t.memoizedState !== null
        ? ((t.child = e.child), (t.flags |= 128), null)
        : ((o = i.fallback),
          (r = t.mode),
          (i = za({ mode: 'visible', children: i.children }, r, 0, null)),
          (o = ii(o, r, a, null)),
          (o.flags |= 2),
          (i.return = t),
          (o.return = t),
          (i.sibling = o),
          (t.child = i),
          (t.mode & 1) !== 0 && Zi(t, e.child, null, a),
          (t.child.memoizedState = Kl(a)),
          (t.memoizedState = Wl),
          o);
  if ((t.mode & 1) === 0) return Lo(e, t, a, null);
  if (r.data === '$!') {
    if (((i = r.nextSibling && r.nextSibling.dataset), i)) var s = i.dgst;
    return (i = s), (o = Error(S(419))), (i = Zs(o, i, void 0)), Lo(e, t, a, i);
  }
  if (((s = (a & e.childLanes) !== 0), pt || s)) {
    if (((i = Fe), i !== null)) {
      switch (a & -a) {
        case 4:
          r = 2;
          break;
        case 16:
          r = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          r = 32;
          break;
        case 536870912:
          r = 268435456;
          break;
        default:
          r = 0;
      }
      (r = (r & (i.suspendedLanes | a)) !== 0 ? 0 : r),
        r !== 0 && r !== o.retryLane && ((o.retryLane = r), hn(e, r), jt(i, e, r, -1));
    }
    return cu(), (i = Zs(Error(S(421)))), Lo(e, t, a, i);
  }
  return r.data === '$?'
    ? ((t.flags |= 128), (t.child = e.child), (t = O_.bind(null, e)), (r._reactRetry = t), null)
    : ((e = o.treeContext),
      (Et = Dn(r.nextSibling)),
      (yt = t),
      (ge = !0),
      (Ht = null),
      e !== null && ((Mt[Tt++] = ln), (Mt[Tt++] = cn), (Mt[Tt++] = si), (ln = e.id), (cn = e.overflow), (si = t)),
      (t = iu(t, i.children)),
      (t.flags |= 4096),
      t);
}
function Kd(e, t, n) {
  e.lanes |= t;
  var i = e.alternate;
  i !== null && (i.lanes |= t), $l(e.return, t, n);
}
function Ys(e, t, n, i, r) {
  var o = e.memoizedState;
  o === null
    ? (e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: i, tail: n, tailMode: r })
    : ((o.isBackwards = t),
      (o.rendering = null),
      (o.renderingStartTime = 0),
      (o.last = i),
      (o.tail = n),
      (o.tailMode = r));
}
function Um(e, t, n) {
  var i = t.pendingProps,
    r = i.revealOrder,
    o = i.tail;
  if ((rt(e, t, i.children, n), (i = _e.current), (i & 2) !== 0)) (i = (i & 1) | 2), (t.flags |= 128);
  else {
    if (e !== null && (e.flags & 128) !== 0)
      e: for (e = t.child; e !== null; ) {
        if (e.tag === 13) e.memoizedState !== null && Kd(e, n, t);
        else if (e.tag === 19) Kd(e, n, t);
        else if (e.child !== null) {
          (e.child.return = e), (e = e.child);
          continue;
        }
        if (e === t) break e;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) break e;
          e = e.return;
        }
        (e.sibling.return = e.return), (e = e.sibling);
      }
    i &= 1;
  }
  if ((pe(_e, i), (t.mode & 1) === 0)) t.memoizedState = null;
  else
    switch (r) {
      case 'forwards':
        for (n = t.child, r = null; n !== null; )
          (e = n.alternate), e !== null && xa(e) === null && (r = n), (n = n.sibling);
        (n = r),
          n === null ? ((r = t.child), (t.child = null)) : ((r = n.sibling), (n.sibling = null)),
          Ys(t, !1, r, n, o);
        break;
      case 'backwards':
        for (n = null, r = t.child, t.child = null; r !== null; ) {
          if (((e = r.alternate), e !== null && xa(e) === null)) {
            t.child = r;
            break;
          }
          (e = r.sibling), (r.sibling = n), (n = r), (r = e);
        }
        Ys(t, !0, n, null, o);
        break;
      case 'together':
        Ys(t, !1, null, null, void 0);
        break;
      default:
        t.memoizedState = null;
    }
  return t.child;
}
function Xo(e, t) {
  (t.mode & 1) === 0 && e !== null && ((e.alternate = null), (t.alternate = null), (t.flags |= 2));
}
function mn(e, t, n) {
  if ((e !== null && (t.dependencies = e.dependencies), (ci |= t.lanes), (n & t.childLanes) === 0)) return null;
  if (e !== null && t.child !== e.child) throw Error(S(153));
  if (t.child !== null) {
    for (e = t.child, n = Fn(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; )
      (e = e.sibling), (n = n.sibling = Fn(e, e.pendingProps)), (n.return = t);
    n.sibling = null;
  }
  return t.child;
}
function w_(e, t, n) {
  switch (t.tag) {
    case 3:
      zm(t), Xi();
      break;
    case 5:
      fm(t);
      break;
    case 1:
      mt(t.type) && ha(t);
      break;
    case 4:
      Wc(t, t.stateNode.containerInfo);
      break;
    case 10:
      var i = t.type._context,
        r = t.memoizedProps.value;
      pe(ga, i._currentValue), (i._currentValue = r);
      break;
    case 13:
      if (((i = t.memoizedState), i !== null))
        return i.dehydrated !== null
          ? (pe(_e, _e.current & 1), (t.flags |= 128), null)
          : (n & t.child.childLanes) !== 0
            ? Bm(e, t, n)
            : (pe(_e, _e.current & 1), (e = mn(e, t, n)), e !== null ? e.sibling : null);
      pe(_e, _e.current & 1);
      break;
    case 19:
      if (((i = (n & t.childLanes) !== 0), (e.flags & 128) !== 0)) {
        if (i) return Um(e, t, n);
        t.flags |= 128;
      }
      if (
        ((r = t.memoizedState),
        r !== null && ((r.rendering = null), (r.tail = null), (r.lastEffect = null)),
        pe(_e, _e.current),
        i)
      )
        break;
      return null;
    case 22:
    case 23:
      return (t.lanes = 0), Fm(e, t, n);
  }
  return mn(e, t, n);
}
var $m, Xl, Gm, Jm;
$m = function (e, t) {
  for (var n = t.child; n !== null; ) {
    if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
    else if (n.tag !== 4 && n.child !== null) {
      (n.child.return = n), (n = n.child);
      continue;
    }
    if (n === t) break;
    for (; n.sibling === null; ) {
      if (n.return === null || n.return === t) return;
      n = n.return;
    }
    (n.sibling.return = n.return), (n = n.sibling);
  }
};
Xl = function () {};
Gm = function (e, t, n, i) {
  var r = e.memoizedProps;
  if (r !== i) {
    (e = t.stateNode), ei(Zt.current);
    var o = null;
    switch (n) {
      case 'input':
        (r = xl(e, r)), (i = xl(e, i)), (o = []);
        break;
      case 'select':
        (r = Ee({}, r, { value: void 0 })), (i = Ee({}, i, { value: void 0 })), (o = []);
        break;
      case 'textarea':
        (r = Al(e, r)), (i = Al(e, i)), (o = []);
        break;
      default:
        typeof r.onClick != 'function' && typeof i.onClick == 'function' && (e.onclick = da);
    }
    kl(n, i);
    var a;
    n = null;
    for (c in r)
      if (!i.hasOwnProperty(c) && r.hasOwnProperty(c) && r[c] != null)
        if (c === 'style') {
          var s = r[c];
          for (a in s) s.hasOwnProperty(a) && (n || (n = {}), (n[a] = ''));
        } else
          c !== 'dangerouslySetInnerHTML' &&
            c !== 'children' &&
            c !== 'suppressContentEditableWarning' &&
            c !== 'suppressHydrationWarning' &&
            c !== 'autoFocus' &&
            (Ur.hasOwnProperty(c) ? o || (o = []) : (o = o || []).push(c, null));
    for (c in i) {
      var l = i[c];
      if (((s = r != null ? r[c] : void 0), i.hasOwnProperty(c) && l !== s && (l != null || s != null)))
        if (c === 'style')
          if (s) {
            for (a in s) !s.hasOwnProperty(a) || (l && l.hasOwnProperty(a)) || (n || (n = {}), (n[a] = ''));
            for (a in l) l.hasOwnProperty(a) && s[a] !== l[a] && (n || (n = {}), (n[a] = l[a]));
          } else n || (o || (o = []), o.push(c, n)), (n = l);
        else
          c === 'dangerouslySetInnerHTML'
            ? ((l = l ? l.__html : void 0),
              (s = s ? s.__html : void 0),
              l != null && s !== l && (o = o || []).push(c, l))
            : c === 'children'
              ? (typeof l != 'string' && typeof l != 'number') || (o = o || []).push(c, '' + l)
              : c !== 'suppressContentEditableWarning' &&
                c !== 'suppressHydrationWarning' &&
                (Ur.hasOwnProperty(c)
                  ? (l != null && c === 'onScroll' && he('scroll', e), o || s === l || (o = []))
                  : (o = o || []).push(c, l));
    }
    n && (o = o || []).push('style', n);
    var c = o;
    (t.updateQueue = c) && (t.flags |= 4);
  }
};
Jm = function (e, t, n, i) {
  n !== i && (t.flags |= 4);
};
function wr(e, t) {
  if (!ge)
    switch (e.tailMode) {
      case 'hidden':
        t = e.tail;
        for (var n = null; t !== null; ) t.alternate !== null && (n = t), (t = t.sibling);
        n === null ? (e.tail = null) : (n.sibling = null);
        break;
      case 'collapsed':
        n = e.tail;
        for (var i = null; n !== null; ) n.alternate !== null && (i = n), (n = n.sibling);
        i === null ? (t || e.tail === null ? (e.tail = null) : (e.tail.sibling = null)) : (i.sibling = null);
    }
}
function Xe(e) {
  var t = e.alternate !== null && e.alternate.child === e.child,
    n = 0,
    i = 0;
  if (t)
    for (var r = e.child; r !== null; )
      (n |= r.lanes | r.childLanes),
        (i |= r.subtreeFlags & 14680064),
        (i |= r.flags & 14680064),
        (r.return = e),
        (r = r.sibling);
  else
    for (r = e.child; r !== null; )
      (n |= r.lanes | r.childLanes), (i |= r.subtreeFlags), (i |= r.flags), (r.return = e), (r = r.sibling);
  return (e.subtreeFlags |= i), (e.childLanes = n), t;
}
function k_(e, t, n) {
  var i = t.pendingProps;
  switch ((Uc(t), t.tag)) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return Xe(t), null;
    case 1:
      return mt(t.type) && pa(), Xe(t), null;
    case 3:
      return (
        (i = t.stateNode),
        Yi(),
        fe(ht),
        fe(et),
        Xc(),
        i.pendingContext && ((i.context = i.pendingContext), (i.pendingContext = null)),
        (e === null || e.child === null) &&
          (Do(t)
            ? (t.flags |= 4)
            : e === null ||
              (e.memoizedState.isDehydrated && (t.flags & 256) === 0) ||
              ((t.flags |= 1024), Ht !== null && (oc(Ht), (Ht = null)))),
        Xl(e, t),
        Xe(t),
        null
      );
    case 5:
      Kc(t);
      var r = ei(eo.current);
      if (((n = t.type), e !== null && t.stateNode != null))
        Gm(e, t, n, i, r), e.ref !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
      else {
        if (!i) {
          if (t.stateNode === null) throw Error(S(166));
          return Xe(t), null;
        }
        if (((e = ei(Zt.current)), Do(t))) {
          (i = t.stateNode), (n = t.type);
          var o = t.memoizedProps;
          switch (((i[Kt] = t), (i[Zr] = o), (e = (t.mode & 1) !== 0), n)) {
            case 'dialog':
              he('cancel', i), he('close', i);
              break;
            case 'iframe':
            case 'object':
            case 'embed':
              he('load', i);
              break;
            case 'video':
            case 'audio':
              for (r = 0; r < Pr.length; r++) he(Pr[r], i);
              break;
            case 'source':
              he('error', i);
              break;
            case 'img':
            case 'image':
            case 'link':
              he('error', i), he('load', i);
              break;
            case 'details':
              he('toggle', i);
              break;
            case 'input':
              od(i, o), he('invalid', i);
              break;
            case 'select':
              (i._wrapperState = { wasMultiple: !!o.multiple }), he('invalid', i);
              break;
            case 'textarea':
              sd(i, o), he('invalid', i);
          }
          kl(n, o), (r = null);
          for (var a in o)
            if (o.hasOwnProperty(a)) {
              var s = o[a];
              a === 'children'
                ? typeof s == 'string'
                  ? i.textContent !== s &&
                    (o.suppressHydrationWarning !== !0 && Io(i.textContent, s, e), (r = ['children', s]))
                  : typeof s == 'number' &&
                    i.textContent !== '' + s &&
                    (o.suppressHydrationWarning !== !0 && Io(i.textContent, s, e), (r = ['children', '' + s]))
                : Ur.hasOwnProperty(a) && s != null && a === 'onScroll' && he('scroll', i);
            }
          switch (n) {
            case 'input':
              So(i), ad(i, o, !0);
              break;
            case 'textarea':
              So(i), ld(i);
              break;
            case 'select':
            case 'option':
              break;
            default:
              typeof o.onClick == 'function' && (i.onclick = da);
          }
          (i = r), (t.updateQueue = i), i !== null && (t.flags |= 4);
        } else {
          (a = r.nodeType === 9 ? r : r.ownerDocument),
            e === 'http://www.w3.org/1999/xhtml' && (e = _h(n)),
            e === 'http://www.w3.org/1999/xhtml'
              ? n === 'script'
                ? ((e = a.createElement('div')), (e.innerHTML = '<script></script>'), (e = e.removeChild(e.firstChild)))
                : typeof i.is == 'string'
                  ? (e = a.createElement(n, { is: i.is }))
                  : ((e = a.createElement(n)),
                    n === 'select' && ((a = e), i.multiple ? (a.multiple = !0) : i.size && (a.size = i.size)))
              : (e = a.createElementNS(e, n)),
            (e[Kt] = t),
            (e[Zr] = i),
            $m(e, t, !1, !1),
            (t.stateNode = e);
          e: {
            switch (((a = Sl(n, i)), n)) {
              case 'dialog':
                he('cancel', e), he('close', e), (r = i);
                break;
              case 'iframe':
              case 'object':
              case 'embed':
                he('load', e), (r = i);
                break;
              case 'video':
              case 'audio':
                for (r = 0; r < Pr.length; r++) he(Pr[r], e);
                r = i;
                break;
              case 'source':
                he('error', e), (r = i);
                break;
              case 'img':
              case 'image':
              case 'link':
                he('error', e), he('load', e), (r = i);
                break;
              case 'details':
                he('toggle', e), (r = i);
                break;
              case 'input':
                od(e, i), (r = xl(e, i)), he('invalid', e);
                break;
              case 'option':
                r = i;
                break;
              case 'select':
                (e._wrapperState = { wasMultiple: !!i.multiple }), (r = Ee({}, i, { value: void 0 })), he('invalid', e);
                break;
              case 'textarea':
                sd(e, i), (r = Al(e, i)), he('invalid', e);
                break;
              default:
                r = i;
            }
            kl(n, r), (s = r);
            for (o in s)
              if (s.hasOwnProperty(o)) {
                var l = s[o];
                o === 'style'
                  ? yh(e, l)
                  : o === 'dangerouslySetInnerHTML'
                    ? ((l = l ? l.__html : void 0), l != null && xh(e, l))
                    : o === 'children'
                      ? typeof l == 'string'
                        ? (n !== 'textarea' || l !== '') && $r(e, l)
                        : typeof l == 'number' && $r(e, '' + l)
                      : o !== 'suppressContentEditableWarning' &&
                        o !== 'suppressHydrationWarning' &&
                        o !== 'autoFocus' &&
                        (Ur.hasOwnProperty(o)
                          ? l != null && o === 'onScroll' && he('scroll', e)
                          : l != null && Mc(e, o, l, a));
              }
            switch (n) {
              case 'input':
                So(e), ad(e, i, !1);
                break;
              case 'textarea':
                So(e), ld(e);
                break;
              case 'option':
                i.value != null && e.setAttribute('value', '' + jn(i.value));
                break;
              case 'select':
                (e.multiple = !!i.multiple),
                  (o = i.value),
                  o != null
                    ? Ui(e, !!i.multiple, o, !1)
                    : i.defaultValue != null && Ui(e, !!i.multiple, i.defaultValue, !0);
                break;
              default:
                typeof r.onClick == 'function' && (e.onclick = da);
            }
            switch (n) {
              case 'button':
              case 'input':
              case 'select':
              case 'textarea':
                i = !!i.autoFocus;
                break e;
              case 'img':
                i = !0;
                break e;
              default:
                i = !1;
            }
          }
          i && (t.flags |= 4);
        }
        t.ref !== null && ((t.flags |= 512), (t.flags |= 2097152));
      }
      return Xe(t), null;
    case 6:
      if (e && t.stateNode != null) Jm(e, t, e.memoizedProps, i);
      else {
        if (typeof i != 'string' && t.stateNode === null) throw Error(S(166));
        if (((n = ei(eo.current)), ei(Zt.current), Do(t))) {
          if (
            ((i = t.stateNode), (n = t.memoizedProps), (i[Kt] = t), (o = i.nodeValue !== n) && ((e = yt), e !== null))
          )
            switch (e.tag) {
              case 3:
                Io(i.nodeValue, n, (e.mode & 1) !== 0);
                break;
              case 5:
                e.memoizedProps.suppressHydrationWarning !== !0 && Io(i.nodeValue, n, (e.mode & 1) !== 0);
            }
          o && (t.flags |= 4);
        } else (i = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(i)), (i[Kt] = t), (t.stateNode = i);
      }
      return Xe(t), null;
    case 13:
      if (
        (fe(_e), (i = t.memoizedState), e === null || (e.memoizedState !== null && e.memoizedState.dehydrated !== null))
      ) {
        if (ge && Et !== null && (t.mode & 1) !== 0 && (t.flags & 128) === 0) lm(), Xi(), (t.flags |= 98560), (o = !1);
        else if (((o = Do(t)), i !== null && i.dehydrated !== null)) {
          if (e === null) {
            if (!o) throw Error(S(318));
            if (((o = t.memoizedState), (o = o !== null ? o.dehydrated : null), !o)) throw Error(S(317));
            o[Kt] = t;
          } else Xi(), (t.flags & 128) === 0 && (t.memoizedState = null), (t.flags |= 4);
          Xe(t), (o = !1);
        } else Ht !== null && (oc(Ht), (Ht = null)), (o = !0);
        if (!o) return t.flags & 65536 ? t : null;
      }
      return (t.flags & 128) !== 0
        ? ((t.lanes = n), t)
        : ((i = i !== null),
          i !== (e !== null && e.memoizedState !== null) &&
            i &&
            ((t.child.flags |= 8192),
            (t.mode & 1) !== 0 && (e === null || (_e.current & 1) !== 0 ? Ce === 0 && (Ce = 3) : cu())),
          t.updateQueue !== null && (t.flags |= 4),
          Xe(t),
          null);
    case 4:
      return Yi(), Xl(e, t), e === null && Kr(t.stateNode.containerInfo), Xe(t), null;
    case 10:
      return Vc(t.type._context), Xe(t), null;
    case 17:
      return mt(t.type) && pa(), Xe(t), null;
    case 19:
      if ((fe(_e), (o = t.memoizedState), o === null)) return Xe(t), null;
      if (((i = (t.flags & 128) !== 0), (a = o.rendering), a === null))
        if (i) wr(o, !1);
        else {
          if (Ce !== 0 || (e !== null && (e.flags & 128) !== 0))
            for (e = t.child; e !== null; ) {
              if (((a = xa(e)), a !== null)) {
                for (
                  t.flags |= 128,
                    wr(o, !1),
                    i = a.updateQueue,
                    i !== null && ((t.updateQueue = i), (t.flags |= 4)),
                    t.subtreeFlags = 0,
                    i = n,
                    n = t.child;
                  n !== null;

                )
                  (o = n),
                    (e = i),
                    (o.flags &= 14680066),
                    (a = o.alternate),
                    a === null
                      ? ((o.childLanes = 0),
                        (o.lanes = e),
                        (o.child = null),
                        (o.subtreeFlags = 0),
                        (o.memoizedProps = null),
                        (o.memoizedState = null),
                        (o.updateQueue = null),
                        (o.dependencies = null),
                        (o.stateNode = null))
                      : ((o.childLanes = a.childLanes),
                        (o.lanes = a.lanes),
                        (o.child = a.child),
                        (o.subtreeFlags = 0),
                        (o.deletions = null),
                        (o.memoizedProps = a.memoizedProps),
                        (o.memoizedState = a.memoizedState),
                        (o.updateQueue = a.updateQueue),
                        (o.type = a.type),
                        (e = a.dependencies),
                        (o.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext })),
                    (n = n.sibling);
                return pe(_e, (_e.current & 1) | 2), t.child;
              }
              e = e.sibling;
            }
          o.tail !== null && ke() > tr && ((t.flags |= 128), (i = !0), wr(o, !1), (t.lanes = 4194304));
        }
      else {
        if (!i)
          if (((e = xa(a)), e !== null)) {
            if (
              ((t.flags |= 128),
              (i = !0),
              (n = e.updateQueue),
              n !== null && ((t.updateQueue = n), (t.flags |= 4)),
              wr(o, !0),
              o.tail === null && o.tailMode === 'hidden' && !a.alternate && !ge)
            )
              return Xe(t), null;
          } else
            2 * ke() - o.renderingStartTime > tr &&
              n !== 1073741824 &&
              ((t.flags |= 128), (i = !0), wr(o, !1), (t.lanes = 4194304));
        o.isBackwards
          ? ((a.sibling = t.child), (t.child = a))
          : ((n = o.last), n !== null ? (n.sibling = a) : (t.child = a), (o.last = a));
      }
      return o.tail !== null
        ? ((t = o.tail),
          (o.rendering = t),
          (o.tail = t.sibling),
          (o.renderingStartTime = ke()),
          (t.sibling = null),
          (n = _e.current),
          pe(_e, i ? (n & 1) | 2 : n & 1),
          t)
        : (Xe(t), null);
    case 22:
    case 23:
      return (
        lu(),
        (i = t.memoizedState !== null),
        e !== null && (e.memoizedState !== null) !== i && (t.flags |= 8192),
        i && (t.mode & 1) !== 0 ? (xt & 1073741824) !== 0 && (Xe(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Xe(t),
        null
      );
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(S(156, t.tag));
}
function S_(e, t) {
  switch ((Uc(t), t.tag)) {
    case 1:
      return mt(t.type) && pa(), (e = t.flags), e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null;
    case 3:
      return (
        Yi(),
        fe(ht),
        fe(et),
        Xc(),
        (e = t.flags),
        (e & 65536) !== 0 && (e & 128) === 0 ? ((t.flags = (e & -65537) | 128), t) : null
      );
    case 5:
      return Kc(t), null;
    case 13:
      if ((fe(_e), (e = t.memoizedState), e !== null && e.dehydrated !== null)) {
        if (t.alternate === null) throw Error(S(340));
        Xi();
      }
      return (e = t.flags), e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null;
    case 19:
      return fe(_e), null;
    case 4:
      return Yi(), null;
    case 10:
      return Vc(t.type._context), null;
    case 22:
    case 23:
      return lu(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var Ho = !1,
  Ye = !1,
  b_ = typeof WeakSet == 'function' ? WeakSet : Set,
  F = null;
function Fi(e, t) {
  var n = e.ref;
  if (n !== null)
    if (typeof n == 'function')
      try {
        n(null);
      } catch (i) {
        ye(e, t, i);
      }
    else n.current = null;
}
function Zl(e, t, n) {
  try {
    n();
  } catch (i) {
    ye(e, t, i);
  }
}
var Xd = !1;
function M_(e, t) {
  if (((Ol = la), (e = Wh()), zc(e))) {
    if ('selectionStart' in e) var n = { start: e.selectionStart, end: e.selectionEnd };
    else
      e: {
        n = ((n = e.ownerDocument) && n.defaultView) || window;
        var i = n.getSelection && n.getSelection();
        if (i && i.rangeCount !== 0) {
          n = i.anchorNode;
          var r = i.anchorOffset,
            o = i.focusNode;
          i = i.focusOffset;
          try {
            n.nodeType, o.nodeType;
          } catch {
            n = null;
            break e;
          }
          var a = 0,
            s = -1,
            l = -1,
            c = 0,
            u = 0,
            m = e,
            h = null;
          t: for (;;) {
            for (
              var v;
              m !== n || (r !== 0 && m.nodeType !== 3) || (s = a + r),
                m !== o || (i !== 0 && m.nodeType !== 3) || (l = a + i),
                m.nodeType === 3 && (a += m.nodeValue.length),
                (v = m.firstChild) !== null;

            )
              (h = m), (m = v);
            for (;;) {
              if (m === e) break t;
              if ((h === n && ++c === r && (s = a), h === o && ++u === i && (l = a), (v = m.nextSibling) !== null))
                break;
              (m = h), (h = m.parentNode);
            }
            m = v;
          }
          n = s === -1 || l === -1 ? null : { start: s, end: l };
        } else n = null;
      }
    n = n || { start: 0, end: 0 };
  } else n = null;
  for (Ll = { focusedElem: e, selectionRange: n }, la = !1, F = t; F !== null; )
    if (((t = F), (e = t.child), (t.subtreeFlags & 1028) !== 0 && e !== null)) (e.return = t), (F = e);
    else
      for (; F !== null; ) {
        t = F;
        try {
          var x = t.alternate;
          if ((t.flags & 1024) !== 0)
            switch (t.tag) {
              case 0:
              case 11:
              case 15:
                break;
              case 1:
                if (x !== null) {
                  var f = x.memoizedProps,
                    D = x.memoizedState,
                    p = t.stateNode,
                    d = p.getSnapshotBeforeUpdate(t.elementType === t.type ? f : Ot(t.type, f), D);
                  p.__reactInternalSnapshotBeforeUpdate = d;
                }
                break;
              case 3:
                var g = t.stateNode.containerInfo;
                g.nodeType === 1
                  ? (g.textContent = '')
                  : g.nodeType === 9 && g.documentElement && g.removeChild(g.documentElement);
                break;
              case 5:
              case 6:
              case 4:
              case 17:
                break;
              default:
                throw Error(S(163));
            }
        } catch (y) {
          ye(t, t.return, y);
        }
        if (((e = t.sibling), e !== null)) {
          (e.return = t.return), (F = e);
          break;
        }
        F = t.return;
      }
  return (x = Xd), (Xd = !1), x;
}
function Fr(e, t, n) {
  var i = t.updateQueue;
  if (((i = i !== null ? i.lastEffect : null), i !== null)) {
    var r = (i = i.next);
    do {
      if ((r.tag & e) === e) {
        var o = r.destroy;
        (r.destroy = void 0), o !== void 0 && Zl(t, n, o);
      }
      r = r.next;
    } while (r !== i);
  }
}
function Fa(e, t) {
  if (((t = t.updateQueue), (t = t !== null ? t.lastEffect : null), t !== null)) {
    var n = (t = t.next);
    do {
      if ((n.tag & e) === e) {
        var i = n.create;
        n.destroy = i();
      }
      n = n.next;
    } while (n !== t);
  }
}
function Yl(e) {
  var t = e.ref;
  if (t !== null) {
    var n = e.stateNode;
    switch (e.tag) {
      case 5:
        e = n;
        break;
      default:
        e = n;
    }
    typeof t == 'function' ? t(e) : (t.current = e);
  }
}
function Vm(e) {
  var t = e.alternate;
  t !== null && ((e.alternate = null), Vm(t)),
    (e.child = null),
    (e.deletions = null),
    (e.sibling = null),
    e.tag === 5 &&
      ((t = e.stateNode), t !== null && (delete t[Kt], delete t[Zr], delete t[jl], delete t[c_], delete t[u_])),
    (e.stateNode = null),
    (e.return = null),
    (e.dependencies = null),
    (e.memoizedProps = null),
    (e.memoizedState = null),
    (e.pendingProps = null),
    (e.stateNode = null),
    (e.updateQueue = null);
}
function qm(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function Zd(e) {
  e: for (;;) {
    for (; e.sibling === null; ) {
      if (e.return === null || qm(e.return)) return null;
      e = e.return;
    }
    for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
      if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
      (e.child.return = e), (e = e.child);
    }
    if (!(e.flags & 2)) return e.stateNode;
  }
}
function ec(e, t, n) {
  var i = e.tag;
  if (i === 5 || i === 6)
    (e = e.stateNode),
      t
        ? n.nodeType === 8
          ? n.parentNode.insertBefore(e, t)
          : n.insertBefore(e, t)
        : (n.nodeType === 8 ? ((t = n.parentNode), t.insertBefore(e, n)) : ((t = n), t.appendChild(e)),
          (n = n._reactRootContainer),
          n != null || t.onclick !== null || (t.onclick = da));
  else if (i !== 4 && ((e = e.child), e !== null))
    for (ec(e, t, n), e = e.sibling; e !== null; ) ec(e, t, n), (e = e.sibling);
}
function tc(e, t, n) {
  var i = e.tag;
  if (i === 5 || i === 6) (e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e);
  else if (i !== 4 && ((e = e.child), e !== null))
    for (tc(e, t, n), e = e.sibling; e !== null; ) tc(e, t, n), (e = e.sibling);
}
var Ue = null,
  Lt = !1;
function kn(e, t, n) {
  for (n = n.child; n !== null; ) Qm(e, t, n), (n = n.sibling);
}
function Qm(e, t, n) {
  if (Xt && typeof Xt.onCommitFiberUnmount == 'function')
    try {
      Xt.onCommitFiberUnmount(Pa, n);
    } catch {}
  switch (n.tag) {
    case 5:
      Ye || Fi(n, t);
    case 6:
      var i = Ue,
        r = Lt;
      (Ue = null),
        kn(e, t, n),
        (Ue = i),
        (Lt = r),
        Ue !== null &&
          (Lt
            ? ((e = Ue), (n = n.stateNode), e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n))
            : Ue.removeChild(n.stateNode));
      break;
    case 18:
      Ue !== null &&
        (Lt
          ? ((e = Ue), (n = n.stateNode), e.nodeType === 8 ? Vs(e.parentNode, n) : e.nodeType === 1 && Vs(e, n), qr(e))
          : Vs(Ue, n.stateNode));
      break;
    case 4:
      (i = Ue), (r = Lt), (Ue = n.stateNode.containerInfo), (Lt = !0), kn(e, t, n), (Ue = i), (Lt = r);
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!Ye && ((i = n.updateQueue), i !== null && ((i = i.lastEffect), i !== null))) {
        r = i = i.next;
        do {
          var o = r,
            a = o.destroy;
          (o = o.tag), a !== void 0 && ((o & 2) !== 0 || (o & 4) !== 0) && Zl(n, t, a), (r = r.next);
        } while (r !== i);
      }
      kn(e, t, n);
      break;
    case 1:
      if (!Ye && (Fi(n, t), (i = n.stateNode), typeof i.componentWillUnmount == 'function'))
        try {
          (i.props = n.memoizedProps), (i.state = n.memoizedState), i.componentWillUnmount();
        } catch (s) {
          ye(n, t, s);
        }
      kn(e, t, n);
      break;
    case 21:
      kn(e, t, n);
      break;
    case 22:
      n.mode & 1 ? ((Ye = (i = Ye) || n.memoizedState !== null), kn(e, t, n), (Ye = i)) : kn(e, t, n);
      break;
    default:
      kn(e, t, n);
  }
}
function Yd(e) {
  var t = e.updateQueue;
  if (t !== null) {
    e.updateQueue = null;
    var n = e.stateNode;
    n === null && (n = e.stateNode = new b_()),
      t.forEach(function (i) {
        var r = L_.bind(null, e, i);
        n.has(i) || (n.add(i), i.then(r, r));
      });
  }
}
function Dt(e, t) {
  var n = t.deletions;
  if (n !== null)
    for (var i = 0; i < n.length; i++) {
      var r = n[i];
      try {
        var o = e,
          a = t,
          s = a;
        e: for (; s !== null; ) {
          switch (s.tag) {
            case 5:
              (Ue = s.stateNode), (Lt = !1);
              break e;
            case 3:
              (Ue = s.stateNode.containerInfo), (Lt = !0);
              break e;
            case 4:
              (Ue = s.stateNode.containerInfo), (Lt = !0);
              break e;
          }
          s = s.return;
        }
        if (Ue === null) throw Error(S(160));
        Qm(o, a, r), (Ue = null), (Lt = !1);
        var l = r.alternate;
        l !== null && (l.return = null), (r.return = null);
      } catch (c) {
        ye(r, t, c);
      }
    }
  if (t.subtreeFlags & 12854) for (t = t.child; t !== null; ) Wm(t, e), (t = t.sibling);
}
function Wm(e, t) {
  var n = e.alternate,
    i = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if ((Dt(t, e), Jt(e), i & 4)) {
        try {
          Fr(3, e, e.return), Fa(3, e);
        } catch (f) {
          ye(e, e.return, f);
        }
        try {
          Fr(5, e, e.return);
        } catch (f) {
          ye(e, e.return, f);
        }
      }
      break;
    case 1:
      Dt(t, e), Jt(e), i & 512 && n !== null && Fi(n, n.return);
      break;
    case 5:
      if ((Dt(t, e), Jt(e), i & 512 && n !== null && Fi(n, n.return), e.flags & 32)) {
        var r = e.stateNode;
        try {
          $r(r, '');
        } catch (f) {
          ye(e, e.return, f);
        }
      }
      if (i & 4 && ((r = e.stateNode), r != null)) {
        var o = e.memoizedProps,
          a = n !== null ? n.memoizedProps : o,
          s = e.type,
          l = e.updateQueue;
        if (((e.updateQueue = null), l !== null))
          try {
            s === 'input' && o.type === 'radio' && o.name != null && gh(r, o), Sl(s, a);
            var c = Sl(s, o);
            for (a = 0; a < l.length; a += 2) {
              var u = l[a],
                m = l[a + 1];
              u === 'style'
                ? yh(r, m)
                : u === 'dangerouslySetInnerHTML'
                  ? xh(r, m)
                  : u === 'children'
                    ? $r(r, m)
                    : Mc(r, u, m, c);
            }
            switch (s) {
              case 'input':
                El(r, o);
                break;
              case 'textarea':
                vh(r, o);
                break;
              case 'select':
                var h = r._wrapperState.wasMultiple;
                r._wrapperState.wasMultiple = !!o.multiple;
                var v = o.value;
                v != null
                  ? Ui(r, !!o.multiple, v, !1)
                  : h !== !!o.multiple &&
                    (o.defaultValue != null
                      ? Ui(r, !!o.multiple, o.defaultValue, !0)
                      : Ui(r, !!o.multiple, o.multiple ? [] : '', !1));
            }
            r[Zr] = o;
          } catch (f) {
            ye(e, e.return, f);
          }
      }
      break;
    case 6:
      if ((Dt(t, e), Jt(e), i & 4)) {
        if (e.stateNode === null) throw Error(S(162));
        (r = e.stateNode), (o = e.memoizedProps);
        try {
          r.nodeValue = o;
        } catch (f) {
          ye(e, e.return, f);
        }
      }
      break;
    case 3:
      if ((Dt(t, e), Jt(e), i & 4 && n !== null && n.memoizedState.isDehydrated))
        try {
          qr(t.containerInfo);
        } catch (f) {
          ye(e, e.return, f);
        }
      break;
    case 4:
      Dt(t, e), Jt(e);
      break;
    case 13:
      Dt(t, e),
        Jt(e),
        (r = e.child),
        r.flags & 8192 &&
          ((o = r.memoizedState !== null),
          (r.stateNode.isHidden = o),
          !o || (r.alternate !== null && r.alternate.memoizedState !== null) || (au = ke())),
        i & 4 && Yd(e);
      break;
    case 22:
      if (
        ((u = n !== null && n.memoizedState !== null),
        e.mode & 1 ? ((Ye = (c = Ye) || u), Dt(t, e), (Ye = c)) : Dt(t, e),
        Jt(e),
        i & 8192)
      ) {
        if (((c = e.memoizedState !== null), (e.stateNode.isHidden = c) && !u && (e.mode & 1) !== 0))
          for (F = e, u = e.child; u !== null; ) {
            for (m = F = u; F !== null; ) {
              switch (((h = F), (v = h.child), h.tag)) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Fr(4, h, h.return);
                  break;
                case 1:
                  Fi(h, h.return);
                  var x = h.stateNode;
                  if (typeof x.componentWillUnmount == 'function') {
                    (i = h), (n = h.return);
                    try {
                      (t = i), (x.props = t.memoizedProps), (x.state = t.memoizedState), x.componentWillUnmount();
                    } catch (f) {
                      ye(i, n, f);
                    }
                  }
                  break;
                case 5:
                  Fi(h, h.return);
                  break;
                case 22:
                  if (h.memoizedState !== null) {
                    tp(m);
                    continue;
                  }
              }
              v !== null ? ((v.return = h), (F = v)) : tp(m);
            }
            u = u.sibling;
          }
        e: for (u = null, m = e; ; ) {
          if (m.tag === 5) {
            if (u === null) {
              u = m;
              try {
                (r = m.stateNode),
                  c
                    ? ((o = r.style),
                      typeof o.setProperty == 'function'
                        ? o.setProperty('display', 'none', 'important')
                        : (o.display = 'none'))
                    : ((s = m.stateNode),
                      (l = m.memoizedProps.style),
                      (a = l != null && l.hasOwnProperty('display') ? l.display : null),
                      (s.style.display = Eh('display', a)));
              } catch (f) {
                ye(e, e.return, f);
              }
            }
          } else if (m.tag === 6) {
            if (u === null)
              try {
                m.stateNode.nodeValue = c ? '' : m.memoizedProps;
              } catch (f) {
                ye(e, e.return, f);
              }
          } else if (((m.tag !== 22 && m.tag !== 23) || m.memoizedState === null || m === e) && m.child !== null) {
            (m.child.return = m), (m = m.child);
            continue;
          }
          if (m === e) break e;
          for (; m.sibling === null; ) {
            if (m.return === null || m.return === e) break e;
            u === m && (u = null), (m = m.return);
          }
          u === m && (u = null), (m.sibling.return = m.return), (m = m.sibling);
        }
      }
      break;
    case 19:
      Dt(t, e), Jt(e), i & 4 && Yd(e);
      break;
    case 21:
      break;
    default:
      Dt(t, e), Jt(e);
  }
}
function Jt(e) {
  var t = e.flags;
  if (t & 2) {
    try {
      e: {
        for (var n = e.return; n !== null; ) {
          if (qm(n)) {
            var i = n;
            break e;
          }
          n = n.return;
        }
        throw Error(S(160));
      }
      switch (i.tag) {
        case 5:
          var r = i.stateNode;
          i.flags & 32 && ($r(r, ''), (i.flags &= -33));
          var o = Zd(e);
          tc(e, o, r);
          break;
        case 3:
        case 4:
          var a = i.stateNode.containerInfo,
            s = Zd(e);
          ec(e, s, a);
          break;
        default:
          throw Error(S(161));
      }
    } catch (l) {
      ye(e, e.return, l);
    }
    e.flags &= -3;
  }
  t & 4096 && (e.flags &= -4097);
}
function T_(e, t, n) {
  (F = e), Km(e);
}
function Km(e, t, n) {
  for (var i = (e.mode & 1) !== 0; F !== null; ) {
    var r = F,
      o = r.child;
    if (r.tag === 22 && i) {
      var a = r.memoizedState !== null || Ho;
      if (!a) {
        var s = r.alternate,
          l = (s !== null && s.memoizedState !== null) || Ye;
        s = Ho;
        var c = Ye;
        if (((Ho = a), (Ye = l) && !c))
          for (F = r; F !== null; )
            (a = F),
              (l = a.child),
              a.tag === 22 && a.memoizedState !== null ? np(r) : l !== null ? ((l.return = a), (F = l)) : np(r);
        for (; o !== null; ) (F = o), Km(o), (o = o.sibling);
        (F = r), (Ho = s), (Ye = c);
      }
      ep(e);
    } else (r.subtreeFlags & 8772) !== 0 && o !== null ? ((o.return = r), (F = o)) : ep(e);
  }
}
function ep(e) {
  for (; F !== null; ) {
    var t = F;
    if ((t.flags & 8772) !== 0) {
      var n = t.alternate;
      try {
        if ((t.flags & 8772) !== 0)
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              Ye || Fa(5, t);
              break;
            case 1:
              var i = t.stateNode;
              if (t.flags & 4 && !Ye)
                if (n === null) i.componentDidMount();
                else {
                  var r = t.elementType === t.type ? n.memoizedProps : Ot(t.type, n.memoizedProps);
                  i.componentDidUpdate(r, n.memoizedState, i.__reactInternalSnapshotBeforeUpdate);
                }
              var o = t.updateQueue;
              o !== null && Hd(t, o, i);
              break;
            case 3:
              var a = t.updateQueue;
              if (a !== null) {
                if (((n = null), t.child !== null))
                  switch (t.child.tag) {
                    case 5:
                      n = t.child.stateNode;
                      break;
                    case 1:
                      n = t.child.stateNode;
                  }
                Hd(t, a, n);
              }
              break;
            case 5:
              var s = t.stateNode;
              if (n === null && t.flags & 4) {
                n = s;
                var l = t.memoizedProps;
                switch (t.type) {
                  case 'button':
                  case 'input':
                  case 'select':
                  case 'textarea':
                    l.autoFocus && n.focus();
                    break;
                  case 'img':
                    l.src && (n.src = l.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (t.memoizedState === null) {
                var c = t.alternate;
                if (c !== null) {
                  var u = c.memoizedState;
                  if (u !== null) {
                    var m = u.dehydrated;
                    m !== null && qr(m);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(S(163));
          }
        Ye || (t.flags & 512 && Yl(t));
      } catch (h) {
        ye(t, t.return, h);
      }
    }
    if (t === e) {
      F = null;
      break;
    }
    if (((n = t.sibling), n !== null)) {
      (n.return = t.return), (F = n);
      break;
    }
    F = t.return;
  }
}
function tp(e) {
  for (; F !== null; ) {
    var t = F;
    if (t === e) {
      F = null;
      break;
    }
    var n = t.sibling;
    if (n !== null) {
      (n.return = t.return), (F = n);
      break;
    }
    F = t.return;
  }
}
function np(e) {
  for (; F !== null; ) {
    var t = F;
    try {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          var n = t.return;
          try {
            Fa(4, t);
          } catch (l) {
            ye(t, n, l);
          }
          break;
        case 1:
          var i = t.stateNode;
          if (typeof i.componentDidMount == 'function') {
            var r = t.return;
            try {
              i.componentDidMount();
            } catch (l) {
              ye(t, r, l);
            }
          }
          var o = t.return;
          try {
            Yl(t);
          } catch (l) {
            ye(t, o, l);
          }
          break;
        case 5:
          var a = t.return;
          try {
            Yl(t);
          } catch (l) {
            ye(t, a, l);
          }
      }
    } catch (l) {
      ye(t, t.return, l);
    }
    if (t === e) {
      F = null;
      break;
    }
    var s = t.sibling;
    if (s !== null) {
      (s.return = t.return), (F = s);
      break;
    }
    F = t.return;
  }
}
var R_ = Math.ceil,
  Aa = vn.ReactCurrentDispatcher,
  ru = vn.ReactCurrentOwner,
  Pt = vn.ReactCurrentBatchConfig,
  te = 0,
  Fe = null,
  Me = null,
  $e = 0,
  xt = 0,
  ji = Un(0),
  Ce = 0,
  ro = null,
  ci = 0,
  ja = 0,
  ou = 0,
  jr = null,
  dt = null,
  au = 0,
  tr = 1 / 0,
  an = null,
  wa = !1,
  nc = null,
  Ln = null,
  Fo = !1,
  Pn = null,
  ka = 0,
  zr = 0,
  ic = null,
  Zo = -1,
  Yo = 0;
function ot() {
  return (te & 6) !== 0 ? ke() : Zo !== -1 ? Zo : (Zo = ke());
}
function Hn(e) {
  return (e.mode & 1) === 0
    ? 1
    : (te & 2) !== 0 && $e !== 0
      ? $e & -$e
      : p_.transition !== null
        ? (Yo === 0 && (Yo = Ih()), Yo)
        : ((e = se), e !== 0 || ((e = window.event), (e = e === void 0 ? 16 : zh(e.type))), e);
}
function jt(e, t, n, i) {
  if (50 < zr) throw ((zr = 0), (ic = null), Error(S(185)));
  ao(e, n, i),
    ((te & 2) === 0 || e !== Fe) &&
      (e === Fe && ((te & 2) === 0 && (ja |= n), Ce === 4 && Tn(e, $e)),
      ft(e, i),
      n === 1 && te === 0 && (t.mode & 1) === 0 && ((tr = ke() + 500), Oa && $n()));
}
function ft(e, t) {
  var n = e.callbackNode;
  pv(e, t);
  var i = sa(e, e === Fe ? $e : 0);
  if (i === 0) n !== null && dd(n), (e.callbackNode = null), (e.callbackPriority = 0);
  else if (((t = i & -i), e.callbackPriority !== t)) {
    if ((n != null && dd(n), t === 1))
      e.tag === 0 ? d_(ip.bind(null, e)) : om(ip.bind(null, e)),
        s_(function () {
          (te & 6) === 0 && $n();
        }),
        (n = null);
    else {
      switch (Dh(i)) {
        case 1:
          n = Nc;
          break;
        case 4:
          n = Ch;
          break;
        case 16:
          n = aa;
          break;
        case 536870912:
          n = Nh;
          break;
        default:
          n = aa;
      }
      n = of(n, Xm.bind(null, e));
    }
    (e.callbackPriority = t), (e.callbackNode = n);
  }
}
function Xm(e, t) {
  if (((Zo = -1), (Yo = 0), (te & 6) !== 0)) throw Error(S(327));
  var n = e.callbackNode;
  if (qi() && e.callbackNode !== n) return null;
  var i = sa(e, e === Fe ? $e : 0);
  if (i === 0) return null;
  if ((i & 30) !== 0 || (i & e.expiredLanes) !== 0 || t) t = Sa(e, i);
  else {
    t = i;
    var r = te;
    te |= 2;
    var o = Ym();
    (Fe !== e || $e !== t) && ((an = null), (tr = ke() + 500), ni(e, t));
    do
      try {
        N_();
        break;
      } catch (s) {
        Zm(e, s);
      }
    while (1);
    Jc(), (Aa.current = o), (te = r), Me !== null ? (t = 0) : ((Fe = null), ($e = 0), (t = Ce));
  }
  if (t !== 0) {
    if ((t === 2 && ((r = Pl(e)), r !== 0 && ((i = r), (t = rc(e, r)))), t === 1))
      throw ((n = ro), ni(e, 0), Tn(e, i), ft(e, ke()), n);
    if (t === 6) Tn(e, i);
    else {
      if (
        ((r = e.current.alternate),
        (i & 30) === 0 &&
          !P_(r) &&
          ((t = Sa(e, i)), t === 2 && ((o = Pl(e)), o !== 0 && ((i = o), (t = rc(e, o)))), t === 1))
      )
        throw ((n = ro), ni(e, 0), Tn(e, i), ft(e, ke()), n);
      switch (((e.finishedWork = r), (e.finishedLanes = i), t)) {
        case 0:
        case 1:
          throw Error(S(345));
        case 2:
          Xn(e, dt, an);
          break;
        case 3:
          if ((Tn(e, i), (i & 130023424) === i && ((t = au + 500 - ke()), 10 < t))) {
            if (sa(e, 0) !== 0) break;
            if (((r = e.suspendedLanes), (r & i) !== i)) {
              ot(), (e.pingedLanes |= e.suspendedLanes & r);
              break;
            }
            e.timeoutHandle = Fl(Xn.bind(null, e, dt, an), t);
            break;
          }
          Xn(e, dt, an);
          break;
        case 4:
          if ((Tn(e, i), (i & 4194240) === i)) break;
          for (t = e.eventTimes, r = -1; 0 < i; ) {
            var a = 31 - Ft(i);
            (o = 1 << a), (a = t[a]), a > r && (r = a), (i &= ~o);
          }
          if (
            ((i = r),
            (i = ke() - i),
            (i =
              (120 > i
                ? 120
                : 480 > i
                  ? 480
                  : 1080 > i
                    ? 1080
                    : 1920 > i
                      ? 1920
                      : 3e3 > i
                        ? 3e3
                        : 4320 > i
                          ? 4320
                          : 1960 * R_(i / 1960)) - i),
            10 < i)
          ) {
            e.timeoutHandle = Fl(Xn.bind(null, e, dt, an), i);
            break;
          }
          Xn(e, dt, an);
          break;
        case 5:
          Xn(e, dt, an);
          break;
        default:
          throw Error(S(329));
      }
    }
  }
  return ft(e, ke()), e.callbackNode === n ? Xm.bind(null, e) : null;
}
function rc(e, t) {
  var n = jr;
  return (
    e.current.memoizedState.isDehydrated && (ni(e, t).flags |= 256),
    (e = Sa(e, t)),
    e !== 2 && ((t = dt), (dt = n), t !== null && oc(t)),
    e
  );
}
function oc(e) {
  dt === null ? (dt = e) : dt.push.apply(dt, e);
}
function P_(e) {
  for (var t = e; ; ) {
    if (t.flags & 16384) {
      var n = t.updateQueue;
      if (n !== null && ((n = n.stores), n !== null))
        for (var i = 0; i < n.length; i++) {
          var r = n[i],
            o = r.getSnapshot;
          r = r.value;
          try {
            if (!zt(o(), r)) return !1;
          } catch {
            return !1;
          }
        }
    }
    if (((n = t.child), t.subtreeFlags & 16384 && n !== null)) (n.return = t), (t = n);
    else {
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return !0;
        t = t.return;
      }
      (t.sibling.return = t.return), (t = t.sibling);
    }
  }
  return !0;
}
function Tn(e, t) {
  for (t &= ~ou, t &= ~ja, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
    var n = 31 - Ft(t),
      i = 1 << n;
    (e[n] = -1), (t &= ~i);
  }
}
function ip(e) {
  if ((te & 6) !== 0) throw Error(S(327));
  qi();
  var t = sa(e, 0);
  if ((t & 1) === 0) return ft(e, ke()), null;
  var n = Sa(e, t);
  if (e.tag !== 0 && n === 2) {
    var i = Pl(e);
    i !== 0 && ((t = i), (n = rc(e, i)));
  }
  if (n === 1) throw ((n = ro), ni(e, 0), Tn(e, t), ft(e, ke()), n);
  if (n === 6) throw Error(S(345));
  return (e.finishedWork = e.current.alternate), (e.finishedLanes = t), Xn(e, dt, an), ft(e, ke()), null;
}
function su(e, t) {
  var n = te;
  te |= 1;
  try {
    return e(t);
  } finally {
    (te = n), te === 0 && ((tr = ke() + 500), Oa && $n());
  }
}
function ui(e) {
  Pn !== null && Pn.tag === 0 && (te & 6) === 0 && qi();
  var t = te;
  te |= 1;
  var n = Pt.transition,
    i = se;
  try {
    if (((Pt.transition = null), (se = 1), e)) return e();
  } finally {
    (se = i), (Pt.transition = n), (te = t), (te & 6) === 0 && $n();
  }
}
function lu() {
  (xt = ji.current), fe(ji);
}
function ni(e, t) {
  (e.finishedWork = null), (e.finishedLanes = 0);
  var n = e.timeoutHandle;
  if ((n !== -1 && ((e.timeoutHandle = -1), a_(n)), Me !== null))
    for (n = Me.return; n !== null; ) {
      var i = n;
      switch ((Uc(i), i.tag)) {
        case 1:
          (i = i.type.childContextTypes), i != null && pa();
          break;
        case 3:
          Yi(), fe(ht), fe(et), Xc();
          break;
        case 5:
          Kc(i);
          break;
        case 4:
          Yi();
          break;
        case 13:
          fe(_e);
          break;
        case 19:
          fe(_e);
          break;
        case 10:
          Vc(i.type._context);
          break;
        case 22:
        case 23:
          lu();
      }
      n = n.return;
    }
  if (
    ((Fe = e),
    (Me = e = Fn(e.current, null)),
    ($e = xt = t),
    (Ce = 0),
    (ro = null),
    (ou = ja = ci = 0),
    (dt = jr = null),
    Yn !== null)
  ) {
    for (t = 0; t < Yn.length; t++)
      if (((n = Yn[t]), (i = n.interleaved), i !== null)) {
        n.interleaved = null;
        var r = i.next,
          o = n.pending;
        if (o !== null) {
          var a = o.next;
          (o.next = r), (i.next = a);
        }
        n.pending = i;
      }
    Yn = null;
  }
  return e;
}
function Zm(e, t) {
  do {
    var n = Me;
    try {
      if ((Jc(), (Wo.current = ya), Ea)) {
        for (var i = xe.memoizedState; i !== null; ) {
          var r = i.queue;
          r !== null && (r.pending = null), (i = i.next);
        }
        Ea = !1;
      }
      if (
        ((li = 0), (He = Pe = xe = null), (Hr = !1), (to = 0), (ru.current = null), n === null || n.return === null)
      ) {
        (Ce = 1), (ro = t), (Me = null);
        break;
      }
      e: {
        var o = e,
          a = n.return,
          s = n,
          l = t;
        if (((t = $e), (s.flags |= 32768), l !== null && typeof l == 'object' && typeof l.then == 'function')) {
          var c = l,
            u = s,
            m = u.tag;
          if ((u.mode & 1) === 0 && (m === 0 || m === 11 || m === 15)) {
            var h = u.alternate;
            h
              ? ((u.updateQueue = h.updateQueue), (u.memoizedState = h.memoizedState), (u.lanes = h.lanes))
              : ((u.updateQueue = null), (u.memoizedState = null));
          }
          var v = Gd(a);
          if (v !== null) {
            (v.flags &= -257), Jd(v, a, s, o, t), v.mode & 1 && $d(o, c, t), (t = v), (l = c);
            var x = t.updateQueue;
            if (x === null) {
              var f = new Set();
              f.add(l), (t.updateQueue = f);
            } else x.add(l);
            break e;
          } else {
            if ((t & 1) === 0) {
              $d(o, c, t), cu();
              break e;
            }
            l = Error(S(426));
          }
        } else if (ge && s.mode & 1) {
          var D = Gd(a);
          if (D !== null) {
            (D.flags & 65536) === 0 && (D.flags |= 256), Jd(D, a, s, o, t), $c(er(l, s));
            break e;
          }
        }
        (o = l = er(l, s)), Ce !== 4 && (Ce = 2), jr === null ? (jr = [o]) : jr.push(o), (o = a);
        do {
          switch (o.tag) {
            case 3:
              (o.flags |= 65536), (t &= -t), (o.lanes |= t);
              var p = Om(o, l, t);
              Ld(o, p);
              break e;
            case 1:
              s = l;
              var d = o.type,
                g = o.stateNode;
              if (
                (o.flags & 128) === 0 &&
                (typeof d.getDerivedStateFromError == 'function' ||
                  (g !== null && typeof g.componentDidCatch == 'function' && (Ln === null || !Ln.has(g))))
              ) {
                (o.flags |= 65536), (t &= -t), (o.lanes |= t);
                var y = Lm(o, s, t);
                Ld(o, y);
                break e;
              }
          }
          o = o.return;
        } while (o !== null);
      }
      tf(n);
    } catch (b) {
      (t = b), Me === n && n !== null && (Me = n = n.return);
      continue;
    }
    break;
  } while (1);
}
function Ym() {
  var e = Aa.current;
  return (Aa.current = ya), e === null ? ya : e;
}
function cu() {
  (Ce === 0 || Ce === 3 || Ce === 2) && (Ce = 4),
    Fe === null || ((ci & 268435455) === 0 && (ja & 268435455) === 0) || Tn(Fe, $e);
}
function Sa(e, t) {
  var n = te;
  te |= 2;
  var i = Ym();
  (Fe !== e || $e !== t) && ((an = null), ni(e, t));
  do
    try {
      C_();
      break;
    } catch (r) {
      Zm(e, r);
    }
  while (1);
  if ((Jc(), (te = n), (Aa.current = i), Me !== null)) throw Error(S(261));
  return (Fe = null), ($e = 0), Ce;
}
function C_() {
  for (; Me !== null; ) ef(Me);
}
function N_() {
  for (; Me !== null && !iv(); ) ef(Me);
}
function ef(e) {
  var t = rf(e.alternate, e, xt);
  (e.memoizedProps = e.pendingProps), t === null ? tf(e) : (Me = t), (ru.current = null);
}
function tf(e) {
  var t = e;
  do {
    var n = t.alternate;
    if (((e = t.return), (t.flags & 32768) === 0)) {
      if (((n = k_(n, t, xt)), n !== null)) {
        Me = n;
        return;
      }
    } else {
      if (((n = S_(n, t)), n !== null)) {
        (n.flags &= 32767), (Me = n);
        return;
      }
      if (e !== null) (e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null);
      else {
        (Ce = 6), (Me = null);
        return;
      }
    }
    if (((t = t.sibling), t !== null)) {
      Me = t;
      return;
    }
    Me = t = e;
  } while (t !== null);
  Ce === 0 && (Ce = 5);
}
function Xn(e, t, n) {
  var i = se,
    r = Pt.transition;
  try {
    (Pt.transition = null), (se = 1), I_(e, t, n, i);
  } finally {
    (Pt.transition = r), (se = i);
  }
  return null;
}
function I_(e, t, n, i) {
  do qi();
  while (Pn !== null);
  if ((te & 6) !== 0) throw Error(S(327));
  n = e.finishedWork;
  var r = e.finishedLanes;
  if (n === null) return null;
  if (((e.finishedWork = null), (e.finishedLanes = 0), n === e.current)) throw Error(S(177));
  (e.callbackNode = null), (e.callbackPriority = 0);
  var o = n.lanes | n.childLanes;
  if (
    (hv(e, o),
    e === Fe && ((Me = Fe = null), ($e = 0)),
    ((n.subtreeFlags & 2064) === 0 && (n.flags & 2064) === 0) ||
      Fo ||
      ((Fo = !0),
      of(aa, function () {
        return qi(), null;
      })),
    (o = (n.flags & 15990) !== 0),
    (n.subtreeFlags & 15990) !== 0 || o)
  ) {
    (o = Pt.transition), (Pt.transition = null);
    var a = se;
    se = 1;
    var s = te;
    (te |= 4),
      (ru.current = null),
      M_(e, n),
      Wm(n, e),
      Yv(Ll),
      (la = !!Ol),
      (Ll = Ol = null),
      (e.current = n),
      T_(n),
      rv(),
      (te = s),
      (se = a),
      (Pt.transition = o);
  } else e.current = n;
  if (
    (Fo && ((Fo = !1), (Pn = e), (ka = r)),
    (o = e.pendingLanes),
    o === 0 && (Ln = null),
    sv(n.stateNode),
    ft(e, ke()),
    t !== null)
  )
    for (i = e.onRecoverableError, n = 0; n < t.length; n++)
      (r = t[n]), i(r.value, { componentStack: r.stack, digest: r.digest });
  if (wa) throw ((wa = !1), (e = nc), (nc = null), e);
  return (
    (ka & 1) !== 0 && e.tag !== 0 && qi(),
    (o = e.pendingLanes),
    (o & 1) !== 0 ? (e === ic ? zr++ : ((zr = 0), (ic = e))) : (zr = 0),
    $n(),
    null
  );
}
function qi() {
  if (Pn !== null) {
    var e = Dh(ka),
      t = Pt.transition,
      n = se;
    try {
      if (((Pt.transition = null), (se = 16 > e ? 16 : e), Pn === null)) var i = !1;
      else {
        if (((e = Pn), (Pn = null), (ka = 0), (te & 6) !== 0)) throw Error(S(331));
        var r = te;
        for (te |= 4, F = e.current; F !== null; ) {
          var o = F,
            a = o.child;
          if ((F.flags & 16) !== 0) {
            var s = o.deletions;
            if (s !== null) {
              for (var l = 0; l < s.length; l++) {
                var c = s[l];
                for (F = c; F !== null; ) {
                  var u = F;
                  switch (u.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Fr(8, u, o);
                  }
                  var m = u.child;
                  if (m !== null) (m.return = u), (F = m);
                  else
                    for (; F !== null; ) {
                      u = F;
                      var h = u.sibling,
                        v = u.return;
                      if ((Vm(u), u === c)) {
                        F = null;
                        break;
                      }
                      if (h !== null) {
                        (h.return = v), (F = h);
                        break;
                      }
                      F = v;
                    }
                }
              }
              var x = o.alternate;
              if (x !== null) {
                var f = x.child;
                if (f !== null) {
                  x.child = null;
                  do {
                    var D = f.sibling;
                    (f.sibling = null), (f = D);
                  } while (f !== null);
                }
              }
              F = o;
            }
          }
          if ((o.subtreeFlags & 2064) !== 0 && a !== null) (a.return = o), (F = a);
          else
            e: for (; F !== null; ) {
              if (((o = F), (o.flags & 2048) !== 0))
                switch (o.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Fr(9, o, o.return);
                }
              var p = o.sibling;
              if (p !== null) {
                (p.return = o.return), (F = p);
                break e;
              }
              F = o.return;
            }
        }
        var d = e.current;
        for (F = d; F !== null; ) {
          a = F;
          var g = a.child;
          if ((a.subtreeFlags & 2064) !== 0 && g !== null) (g.return = a), (F = g);
          else
            e: for (a = d; F !== null; ) {
              if (((s = F), (s.flags & 2048) !== 0))
                try {
                  switch (s.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Fa(9, s);
                  }
                } catch (b) {
                  ye(s, s.return, b);
                }
              if (s === a) {
                F = null;
                break e;
              }
              var y = s.sibling;
              if (y !== null) {
                (y.return = s.return), (F = y);
                break e;
              }
              F = s.return;
            }
        }
        if (((te = r), $n(), Xt && typeof Xt.onPostCommitFiberRoot == 'function'))
          try {
            Xt.onPostCommitFiberRoot(Pa, e);
          } catch {}
        i = !0;
      }
      return i;
    } finally {
      (se = n), (Pt.transition = t);
    }
  }
  return !1;
}
function rp(e, t, n) {
  (t = er(n, t)), (t = Om(e, t, 1)), (e = On(e, t, 1)), (t = ot()), e !== null && (ao(e, 1, t), ft(e, t));
}
function ye(e, t, n) {
  if (e.tag === 3) rp(e, e, n);
  else
    for (; t !== null; ) {
      if (t.tag === 3) {
        rp(t, e, n);
        break;
      } else if (t.tag === 1) {
        var i = t.stateNode;
        if (
          typeof t.type.getDerivedStateFromError == 'function' ||
          (typeof i.componentDidCatch == 'function' && (Ln === null || !Ln.has(i)))
        ) {
          (e = er(n, e)), (e = Lm(t, e, 1)), (t = On(t, e, 1)), (e = ot()), t !== null && (ao(t, 1, e), ft(t, e));
          break;
        }
      }
      t = t.return;
    }
}
function D_(e, t, n) {
  var i = e.pingCache;
  i !== null && i.delete(t),
    (t = ot()),
    (e.pingedLanes |= e.suspendedLanes & n),
    Fe === e &&
      ($e & n) === n &&
      (Ce === 4 || (Ce === 3 && ($e & 130023424) === $e && 500 > ke() - au) ? ni(e, 0) : (ou |= n)),
    ft(e, t);
}
function nf(e, t) {
  t === 0 && ((e.mode & 1) === 0 ? (t = 1) : ((t = To), (To <<= 1), (To & 130023424) === 0 && (To = 4194304)));
  var n = ot();
  (e = hn(e, t)), e !== null && (ao(e, t, n), ft(e, n));
}
function O_(e) {
  var t = e.memoizedState,
    n = 0;
  t !== null && (n = t.retryLane), nf(e, n);
}
function L_(e, t) {
  var n = 0;
  switch (e.tag) {
    case 13:
      var i = e.stateNode,
        r = e.memoizedState;
      r !== null && (n = r.retryLane);
      break;
    case 19:
      i = e.stateNode;
      break;
    default:
      throw Error(S(314));
  }
  i !== null && i.delete(t), nf(e, n);
}
var rf;
rf = function (e, t, n) {
  if (e !== null)
    if (e.memoizedProps !== t.pendingProps || ht.current) pt = !0;
    else {
      if ((e.lanes & n) === 0 && (t.flags & 128) === 0) return (pt = !1), w_(e, t, n);
      pt = (e.flags & 131072) !== 0;
    }
  else (pt = !1), ge && (t.flags & 1048576) !== 0 && am(t, fa, t.index);
  switch (((t.lanes = 0), t.tag)) {
    case 2:
      var i = t.type;
      Xo(e, t), (e = t.pendingProps);
      var r = Ki(t, et.current);
      Vi(t, n), (r = Yc(null, t, i, e, r, n));
      var o = eu();
      return (
        (t.flags |= 1),
        typeof r == 'object' && r !== null && typeof r.render == 'function' && r.$$typeof === void 0
          ? ((t.tag = 1),
            (t.memoizedState = null),
            (t.updateQueue = null),
            mt(i) ? ((o = !0), ha(t)) : (o = !1),
            (t.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null),
            Qc(t),
            (r.updater = La),
            (t.stateNode = r),
            (r._reactInternals = t),
            Jl(t, i, e, n),
            (t = Ql(null, t, i, !0, o, n)))
          : ((t.tag = 0), ge && o && Bc(t), rt(null, t, r, n), (t = t.child)),
        t
      );
    case 16:
      i = t.elementType;
      e: {
        switch (
          (Xo(e, t),
          (e = t.pendingProps),
          (r = i._init),
          (i = r(i._payload)),
          (t.type = i),
          (r = t.tag = F_(i)),
          (e = Ot(i, e)),
          r)
        ) {
          case 0:
            t = ql(null, t, i, e, n);
            break e;
          case 1:
            t = Qd(null, t, i, e, n);
            break e;
          case 11:
            t = Vd(null, t, i, e, n);
            break e;
          case 14:
            t = qd(null, t, i, Ot(i.type, e), n);
            break e;
        }
        throw Error(S(306, i, ''));
      }
      return t;
    case 0:
      return (i = t.type), (r = t.pendingProps), (r = t.elementType === i ? r : Ot(i, r)), ql(e, t, i, r, n);
    case 1:
      return (i = t.type), (r = t.pendingProps), (r = t.elementType === i ? r : Ot(i, r)), Qd(e, t, i, r, n);
    case 3:
      e: {
        if ((zm(t), e === null)) throw Error(S(387));
        (i = t.pendingProps), (o = t.memoizedState), (r = o.element), um(e, t), _a(t, i, null, n);
        var a = t.memoizedState;
        if (((i = a.element), o.isDehydrated))
          if (
            ((o = {
              element: i,
              isDehydrated: !1,
              cache: a.cache,
              pendingSuspenseBoundaries: a.pendingSuspenseBoundaries,
              transitions: a.transitions,
            }),
            (t.updateQueue.baseState = o),
            (t.memoizedState = o),
            t.flags & 256)
          ) {
            (r = er(Error(S(423)), t)), (t = Wd(e, t, i, n, r));
            break e;
          } else if (i !== r) {
            (r = er(Error(S(424)), t)), (t = Wd(e, t, i, n, r));
            break e;
          } else
            for (
              Et = Dn(t.stateNode.containerInfo.firstChild),
                yt = t,
                ge = !0,
                Ht = null,
                n = mm(t, null, i, n),
                t.child = n;
              n;

            )
              (n.flags = (n.flags & -3) | 4096), (n = n.sibling);
        else {
          if ((Xi(), i === r)) {
            t = mn(e, t, n);
            break e;
          }
          rt(e, t, i, n);
        }
        t = t.child;
      }
      return t;
    case 5:
      return (
        fm(t),
        e === null && Ul(t),
        (i = t.type),
        (r = t.pendingProps),
        (o = e !== null ? e.memoizedProps : null),
        (a = r.children),
        Hl(i, r) ? (a = null) : o !== null && Hl(i, o) && (t.flags |= 32),
        jm(e, t),
        rt(e, t, a, n),
        t.child
      );
    case 6:
      return e === null && Ul(t), null;
    case 13:
      return Bm(e, t, n);
    case 4:
      return (
        Wc(t, t.stateNode.containerInfo),
        (i = t.pendingProps),
        e === null ? (t.child = Zi(t, null, i, n)) : rt(e, t, i, n),
        t.child
      );
    case 11:
      return (i = t.type), (r = t.pendingProps), (r = t.elementType === i ? r : Ot(i, r)), Vd(e, t, i, r, n);
    case 7:
      return rt(e, t, t.pendingProps, n), t.child;
    case 8:
      return rt(e, t, t.pendingProps.children, n), t.child;
    case 12:
      return rt(e, t, t.pendingProps.children, n), t.child;
    case 10:
      e: {
        if (
          ((i = t.type._context),
          (r = t.pendingProps),
          (o = t.memoizedProps),
          (a = r.value),
          pe(ga, i._currentValue),
          (i._currentValue = a),
          o !== null)
        )
          if (zt(o.value, a)) {
            if (o.children === r.children && !ht.current) {
              t = mn(e, t, n);
              break e;
            }
          } else
            for (o = t.child, o !== null && (o.return = t); o !== null; ) {
              var s = o.dependencies;
              if (s !== null) {
                a = o.child;
                for (var l = s.firstContext; l !== null; ) {
                  if (l.context === i) {
                    if (o.tag === 1) {
                      (l = un(-1, n & -n)), (l.tag = 2);
                      var c = o.updateQueue;
                      if (c !== null) {
                        c = c.shared;
                        var u = c.pending;
                        u === null ? (l.next = l) : ((l.next = u.next), (u.next = l)), (c.pending = l);
                      }
                    }
                    (o.lanes |= n), (l = o.alternate), l !== null && (l.lanes |= n), $l(o.return, n, t), (s.lanes |= n);
                    break;
                  }
                  l = l.next;
                }
              } else if (o.tag === 10) a = o.type === t.type ? null : o.child;
              else if (o.tag === 18) {
                if (((a = o.return), a === null)) throw Error(S(341));
                (a.lanes |= n), (s = a.alternate), s !== null && (s.lanes |= n), $l(a, n, t), (a = o.sibling);
              } else a = o.child;
              if (a !== null) a.return = o;
              else
                for (a = o; a !== null; ) {
                  if (a === t) {
                    a = null;
                    break;
                  }
                  if (((o = a.sibling), o !== null)) {
                    (o.return = a.return), (a = o);
                    break;
                  }
                  a = a.return;
                }
              o = a;
            }
        rt(e, t, r.children, n), (t = t.child);
      }
      return t;
    case 9:
      return (
        (r = t.type),
        (i = t.pendingProps.children),
        Vi(t, n),
        (r = Ct(r)),
        (i = i(r)),
        (t.flags |= 1),
        rt(e, t, i, n),
        t.child
      );
    case 14:
      return (i = t.type), (r = Ot(i, t.pendingProps)), (r = Ot(i.type, r)), qd(e, t, i, r, n);
    case 15:
      return Hm(e, t, t.type, t.pendingProps, n);
    case 17:
      return (
        (i = t.type),
        (r = t.pendingProps),
        (r = t.elementType === i ? r : Ot(i, r)),
        Xo(e, t),
        (t.tag = 1),
        mt(i) ? ((e = !0), ha(t)) : (e = !1),
        Vi(t, n),
        pm(t, i, r),
        Jl(t, i, r, n),
        Ql(null, t, i, !0, e, n)
      );
    case 19:
      return Um(e, t, n);
    case 22:
      return Fm(e, t, n);
  }
  throw Error(S(156, t.tag));
};
function of(e, t) {
  return Ph(e, t);
}
function H_(e, t, n, i) {
  (this.tag = e),
    (this.key = n),
    (this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null),
    (this.index = 0),
    (this.ref = null),
    (this.pendingProps = t),
    (this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null),
    (this.mode = i),
    (this.subtreeFlags = this.flags = 0),
    (this.deletions = null),
    (this.childLanes = this.lanes = 0),
    (this.alternate = null);
}
function Rt(e, t, n, i) {
  return new H_(e, t, n, i);
}
function uu(e) {
  return (e = e.prototype), !(!e || !e.isReactComponent);
}
function F_(e) {
  if (typeof e == 'function') return uu(e) ? 1 : 0;
  if (e != null) {
    if (((e = e.$$typeof), e === Rc)) return 11;
    if (e === Pc) return 14;
  }
  return 2;
}
function Fn(e, t) {
  var n = e.alternate;
  return (
    n === null
      ? ((n = Rt(e.tag, t, e.key, e.mode)),
        (n.elementType = e.elementType),
        (n.type = e.type),
        (n.stateNode = e.stateNode),
        (n.alternate = e),
        (e.alternate = n))
      : ((n.pendingProps = t), (n.type = e.type), (n.flags = 0), (n.subtreeFlags = 0), (n.deletions = null)),
    (n.flags = e.flags & 14680064),
    (n.childLanes = e.childLanes),
    (n.lanes = e.lanes),
    (n.child = e.child),
    (n.memoizedProps = e.memoizedProps),
    (n.memoizedState = e.memoizedState),
    (n.updateQueue = e.updateQueue),
    (t = e.dependencies),
    (n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }),
    (n.sibling = e.sibling),
    (n.index = e.index),
    (n.ref = e.ref),
    n
  );
}
function ea(e, t, n, i, r, o) {
  var a = 2;
  if (((i = e), typeof e == 'function')) uu(e) && (a = 1);
  else if (typeof e == 'string') a = 5;
  else
    e: switch (e) {
      case Ri:
        return ii(n.children, r, o, t);
      case Tc:
        (a = 8), (r |= 8);
        break;
      case fl:
        return (e = Rt(12, n, t, r | 2)), (e.elementType = fl), (e.lanes = o), e;
      case gl:
        return (e = Rt(13, n, t, r)), (e.elementType = gl), (e.lanes = o), e;
      case vl:
        return (e = Rt(19, n, t, r)), (e.elementType = vl), (e.lanes = o), e;
      case hh:
        return za(n, r, o, t);
      default:
        if (typeof e == 'object' && e !== null)
          switch (e.$$typeof) {
            case dh:
              a = 10;
              break e;
            case ph:
              a = 9;
              break e;
            case Rc:
              a = 11;
              break e;
            case Pc:
              a = 14;
              break e;
            case Sn:
              (a = 16), (i = null);
              break e;
          }
        throw Error(S(130, e == null ? e : typeof e, ''));
    }
  return (t = Rt(a, n, t, r)), (t.elementType = e), (t.type = i), (t.lanes = o), t;
}
function ii(e, t, n, i) {
  return (e = Rt(7, e, i, t)), (e.lanes = n), e;
}
function za(e, t, n, i) {
  return (e = Rt(22, e, i, t)), (e.elementType = hh), (e.lanes = n), (e.stateNode = { isHidden: !1 }), e;
}
function el(e, t, n) {
  return (e = Rt(6, e, null, t)), (e.lanes = n), e;
}
function tl(e, t, n) {
  return (
    (t = Rt(4, e.children !== null ? e.children : [], e.key, t)),
    (t.lanes = n),
    (t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }),
    t
  );
}
function j_(e, t, n, i, r) {
  (this.tag = t),
    (this.containerInfo = e),
    (this.finishedWork = this.pingCache = this.current = this.pendingChildren = null),
    (this.timeoutHandle = -1),
    (this.callbackNode = this.pendingContext = this.context = null),
    (this.callbackPriority = 0),
    (this.eventTimes = Os(0)),
    (this.expirationTimes = Os(-1)),
    (this.entangledLanes =
      this.finishedLanes =
      this.mutableReadLanes =
      this.expiredLanes =
      this.pingedLanes =
      this.suspendedLanes =
      this.pendingLanes =
        0),
    (this.entanglements = Os(0)),
    (this.identifierPrefix = i),
    (this.onRecoverableError = r),
    (this.mutableSourceEagerHydrationData = null);
}
function du(e, t, n, i, r, o, a, s, l) {
  return (
    (e = new j_(e, t, n, s, l)),
    t === 1 ? ((t = 1), o === !0 && (t |= 8)) : (t = 0),
    (o = Rt(3, null, null, t)),
    (e.current = o),
    (o.stateNode = e),
    (o.memoizedState = {
      element: i,
      isDehydrated: n,
      cache: null,
      transitions: null,
      pendingSuspenseBoundaries: null,
    }),
    Qc(o),
    e
  );
}
function z_(e, t, n) {
  var i = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: Ti, key: i == null ? null : '' + i, children: e, containerInfo: t, implementation: n };
}
function af(e) {
  if (!e) return zn;
  e = e._reactInternals;
  e: {
    if (hi(e) !== e || e.tag !== 1) throw Error(S(170));
    var t = e;
    do {
      switch (t.tag) {
        case 3:
          t = t.stateNode.context;
          break e;
        case 1:
          if (mt(t.type)) {
            t = t.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      t = t.return;
    } while (t !== null);
    throw Error(S(171));
  }
  if (e.tag === 1) {
    var n = e.type;
    if (mt(n)) return rm(e, n, t);
  }
  return t;
}
function sf(e, t, n, i, r, o, a, s, l) {
  return (
    (e = du(n, i, !0, e, r, o, a, s, l)),
    (e.context = af(null)),
    (n = e.current),
    (i = ot()),
    (r = Hn(n)),
    (o = un(i, r)),
    (o.callback = t != null ? t : null),
    On(n, o, r),
    (e.current.lanes = r),
    ao(e, r, i),
    ft(e, i),
    e
  );
}
function Ba(e, t, n, i) {
  var r = t.current,
    o = ot(),
    a = Hn(r);
  return (
    (n = af(n)),
    t.context === null ? (t.context = n) : (t.pendingContext = n),
    (t = un(o, a)),
    (t.payload = { element: e }),
    (i = i === void 0 ? null : i),
    i !== null && (t.callback = i),
    (e = On(r, t, a)),
    e !== null && (jt(e, r, a, o), Qo(e, r, a)),
    a
  );
}
function ba(e) {
  if (((e = e.current), !e.child)) return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function op(e, t) {
  if (((e = e.memoizedState), e !== null && e.dehydrated !== null)) {
    var n = e.retryLane;
    e.retryLane = n !== 0 && n < t ? n : t;
  }
}
function pu(e, t) {
  op(e, t), (e = e.alternate) && op(e, t);
}
function B_() {
  return null;
}
var lf =
  typeof reportError == 'function'
    ? reportError
    : function (e) {
        console.error(e);
      };
function hu(e) {
  this._internalRoot = e;
}
Ua.prototype.render = hu.prototype.render = function (e) {
  var t = this._internalRoot;
  if (t === null) throw Error(S(409));
  Ba(e, t, null, null);
};
Ua.prototype.unmount = hu.prototype.unmount = function () {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var t = e.containerInfo;
    ui(function () {
      Ba(null, e, null, null);
    }),
      (t[pn] = null);
  }
};
function Ua(e) {
  this._internalRoot = e;
}
Ua.prototype.unstable_scheduleHydration = function (e) {
  if (e) {
    var t = Hh();
    e = { blockedOn: null, target: e, priority: t };
    for (var n = 0; n < Mn.length && t !== 0 && t < Mn[n].priority; n++);
    Mn.splice(n, 0, e), n === 0 && jh(e);
  }
};
function mu(e) {
  return !(!e || (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11));
}
function $a(e) {
  return !(
    !e ||
    (e.nodeType !== 1 &&
      e.nodeType !== 9 &&
      e.nodeType !== 11 &&
      (e.nodeType !== 8 || e.nodeValue !== ' react-mount-point-unstable '))
  );
}
function ap() {}
function U_(e, t, n, i, r) {
  if (r) {
    if (typeof i == 'function') {
      var o = i;
      i = function () {
        var c = ba(a);
        o.call(c);
      };
    }
    var a = sf(t, i, e, 0, null, !1, !1, '', ap);
    return (e._reactRootContainer = a), (e[pn] = a.current), Kr(e.nodeType === 8 ? e.parentNode : e), ui(), a;
  }
  for (; (r = e.lastChild); ) e.removeChild(r);
  if (typeof i == 'function') {
    var s = i;
    i = function () {
      var c = ba(l);
      s.call(c);
    };
  }
  var l = du(e, 0, !1, null, null, !1, !1, '', ap);
  return (
    (e._reactRootContainer = l),
    (e[pn] = l.current),
    Kr(e.nodeType === 8 ? e.parentNode : e),
    ui(function () {
      Ba(t, l, n, i);
    }),
    l
  );
}
function Ga(e, t, n, i, r) {
  var o = n._reactRootContainer;
  if (o) {
    var a = o;
    if (typeof r == 'function') {
      var s = r;
      r = function () {
        var l = ba(a);
        s.call(l);
      };
    }
    Ba(t, a, e, r);
  } else a = U_(n, t, e, r, i);
  return ba(a);
}
Oh = function (e) {
  switch (e.tag) {
    case 3:
      var t = e.stateNode;
      if (t.current.memoizedState.isDehydrated) {
        var n = Rr(t.pendingLanes);
        n !== 0 && (Ic(t, n | 1), ft(t, ke()), (te & 6) === 0 && ((tr = ke() + 500), $n()));
      }
      break;
    case 13:
      ui(function () {
        var i = hn(e, 1);
        if (i !== null) {
          var r = ot();
          jt(i, e, 1, r);
        }
      }),
        pu(e, 1);
  }
};
Dc = function (e) {
  if (e.tag === 13) {
    var t = hn(e, 134217728);
    if (t !== null) {
      var n = ot();
      jt(t, e, 134217728, n);
    }
    pu(e, 134217728);
  }
};
Lh = function (e) {
  if (e.tag === 13) {
    var t = Hn(e),
      n = hn(e, t);
    if (n !== null) {
      var i = ot();
      jt(n, e, t, i);
    }
    pu(e, t);
  }
};
Hh = function () {
  return se;
};
Fh = function (e, t) {
  var n = se;
  try {
    return (se = e), t();
  } finally {
    se = n;
  }
};
Ml = function (e, t, n) {
  switch (t) {
    case 'input':
      if ((El(e, n), (t = n.name), n.type === 'radio' && t != null)) {
        for (n = e; n.parentNode; ) n = n.parentNode;
        for (
          n = n.querySelectorAll('input[name=' + JSON.stringify('' + t) + '][type="radio"]'), t = 0;
          t < n.length;
          t++
        ) {
          var i = n[t];
          if (i !== e && i.form === e.form) {
            var r = Da(i);
            if (!r) throw Error(S(90));
            fh(i), El(i, r);
          }
        }
      }
      break;
    case 'textarea':
      vh(e, n);
      break;
    case 'select':
      (t = n.value), t != null && Ui(e, !!n.multiple, t, !1);
  }
};
kh = su;
Sh = ui;
var $_ = { usingClientEntryPoint: !1, Events: [lo, Ii, Da, Ah, wh, su] },
  kr = { findFiberByHostInstance: Zn, bundleType: 0, version: '18.2.0', rendererPackageName: 'react-dom' },
  G_ = {
    bundleType: kr.bundleType,
    version: kr.version,
    rendererPackageName: kr.rendererPackageName,
    rendererConfig: kr.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: vn.ReactCurrentDispatcher,
    findHostInstanceByFiber: function (e) {
      return (e = Th(e)), e === null ? null : e.stateNode;
    },
    findFiberByHostInstance: kr.findFiberByHostInstance || B_,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: '18.2.0-next-9e3b772b8-20220608',
  };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u') {
  var jo = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!jo.isDisabled && jo.supportsFiber)
    try {
      (Pa = jo.inject(G_)), (Xt = jo);
    } catch {}
}
wt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $_;
wt.createPortal = function (e, t) {
  var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!mu(t)) throw Error(S(200));
  return z_(e, t, null, n);
};
wt.createRoot = function (e, t) {
  if (!mu(e)) throw Error(S(299));
  var n = !1,
    i = '',
    r = lf;
  return (
    t != null &&
      (t.unstable_strictMode === !0 && (n = !0),
      t.identifierPrefix !== void 0 && (i = t.identifierPrefix),
      t.onRecoverableError !== void 0 && (r = t.onRecoverableError)),
    (t = du(e, 1, !1, null, null, n, !1, i, r)),
    (e[pn] = t.current),
    Kr(e.nodeType === 8 ? e.parentNode : e),
    new hu(t)
  );
};
wt.findDOMNode = function (e) {
  if (e == null) return null;
  if (e.nodeType === 1) return e;
  var t = e._reactInternals;
  if (t === void 0)
    throw typeof e.render == 'function' ? Error(S(188)) : ((e = Object.keys(e).join(',')), Error(S(268, e)));
  return (e = Th(t)), (e = e === null ? null : e.stateNode), e;
};
wt.flushSync = function (e) {
  return ui(e);
};
wt.hydrate = function (e, t, n) {
  if (!$a(t)) throw Error(S(200));
  return Ga(null, e, t, !0, n);
};
wt.hydrateRoot = function (e, t, n) {
  if (!mu(e)) throw Error(S(405));
  var i = (n != null && n.hydratedSources) || null,
    r = !1,
    o = '',
    a = lf;
  if (
    (n != null &&
      (n.unstable_strictMode === !0 && (r = !0),
      n.identifierPrefix !== void 0 && (o = n.identifierPrefix),
      n.onRecoverableError !== void 0 && (a = n.onRecoverableError)),
    (t = sf(t, null, e, 1, n != null ? n : null, r, !1, o, a)),
    (e[pn] = t.current),
    Kr(e),
    i)
  )
    for (e = 0; e < i.length; e++)
      (n = i[e]),
        (r = n._getVersion),
        (r = r(n._source)),
        t.mutableSourceEagerHydrationData == null
          ? (t.mutableSourceEagerHydrationData = [n, r])
          : t.mutableSourceEagerHydrationData.push(n, r);
  return new Ua(t);
};
wt.render = function (e, t, n) {
  if (!$a(t)) throw Error(S(200));
  return Ga(null, e, t, !1, n);
};
wt.unmountComponentAtNode = function (e) {
  if (!$a(e)) throw Error(S(40));
  return e._reactRootContainer
    ? (ui(function () {
        Ga(null, null, e, !1, function () {
          (e._reactRootContainer = null), (e[pn] = null);
        });
      }),
      !0)
    : !1;
};
wt.unstable_batchedUpdates = su;
wt.unstable_renderSubtreeIntoContainer = function (e, t, n, i) {
  if (!$a(n)) throw Error(S(200));
  if (e == null || e._reactInternals === void 0) throw Error(S(38));
  return Ga(e, t, n, !1, i);
};
wt.version = '18.2.0-next-9e3b772b8-20220608';
(function (e) {
  function t() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
      } catch (n) {
        console.error(n);
      }
  }
  t(), (e.exports = wt);
})(ah);
var cf,
  sp = ah.exports;
(cf = sp.createRoot), sp.hydrateRoot;
/**
 * @remix-run/router v1.0.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function be() {
  return (
    (be = Object.assign
      ? Object.assign.bind()
      : function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
          return e;
        }),
    be.apply(this, arguments)
  );
}
var Re;
(function (e) {
  (e.Pop = 'POP'), (e.Push = 'PUSH'), (e.Replace = 'REPLACE');
})(Re || (Re = {}));
const lp = 'popstate';
function J_(e) {
  e === void 0 && (e = {});
  function t(i, r) {
    var o, a;
    let { pathname: s, search: l, hash: c } = i.location;
    return ri(
      '',
      { pathname: s, search: l, hash: c },
      ((o = r.state) == null ? void 0 : o.usr) || null,
      ((a = r.state) == null ? void 0 : a.key) || 'default',
    );
  }
  function n(i, r) {
    return typeof r == 'string' ? r : ac(r);
  }
  return q_(t, n, null, e);
}
function V_() {
  return Math.random().toString(36).substr(2, 8);
}
function cp(e) {
  return { usr: e.state, key: e.key };
}
function ri(e, t, n, i) {
  return (
    n === void 0 && (n = null),
    be({ pathname: typeof e == 'string' ? e : e.pathname, search: '', hash: '' }, typeof t == 'string' ? fn(t) : t, {
      state: n,
      key: (t == null ? void 0 : t.key) || i || V_(),
    })
  );
}
function ac(e) {
  let { pathname: t = '/', search: n = '', hash: i = '' } = e;
  return (
    n && n !== '?' && (t += n.charAt(0) === '?' ? n : '?' + n),
    i && i !== '#' && (t += i.charAt(0) === '#' ? i : '#' + i),
    t
  );
}
function fn(e) {
  let t = {};
  if (e) {
    let n = e.indexOf('#');
    n >= 0 && ((t.hash = e.substr(n)), (e = e.substr(0, n)));
    let i = e.indexOf('?');
    i >= 0 && ((t.search = e.substr(i)), (e = e.substr(0, i))), e && (t.pathname = e);
  }
  return t;
}
function q_(e, t, n, i) {
  i === void 0 && (i = {});
  let { window: r = document.defaultView, v5Compat: o = !1 } = i,
    a = r.history,
    s = Re.Pop,
    l = null;
  function c() {
    (s = Re.Pop), l && l({ action: s, location: h.location });
  }
  function u(v, x) {
    s = Re.Push;
    let f = ri(h.location, v, x);
    n == null || n(f, v);
    let D = cp(f),
      p = h.createHref(f);
    try {
      a.pushState(D, '', p);
    } catch {
      r.location.assign(p);
    }
    o && l && l({ action: s, location: f });
  }
  function m(v, x) {
    s = Re.Replace;
    let f = ri(h.location, v, x);
    n == null || n(f, v);
    let D = cp(f),
      p = h.createHref(f);
    a.replaceState(D, '', p), o && l && l({ action: s, location: f });
  }
  let h = {
    get action() {
      return s;
    },
    get location() {
      return e(r, a);
    },
    listen(v) {
      if (l) throw new Error('A history only accepts one active listener');
      return (
        r.addEventListener(lp, c),
        (l = v),
        () => {
          r.removeEventListener(lp, c), (l = null);
        }
      );
    },
    createHref(v) {
      return t(r, v);
    },
    push: u,
    replace: m,
    go(v) {
      return a.go(v);
    },
  };
  return h;
}
var Ze;
(function (e) {
  (e.data = 'data'), (e.deferred = 'deferred'), (e.redirect = 'redirect'), (e.error = 'error');
})(Ze || (Ze = {}));
function uf(e, t, n) {
  return (
    t === void 0 && (t = []),
    n === void 0 && (n = new Set()),
    e.map((i, r) => {
      let o = [...t, r],
        a = typeof i.id == 'string' ? i.id : o.join('-');
      return (
        oe(
          !n.has(a),
          'Found a route id collision on id "' + a + `".  Route id's must be globally unique within Data Router usages`,
        ),
        n.add(a),
        be({}, i, { id: a, children: i.children ? uf(i.children, o, n) : void 0 })
      );
    })
  );
}
function Cr(e, t, n) {
  n === void 0 && (n = '/');
  let i = typeof t == 'string' ? fn(t) : t,
    r = pf(i.pathname || '/', n);
  if (r == null) return null;
  let o = df(e);
  Q_(o);
  let a = null;
  for (let s = 0; a == null && s < o.length; ++s) a = ix(o[s], r);
  return a;
}
function df(e, t, n, i) {
  return (
    t === void 0 && (t = []),
    n === void 0 && (n = []),
    i === void 0 && (i = ''),
    e.forEach((r, o) => {
      let a = { relativePath: r.path || '', caseSensitive: r.caseSensitive === !0, childrenIndex: o, route: r };
      a.relativePath.startsWith('/') &&
        (oe(
          a.relativePath.startsWith(i),
          'Absolute route path "' +
            a.relativePath +
            '" nested under path ' +
            ('"' + i + '" is not valid. An absolute child route path ') +
            'must start with the combined path of all its parent routes.',
        ),
        (a.relativePath = a.relativePath.slice(i.length)));
      let s = oi([i, a.relativePath]),
        l = n.concat(a);
      r.children &&
        r.children.length > 0 &&
        (oe(
          r.index !== !0,
          'Index routes must not have child routes. Please remove ' + ('all child routes from route path "' + s + '".'),
        ),
        df(r.children, t, l, s)),
        !(r.path == null && !r.index) && t.push({ path: s, score: tx(s, r.index), routesMeta: l });
    }),
    t
  );
}
function Q_(e) {
  e.sort((t, n) =>
    t.score !== n.score
      ? n.score - t.score
      : nx(
          t.routesMeta.map((i) => i.childrenIndex),
          n.routesMeta.map((i) => i.childrenIndex),
        ),
  );
}
const W_ = /^:\w+$/,
  K_ = 3,
  X_ = 2,
  Z_ = 1,
  Y_ = 10,
  ex = -2,
  up = (e) => e === '*';
function tx(e, t) {
  let n = e.split('/'),
    i = n.length;
  return (
    n.some(up) && (i += ex),
    t && (i += X_),
    n.filter((r) => !up(r)).reduce((r, o) => r + (W_.test(o) ? K_ : o === '' ? Z_ : Y_), i)
  );
}
function nx(e, t) {
  return e.length === t.length && e.slice(0, -1).every((i, r) => i === t[r]) ? e[e.length - 1] - t[t.length - 1] : 0;
}
function ix(e, t) {
  let { routesMeta: n } = e,
    i = {},
    r = '/',
    o = [];
  for (let a = 0; a < n.length; ++a) {
    let s = n[a],
      l = a === n.length - 1,
      c = r === '/' ? t : t.slice(r.length) || '/',
      u = rx({ path: s.relativePath, caseSensitive: s.caseSensitive, end: l }, c);
    if (!u) return null;
    Object.assign(i, u.params);
    let m = s.route;
    o.push({ params: i, pathname: oi([r, u.pathname]), pathnameBase: ux(oi([r, u.pathnameBase])), route: m }),
      u.pathnameBase !== '/' && (r = oi([r, u.pathnameBase]));
  }
  return o;
}
function rx(e, t) {
  typeof e == 'string' && (e = { path: e, caseSensitive: !1, end: !0 });
  let [n, i] = ox(e.path, e.caseSensitive, e.end),
    r = t.match(n);
  if (!r) return null;
  let o = r[0],
    a = o.replace(/(.)\/+$/, '$1'),
    s = r.slice(1);
  return {
    params: i.reduce((c, u, m) => {
      if (u === '*') {
        let h = s[m] || '';
        a = o.slice(0, o.length - h.length).replace(/(.)\/+$/, '$1');
      }
      return (c[u] = ax(s[m] || '', u)), c;
    }, {}),
    pathname: o,
    pathnameBase: a,
    pattern: e,
  };
}
function ox(e, t, n) {
  t === void 0 && (t = !1),
    n === void 0 && (n = !0),
    hf(
      e === '*' || !e.endsWith('*') || e.endsWith('/*'),
      'Route path "' +
        e +
        '" will be treated as if it were ' +
        ('"' + e.replace(/\*$/, '/*') + '" because the `*` character must ') +
        'always follow a `/` in the pattern. To get rid of this warning, ' +
        ('please change the route path to "' + e.replace(/\*$/, '/*') + '".'),
    );
  let i = [],
    r =
      '^' +
      e
        .replace(/\/*\*?$/, '')
        .replace(/^\/*/, '/')
        .replace(/[\\.*+^$?{}|()[\]]/g, '\\$&')
        .replace(/:(\w+)/g, (a, s) => (i.push(s), '([^\\/]+)'));
  return (
    e.endsWith('*')
      ? (i.push('*'), (r += e === '*' || e === '/*' ? '(.*)$' : '(?:\\/(.+)|\\/*)$'))
      : (r += n ? '\\/*$' : '(?:(?=[@.~-]|%[0-9A-F]{2})|\\b|\\/|$)'),
    [new RegExp(r, t ? void 0 : 'i'), i]
  );
}
function ax(e, t) {
  try {
    return decodeURIComponent(e);
  } catch (n) {
    return (
      hf(
        !1,
        'The value for the URL param "' +
          t +
          '" will not be decoded because' +
          (' the string "' + e + '" is a malformed URL segment. This is probably') +
          (' due to a bad percent encoding (' + n + ').'),
      ),
      e
    );
  }
}
function pf(e, t) {
  if (t === '/') return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase())) return null;
  let n = t.endsWith('/') ? t.length - 1 : t.length,
    i = e.charAt(n);
  return i && i !== '/' ? null : e.slice(n) || '/';
}
function oe(e, t) {
  if (e === !1 || e === null || typeof e > 'u') throw new Error(t);
}
function hf(e, t) {
  if (!e) {
    typeof console < 'u' && console.warn(t);
    try {
      throw new Error(t);
    } catch {}
  }
}
function sx(e, t) {
  t === void 0 && (t = '/');
  let { pathname: n, search: i = '', hash: r = '' } = typeof e == 'string' ? fn(e) : e;
  return { pathname: n ? (n.startsWith('/') ? n : lx(n, t)) : t, search: dx(i), hash: px(r) };
}
function lx(e, t) {
  let n = t.replace(/\/+$/, '').split('/');
  return (
    e.split('/').forEach((r) => {
      r === '..' ? n.length > 1 && n.pop() : r !== '.' && n.push(r);
    }),
    n.length > 1 ? n.join('/') : '/'
  );
}
function cx(e, t, n, i) {
  i === void 0 && (i = !1);
  let r = typeof e == 'string' ? fn(e) : be({}, e),
    o = e === '' || r.pathname === '',
    a = o ? '/' : r.pathname,
    s;
  if (i || a == null) s = n;
  else {
    let m = t.length - 1;
    if (a.startsWith('..')) {
      let h = a.split('/');
      for (; h[0] === '..'; ) h.shift(), (m -= 1);
      r.pathname = h.join('/');
    }
    s = m >= 0 ? t[m] : '/';
  }
  let l = sx(r, s),
    c = a && a !== '/' && a.endsWith('/'),
    u = (o || a === '.') && n.endsWith('/');
  return !l.pathname.endsWith('/') && (c || u) && (l.pathname += '/'), l;
}
const oi = (e) => e.join('/').replace(/\/\/+/g, '/'),
  ux = (e) => e.replace(/\/+$/, '').replace(/^\/*/, '/'),
  dx = (e) => (!e || e === '?' ? '' : e.startsWith('?') ? e : '?' + e),
  px = (e) => (!e || e === '#' ? '' : e.startsWith('#') ? e : '#' + e);
class dp extends Error {}
class hx {
  constructor(t) {
    (this.pendingKeys = new Set()),
      (this.subscriber = void 0),
      oe(t && typeof t == 'object' && !Array.isArray(t), 'defer() only accepts plain objects');
    let n;
    (this.abortPromise = new Promise((r, o) => (n = o))), (this.controller = new AbortController());
    let i = () => n(new dp('Deferred data aborted'));
    (this.unlistenAbortSignal = () => this.controller.signal.removeEventListener('abort', i)),
      this.controller.signal.addEventListener('abort', i),
      (this.data = Object.entries(t).reduce((r, o) => {
        let [a, s] = o;
        return Object.assign(r, { [a]: this.trackPromise(a, s) });
      }, {}));
  }
  trackPromise(t, n) {
    if (!(n instanceof Promise)) return n;
    this.pendingKeys.add(t);
    let i = Promise.race([n, this.abortPromise]).then(
      (r) => this.onSettle(i, t, null, r),
      (r) => this.onSettle(i, t, r),
    );
    return i.catch(() => {}), Object.defineProperty(i, '_tracked', { get: () => !0 }), i;
  }
  onSettle(t, n, i, r) {
    var o;
    if (this.controller.signal.aborted && i instanceof dp)
      return this.unlistenAbortSignal(), Object.defineProperty(t, '_error', { get: () => i }), Promise.reject(i);
    if ((this.pendingKeys.delete(n), this.done && this.unlistenAbortSignal(), i)) {
      var a;
      return (
        Object.defineProperty(t, '_error', { get: () => i }),
        (a = this.subscriber) == null || a.call(this, !1),
        Promise.reject(i)
      );
    }
    return Object.defineProperty(t, '_data', { get: () => r }), (o = this.subscriber) == null || o.call(this, !1), r;
  }
  subscribe(t) {
    this.subscriber = t;
  }
  cancel() {
    var t;
    this.controller.abort(),
      this.pendingKeys.forEach((n, i) => this.pendingKeys.delete(i)),
      (t = this.subscriber) == null || t.call(this, !0);
  }
  async resolveData(t) {
    let n = !1;
    if (!this.done) {
      let i = () => this.cancel();
      t.addEventListener('abort', i),
        (n = await new Promise((r) => {
          this.subscribe((o) => {
            t.removeEventListener('abort', i), (o || this.done) && r(o);
          });
        }));
    }
    return n;
  }
  get done() {
    return this.pendingKeys.size === 0;
  }
  get unwrappedData() {
    return (
      oe(this.data !== null && this.done, 'Can only unwrap data on initialized and settled deferreds'),
      Object.entries(this.data).reduce((t, n) => {
        let [i, r] = n;
        return Object.assign(t, { [i]: fx(r) });
      }, {})
    );
  }
}
function mx(e) {
  return e instanceof Promise && e._tracked === !0;
}
function fx(e) {
  if (!mx(e)) return e;
  if (e._error) throw e._error;
  return e._data;
}
class ar {
  constructor(t, n, i) {
    (this.status = t), (this.statusText = n || ''), (this.data = i);
  }
}
function mf(e) {
  return e instanceof ar;
}
const nl = {
    state: 'idle',
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
  },
  gx = { state: 'idle', data: void 0, formMethod: void 0, formAction: void 0, formEncType: void 0, formData: void 0 };
function vx(e) {
  var t, n, i;
  oe(e.routes.length > 0, 'You must provide a non-empty routes array to createRouter');
  let r = uf(e.routes),
    o = null,
    a = new Set(),
    s = null,
    l = null,
    c = null,
    u = !1,
    m = Cr(r, e.history.location, e.basename),
    h = null;
  if (m == null) {
    let { matches: w, route: M, error: I } = gp(r);
    (m = w), (h = { [M.id]: I });
  }
  let v = !m.some((w) => w.route.loader) || e.hydrationData != null,
    x,
    f = {
      historyAction: e.history.action,
      location: e.history.location,
      matches: m,
      initialized: v,
      navigation: nl,
      restoreScrollPosition: null,
      preventScrollReset: !1,
      revalidation: 'idle',
      loaderData: ((t = e.hydrationData) == null ? void 0 : t.loaderData) || {},
      actionData: ((n = e.hydrationData) == null ? void 0 : n.actionData) || null,
      errors: ((i = e.hydrationData) == null ? void 0 : i.errors) || h,
      fetchers: new Map(),
    },
    D = Re.Pop,
    p = !1,
    d,
    g = !1,
    y = !1,
    b = [],
    C = [],
    R = new Map(),
    z = 0,
    Y = -1,
    W = new Map(),
    Ne = new Set(),
    Ae = new Map(),
    nt = new Map();
  function fi() {
    return (
      (o = e.history.listen((w) => {
        let { action: M, location: I } = w;
        return ee(M, I);
      })),
      f.initialized || ee(Re.Pop, f.location),
      x
    );
  }
  function Te() {
    var w;
    o && o(), a.clear(), (w = d) == null || w.abort(), f.fetchers.forEach((M, I) => En(I));
  }
  function tn(w) {
    return a.add(w), () => a.delete(w);
  }
  function re(w) {
    (f = be({}, f, w)), a.forEach((M) => M(f));
  }
  function O(w, M) {
    let I = f.actionData != null && f.navigation.formMethod != null && f.navigation.state === 'loading',
      Q = M.loaderData ? { loaderData: rl(f.loaderData, M.loaderData, M.matches || []) } : {};
    re(
      be({}, I ? {} : { actionData: null }, M, Q, {
        historyAction: D,
        location: w,
        initialized: !0,
        navigation: nl,
        revalidation: 'idle',
        restoreScrollPosition: f.navigation.formData ? !1 : vo(w, M.matches || f.matches),
        preventScrollReset: p,
      }),
    ),
      g ||
        D === Re.Pop ||
        (D === Re.Push ? e.history.push(w, w.state) : D === Re.Replace && e.history.replace(w, w.state)),
      (D = Re.Pop),
      (p = !1),
      (g = !1),
      (y = !1),
      (b = []),
      (C = []);
  }
  async function P(w, M) {
    if (typeof w == 'number') {
      e.history.go(w);
      return;
    }
    let { path: I, submission: Q, error: A } = pp(w, M),
      k = ri(f.location, I, M == null ? void 0 : M.state),
      N = (M == null ? void 0 : M.replace) === !0 || Q != null ? Re.Replace : Re.Push,
      L = M && 'preventScrollReset' in M ? M.preventScrollReset === !0 : void 0;
    return await ee(N, k, {
      submission: Q,
      pendingError: A,
      preventScrollReset: L,
      replace: M == null ? void 0 : M.replace,
    });
  }
  function q() {
    if ((Vn(), re({ revalidation: 'loading' }), f.navigation.state !== 'submitting')) {
      if (f.navigation.state === 'idle') {
        ee(f.historyAction, f.location, { startUninterruptedRevalidation: !0 });
        return;
      }
      ee(D || f.historyAction, f.navigation.location, { overrideNavigation: f.navigation });
    }
  }
  async function ee(w, M, I) {
    var Q;
    (Q = d) == null || Q.abort(),
      (d = null),
      (D = w),
      (g = (I == null ? void 0 : I.startUninterruptedRevalidation) === !0),
      ds(f.location, f.matches),
      (p = (I == null ? void 0 : I.preventScrollReset) === !0);
    let A = I == null ? void 0 : I.overrideNavigation,
      k = Cr(r, M, e.basename);
    if (!k) {
      let { matches: Ie, route: ct, error: nn } = gp(r);
      ur(), O(M, { matches: Ie, loaderData: {}, errors: { [ct.id]: nn } });
      return;
    }
    if (yx(f.location, M)) {
      O(M, { matches: k });
      return;
    }
    d = new AbortController();
    let N = br(M, d.signal, I == null ? void 0 : I.submission),
      L,
      G;
    if (I != null && I.pendingError) G = { [zi(k).route.id]: I.pendingError };
    else if (I != null && I.submission) {
      let Ie = await ve(N, M, I.submission, k, { replace: I.replace });
      if (Ie.shortCircuited) return;
      (L = Ie.pendingActionData),
        (G = Ie.pendingActionError),
        (A = be({ state: 'loading', location: M }, I.submission));
    }
    let {
      shortCircuited: ne,
      loaderData: ce,
      errors: Je,
    } = await Ut(N, M, k, A, I == null ? void 0 : I.submission, I == null ? void 0 : I.replace, L, G);
    ne || ((d = null), O(M, { matches: k, loaderData: ce, errors: Je }));
  }
  async function ve(w, M, I, Q, A) {
    Vn();
    let k = be({ state: 'submitting', location: M }, I);
    re({ navigation: k });
    let N,
      L = yp(Q, M);
    if (!L.route.action) N = vp(M);
    else if (((N = await Sr('action', w, L)), w.signal.aborted)) return { shortCircuited: !0 };
    if (Qi(N)) {
      let G = be({ state: 'loading', location: ri(f.location, N.location) }, I);
      return await xn(N, G, A == null ? void 0 : A.replace), { shortCircuited: !0 };
    }
    if (Br(N)) {
      let G = zi(Q, L.route.id);
      return (
        (A == null ? void 0 : A.replace) !== !0 && (D = Re.Push), { pendingActionError: { [G.route.id]: N.error } }
      );
    }
    if (ti(N)) throw new Error('defer() is not supported in actions');
    return { pendingActionData: { [L.route.id]: N.data } };
  }
  async function Ut(w, M, I, Q, A, k, N, L) {
    let G = Q;
    G ||
      (G = {
        state: 'loading',
        location: M,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
      });
    let [ne, ce] = hp(f, I, A, M, y, b, C, N, L, Ae);
    if (
      (ur(
        (we) =>
          !(I != null && I.some((Ve) => Ve.route.id === we)) ||
          (ne == null ? void 0 : ne.some((Ve) => Ve.route.id === we)),
      ),
      ne.length === 0 && ce.length === 0)
    )
      return (
        O(M, { matches: I, loaderData: rl(f.loaderData, {}, I), errors: L || null, actionData: N || null }),
        { shortCircuited: !0 }
      );
    g ||
      (ce.forEach((we) => {
        var Ve;
        let [$t] = we,
          xi = {
            state: 'loading',
            data: (Ve = f.fetchers.get($t)) == null ? void 0 : Ve.data,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
          };
        f.fetchers.set($t, xi);
      }),
      re(
        be(
          { navigation: G, actionData: N || f.actionData || null },
          ce.length > 0 ? { fetchers: new Map(f.fetchers) } : {},
        ),
      )),
      (Y = ++z),
      ce.forEach((we) => {
        let [Ve] = we;
        return R.set(Ve, d);
      });
    let { results: Je, loaderResults: Ie, fetcherResults: ct } = await cr(f.matches, ne, ce, w);
    if (w.signal.aborted) return { shortCircuited: !0 };
    ce.forEach((we) => {
      let [Ve] = we;
      return R.delete(Ve);
    });
    let nn = _p(Je);
    if (nn) {
      let we = il(f, nn);
      return await xn(nn, we, k), { shortCircuited: !0 };
    }
    let { loaderData: _i, errors: yn } = fp(f, I, ne, Ie, L, ce, ct, nt);
    nt.forEach((we, Ve) => {
      we.subscribe(($t) => {
        ($t || we.done) && nt.delete(Ve);
      });
    }),
      cs();
    let An = go(Y);
    return be({ loaderData: _i, errors: yn }, An || ce.length > 0 ? { fetchers: new Map(f.fetchers) } : {});
  }
  function lt(w) {
    return f.fetchers.get(w) || gx;
  }
  function Jn(w, M, I, Q) {
    if (typeof AbortController > 'u')
      throw new Error(
        "router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.",
      );
    R.has(w) && vi(w);
    let A = Cr(r, I, e.basename);
    if (!A) {
      gi(w, M, new ar(404, 'Not Found', null));
      return;
    }
    let { path: k, submission: N } = pp(I, Q),
      L = yp(A, k);
    if (N) {
      vt(w, M, k, L, N);
      return;
    }
    Ae.set(w, [k, L]), _n(w, M, k, L);
  }
  async function vt(w, M, I, Q, A) {
    var k;
    if ((Vn(), Ae.delete(w), !Q.route.action)) {
      let { error: qe } = vp(I);
      gi(w, M, qe);
      return;
    }
    let N = be({ state: 'submitting' }, A, { data: ((k = f.fetchers.get(w)) == null ? void 0 : k.data) || void 0 });
    f.fetchers.set(w, N), re({ fetchers: new Map(f.fetchers) });
    let L = new AbortController(),
      G = br(I, L.signal, A);
    R.set(w, L);
    let ne = await Sr('action', G, Q);
    if (G.signal.aborted) {
      R.get(w) === L && R.delete(w);
      return;
    }
    if (Qi(ne)) {
      R.delete(w), Ne.add(w);
      let qe = be({ state: 'loading' }, A, { data: void 0 });
      f.fetchers.set(w, qe), re({ fetchers: new Map(f.fetchers) });
      let bt = be({ state: 'loading', location: ri(f.location, ne.location) }, A);
      await xn(ne, bt);
      return;
    }
    if (Br(ne)) {
      gi(w, M, ne.error);
      return;
    }
    ti(ne) && oe(!1, 'defer() is not supported in actions');
    let ce = f.navigation.location || f.location,
      Je = br(ce, L.signal),
      Ie = f.navigation.state !== 'idle' ? Cr(r, f.navigation.location, e.basename) : f.matches;
    oe(Ie, "Didn't find any matches after fetcher action");
    let ct = ++z;
    W.set(w, ct);
    let nn = be({ state: 'loading', data: ne.data }, A);
    f.fetchers.set(w, nn);
    let [_i, yn] = hp(f, Ie, A, ce, y, b, C, { [Q.route.id]: ne.data }, void 0, Ae);
    yn
      .filter((qe) => {
        let [bt] = qe;
        return bt !== w;
      })
      .forEach((qe) => {
        var bt;
        let [hr] = qe,
          ps = {
            state: 'loading',
            data: (bt = f.fetchers.get(hr)) == null ? void 0 : bt.data,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
          };
        f.fetchers.set(hr, ps), R.set(hr, L);
      }),
      re({ fetchers: new Map(f.fetchers) });
    let { results: An, loaderResults: we, fetcherResults: Ve } = await cr(f.matches, _i, yn, Je);
    if (L.signal.aborted) return;
    W.delete(w),
      R.delete(w),
      yn.forEach((qe) => {
        let [bt] = qe;
        return R.delete(bt);
      });
    let $t = _p(An);
    if ($t) {
      let qe = il(f, $t);
      await xn($t, qe);
      return;
    }
    let { loaderData: xi, errors: Ei } = fp(f, f.matches, _i, we, void 0, yn, Ve, nt),
      dr = {
        state: 'idle',
        data: ne.data,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
      };
    f.fetchers.set(w, dr);
    let _t = go(ct);
    if (f.navigation.state === 'loading' && ct > Y) {
      var pr;
      oe(D, 'Expected pending action'),
        (pr = d) == null || pr.abort(),
        O(f.navigation.location, { matches: Ie, loaderData: xi, errors: Ei, fetchers: new Map(f.fetchers) });
    } else
      re(be({ errors: Ei, loaderData: rl(f.loaderData, xi, Ie) }, _t ? { fetchers: new Map(f.fetchers) } : {})),
        (y = !1);
  }
  async function _n(w, M, I, Q) {
    var A;
    let k = {
      state: 'loading',
      formMethod: void 0,
      formAction: void 0,
      formEncType: void 0,
      formData: void 0,
      data: ((A = f.fetchers.get(w)) == null ? void 0 : A.data) || void 0,
    };
    f.fetchers.set(w, k), re({ fetchers: new Map(f.fetchers) });
    let N = new AbortController(),
      L = br(I, N.signal);
    R.set(w, N);
    let G = await Sr('loader', L, Q);
    if ((ti(G) && (G = (await vf(G, L.signal, !0)) || G), R.get(w) === N && R.delete(w), L.signal.aborted)) return;
    if (Qi(G)) {
      let ce = il(f, G);
      await xn(G, ce);
      return;
    }
    if (Br(G)) {
      let ce = zi(f.matches, M);
      f.fetchers.delete(w), re({ fetchers: new Map(f.fetchers), errors: { [ce.route.id]: G.error } });
      return;
    }
    oe(!ti(G), 'Unhandled fetcher deferred data');
    let ne = {
      state: 'idle',
      data: G.data,
      formMethod: void 0,
      formAction: void 0,
      formEncType: void 0,
      formData: void 0,
    };
    f.fetchers.set(w, ne), re({ fetchers: new Map(f.fetchers) });
  }
  async function xn(w, M, I) {
    w.revalidate && (y = !0), oe(M.location, 'Expected a location on the redirect navigation'), (d = null);
    let Q = I === !0 ? Re.Replace : Re.Push;
    await ee(Q, M.location, { overrideNavigation: M });
  }
  async function cr(w, M, I, Q) {
    let A = await Promise.all([
        ...M.map((L) => Sr('loader', Q, L)),
        ...I.map((L) => {
          let [, G, ne] = L;
          return Sr('loader', br(G, Q.signal), ne);
        }),
      ]),
      k = A.slice(0, M.length),
      N = A.slice(M.length);
    return (
      await Promise.all([
        xp(w, M, k, Q.signal, !1, f.loaderData),
        xp(
          w,
          I.map((L) => {
            let [, , G] = L;
            return G;
          }),
          N,
          Q.signal,
          !0,
        ),
      ]),
      { results: A, loaderResults: k, fetcherResults: N }
    );
  }
  function Vn() {
    (y = !0),
      b.push(...ur()),
      Ae.forEach((w, M) => {
        R.has(M) && (C.push(M), vi(M));
      });
  }
  function gi(w, M, I) {
    let Q = zi(f.matches, M);
    En(w), re({ errors: { [Q.route.id]: I }, fetchers: new Map(f.fetchers) });
  }
  function En(w) {
    R.has(w) && vi(w), Ae.delete(w), W.delete(w), Ne.delete(w), f.fetchers.delete(w);
  }
  function vi(w) {
    let M = R.get(w);
    oe(M, 'Expected fetch controller: ' + w), M.abort(), R.delete(w);
  }
  function fo(w) {
    for (let M of w) {
      let Q = {
        state: 'idle',
        data: lt(M).data,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
      };
      f.fetchers.set(M, Q);
    }
  }
  function cs() {
    let w = [];
    for (let M of Ne) {
      let I = f.fetchers.get(M);
      oe(I, 'Expected fetcher: ' + M), I.state === 'loading' && (Ne.delete(M), w.push(M));
    }
    fo(w);
  }
  function go(w) {
    let M = [];
    for (let [I, Q] of W)
      if (Q < w) {
        let A = f.fetchers.get(I);
        oe(A, 'Expected fetcher: ' + I), A.state === 'loading' && (vi(I), W.delete(I), M.push(I));
      }
    return fo(M), M.length > 0;
  }
  function ur(w) {
    let M = [];
    return (
      nt.forEach((I, Q) => {
        (!w || w(Q)) && (I.cancel(), M.push(Q), nt.delete(Q));
      }),
      M
    );
  }
  function us(w, M, I) {
    if (((s = w), (c = M), (l = I || ((Q) => Q.key)), !u && f.navigation === nl)) {
      u = !0;
      let Q = vo(f.location, f.matches);
      Q != null && re({ restoreScrollPosition: Q });
    }
    return () => {
      (s = null), (c = null), (l = null);
    };
  }
  function ds(w, M) {
    if (s && l && c) {
      let I = M.map((A) => Ep(A, f.loaderData)),
        Q = l(w, I) || w.key;
      s[Q] = c();
    }
  }
  function vo(w, M) {
    if (s && l && c) {
      let I = M.map((k) => Ep(k, f.loaderData)),
        Q = l(w, I) || w.key,
        A = s[Q];
      if (typeof A == 'number') return A;
    }
    return null;
  }
  return (
    (x = {
      get basename() {
        return e.basename;
      },
      get state() {
        return f;
      },
      get routes() {
        return r;
      },
      initialize: fi,
      subscribe: tn,
      enableScrollRestoration: us,
      navigate: P,
      fetch: Jn,
      revalidate: q,
      createHref: Ja,
      getFetcher: lt,
      deleteFetcher: En,
      dispose: Te,
      _internalFetchControllers: R,
      _internalActiveDeferreds: nt,
    }),
    x
  );
}
function pp(e, t) {
  let n = typeof e == 'string' ? e : ac(e);
  if (!t || (!('formMethod' in t) && !('formData' in t))) return { path: n };
  if (t.formMethod != null && t.formMethod !== 'get')
    return {
      path: n,
      submission: {
        formMethod: t.formMethod,
        formAction: Ja(fn(n)),
        formEncType: (t == null ? void 0 : t.formEncType) || 'application/x-www-form-urlencoded',
        formData: t.formData,
      },
    };
  if (!t.formData) return { path: n };
  let i = fn(n);
  try {
    let r = gf(t.formData);
    i.search = '?' + r;
  } catch {
    return { path: n, error: new ar(400, 'Bad Request', 'Cannot submit binary form data using GET') };
  }
  return { path: ac(i) };
}
function il(e, t) {
  let { formMethod: n, formAction: i, formEncType: r, formData: o } = e.navigation;
  return {
    state: 'loading',
    location: ri(e.location, t.location),
    formMethod: n || void 0,
    formAction: i || void 0,
    formEncType: r || void 0,
    formData: o || void 0,
  };
}
function _x(e, t) {
  let n = e;
  if (t) {
    let i = e.findIndex((r) => r.route.id === t);
    i >= 0 && (n = e.slice(0, i));
  }
  return n;
}
function hp(e, t, n, i, r, o, a, s, l, c) {
  let u = l ? Object.values(l)[0] : s ? Object.values(s)[0] : null,
    m = l ? Object.keys(l)[0] : void 0,
    v = _x(t, m).filter(
      (f, D) =>
        f.route.loader != null &&
        (xx(e.loaderData, e.matches[D], f) ||
          o.some((p) => p === f.route.id) ||
          mp(e.location, e.matches[D], n, i, f, r, u)),
    ),
    x = [];
  return (
    c == null ||
      c.forEach((f, D) => {
        let [p, d] = f;
        a.includes(D) ? x.push([D, p, d]) : r && mp(p, d, n, p, d, r, u) && x.push([D, p, d]);
      }),
    [v, x]
  );
}
function xx(e, t, n) {
  let i = !t || n.route.id !== t.route.id,
    r = e[n.route.id] === void 0;
  return i || r;
}
function ff(e, t) {
  var n;
  return (
    e.pathname !== t.pathname ||
    (((n = e.route.path) == null ? void 0 : n.endsWith('*')) && e.params['*'] !== t.params['*'])
  );
}
function mp(e, t, n, i, r, o, a) {
  let s = sc(e),
    l = t.params,
    c = sc(i),
    u = r.params,
    m = ff(t, r) || s.toString() === c.toString() || s.search !== c.search || o;
  if (r.route.shouldRevalidate) {
    let h = r.route.shouldRevalidate(
      be({ currentUrl: s, currentParams: l, nextUrl: c, nextParams: u }, n, {
        actionResult: a,
        defaultShouldRevalidate: m,
      }),
    );
    if (typeof h == 'boolean') return h;
  }
  return m;
}
async function Sr(e, t, n, i, r) {
  i === void 0 && (i = !1), r === void 0 && (r = !1);
  let o,
    a,
    s,
    l = new Promise((m, h) => (s = h)),
    c = () => s();
  t.signal.addEventListener('abort', c);
  try {
    let m = n.route[e];
    oe(m, 'Could not find the ' + e + ' to run on the "' + n.route.id + '" route'),
      (a = await Promise.race([m({ request: t, params: n.params }), l]));
  } catch (m) {
    (o = Ze.error), (a = m);
  } finally {
    t.signal.removeEventListener('abort', c);
  }
  if (a instanceof Response) {
    var u;
    let m = a.status,
      h = a.headers.get('Location');
    if (r) throw a;
    if (m >= 300 && m <= 399 && h != null) {
      if (i) throw a;
      return { type: Ze.redirect, status: m, location: h, revalidate: a.headers.get('X-Remix-Revalidate') !== null };
    }
    let v;
    return (
      (u = a.headers.get('Content-Type')) != null && u.startsWith('application/json')
        ? (v = await a.json())
        : (v = await a.text()),
      o === Ze.error
        ? { type: o, error: new ar(m, a.statusText, v), headers: a.headers }
        : { type: Ze.data, data: v, statusCode: a.status, headers: a.headers }
    );
  }
  return o === Ze.error
    ? { type: o, error: a }
    : a instanceof hx
      ? { type: Ze.deferred, deferredData: a }
      : { type: Ze.data, data: a };
}
function br(e, t, n) {
  let i = sc(e).toString(),
    r = { signal: t };
  if (n) {
    let { formMethod: o, formEncType: a, formData: s } = n;
    (r.method = o.toUpperCase()), (r.body = a === 'application/x-www-form-urlencoded' ? gf(s) : s);
  }
  return new Request(i, r);
}
function gf(e) {
  let t = new URLSearchParams();
  for (let [n, i] of e.entries())
    oe(
      typeof i == 'string',
      'File inputs are not supported with encType "application/x-www-form-urlencoded", please use "multipart/form-data" instead.',
    ),
      t.append(n, i);
  return t;
}
function Ex(e, t, n, i, r) {
  let o = {},
    a = null,
    s,
    l = !1,
    c = {};
  return (
    n.forEach((u, m) => {
      let h = t[m].route.id;
      if ((oe(!Qi(u), 'Cannot handle redirect results in processLoaderData'), Br(u))) {
        let v = zi(e, h),
          x = u.error;
        i && ((x = Object.values(i)[0]), (i = void 0)),
          (a = Object.assign(a || {}, { [v.route.id]: x })),
          l || ((l = !0), (s = mf(u.error) ? u.error.status : 500)),
          u.headers && (c[h] = u.headers);
      } else
        ti(u)
          ? (r == null || r.set(h, u.deferredData), (o[h] = u.deferredData.data))
          : ((o[h] = u.data), u.statusCode !== 200 && !l && (s = u.statusCode), u.headers && (c[h] = u.headers));
    }),
    i && (a = i),
    { loaderData: o, errors: a, statusCode: s || 200, loaderHeaders: c }
  );
}
function fp(e, t, n, i, r, o, a, s) {
  let { loaderData: l, errors: c } = Ex(t, n, i, r, s);
  for (let m = 0; m < o.length; m++) {
    let [h, , v] = o[m];
    oe(a !== void 0 && a[m] !== void 0, 'Did not find corresponding fetcher result');
    let x = a[m];
    if (Br(x)) {
      var u;
      let f = zi(e.matches, v.route.id);
      ((u = c) != null && u[f.route.id]) || (c = be({}, c, { [f.route.id]: x.error })), e.fetchers.delete(h);
    } else {
      if (Qi(x)) throw new Error('Unhandled fetcher revalidation redirect');
      if (ti(x)) throw new Error('Unhandled fetcher deferred data');
      {
        let f = {
          state: 'idle',
          data: x.data,
          formMethod: void 0,
          formAction: void 0,
          formEncType: void 0,
          formData: void 0,
        };
        e.fetchers.set(h, f);
      }
    }
  }
  return { loaderData: l, errors: c };
}
function rl(e, t, n) {
  let i = be({}, t);
  return (
    n.forEach((r) => {
      let o = r.route.id;
      t[o] === void 0 && e[o] !== void 0 && (i[o] = e[o]);
    }),
    i
  );
}
function zi(e, t) {
  return (
    (t ? e.slice(0, e.findIndex((i) => i.route.id === t) + 1) : [...e])
      .reverse()
      .find((i) => i.route.hasErrorBoundary === !0) || e[0]
  );
}
function gp(e) {
  let t = e.find((n) => n.index || n.path === '' || n.path === '/') || { id: '__shim-404-route__' };
  return {
    matches: [{ params: {}, pathname: '', pathnameBase: '', route: t }],
    route: t,
    error: new ar(404, 'Not Found', null),
  };
}
function vp(e) {
  let t = typeof e == 'string' ? e : Ja(e);
  return (
    console.warn(
      "You're trying to submit to a route that does not have an action.  To fix this, please add an `action` function to the route for " +
        ('[' + t + ']'),
    ),
    { type: Ze.error, error: new ar(405, 'Method Not Allowed', 'No action found for [' + t + ']') }
  );
}
function _p(e) {
  for (let t = e.length - 1; t >= 0; t--) {
    let n = e[t];
    if (Qi(n)) return n;
  }
}
function Ja(e) {
  return (e.pathname || '') + (e.search || '');
}
function yx(e, t) {
  return e.pathname === t.pathname && e.search === t.search && e.hash !== t.hash;
}
function ti(e) {
  return e.type === Ze.deferred;
}
function Br(e) {
  return e.type === Ze.error;
}
function Qi(e) {
  return (e == null ? void 0 : e.type) === Ze.redirect;
}
async function xp(e, t, n, i, r, o) {
  for (let a = 0; a < n.length; a++) {
    let s = n[a],
      l = t[a],
      c = e.find((m) => m.route.id === l.route.id),
      u = c != null && !ff(c, l) && (o == null ? void 0 : o[l.route.id]) !== void 0;
    ti(s) &&
      (r || u) &&
      (await vf(s, i, r).then((m) => {
        m && (n[a] = m || n[a]);
      }));
  }
}
async function vf(e, t, n) {
  if ((n === void 0 && (n = !1), !(await e.deferredData.resolveData(t)))) {
    if (n)
      try {
        return { type: Ze.data, data: e.deferredData.unwrappedData };
      } catch (r) {
        return { type: Ze.error, error: r };
      }
    return { type: Ze.data, data: e.deferredData.data };
  }
}
function Ax(e) {
  return new URLSearchParams(e).getAll('index').some((t) => t === '');
}
function Ep(e, t) {
  let { route: n, pathname: i, params: r } = e;
  return { id: n.id, pathname: i, params: r, data: t[n.id], handle: n.handle };
}
function yp(e, t) {
  let n = typeof t == 'string' ? fn(t).search : t.search;
  return e[e.length - 1].route.index && !Ax(n || '') ? e.slice(-2)[0] : e.slice(-1)[0];
}
function sc(e) {
  let t = typeof window < 'u' && typeof window.location < 'u' ? window.location.origin : 'unknown://unknown',
    n = typeof e == 'string' ? e : Ja(e);
  return new URL(n, t);
}
var Va = { exports: {} },
  qa = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var wx = $.exports,
  kx = Symbol.for('react.element'),
  Sx = Symbol.for('react.fragment'),
  bx = Object.prototype.hasOwnProperty,
  Mx = wx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  Tx = { key: !0, ref: !0, __self: !0, __source: !0 };
function _f(e, t, n) {
  var i,
    r = {},
    o = null,
    a = null;
  n !== void 0 && (o = '' + n), t.key !== void 0 && (o = '' + t.key), t.ref !== void 0 && (a = t.ref);
  for (i in t) bx.call(t, i) && !Tx.hasOwnProperty(i) && (r[i] = t[i]);
  if (e && e.defaultProps) for (i in ((t = e.defaultProps), t)) r[i] === void 0 && (r[i] = t[i]);
  return { $$typeof: kx, type: e, key: o, ref: a, props: r, _owner: Mx.current };
}
qa.Fragment = Sx;
qa.jsx = _f;
qa.jsxs = _f;
(function (e) {
  e.exports = qa;
})(Va);
const di = Va.exports.Fragment,
  E = Va.exports.jsx,
  ae = Va.exports.jsxs;
/**
 * React Router v6.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function Ma() {
  return (
    (Ma = Object.assign
      ? Object.assign.bind()
      : function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
          return e;
        }),
    Ma.apply(this, arguments)
  );
}
function Rx(e, t) {
  return (e === t && (e !== 0 || 1 / e === 1 / t)) || (e !== e && t !== t);
}
const Px = typeof Object.is == 'function' ? Object.is : Rx,
  { useState: Cx, useEffect: Nx, useLayoutEffect: Ix, useDebugValue: Dx } = hl;
function Ox(e, t, n) {
  const i = t(),
    [{ inst: r }, o] = Cx({ inst: { value: i, getSnapshot: t } });
  return (
    Ix(() => {
      (r.value = i), (r.getSnapshot = t), ol(r) && o({ inst: r });
    }, [e, i, t]),
    Nx(
      () => (
        ol(r) && o({ inst: r }),
        e(() => {
          ol(r) && o({ inst: r });
        })
      ),
      [e],
    ),
    Dx(i),
    i
  );
}
function ol(e) {
  const t = e.getSnapshot,
    n = e.value;
  try {
    const i = t();
    return !Px(n, i);
  } catch {
    return !0;
  }
}
function Lx(e, t, n) {
  return t();
}
const Hx = typeof window < 'u' && typeof window.document < 'u' && typeof window.document.createElement < 'u',
  Fx = !Hx,
  jx = Fx ? Lx : Ox,
  zx = 'useSyncExternalStore' in hl ? ((e) => e.useSyncExternalStore)(hl) : jx,
  Bx = $.exports.createContext(null),
  xf = $.exports.createContext(null),
  fu = $.exports.createContext(null),
  Ef = $.exports.createContext(null),
  Qa = $.exports.createContext(null),
  uo = $.exports.createContext({ outlet: null, matches: [] }),
  yf = $.exports.createContext(null);
function Wa() {
  return $.exports.useContext(Qa) != null;
}
function Af() {
  return Wa() || oe(!1), $.exports.useContext(Qa).location;
}
function Ux(e) {
  return e.filter((t, n) => n === 0 || (!t.route.index && t.pathnameBase !== e[n - 1].pathnameBase));
}
function $x() {
  Wa() || oe(!1);
  let { basename: e, navigator: t } = $.exports.useContext(Ef),
    { matches: n } = $.exports.useContext(uo),
    { pathname: i } = Af(),
    r = JSON.stringify(Ux(n).map((s) => s.pathnameBase)),
    o = $.exports.useRef(!1);
  return (
    $.exports.useEffect(() => {
      o.current = !0;
    }),
    $.exports.useCallback(
      function (s, l) {
        if ((l === void 0 && (l = {}), !o.current)) return;
        if (typeof s == 'number') {
          t.go(s);
          return;
        }
        let c = cx(s, JSON.parse(r), i, l.relative === 'path');
        e !== '/' && (c.pathname = c.pathname === '/' ? e : oi([e, c.pathname])),
          (l.replace ? t.replace : t.push)(c, l.state, l);
      },
      [e, t, r, i],
    )
  );
}
function Gx() {
  let { matches: e } = $.exports.useContext(uo),
    t = e[e.length - 1];
  return t ? t.params : {};
}
function Jx(e, t) {
  Wa() || oe(!1);
  let n = $.exports.useContext(fu),
    { matches: i } = $.exports.useContext(uo),
    r = i[i.length - 1],
    o = r ? r.params : {};
  r && r.pathname;
  let a = r ? r.pathnameBase : '/';
  r && r.route;
  let s = Af(),
    l;
  if (t) {
    var c;
    let x = typeof t == 'string' ? fn(t) : t;
    a === '/' || ((c = x.pathname) == null ? void 0 : c.startsWith(a)) || oe(!1), (l = x);
  } else l = s;
  let u = l.pathname || '/',
    m = a === '/' ? u : u.slice(a.length) || '/',
    h = Cr(e, { pathname: m }),
    v = Wx(
      h &&
        h.map((x) =>
          Object.assign({}, x, {
            params: Object.assign({}, o, x.params),
            pathname: oi([a, x.pathname]),
            pathnameBase: x.pathnameBase === '/' ? a : oi([a, x.pathnameBase]),
          }),
        ),
      i,
      n || void 0,
    );
  return t
    ? E(Qa.Provider, {
        value: {
          location: Ma({ pathname: '/', search: '', hash: '', state: null, key: 'default' }, l),
          navigationType: Re.Pop,
        },
        children: v,
      })
    : v;
}
function Vx() {
  let e = Xx(),
    t = mf(e) ? e.status + ' ' + e.statusText : e instanceof Error ? e.message : JSON.stringify(e),
    n = e instanceof Error ? e.stack : null,
    i = 'rgba(200,200,200, 0.5)',
    r = { padding: '0.5rem', backgroundColor: i },
    o = { padding: '2px 4px', backgroundColor: i };
  return ae(di, {
    children: [
      E('h2', { children: 'Unhandled Thrown Error!' }),
      E('h3', { style: { fontStyle: 'italic' }, children: t }),
      n ? E('pre', { style: r, children: n }) : null,
      E('p', { children: '\u{1F4BF} Hey developer \u{1F44B}' }),
      ae('p', {
        children: [
          'You can provide a way better UX than this when your app throws errors by providing your own\xA0',
          E('code', { style: o, children: 'errorElement' }),
          ' props on\xA0',
          E('code', { style: o, children: '<Route>' }),
        ],
      }),
    ],
  });
}
class qx extends $.exports.Component {
  constructor(t) {
    super(t), (this.state = { location: t.location, error: t.error });
  }
  static getDerivedStateFromError(t) {
    return { error: t };
  }
  static getDerivedStateFromProps(t, n) {
    return n.location !== t.location
      ? { error: t.error, location: t.location }
      : { error: t.error || n.error, location: n.location };
  }
  componentDidCatch(t, n) {
    console.error('React Router caught the following error during render', t, n);
  }
  render() {
    return this.state.error
      ? E(yf.Provider, { value: this.state.error, children: this.props.component })
      : this.props.children;
  }
}
function Qx(e) {
  let { routeContext: t, match: n, children: i } = e,
    r = $.exports.useContext(Bx);
  return (
    r && n.route.errorElement && (r._deepestRenderedBoundaryId = n.route.id), E(uo.Provider, { value: t, children: i })
  );
}
function Wx(e, t, n) {
  if ((t === void 0 && (t = []), e == null))
    if (n != null && n.errors) e = n.matches;
    else return null;
  let i = e,
    r = n == null ? void 0 : n.errors;
  if (r != null) {
    let o = i.findIndex((a) => a.route.id && (r == null ? void 0 : r[a.route.id]));
    o >= 0 || oe(!1), (i = i.slice(0, Math.min(i.length, o + 1)));
  }
  return i.reduceRight((o, a, s) => {
    let l = a.route.id ? (r == null ? void 0 : r[a.route.id]) : null,
      c = n ? a.route.errorElement || E(Vx, {}) : null,
      u = () =>
        E(Qx, {
          match: a,
          routeContext: { outlet: o, matches: t.concat(i.slice(0, s + 1)) },
          children: l ? c : a.route.element !== void 0 ? a.route.element : o,
        });
    return n && (a.route.errorElement || s === 0)
      ? E(qx, { location: n.location, component: c, error: l, children: u() })
      : u();
  }, null);
}
var lc;
(function (e) {
  (e.UseLoaderData = 'useLoaderData'),
    (e.UseActionData = 'useActionData'),
    (e.UseRouteError = 'useRouteError'),
    (e.UseNavigation = 'useNavigation'),
    (e.UseRouteLoaderData = 'useRouteLoaderData'),
    (e.UseMatches = 'useMatches'),
    (e.UseRevalidator = 'useRevalidator');
})(lc || (lc = {}));
function Kx(e) {
  let t = $.exports.useContext(fu);
  return t || oe(!1), t;
}
function Xx() {
  var e;
  let t = $.exports.useContext(yf),
    n = Kx(lc.UseRouteError),
    i = $.exports.useContext(uo),
    r = i.matches[i.matches.length - 1];
  return t || (i || oe(!1), r.route.id || oe(!1), (e = n.errors) == null ? void 0 : e[r.route.id]);
}
function Zx(e) {
  let { fallbackElement: t, router: n } = e,
    i = zx(
      n.subscribe,
      () => n.state,
      () => n.state,
    ),
    r = $.exports.useMemo(
      () => ({
        createHref: n.createHref,
        go: (a) => n.navigate(a),
        push: (a, s, l) => n.navigate(a, { state: s, preventScrollReset: l == null ? void 0 : l.preventScrollReset }),
        replace: (a, s, l) =>
          n.navigate(a, { replace: !0, state: s, preventScrollReset: l == null ? void 0 : l.preventScrollReset }),
      }),
      [n],
    ),
    o = n.basename || '/';
  return E(xf.Provider, {
    value: { router: n, navigator: r, static: !1, basename: o },
    children: E(fu.Provider, {
      value: i,
      children: E(e0, {
        basename: n.basename,
        location: n.state.location,
        navigationType: n.state.historyAction,
        navigator: r,
        children: n.state.initialized ? E(t0, {}) : t,
      }),
    }),
  });
}
function Yx(e) {
  oe(!1);
}
function e0(e) {
  let {
    basename: t = '/',
    children: n = null,
    location: i,
    navigationType: r = Re.Pop,
    navigator: o,
    static: a = !1,
  } = e;
  Wa() && oe(!1);
  let s = t.replace(/^\/*/, '/'),
    l = $.exports.useMemo(() => ({ basename: s, navigator: o, static: a }), [s, o, a]);
  typeof i == 'string' && (i = fn(i));
  let { pathname: c = '/', search: u = '', hash: m = '', state: h = null, key: v = 'default' } = i,
    x = $.exports.useMemo(() => {
      let f = pf(c, s);
      return f == null ? null : { pathname: f, search: u, hash: m, state: h, key: v };
    }, [s, c, u, m, h, v]);
  return x == null
    ? null
    : E(Ef.Provider, {
        value: l,
        children: E(Qa.Provider, { children: n, value: { location: x, navigationType: r } }),
      });
}
function t0(e) {
  let { children: t, location: n } = e,
    i = $.exports.useContext(xf),
    r = i && !t ? i.router.routes : cc(t);
  return Jx(r, n);
}
var Ap;
(function (e) {
  (e[(e.pending = 0)] = 'pending'), (e[(e.success = 1)] = 'success'), (e[(e.error = 2)] = 'error');
})(Ap || (Ap = {}));
new Promise(() => {});
function cc(e, t) {
  t === void 0 && (t = []);
  let n = [];
  return (
    $.exports.Children.forEach(e, (i, r) => {
      if (!$.exports.isValidElement(i)) return;
      if (i.type === $.exports.Fragment) {
        n.push.apply(n, cc(i.props.children, t));
        return;
      }
      i.type !== Yx && oe(!1);
      let o = [...t, r],
        a = {
          id: i.props.id || o.join('-'),
          caseSensitive: i.props.caseSensitive,
          element: i.props.element,
          index: i.props.index,
          path: i.props.path,
          loader: i.props.loader,
          action: i.props.action,
          errorElement: i.props.errorElement,
          hasErrorBoundary: i.props.errorElement != null,
          shouldRevalidate: i.props.shouldRevalidate,
          handle: i.props.handle,
        };
      i.props.children && (a.children = cc(i.props.children, o)), n.push(a);
    }),
    n
  );
}
function wf(e) {
  return e.map((t) => {
    let n = Ma({}, t);
    return (
      n.hasErrorBoundary == null && (n.hasErrorBoundary = n.errorElement != null),
      n.children && (n.children = wf(n.children)),
      n
    );
  });
}
/**
 * React Router DOM v6.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function n0(e, t) {
  var n;
  return vx({
    basename: t == null ? void 0 : t.basename,
    history: J_({ window: t == null ? void 0 : t.window }),
    hydrationData:
      (t == null ? void 0 : t.hydrationData) || ((n = window) == null ? void 0 : n.__staticRouterHydrationData),
    routes: wf(e),
  }).initialize();
}
var uc = function (e, t) {
  return (
    (uc =
      Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array &&
        function (n, i) {
          n.__proto__ = i;
        }) ||
      function (n, i) {
        for (var r in i) Object.prototype.hasOwnProperty.call(i, r) && (n[r] = i[r]);
      }),
    uc(e, t)
  );
};
function It(e, t) {
  if (typeof t != 'function' && t !== null)
    throw new TypeError('Class extends value ' + String(t) + ' is not a constructor or null');
  uc(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : ((n.prototype = t.prototype), new n());
}
var B = function () {
  return (
    (B =
      Object.assign ||
      function (t) {
        for (var n, i = 1, r = arguments.length; i < r; i++) {
          n = arguments[i];
          for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
        }
        return t;
      }),
    B.apply(this, arguments)
  );
};
function gu(e, t) {
  var n = {};
  for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == 'function')
    for (var r = 0, i = Object.getOwnPropertySymbols(e); r < i.length; r++)
      t.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[r]) && (n[i[r]] = e[i[r]]);
  return n;
}
function Wt(e, t, n) {
  if (n || arguments.length === 2)
    for (var i = 0, r = t.length, o; i < r; i++)
      (o || !(i in t)) && (o || (o = Array.prototype.slice.call(t, 0, i)), (o[i] = t[i]));
  return e.concat(o || Array.prototype.slice.call(t));
}
var kf = { exports: {} },
  le = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var je = typeof Symbol == 'function' && Symbol.for,
  vu = je ? Symbol.for('react.element') : 60103,
  _u = je ? Symbol.for('react.portal') : 60106,
  Ka = je ? Symbol.for('react.fragment') : 60107,
  Xa = je ? Symbol.for('react.strict_mode') : 60108,
  Za = je ? Symbol.for('react.profiler') : 60114,
  Ya = je ? Symbol.for('react.provider') : 60109,
  es = je ? Symbol.for('react.context') : 60110,
  xu = je ? Symbol.for('react.async_mode') : 60111,
  ts = je ? Symbol.for('react.concurrent_mode') : 60111,
  ns = je ? Symbol.for('react.forward_ref') : 60112,
  is = je ? Symbol.for('react.suspense') : 60113,
  i0 = je ? Symbol.for('react.suspense_list') : 60120,
  rs = je ? Symbol.for('react.memo') : 60115,
  os = je ? Symbol.for('react.lazy') : 60116,
  r0 = je ? Symbol.for('react.block') : 60121,
  o0 = je ? Symbol.for('react.fundamental') : 60117,
  a0 = je ? Symbol.for('react.responder') : 60118,
  s0 = je ? Symbol.for('react.scope') : 60119;
function St(e) {
  if (typeof e == 'object' && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case vu:
        switch (((e = e.type), e)) {
          case xu:
          case ts:
          case Ka:
          case Za:
          case Xa:
          case is:
            return e;
          default:
            switch (((e = e && e.$$typeof), e)) {
              case es:
              case ns:
              case os:
              case rs:
              case Ya:
                return e;
              default:
                return t;
            }
        }
      case _u:
        return t;
    }
  }
}
function Sf(e) {
  return St(e) === ts;
}
le.AsyncMode = xu;
le.ConcurrentMode = ts;
le.ContextConsumer = es;
le.ContextProvider = Ya;
le.Element = vu;
le.ForwardRef = ns;
le.Fragment = Ka;
le.Lazy = os;
le.Memo = rs;
le.Portal = _u;
le.Profiler = Za;
le.StrictMode = Xa;
le.Suspense = is;
le.isAsyncMode = function (e) {
  return Sf(e) || St(e) === xu;
};
le.isConcurrentMode = Sf;
le.isContextConsumer = function (e) {
  return St(e) === es;
};
le.isContextProvider = function (e) {
  return St(e) === Ya;
};
le.isElement = function (e) {
  return typeof e == 'object' && e !== null && e.$$typeof === vu;
};
le.isForwardRef = function (e) {
  return St(e) === ns;
};
le.isFragment = function (e) {
  return St(e) === Ka;
};
le.isLazy = function (e) {
  return St(e) === os;
};
le.isMemo = function (e) {
  return St(e) === rs;
};
le.isPortal = function (e) {
  return St(e) === _u;
};
le.isProfiler = function (e) {
  return St(e) === Za;
};
le.isStrictMode = function (e) {
  return St(e) === Xa;
};
le.isSuspense = function (e) {
  return St(e) === is;
};
le.isValidElementType = function (e) {
  return (
    typeof e == 'string' ||
    typeof e == 'function' ||
    e === Ka ||
    e === ts ||
    e === Za ||
    e === Xa ||
    e === is ||
    e === i0 ||
    (typeof e == 'object' &&
      e !== null &&
      (e.$$typeof === os ||
        e.$$typeof === rs ||
        e.$$typeof === Ya ||
        e.$$typeof === es ||
        e.$$typeof === ns ||
        e.$$typeof === o0 ||
        e.$$typeof === a0 ||
        e.$$typeof === s0 ||
        e.$$typeof === r0))
  );
};
le.typeOf = St;
(function (e) {
  e.exports = le;
})(kf);
var Eu = kf.exports,
  l0 = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0,
  },
  c0 = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 },
  u0 = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 },
  bf = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 },
  yu = {};
yu[Eu.ForwardRef] = u0;
yu[Eu.Memo] = bf;
function wp(e) {
  return Eu.isMemo(e) ? bf : yu[e.$$typeof] || l0;
}
var d0 = Object.defineProperty,
  p0 = Object.getOwnPropertyNames,
  kp = Object.getOwnPropertySymbols,
  h0 = Object.getOwnPropertyDescriptor,
  m0 = Object.getPrototypeOf,
  Sp = Object.prototype;
function Mf(e, t, n) {
  if (typeof t != 'string') {
    if (Sp) {
      var i = m0(t);
      i && i !== Sp && Mf(e, i, n);
    }
    var r = p0(t);
    kp && (r = r.concat(kp(t)));
    for (var o = wp(e), a = wp(t), s = 0; s < r.length; ++s) {
      var l = r[s];
      if (!c0[l] && !(n && n[l]) && !(a && a[l]) && !(o && o[l])) {
        var c = h0(t, l);
        try {
          d0(e, l, c);
        } catch {}
      }
    }
  }
  return e;
}
var f0 = Mf;
const bp = f0;
function Tf(e, t, n) {
  if ((n === void 0 && (n = Error), !e)) throw new n(t);
}
var X;
(function (e) {
  (e[(e.EXPECT_ARGUMENT_CLOSING_BRACE = 1)] = 'EXPECT_ARGUMENT_CLOSING_BRACE'),
    (e[(e.EMPTY_ARGUMENT = 2)] = 'EMPTY_ARGUMENT'),
    (e[(e.MALFORMED_ARGUMENT = 3)] = 'MALFORMED_ARGUMENT'),
    (e[(e.EXPECT_ARGUMENT_TYPE = 4)] = 'EXPECT_ARGUMENT_TYPE'),
    (e[(e.INVALID_ARGUMENT_TYPE = 5)] = 'INVALID_ARGUMENT_TYPE'),
    (e[(e.EXPECT_ARGUMENT_STYLE = 6)] = 'EXPECT_ARGUMENT_STYLE'),
    (e[(e.INVALID_NUMBER_SKELETON = 7)] = 'INVALID_NUMBER_SKELETON'),
    (e[(e.INVALID_DATE_TIME_SKELETON = 8)] = 'INVALID_DATE_TIME_SKELETON'),
    (e[(e.EXPECT_NUMBER_SKELETON = 9)] = 'EXPECT_NUMBER_SKELETON'),
    (e[(e.EXPECT_DATE_TIME_SKELETON = 10)] = 'EXPECT_DATE_TIME_SKELETON'),
    (e[(e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11)] = 'UNCLOSED_QUOTE_IN_ARGUMENT_STYLE'),
    (e[(e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12)] = 'EXPECT_SELECT_ARGUMENT_OPTIONS'),
    (e[(e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13)] = 'EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE'),
    (e[(e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14)] = 'INVALID_PLURAL_ARGUMENT_OFFSET_VALUE'),
    (e[(e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15)] = 'EXPECT_SELECT_ARGUMENT_SELECTOR'),
    (e[(e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16)] = 'EXPECT_PLURAL_ARGUMENT_SELECTOR'),
    (e[(e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17)] = 'EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT'),
    (e[(e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18)] = 'EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT'),
    (e[(e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19)] = 'INVALID_PLURAL_ARGUMENT_SELECTOR'),
    (e[(e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20)] = 'DUPLICATE_PLURAL_ARGUMENT_SELECTOR'),
    (e[(e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21)] = 'DUPLICATE_SELECT_ARGUMENT_SELECTOR'),
    (e[(e.MISSING_OTHER_CLAUSE = 22)] = 'MISSING_OTHER_CLAUSE'),
    (e[(e.INVALID_TAG = 23)] = 'INVALID_TAG'),
    (e[(e.INVALID_TAG_NAME = 25)] = 'INVALID_TAG_NAME'),
    (e[(e.UNMATCHED_CLOSING_TAG = 26)] = 'UNMATCHED_CLOSING_TAG'),
    (e[(e.UNCLOSED_TAG = 27)] = 'UNCLOSED_TAG');
})(X || (X = {}));
var me;
(function (e) {
  (e[(e.literal = 0)] = 'literal'),
    (e[(e.argument = 1)] = 'argument'),
    (e[(e.number = 2)] = 'number'),
    (e[(e.date = 3)] = 'date'),
    (e[(e.time = 4)] = 'time'),
    (e[(e.select = 5)] = 'select'),
    (e[(e.plural = 6)] = 'plural'),
    (e[(e.pound = 7)] = 'pound'),
    (e[(e.tag = 8)] = 'tag');
})(me || (me = {}));
var nr;
(function (e) {
  (e[(e.number = 0)] = 'number'), (e[(e.dateTime = 1)] = 'dateTime');
})(nr || (nr = {}));
function Mp(e) {
  return e.type === me.literal;
}
function g0(e) {
  return e.type === me.argument;
}
function Rf(e) {
  return e.type === me.number;
}
function Pf(e) {
  return e.type === me.date;
}
function Cf(e) {
  return e.type === me.time;
}
function Nf(e) {
  return e.type === me.select;
}
function If(e) {
  return e.type === me.plural;
}
function v0(e) {
  return e.type === me.pound;
}
function Df(e) {
  return e.type === me.tag;
}
function Of(e) {
  return !!(e && typeof e == 'object' && e.type === nr.number);
}
function dc(e) {
  return !!(e && typeof e == 'object' && e.type === nr.dateTime);
}
var Lf = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/,
  _0 =
    /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function x0(e) {
  var t = {};
  return (
    e.replace(_0, function (n) {
      var i = n.length;
      switch (n[0]) {
        case 'G':
          t.era = i === 4 ? 'long' : i === 5 ? 'narrow' : 'short';
          break;
        case 'y':
          t.year = i === 2 ? '2-digit' : 'numeric';
          break;
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
          throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
        case 'q':
        case 'Q':
          throw new RangeError('`q/Q` (quarter) patterns are not supported');
        case 'M':
        case 'L':
          t.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][i - 1];
          break;
        case 'w':
        case 'W':
          throw new RangeError('`w/W` (week) patterns are not supported');
        case 'd':
          t.day = ['numeric', '2-digit'][i - 1];
          break;
        case 'D':
        case 'F':
        case 'g':
          throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
        case 'E':
          t.weekday = i === 4 ? 'short' : i === 5 ? 'narrow' : 'short';
          break;
        case 'e':
          if (i < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
          t.weekday = ['short', 'long', 'narrow', 'short'][i - 4];
          break;
        case 'c':
          if (i < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
          t.weekday = ['short', 'long', 'narrow', 'short'][i - 4];
          break;
        case 'a':
          t.hour12 = !0;
          break;
        case 'b':
        case 'B':
          throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
        case 'h':
          (t.hourCycle = 'h12'), (t.hour = ['numeric', '2-digit'][i - 1]);
          break;
        case 'H':
          (t.hourCycle = 'h23'), (t.hour = ['numeric', '2-digit'][i - 1]);
          break;
        case 'K':
          (t.hourCycle = 'h11'), (t.hour = ['numeric', '2-digit'][i - 1]);
          break;
        case 'k':
          (t.hourCycle = 'h24'), (t.hour = ['numeric', '2-digit'][i - 1]);
          break;
        case 'j':
        case 'J':
        case 'C':
          throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
        case 'm':
          t.minute = ['numeric', '2-digit'][i - 1];
          break;
        case 's':
          t.second = ['numeric', '2-digit'][i - 1];
          break;
        case 'S':
        case 'A':
          throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
        case 'z':
          t.timeZoneName = i < 4 ? 'short' : 'long';
          break;
        case 'Z':
        case 'O':
        case 'v':
        case 'V':
        case 'X':
        case 'x':
          throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
      }
      return '';
    }),
    t
  );
}
var E0 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function y0(e) {
  if (e.length === 0) throw new Error('Number skeleton cannot be empty');
  for (
    var t = e.split(E0).filter(function (h) {
        return h.length > 0;
      }),
      n = [],
      i = 0,
      r = t;
    i < r.length;
    i++
  ) {
    var o = r[i],
      a = o.split('/');
    if (a.length === 0) throw new Error('Invalid number skeleton');
    for (var s = a[0], l = a.slice(1), c = 0, u = l; c < u.length; c++) {
      var m = u[c];
      if (m.length === 0) throw new Error('Invalid number skeleton');
    }
    n.push({ stem: s, options: l });
  }
  return n;
}
function A0(e) {
  return e.replace(/^(.*?)-/, '');
}
var Tp = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g,
  Hf = /^(@+)?(\+|#+)?[rs]?$/g,
  w0 = /(\*)(0+)|(#+)(0+)|(0+)/g,
  Ff = /^(0+)$/;
function Rp(e) {
  var t = {};
  return (
    e[e.length - 1] === 'r'
      ? (t.roundingPriority = 'morePrecision')
      : e[e.length - 1] === 's' && (t.roundingPriority = 'lessPrecision'),
    e.replace(Hf, function (n, i, r) {
      return (
        typeof r != 'string'
          ? ((t.minimumSignificantDigits = i.length), (t.maximumSignificantDigits = i.length))
          : r === '+'
            ? (t.minimumSignificantDigits = i.length)
            : i[0] === '#'
              ? (t.maximumSignificantDigits = i.length)
              : ((t.minimumSignificantDigits = i.length),
                (t.maximumSignificantDigits = i.length + (typeof r == 'string' ? r.length : 0))),
        ''
      );
    }),
    t
  );
}
function jf(e) {
  switch (e) {
    case 'sign-auto':
      return { signDisplay: 'auto' };
    case 'sign-accounting':
    case '()':
      return { currencySign: 'accounting' };
    case 'sign-always':
    case '+!':
      return { signDisplay: 'always' };
    case 'sign-accounting-always':
    case '()!':
      return { signDisplay: 'always', currencySign: 'accounting' };
    case 'sign-except-zero':
    case '+?':
      return { signDisplay: 'exceptZero' };
    case 'sign-accounting-except-zero':
    case '()?':
      return { signDisplay: 'exceptZero', currencySign: 'accounting' };
    case 'sign-never':
    case '+_':
      return { signDisplay: 'never' };
  }
}
function k0(e) {
  var t;
  if (
    (e[0] === 'E' && e[1] === 'E'
      ? ((t = { notation: 'engineering' }), (e = e.slice(2)))
      : e[0] === 'E' && ((t = { notation: 'scientific' }), (e = e.slice(1))),
    t)
  ) {
    var n = e.slice(0, 2);
    if (
      (n === '+!'
        ? ((t.signDisplay = 'always'), (e = e.slice(2)))
        : n === '+?' && ((t.signDisplay = 'exceptZero'), (e = e.slice(2))),
      !Ff.test(e))
    )
      throw new Error('Malformed concise eng/scientific notation');
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function Pp(e) {
  var t = {},
    n = jf(e);
  return n || t;
}
function S0(e) {
  for (var t = {}, n = 0, i = e; n < i.length; n++) {
    var r = i[n];
    switch (r.stem) {
      case 'percent':
      case '%':
        t.style = 'percent';
        continue;
      case '%x100':
        (t.style = 'percent'), (t.scale = 100);
        continue;
      case 'currency':
        (t.style = 'currency'), (t.currency = r.options[0]);
        continue;
      case 'group-off':
      case ',_':
        t.useGrouping = !1;
        continue;
      case 'precision-integer':
      case '.':
        t.maximumFractionDigits = 0;
        continue;
      case 'measure-unit':
      case 'unit':
        (t.style = 'unit'), (t.unit = A0(r.options[0]));
        continue;
      case 'compact-short':
      case 'K':
        (t.notation = 'compact'), (t.compactDisplay = 'short');
        continue;
      case 'compact-long':
      case 'KK':
        (t.notation = 'compact'), (t.compactDisplay = 'long');
        continue;
      case 'scientific':
        t = B(
          B(B({}, t), { notation: 'scientific' }),
          r.options.reduce(function (l, c) {
            return B(B({}, l), Pp(c));
          }, {}),
        );
        continue;
      case 'engineering':
        t = B(
          B(B({}, t), { notation: 'engineering' }),
          r.options.reduce(function (l, c) {
            return B(B({}, l), Pp(c));
          }, {}),
        );
        continue;
      case 'notation-simple':
        t.notation = 'standard';
        continue;
      case 'unit-width-narrow':
        (t.currencyDisplay = 'narrowSymbol'), (t.unitDisplay = 'narrow');
        continue;
      case 'unit-width-short':
        (t.currencyDisplay = 'code'), (t.unitDisplay = 'short');
        continue;
      case 'unit-width-full-name':
        (t.currencyDisplay = 'name'), (t.unitDisplay = 'long');
        continue;
      case 'unit-width-iso-code':
        t.currencyDisplay = 'symbol';
        continue;
      case 'scale':
        t.scale = parseFloat(r.options[0]);
        continue;
      case 'integer-width':
        if (r.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
        r.options[0].replace(w0, function (l, c, u, m, h, v) {
          if (c) t.minimumIntegerDigits = u.length;
          else {
            if (m && h) throw new Error('We currently do not support maximum integer digits');
            if (v) throw new Error('We currently do not support exact integer digits');
          }
          return '';
        });
        continue;
    }
    if (Ff.test(r.stem)) {
      t.minimumIntegerDigits = r.stem.length;
      continue;
    }
    if (Tp.test(r.stem)) {
      if (r.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
      r.stem.replace(Tp, function (l, c, u, m, h, v) {
        return (
          u === '*'
            ? (t.minimumFractionDigits = c.length)
            : m && m[0] === '#'
              ? (t.maximumFractionDigits = m.length)
              : h && v
                ? ((t.minimumFractionDigits = h.length), (t.maximumFractionDigits = h.length + v.length))
                : ((t.minimumFractionDigits = c.length), (t.maximumFractionDigits = c.length)),
          ''
        );
      });
      var o = r.options[0];
      o === 'w' ? (t = B(B({}, t), { trailingZeroDisplay: 'stripIfInteger' })) : o && (t = B(B({}, t), Rp(o)));
      continue;
    }
    if (Hf.test(r.stem)) {
      t = B(B({}, t), Rp(r.stem));
      continue;
    }
    var a = jf(r.stem);
    a && (t = B(B({}, t), a));
    var s = k0(r.stem);
    s && (t = B(B({}, t), s));
  }
  return t;
}
var zo = {
  AX: ['H'],
  BQ: ['H'],
  CP: ['H'],
  CZ: ['H'],
  DK: ['H'],
  FI: ['H'],
  ID: ['H'],
  IS: ['H'],
  ML: ['H'],
  NE: ['H'],
  RU: ['H'],
  SE: ['H'],
  SJ: ['H'],
  SK: ['H'],
  AS: ['h', 'H'],
  BT: ['h', 'H'],
  DJ: ['h', 'H'],
  ER: ['h', 'H'],
  GH: ['h', 'H'],
  IN: ['h', 'H'],
  LS: ['h', 'H'],
  PG: ['h', 'H'],
  PW: ['h', 'H'],
  SO: ['h', 'H'],
  TO: ['h', 'H'],
  VU: ['h', 'H'],
  WS: ['h', 'H'],
  '001': ['H', 'h'],
  AL: ['h', 'H', 'hB'],
  TD: ['h', 'H', 'hB'],
  'ca-ES': ['H', 'h', 'hB'],
  CF: ['H', 'h', 'hB'],
  CM: ['H', 'h', 'hB'],
  'fr-CA': ['H', 'h', 'hB'],
  'gl-ES': ['H', 'h', 'hB'],
  'it-CH': ['H', 'h', 'hB'],
  'it-IT': ['H', 'h', 'hB'],
  LU: ['H', 'h', 'hB'],
  NP: ['H', 'h', 'hB'],
  PF: ['H', 'h', 'hB'],
  SC: ['H', 'h', 'hB'],
  SM: ['H', 'h', 'hB'],
  SN: ['H', 'h', 'hB'],
  TF: ['H', 'h', 'hB'],
  VA: ['H', 'h', 'hB'],
  CY: ['h', 'H', 'hb', 'hB'],
  GR: ['h', 'H', 'hb', 'hB'],
  CO: ['h', 'H', 'hB', 'hb'],
  DO: ['h', 'H', 'hB', 'hb'],
  KP: ['h', 'H', 'hB', 'hb'],
  KR: ['h', 'H', 'hB', 'hb'],
  NA: ['h', 'H', 'hB', 'hb'],
  PA: ['h', 'H', 'hB', 'hb'],
  PR: ['h', 'H', 'hB', 'hb'],
  VE: ['h', 'H', 'hB', 'hb'],
  AC: ['H', 'h', 'hb', 'hB'],
  AI: ['H', 'h', 'hb', 'hB'],
  BW: ['H', 'h', 'hb', 'hB'],
  BZ: ['H', 'h', 'hb', 'hB'],
  CC: ['H', 'h', 'hb', 'hB'],
  CK: ['H', 'h', 'hb', 'hB'],
  CX: ['H', 'h', 'hb', 'hB'],
  DG: ['H', 'h', 'hb', 'hB'],
  FK: ['H', 'h', 'hb', 'hB'],
  GB: ['H', 'h', 'hb', 'hB'],
  GG: ['H', 'h', 'hb', 'hB'],
  GI: ['H', 'h', 'hb', 'hB'],
  IE: ['H', 'h', 'hb', 'hB'],
  IM: ['H', 'h', 'hb', 'hB'],
  IO: ['H', 'h', 'hb', 'hB'],
  JE: ['H', 'h', 'hb', 'hB'],
  LT: ['H', 'h', 'hb', 'hB'],
  MK: ['H', 'h', 'hb', 'hB'],
  MN: ['H', 'h', 'hb', 'hB'],
  MS: ['H', 'h', 'hb', 'hB'],
  NF: ['H', 'h', 'hb', 'hB'],
  NG: ['H', 'h', 'hb', 'hB'],
  NR: ['H', 'h', 'hb', 'hB'],
  NU: ['H', 'h', 'hb', 'hB'],
  PN: ['H', 'h', 'hb', 'hB'],
  SH: ['H', 'h', 'hb', 'hB'],
  SX: ['H', 'h', 'hb', 'hB'],
  TA: ['H', 'h', 'hb', 'hB'],
  ZA: ['H', 'h', 'hb', 'hB'],
  'af-ZA': ['H', 'h', 'hB', 'hb'],
  AR: ['H', 'h', 'hB', 'hb'],
  CL: ['H', 'h', 'hB', 'hb'],
  CR: ['H', 'h', 'hB', 'hb'],
  CU: ['H', 'h', 'hB', 'hb'],
  EA: ['H', 'h', 'hB', 'hb'],
  'es-BO': ['H', 'h', 'hB', 'hb'],
  'es-BR': ['H', 'h', 'hB', 'hb'],
  'es-EC': ['H', 'h', 'hB', 'hb'],
  'es-ES': ['H', 'h', 'hB', 'hb'],
  'es-GQ': ['H', 'h', 'hB', 'hb'],
  'es-PE': ['H', 'h', 'hB', 'hb'],
  GT: ['H', 'h', 'hB', 'hb'],
  HN: ['H', 'h', 'hB', 'hb'],
  IC: ['H', 'h', 'hB', 'hb'],
  KG: ['H', 'h', 'hB', 'hb'],
  KM: ['H', 'h', 'hB', 'hb'],
  LK: ['H', 'h', 'hB', 'hb'],
  MA: ['H', 'h', 'hB', 'hb'],
  MX: ['H', 'h', 'hB', 'hb'],
  NI: ['H', 'h', 'hB', 'hb'],
  PY: ['H', 'h', 'hB', 'hb'],
  SV: ['H', 'h', 'hB', 'hb'],
  UY: ['H', 'h', 'hB', 'hb'],
  JP: ['H', 'h', 'K'],
  AD: ['H', 'hB'],
  AM: ['H', 'hB'],
  AO: ['H', 'hB'],
  AT: ['H', 'hB'],
  AW: ['H', 'hB'],
  BE: ['H', 'hB'],
  BF: ['H', 'hB'],
  BJ: ['H', 'hB'],
  BL: ['H', 'hB'],
  BR: ['H', 'hB'],
  CG: ['H', 'hB'],
  CI: ['H', 'hB'],
  CV: ['H', 'hB'],
  DE: ['H', 'hB'],
  EE: ['H', 'hB'],
  FR: ['H', 'hB'],
  GA: ['H', 'hB'],
  GF: ['H', 'hB'],
  GN: ['H', 'hB'],
  GP: ['H', 'hB'],
  GW: ['H', 'hB'],
  HR: ['H', 'hB'],
  IL: ['H', 'hB'],
  IT: ['H', 'hB'],
  KZ: ['H', 'hB'],
  MC: ['H', 'hB'],
  MD: ['H', 'hB'],
  MF: ['H', 'hB'],
  MQ: ['H', 'hB'],
  MZ: ['H', 'hB'],
  NC: ['H', 'hB'],
  NL: ['H', 'hB'],
  PM: ['H', 'hB'],
  PT: ['H', 'hB'],
  RE: ['H', 'hB'],
  RO: ['H', 'hB'],
  SI: ['H', 'hB'],
  SR: ['H', 'hB'],
  ST: ['H', 'hB'],
  TG: ['H', 'hB'],
  TR: ['H', 'hB'],
  WF: ['H', 'hB'],
  YT: ['H', 'hB'],
  BD: ['h', 'hB', 'H'],
  PK: ['h', 'hB', 'H'],
  AZ: ['H', 'hB', 'h'],
  BA: ['H', 'hB', 'h'],
  BG: ['H', 'hB', 'h'],
  CH: ['H', 'hB', 'h'],
  GE: ['H', 'hB', 'h'],
  LI: ['H', 'hB', 'h'],
  ME: ['H', 'hB', 'h'],
  RS: ['H', 'hB', 'h'],
  UA: ['H', 'hB', 'h'],
  UZ: ['H', 'hB', 'h'],
  XK: ['H', 'hB', 'h'],
  AG: ['h', 'hb', 'H', 'hB'],
  AU: ['h', 'hb', 'H', 'hB'],
  BB: ['h', 'hb', 'H', 'hB'],
  BM: ['h', 'hb', 'H', 'hB'],
  BS: ['h', 'hb', 'H', 'hB'],
  CA: ['h', 'hb', 'H', 'hB'],
  DM: ['h', 'hb', 'H', 'hB'],
  'en-001': ['h', 'hb', 'H', 'hB'],
  FJ: ['h', 'hb', 'H', 'hB'],
  FM: ['h', 'hb', 'H', 'hB'],
  GD: ['h', 'hb', 'H', 'hB'],
  GM: ['h', 'hb', 'H', 'hB'],
  GU: ['h', 'hb', 'H', 'hB'],
  GY: ['h', 'hb', 'H', 'hB'],
  JM: ['h', 'hb', 'H', 'hB'],
  KI: ['h', 'hb', 'H', 'hB'],
  KN: ['h', 'hb', 'H', 'hB'],
  KY: ['h', 'hb', 'H', 'hB'],
  LC: ['h', 'hb', 'H', 'hB'],
  LR: ['h', 'hb', 'H', 'hB'],
  MH: ['h', 'hb', 'H', 'hB'],
  MP: ['h', 'hb', 'H', 'hB'],
  MW: ['h', 'hb', 'H', 'hB'],
  NZ: ['h', 'hb', 'H', 'hB'],
  SB: ['h', 'hb', 'H', 'hB'],
  SG: ['h', 'hb', 'H', 'hB'],
  SL: ['h', 'hb', 'H', 'hB'],
  SS: ['h', 'hb', 'H', 'hB'],
  SZ: ['h', 'hb', 'H', 'hB'],
  TC: ['h', 'hb', 'H', 'hB'],
  TT: ['h', 'hb', 'H', 'hB'],
  UM: ['h', 'hb', 'H', 'hB'],
  US: ['h', 'hb', 'H', 'hB'],
  VC: ['h', 'hb', 'H', 'hB'],
  VG: ['h', 'hb', 'H', 'hB'],
  VI: ['h', 'hb', 'H', 'hB'],
  ZM: ['h', 'hb', 'H', 'hB'],
  BO: ['H', 'hB', 'h', 'hb'],
  EC: ['H', 'hB', 'h', 'hb'],
  ES: ['H', 'hB', 'h', 'hb'],
  GQ: ['H', 'hB', 'h', 'hb'],
  PE: ['H', 'hB', 'h', 'hb'],
  AE: ['h', 'hB', 'hb', 'H'],
  'ar-001': ['h', 'hB', 'hb', 'H'],
  BH: ['h', 'hB', 'hb', 'H'],
  DZ: ['h', 'hB', 'hb', 'H'],
  EG: ['h', 'hB', 'hb', 'H'],
  EH: ['h', 'hB', 'hb', 'H'],
  HK: ['h', 'hB', 'hb', 'H'],
  IQ: ['h', 'hB', 'hb', 'H'],
  JO: ['h', 'hB', 'hb', 'H'],
  KW: ['h', 'hB', 'hb', 'H'],
  LB: ['h', 'hB', 'hb', 'H'],
  LY: ['h', 'hB', 'hb', 'H'],
  MO: ['h', 'hB', 'hb', 'H'],
  MR: ['h', 'hB', 'hb', 'H'],
  OM: ['h', 'hB', 'hb', 'H'],
  PH: ['h', 'hB', 'hb', 'H'],
  PS: ['h', 'hB', 'hb', 'H'],
  QA: ['h', 'hB', 'hb', 'H'],
  SA: ['h', 'hB', 'hb', 'H'],
  SD: ['h', 'hB', 'hb', 'H'],
  SY: ['h', 'hB', 'hb', 'H'],
  TN: ['h', 'hB', 'hb', 'H'],
  YE: ['h', 'hB', 'hb', 'H'],
  AF: ['H', 'hb', 'hB', 'h'],
  LA: ['H', 'hb', 'hB', 'h'],
  CN: ['H', 'hB', 'hb', 'h'],
  LV: ['H', 'hB', 'hb', 'h'],
  TL: ['H', 'hB', 'hb', 'h'],
  'zu-ZA': ['H', 'hB', 'hb', 'h'],
  CD: ['hB', 'H'],
  IR: ['hB', 'H'],
  'hi-IN': ['hB', 'h', 'H'],
  'kn-IN': ['hB', 'h', 'H'],
  'ml-IN': ['hB', 'h', 'H'],
  'te-IN': ['hB', 'h', 'H'],
  KH: ['hB', 'h', 'H', 'hb'],
  'ta-IN': ['hB', 'h', 'hb', 'H'],
  BN: ['hb', 'hB', 'h', 'H'],
  MY: ['hb', 'hB', 'h', 'H'],
  ET: ['hB', 'hb', 'h', 'H'],
  'gu-IN': ['hB', 'hb', 'h', 'H'],
  'mr-IN': ['hB', 'hb', 'h', 'H'],
  'pa-IN': ['hB', 'hb', 'h', 'H'],
  TW: ['hB', 'hb', 'h', 'H'],
  KE: ['hB', 'hb', 'H', 'h'],
  MM: ['hB', 'hb', 'H', 'h'],
  TZ: ['hB', 'hb', 'H', 'h'],
  UG: ['hB', 'hb', 'H', 'h'],
};
function b0(e, t) {
  for (var n = '', i = 0; i < e.length; i++) {
    var r = e.charAt(i);
    if (r === 'j') {
      for (var o = 0; i + 1 < e.length && e.charAt(i + 1) === r; ) o++, i++;
      var a = 1 + (o & 1),
        s = o < 2 ? 1 : 3 + (o >> 1),
        l = 'a',
        c = M0(t);
      for ((c == 'H' || c == 'k') && (s = 0); s-- > 0; ) n += l;
      for (; a-- > 0; ) n = c + n;
    } else r === 'J' ? (n += 'H') : (n += r);
  }
  return n;
}
function M0(e) {
  var t = e.hourCycle;
  if ((t === void 0 && e.hourCycles && e.hourCycles.length && (t = e.hourCycles[0]), t))
    switch (t) {
      case 'h24':
        return 'k';
      case 'h23':
        return 'H';
      case 'h12':
        return 'h';
      case 'h11':
        return 'K';
      default:
        throw new Error('Invalid hourCycle');
    }
  var n = e.language,
    i;
  n !== 'root' && (i = e.maximize().region);
  var r = zo[i || ''] || zo[n || ''] || zo[''.concat(n, '-001')] || zo['001'];
  return r[0];
}
var al,
  T0 = new RegExp('^'.concat(Lf.source, '*')),
  R0 = new RegExp(''.concat(Lf.source, '*$'));
function Z(e, t) {
  return { start: e, end: t };
}
var P0 = !!String.prototype.startsWith,
  C0 = !!String.fromCodePoint,
  N0 = !!Object.fromEntries,
  I0 = !!String.prototype.codePointAt,
  D0 = !!String.prototype.trimStart,
  O0 = !!String.prototype.trimEnd,
  L0 = !!Number.isSafeInteger,
  H0 = L0
    ? Number.isSafeInteger
    : function (e) {
        return typeof e == 'number' && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
      },
  pc = !0;
try {
  var F0 = Bf('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
  pc = ((al = F0.exec('a')) === null || al === void 0 ? void 0 : al[0]) === 'a';
} catch {
  pc = !1;
}
var Cp = P0
    ? function (t, n, i) {
        return t.startsWith(n, i);
      }
    : function (t, n, i) {
        return t.slice(i, i + n.length) === n;
      },
  hc = C0
    ? String.fromCodePoint
    : function () {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        for (var i = '', r = t.length, o = 0, a; r > o; ) {
          if (((a = t[o++]), a > 1114111)) throw RangeError(a + ' is not a valid code point');
          i +=
            a < 65536 ? String.fromCharCode(a) : String.fromCharCode(((a -= 65536) >> 10) + 55296, (a % 1024) + 56320);
        }
        return i;
      },
  Np = N0
    ? Object.fromEntries
    : function (t) {
        for (var n = {}, i = 0, r = t; i < r.length; i++) {
          var o = r[i],
            a = o[0],
            s = o[1];
          n[a] = s;
        }
        return n;
      },
  zf = I0
    ? function (t, n) {
        return t.codePointAt(n);
      }
    : function (t, n) {
        var i = t.length;
        if (!(n < 0 || n >= i)) {
          var r = t.charCodeAt(n),
            o;
          return r < 55296 || r > 56319 || n + 1 === i || (o = t.charCodeAt(n + 1)) < 56320 || o > 57343
            ? r
            : ((r - 55296) << 10) + (o - 56320) + 65536;
        }
      },
  j0 = D0
    ? function (t) {
        return t.trimStart();
      }
    : function (t) {
        return t.replace(T0, '');
      },
  z0 = O0
    ? function (t) {
        return t.trimEnd();
      }
    : function (t) {
        return t.replace(R0, '');
      };
function Bf(e, t) {
  return new RegExp(e, t);
}
var mc;
if (pc) {
  var Ip = Bf('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
  mc = function (t, n) {
    var i;
    Ip.lastIndex = n;
    var r = Ip.exec(t);
    return (i = r[1]) !== null && i !== void 0 ? i : '';
  };
} else
  mc = function (t, n) {
    for (var i = []; ; ) {
      var r = zf(t, n);
      if (r === void 0 || Uf(r) || G0(r)) break;
      i.push(r), (n += r >= 65536 ? 2 : 1);
    }
    return hc.apply(void 0, i);
  };
var B0 = (function () {
  function e(t, n) {
    n === void 0 && (n = {}),
      (this.message = t),
      (this.position = { offset: 0, line: 1, column: 1 }),
      (this.ignoreTag = !!n.ignoreTag),
      (this.locale = n.locale),
      (this.requiresOtherClause = !!n.requiresOtherClause),
      (this.shouldParseSkeletons = !!n.shouldParseSkeletons);
  }
  return (
    (e.prototype.parse = function () {
      if (this.offset() !== 0) throw Error('parser can only be used once');
      return this.parseMessage(0, '', !1);
    }),
    (e.prototype.parseMessage = function (t, n, i) {
      for (var r = []; !this.isEOF(); ) {
        var o = this.char();
        if (o === 123) {
          var a = this.parseArgument(t, i);
          if (a.err) return a;
          r.push(a.val);
        } else {
          if (o === 125 && t > 0) break;
          if (o === 35 && (n === 'plural' || n === 'selectordinal')) {
            var s = this.clonePosition();
            this.bump(), r.push({ type: me.pound, location: Z(s, this.clonePosition()) });
          } else if (o === 60 && !this.ignoreTag && this.peek() === 47) {
            if (i) break;
            return this.error(X.UNMATCHED_CLOSING_TAG, Z(this.clonePosition(), this.clonePosition()));
          } else if (o === 60 && !this.ignoreTag && fc(this.peek() || 0)) {
            var a = this.parseTag(t, n);
            if (a.err) return a;
            r.push(a.val);
          } else {
            var a = this.parseLiteral(t, n);
            if (a.err) return a;
            r.push(a.val);
          }
        }
      }
      return { val: r, err: null };
    }),
    (e.prototype.parseTag = function (t, n) {
      var i = this.clonePosition();
      this.bump();
      var r = this.parseTagName();
      if ((this.bumpSpace(), this.bumpIf('/>')))
        return {
          val: { type: me.literal, value: '<'.concat(r, '/>'), location: Z(i, this.clonePosition()) },
          err: null,
        };
      if (this.bumpIf('>')) {
        var o = this.parseMessage(t + 1, n, !0);
        if (o.err) return o;
        var a = o.val,
          s = this.clonePosition();
        if (this.bumpIf('</')) {
          if (this.isEOF() || !fc(this.char())) return this.error(X.INVALID_TAG, Z(s, this.clonePosition()));
          var l = this.clonePosition(),
            c = this.parseTagName();
          return r !== c
            ? this.error(X.UNMATCHED_CLOSING_TAG, Z(l, this.clonePosition()))
            : (this.bumpSpace(),
              this.bumpIf('>')
                ? { val: { type: me.tag, value: r, children: a, location: Z(i, this.clonePosition()) }, err: null }
                : this.error(X.INVALID_TAG, Z(s, this.clonePosition())));
        } else return this.error(X.UNCLOSED_TAG, Z(i, this.clonePosition()));
      } else return this.error(X.INVALID_TAG, Z(i, this.clonePosition()));
    }),
    (e.prototype.parseTagName = function () {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && $0(this.char()); ) this.bump();
      return this.message.slice(t, this.offset());
    }),
    (e.prototype.parseLiteral = function (t, n) {
      for (var i = this.clonePosition(), r = ''; ; ) {
        var o = this.tryParseQuote(n);
        if (o) {
          r += o;
          continue;
        }
        var a = this.tryParseUnquoted(t, n);
        if (a) {
          r += a;
          continue;
        }
        var s = this.tryParseLeftAngleBracket();
        if (s) {
          r += s;
          continue;
        }
        break;
      }
      var l = Z(i, this.clonePosition());
      return { val: { type: me.literal, value: r, location: l }, err: null };
    }),
    (e.prototype.tryParseLeftAngleBracket = function () {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || !U0(this.peek() || 0))
        ? (this.bump(), '<')
        : null;
    }),
    (e.prototype.tryParseQuote = function (t) {
      if (this.isEOF() || this.char() !== 39) return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === 'plural' || t === 'selectordinal') break;
          return null;
        default:
          return null;
      }
      this.bump();
      var n = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var i = this.char();
        if (i === 39)
          if (this.peek() === 39) n.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else n.push(i);
        this.bump();
      }
      return hc.apply(void 0, n);
    }),
    (e.prototype.tryParseUnquoted = function (t, n) {
      if (this.isEOF()) return null;
      var i = this.char();
      return i === 60 || i === 123 || (i === 35 && (n === 'plural' || n === 'selectordinal')) || (i === 125 && t > 0)
        ? null
        : (this.bump(), hc(i));
    }),
    (e.prototype.parseArgument = function (t, n) {
      var i = this.clonePosition();
      if ((this.bump(), this.bumpSpace(), this.isEOF()))
        return this.error(X.EXPECT_ARGUMENT_CLOSING_BRACE, Z(i, this.clonePosition()));
      if (this.char() === 125) return this.bump(), this.error(X.EMPTY_ARGUMENT, Z(i, this.clonePosition()));
      var r = this.parseIdentifierIfPossible().value;
      if (!r) return this.error(X.MALFORMED_ARGUMENT, Z(i, this.clonePosition()));
      if ((this.bumpSpace(), this.isEOF()))
        return this.error(X.EXPECT_ARGUMENT_CLOSING_BRACE, Z(i, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), { val: { type: me.argument, value: r, location: Z(i, this.clonePosition()) }, err: null };
        case 44:
          return (
            this.bump(),
            this.bumpSpace(),
            this.isEOF()
              ? this.error(X.EXPECT_ARGUMENT_CLOSING_BRACE, Z(i, this.clonePosition()))
              : this.parseArgumentOptions(t, n, r, i)
          );
        default:
          return this.error(X.MALFORMED_ARGUMENT, Z(i, this.clonePosition()));
      }
    }),
    (e.prototype.parseIdentifierIfPossible = function () {
      var t = this.clonePosition(),
        n = this.offset(),
        i = mc(this.message, n),
        r = n + i.length;
      this.bumpTo(r);
      var o = this.clonePosition(),
        a = Z(t, o);
      return { value: i, location: a };
    }),
    (e.prototype.parseArgumentOptions = function (t, n, i, r) {
      var o,
        a = this.clonePosition(),
        s = this.parseIdentifierIfPossible().value,
        l = this.clonePosition();
      switch (s) {
        case '':
          return this.error(X.EXPECT_ARGUMENT_TYPE, Z(a, l));
        case 'number':
        case 'date':
        case 'time': {
          this.bumpSpace();
          var c = null;
          if (this.bumpIf(',')) {
            this.bumpSpace();
            var u = this.clonePosition(),
              m = this.parseSimpleArgStyleIfPossible();
            if (m.err) return m;
            var h = z0(m.val);
            if (h.length === 0)
              return this.error(X.EXPECT_ARGUMENT_STYLE, Z(this.clonePosition(), this.clonePosition()));
            var v = Z(u, this.clonePosition());
            c = { style: h, styleLocation: v };
          }
          var x = this.tryParseArgumentClose(r);
          if (x.err) return x;
          var f = Z(r, this.clonePosition());
          if (c && Cp(c == null ? void 0 : c.style, '::', 0)) {
            var D = j0(c.style.slice(2));
            if (s === 'number') {
              var m = this.parseNumberSkeletonFromString(D, c.styleLocation);
              return m.err ? m : { val: { type: me.number, value: i, location: f, style: m.val }, err: null };
            } else {
              if (D.length === 0) return this.error(X.EXPECT_DATE_TIME_SKELETON, f);
              var p = D;
              this.locale && (p = b0(D, this.locale));
              var h = {
                  type: nr.dateTime,
                  pattern: p,
                  location: c.styleLocation,
                  parsedOptions: this.shouldParseSkeletons ? x0(p) : {},
                },
                d = s === 'date' ? me.date : me.time;
              return { val: { type: d, value: i, location: f, style: h }, err: null };
            }
          }
          return {
            val: {
              type: s === 'number' ? me.number : s === 'date' ? me.date : me.time,
              value: i,
              location: f,
              style: (o = c == null ? void 0 : c.style) !== null && o !== void 0 ? o : null,
            },
            err: null,
          };
        }
        case 'plural':
        case 'selectordinal':
        case 'select': {
          var g = this.clonePosition();
          if ((this.bumpSpace(), !this.bumpIf(',')))
            return this.error(X.EXPECT_SELECT_ARGUMENT_OPTIONS, Z(g, B({}, g)));
          this.bumpSpace();
          var y = this.parseIdentifierIfPossible(),
            b = 0;
          if (s !== 'select' && y.value === 'offset') {
            if (!this.bumpIf(':'))
              return this.error(X.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, Z(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var m = this.tryParseDecimalInteger(
              X.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE,
              X.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE,
            );
            if (m.err) return m;
            this.bumpSpace(), (y = this.parseIdentifierIfPossible()), (b = m.val);
          }
          var C = this.tryParsePluralOrSelectOptions(t, s, n, y);
          if (C.err) return C;
          var x = this.tryParseArgumentClose(r);
          if (x.err) return x;
          var R = Z(r, this.clonePosition());
          return s === 'select'
            ? { val: { type: me.select, value: i, options: Np(C.val), location: R }, err: null }
            : {
                val: {
                  type: me.plural,
                  value: i,
                  options: Np(C.val),
                  offset: b,
                  pluralType: s === 'plural' ? 'cardinal' : 'ordinal',
                  location: R,
                },
                err: null,
              };
        }
        default:
          return this.error(X.INVALID_ARGUMENT_TYPE, Z(a, l));
      }
    }),
    (e.prototype.tryParseArgumentClose = function (t) {
      return this.isEOF() || this.char() !== 125
        ? this.error(X.EXPECT_ARGUMENT_CLOSING_BRACE, Z(t, this.clonePosition()))
        : (this.bump(), { val: !0, err: null });
    }),
    (e.prototype.parseSimpleArgStyleIfPossible = function () {
      for (var t = 0, n = this.clonePosition(); !this.isEOF(); ) {
        var i = this.char();
        switch (i) {
          case 39: {
            this.bump();
            var r = this.clonePosition();
            if (!this.bumpUntil("'")) return this.error(X.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, Z(r, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            (t += 1), this.bump();
            break;
          }
          case 125: {
            if (t > 0) t -= 1;
            else return { val: this.message.slice(n.offset, this.offset()), err: null };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return { val: this.message.slice(n.offset, this.offset()), err: null };
    }),
    (e.prototype.parseNumberSkeletonFromString = function (t, n) {
      var i = [];
      try {
        i = y0(t);
      } catch {
        return this.error(X.INVALID_NUMBER_SKELETON, n);
      }
      return {
        val: { type: nr.number, tokens: i, location: n, parsedOptions: this.shouldParseSkeletons ? S0(i) : {} },
        err: null,
      };
    }),
    (e.prototype.tryParsePluralOrSelectOptions = function (t, n, i, r) {
      for (var o, a = !1, s = [], l = new Set(), c = r.value, u = r.location; ; ) {
        if (c.length === 0) {
          var m = this.clonePosition();
          if (n !== 'select' && this.bumpIf('=')) {
            var h = this.tryParseDecimalInteger(X.EXPECT_PLURAL_ARGUMENT_SELECTOR, X.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (h.err) return h;
            (u = Z(m, this.clonePosition())), (c = this.message.slice(m.offset, this.offset()));
          } else break;
        }
        if (l.has(c))
          return this.error(
            n === 'select' ? X.DUPLICATE_SELECT_ARGUMENT_SELECTOR : X.DUPLICATE_PLURAL_ARGUMENT_SELECTOR,
            u,
          );
        c === 'other' && (a = !0), this.bumpSpace();
        var v = this.clonePosition();
        if (!this.bumpIf('{'))
          return this.error(
            n === 'select' ? X.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : X.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT,
            Z(this.clonePosition(), this.clonePosition()),
          );
        var x = this.parseMessage(t + 1, n, i);
        if (x.err) return x;
        var f = this.tryParseArgumentClose(v);
        if (f.err) return f;
        s.push([c, { value: x.val, location: Z(v, this.clonePosition()) }]),
          l.add(c),
          this.bumpSpace(),
          (o = this.parseIdentifierIfPossible()),
          (c = o.value),
          (u = o.location);
      }
      return s.length === 0
        ? this.error(
            n === 'select' ? X.EXPECT_SELECT_ARGUMENT_SELECTOR : X.EXPECT_PLURAL_ARGUMENT_SELECTOR,
            Z(this.clonePosition(), this.clonePosition()),
          )
        : this.requiresOtherClause && !a
          ? this.error(X.MISSING_OTHER_CLAUSE, Z(this.clonePosition(), this.clonePosition()))
          : { val: s, err: null };
    }),
    (e.prototype.tryParseDecimalInteger = function (t, n) {
      var i = 1,
        r = this.clonePosition();
      this.bumpIf('+') || (this.bumpIf('-') && (i = -1));
      for (var o = !1, a = 0; !this.isEOF(); ) {
        var s = this.char();
        if (s >= 48 && s <= 57) (o = !0), (a = a * 10 + (s - 48)), this.bump();
        else break;
      }
      var l = Z(r, this.clonePosition());
      return o ? ((a *= i), H0(a) ? { val: a, err: null } : this.error(n, l)) : this.error(t, l);
    }),
    (e.prototype.offset = function () {
      return this.position.offset;
    }),
    (e.prototype.isEOF = function () {
      return this.offset() === this.message.length;
    }),
    (e.prototype.clonePosition = function () {
      return { offset: this.position.offset, line: this.position.line, column: this.position.column };
    }),
    (e.prototype.char = function () {
      var t = this.position.offset;
      if (t >= this.message.length) throw Error('out of bound');
      var n = zf(this.message, t);
      if (n === void 0) throw Error('Offset '.concat(t, ' is at invalid UTF-16 code unit boundary'));
      return n;
    }),
    (e.prototype.error = function (t, n) {
      return { val: null, err: { kind: t, message: this.message, location: n } };
    }),
    (e.prototype.bump = function () {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10
          ? ((this.position.line += 1), (this.position.column = 1), (this.position.offset += 1))
          : ((this.position.column += 1), (this.position.offset += t < 65536 ? 1 : 2));
      }
    }),
    (e.prototype.bumpIf = function (t) {
      if (Cp(this.message, t, this.offset())) {
        for (var n = 0; n < t.length; n++) this.bump();
        return !0;
      }
      return !1;
    }),
    (e.prototype.bumpUntil = function (t) {
      var n = this.offset(),
        i = this.message.indexOf(t, n);
      return i >= 0 ? (this.bumpTo(i), !0) : (this.bumpTo(this.message.length), !1);
    }),
    (e.prototype.bumpTo = function (t) {
      if (this.offset() > t)
        throw Error(
          'targetOffset '.concat(t, ' must be greater than or equal to the current offset ').concat(this.offset()),
        );
      for (t = Math.min(t, this.message.length); ; ) {
        var n = this.offset();
        if (n === t) break;
        if (n > t) throw Error('targetOffset '.concat(t, ' is at invalid UTF-16 code unit boundary'));
        if ((this.bump(), this.isEOF())) break;
      }
    }),
    (e.prototype.bumpSpace = function () {
      for (; !this.isEOF() && Uf(this.char()); ) this.bump();
    }),
    (e.prototype.peek = function () {
      if (this.isEOF()) return null;
      var t = this.char(),
        n = this.offset(),
        i = this.message.charCodeAt(n + (t >= 65536 ? 2 : 1));
      return i != null ? i : null;
    }),
    e
  );
})();
function fc(e) {
  return (e >= 97 && e <= 122) || (e >= 65 && e <= 90);
}
function U0(e) {
  return fc(e) || e === 47;
}
function $0(e) {
  return (
    e === 45 ||
    e === 46 ||
    (e >= 48 && e <= 57) ||
    e === 95 ||
    (e >= 97 && e <= 122) ||
    (e >= 65 && e <= 90) ||
    e == 183 ||
    (e >= 192 && e <= 214) ||
    (e >= 216 && e <= 246) ||
    (e >= 248 && e <= 893) ||
    (e >= 895 && e <= 8191) ||
    (e >= 8204 && e <= 8205) ||
    (e >= 8255 && e <= 8256) ||
    (e >= 8304 && e <= 8591) ||
    (e >= 11264 && e <= 12271) ||
    (e >= 12289 && e <= 55295) ||
    (e >= 63744 && e <= 64975) ||
    (e >= 65008 && e <= 65533) ||
    (e >= 65536 && e <= 983039)
  );
}
function Uf(e) {
  return (e >= 9 && e <= 13) || e === 32 || e === 133 || (e >= 8206 && e <= 8207) || e === 8232 || e === 8233;
}
function G0(e) {
  return (
    (e >= 33 && e <= 35) ||
    e === 36 ||
    (e >= 37 && e <= 39) ||
    e === 40 ||
    e === 41 ||
    e === 42 ||
    e === 43 ||
    e === 44 ||
    e === 45 ||
    (e >= 46 && e <= 47) ||
    (e >= 58 && e <= 59) ||
    (e >= 60 && e <= 62) ||
    (e >= 63 && e <= 64) ||
    e === 91 ||
    e === 92 ||
    e === 93 ||
    e === 94 ||
    e === 96 ||
    e === 123 ||
    e === 124 ||
    e === 125 ||
    e === 126 ||
    e === 161 ||
    (e >= 162 && e <= 165) ||
    e === 166 ||
    e === 167 ||
    e === 169 ||
    e === 171 ||
    e === 172 ||
    e === 174 ||
    e === 176 ||
    e === 177 ||
    e === 182 ||
    e === 187 ||
    e === 191 ||
    e === 215 ||
    e === 247 ||
    (e >= 8208 && e <= 8213) ||
    (e >= 8214 && e <= 8215) ||
    e === 8216 ||
    e === 8217 ||
    e === 8218 ||
    (e >= 8219 && e <= 8220) ||
    e === 8221 ||
    e === 8222 ||
    e === 8223 ||
    (e >= 8224 && e <= 8231) ||
    (e >= 8240 && e <= 8248) ||
    e === 8249 ||
    e === 8250 ||
    (e >= 8251 && e <= 8254) ||
    (e >= 8257 && e <= 8259) ||
    e === 8260 ||
    e === 8261 ||
    e === 8262 ||
    (e >= 8263 && e <= 8273) ||
    e === 8274 ||
    e === 8275 ||
    (e >= 8277 && e <= 8286) ||
    (e >= 8592 && e <= 8596) ||
    (e >= 8597 && e <= 8601) ||
    (e >= 8602 && e <= 8603) ||
    (e >= 8604 && e <= 8607) ||
    e === 8608 ||
    (e >= 8609 && e <= 8610) ||
    e === 8611 ||
    (e >= 8612 && e <= 8613) ||
    e === 8614 ||
    (e >= 8615 && e <= 8621) ||
    e === 8622 ||
    (e >= 8623 && e <= 8653) ||
    (e >= 8654 && e <= 8655) ||
    (e >= 8656 && e <= 8657) ||
    e === 8658 ||
    e === 8659 ||
    e === 8660 ||
    (e >= 8661 && e <= 8691) ||
    (e >= 8692 && e <= 8959) ||
    (e >= 8960 && e <= 8967) ||
    e === 8968 ||
    e === 8969 ||
    e === 8970 ||
    e === 8971 ||
    (e >= 8972 && e <= 8991) ||
    (e >= 8992 && e <= 8993) ||
    (e >= 8994 && e <= 9e3) ||
    e === 9001 ||
    e === 9002 ||
    (e >= 9003 && e <= 9083) ||
    e === 9084 ||
    (e >= 9085 && e <= 9114) ||
    (e >= 9115 && e <= 9139) ||
    (e >= 9140 && e <= 9179) ||
    (e >= 9180 && e <= 9185) ||
    (e >= 9186 && e <= 9254) ||
    (e >= 9255 && e <= 9279) ||
    (e >= 9280 && e <= 9290) ||
    (e >= 9291 && e <= 9311) ||
    (e >= 9472 && e <= 9654) ||
    e === 9655 ||
    (e >= 9656 && e <= 9664) ||
    e === 9665 ||
    (e >= 9666 && e <= 9719) ||
    (e >= 9720 && e <= 9727) ||
    (e >= 9728 && e <= 9838) ||
    e === 9839 ||
    (e >= 9840 && e <= 10087) ||
    e === 10088 ||
    e === 10089 ||
    e === 10090 ||
    e === 10091 ||
    e === 10092 ||
    e === 10093 ||
    e === 10094 ||
    e === 10095 ||
    e === 10096 ||
    e === 10097 ||
    e === 10098 ||
    e === 10099 ||
    e === 10100 ||
    e === 10101 ||
    (e >= 10132 && e <= 10175) ||
    (e >= 10176 && e <= 10180) ||
    e === 10181 ||
    e === 10182 ||
    (e >= 10183 && e <= 10213) ||
    e === 10214 ||
    e === 10215 ||
    e === 10216 ||
    e === 10217 ||
    e === 10218 ||
    e === 10219 ||
    e === 10220 ||
    e === 10221 ||
    e === 10222 ||
    e === 10223 ||
    (e >= 10224 && e <= 10239) ||
    (e >= 10240 && e <= 10495) ||
    (e >= 10496 && e <= 10626) ||
    e === 10627 ||
    e === 10628 ||
    e === 10629 ||
    e === 10630 ||
    e === 10631 ||
    e === 10632 ||
    e === 10633 ||
    e === 10634 ||
    e === 10635 ||
    e === 10636 ||
    e === 10637 ||
    e === 10638 ||
    e === 10639 ||
    e === 10640 ||
    e === 10641 ||
    e === 10642 ||
    e === 10643 ||
    e === 10644 ||
    e === 10645 ||
    e === 10646 ||
    e === 10647 ||
    e === 10648 ||
    (e >= 10649 && e <= 10711) ||
    e === 10712 ||
    e === 10713 ||
    e === 10714 ||
    e === 10715 ||
    (e >= 10716 && e <= 10747) ||
    e === 10748 ||
    e === 10749 ||
    (e >= 10750 && e <= 11007) ||
    (e >= 11008 && e <= 11055) ||
    (e >= 11056 && e <= 11076) ||
    (e >= 11077 && e <= 11078) ||
    (e >= 11079 && e <= 11084) ||
    (e >= 11085 && e <= 11123) ||
    (e >= 11124 && e <= 11125) ||
    (e >= 11126 && e <= 11157) ||
    e === 11158 ||
    (e >= 11159 && e <= 11263) ||
    (e >= 11776 && e <= 11777) ||
    e === 11778 ||
    e === 11779 ||
    e === 11780 ||
    e === 11781 ||
    (e >= 11782 && e <= 11784) ||
    e === 11785 ||
    e === 11786 ||
    e === 11787 ||
    e === 11788 ||
    e === 11789 ||
    (e >= 11790 && e <= 11798) ||
    e === 11799 ||
    (e >= 11800 && e <= 11801) ||
    e === 11802 ||
    e === 11803 ||
    e === 11804 ||
    e === 11805 ||
    (e >= 11806 && e <= 11807) ||
    e === 11808 ||
    e === 11809 ||
    e === 11810 ||
    e === 11811 ||
    e === 11812 ||
    e === 11813 ||
    e === 11814 ||
    e === 11815 ||
    e === 11816 ||
    e === 11817 ||
    (e >= 11818 && e <= 11822) ||
    e === 11823 ||
    (e >= 11824 && e <= 11833) ||
    (e >= 11834 && e <= 11835) ||
    (e >= 11836 && e <= 11839) ||
    e === 11840 ||
    e === 11841 ||
    e === 11842 ||
    (e >= 11843 && e <= 11855) ||
    (e >= 11856 && e <= 11857) ||
    e === 11858 ||
    (e >= 11859 && e <= 11903) ||
    (e >= 12289 && e <= 12291) ||
    e === 12296 ||
    e === 12297 ||
    e === 12298 ||
    e === 12299 ||
    e === 12300 ||
    e === 12301 ||
    e === 12302 ||
    e === 12303 ||
    e === 12304 ||
    e === 12305 ||
    (e >= 12306 && e <= 12307) ||
    e === 12308 ||
    e === 12309 ||
    e === 12310 ||
    e === 12311 ||
    e === 12312 ||
    e === 12313 ||
    e === 12314 ||
    e === 12315 ||
    e === 12316 ||
    e === 12317 ||
    (e >= 12318 && e <= 12319) ||
    e === 12320 ||
    e === 12336 ||
    e === 64830 ||
    e === 64831 ||
    (e >= 65093 && e <= 65094)
  );
}
function gc(e) {
  e.forEach(function (t) {
    if ((delete t.location, Nf(t) || If(t)))
      for (var n in t.options) delete t.options[n].location, gc(t.options[n].value);
    else
      (Rf(t) && Of(t.style)) || ((Pf(t) || Cf(t)) && dc(t.style)) ? delete t.style.location : Df(t) && gc(t.children);
  });
}
function J0(e, t) {
  t === void 0 && (t = {}), (t = B({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t));
  var n = new B0(e, t).parse();
  if (n.err) {
    var i = SyntaxError(X[n.err.kind]);
    throw ((i.location = n.err.location), (i.originalMessage = n.err.message), i);
  }
  return (t != null && t.captureLocation) || gc(n.val), n.val;
}
function qt(e, t) {
  var n = t && t.cache ? t.cache : X0,
    i = t && t.serializer ? t.serializer : K0,
    r = t && t.strategy ? t.strategy : q0;
  return r(e, { cache: n, serializer: i });
}
function V0(e) {
  return e == null || typeof e == 'number' || typeof e == 'boolean';
}
function $f(e, t, n, i) {
  var r = V0(i) ? i : n(i),
    o = t.get(r);
  return typeof o > 'u' && ((o = e.call(this, i)), t.set(r, o)), o;
}
function Gf(e, t, n) {
  var i = Array.prototype.slice.call(arguments, 3),
    r = n(i),
    o = t.get(r);
  return typeof o > 'u' && ((o = e.apply(this, i)), t.set(r, o)), o;
}
function Au(e, t, n, i, r) {
  return n.bind(t, e, i, r);
}
function q0(e, t) {
  var n = e.length === 1 ? $f : Gf;
  return Au(e, this, n, t.cache.create(), t.serializer);
}
function Q0(e, t) {
  return Au(e, this, Gf, t.cache.create(), t.serializer);
}
function W0(e, t) {
  return Au(e, this, $f, t.cache.create(), t.serializer);
}
var K0 = function () {
  return JSON.stringify(arguments);
};
function wu() {
  this.cache = Object.create(null);
}
wu.prototype.get = function (e) {
  return this.cache[e];
};
wu.prototype.set = function (e, t) {
  this.cache[e] = t;
};
var X0 = {
    create: function () {
      return new wu();
    },
  },
  Qt = { variadic: Q0, monadic: W0 },
  en;
(function (e) {
  (e.MISSING_VALUE = 'MISSING_VALUE'), (e.INVALID_VALUE = 'INVALID_VALUE'), (e.MISSING_INTL_API = 'MISSING_INTL_API');
})(en || (en = {}));
var Gn = (function (e) {
    It(t, e);
    function t(n, i, r) {
      var o = e.call(this, n) || this;
      return (o.code = i), (o.originalMessage = r), o;
    }
    return (
      (t.prototype.toString = function () {
        return '[formatjs Error: '.concat(this.code, '] ').concat(this.message);
      }),
      t
    );
  })(Error),
  Dp = (function (e) {
    It(t, e);
    function t(n, i, r, o) {
      return (
        e.call(
          this,
          'Invalid values for "'
            .concat(n, '": "')
            .concat(i, '". Options are "')
            .concat(Object.keys(r).join('", "'), '"'),
          en.INVALID_VALUE,
          o,
        ) || this
      );
    }
    return t;
  })(Gn),
  Z0 = (function (e) {
    It(t, e);
    function t(n, i, r) {
      return e.call(this, 'Value for "'.concat(n, '" must be of type ').concat(i), en.INVALID_VALUE, r) || this;
    }
    return t;
  })(Gn),
  Y0 = (function (e) {
    It(t, e);
    function t(n, i) {
      return (
        e.call(
          this,
          'The intl string context variable "'.concat(n, '" was not provided to the string "').concat(i, '"'),
          en.MISSING_VALUE,
          i,
        ) || this
      );
    }
    return t;
  })(Gn),
  it;
(function (e) {
  (e[(e.literal = 0)] = 'literal'), (e[(e.object = 1)] = 'object');
})(it || (it = {}));
function eE(e) {
  return e.length < 2
    ? e
    : e.reduce(function (t, n) {
        var i = t[t.length - 1];
        return !i || i.type !== it.literal || n.type !== it.literal ? t.push(n) : (i.value += n.value), t;
      }, []);
}
function Jf(e) {
  return typeof e == 'function';
}
function ta(e, t, n, i, r, o, a) {
  if (e.length === 1 && Mp(e[0])) return [{ type: it.literal, value: e[0].value }];
  for (var s = [], l = 0, c = e; l < c.length; l++) {
    var u = c[l];
    if (Mp(u)) {
      s.push({ type: it.literal, value: u.value });
      continue;
    }
    if (v0(u)) {
      typeof o == 'number' && s.push({ type: it.literal, value: n.getNumberFormat(t).format(o) });
      continue;
    }
    var m = u.value;
    if (!(r && m in r)) throw new Y0(m, a);
    var h = r[m];
    if (g0(u)) {
      (!h || typeof h == 'string' || typeof h == 'number') &&
        (h = typeof h == 'string' || typeof h == 'number' ? String(h) : ''),
        s.push({ type: typeof h == 'string' ? it.literal : it.object, value: h });
      continue;
    }
    if (Pf(u)) {
      var v = typeof u.style == 'string' ? i.date[u.style] : dc(u.style) ? u.style.parsedOptions : void 0;
      s.push({ type: it.literal, value: n.getDateTimeFormat(t, v).format(h) });
      continue;
    }
    if (Cf(u)) {
      var v = typeof u.style == 'string' ? i.time[u.style] : dc(u.style) ? u.style.parsedOptions : i.time.medium;
      s.push({ type: it.literal, value: n.getDateTimeFormat(t, v).format(h) });
      continue;
    }
    if (Rf(u)) {
      var v = typeof u.style == 'string' ? i.number[u.style] : Of(u.style) ? u.style.parsedOptions : void 0;
      v && v.scale && (h = h * (v.scale || 1)), s.push({ type: it.literal, value: n.getNumberFormat(t, v).format(h) });
      continue;
    }
    if (Df(u)) {
      var x = u.children,
        f = u.value,
        D = r[f];
      if (!Jf(D)) throw new Z0(f, 'function', a);
      var p = ta(x, t, n, i, r, o),
        d = D(
          p.map(function (b) {
            return b.value;
          }),
        );
      Array.isArray(d) || (d = [d]),
        s.push.apply(
          s,
          d.map(function (b) {
            return { type: typeof b == 'string' ? it.literal : it.object, value: b };
          }),
        );
    }
    if (Nf(u)) {
      var g = u.options[h] || u.options.other;
      if (!g) throw new Dp(u.value, h, Object.keys(u.options), a);
      s.push.apply(s, ta(g.value, t, n, i, r));
      continue;
    }
    if (If(u)) {
      var g = u.options['='.concat(h)];
      if (!g) {
        if (!Intl.PluralRules)
          throw new Gn(
            `Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`,
            en.MISSING_INTL_API,
            a,
          );
        var y = n.getPluralRules(t, { type: u.pluralType }).select(h - (u.offset || 0));
        g = u.options[y] || u.options.other;
      }
      if (!g) throw new Dp(u.value, h, Object.keys(u.options), a);
      s.push.apply(s, ta(g.value, t, n, i, r, h - (u.offset || 0)));
      continue;
    }
  }
  return eE(s);
}
function tE(e, t) {
  return t
    ? B(
        B(B({}, e || {}), t || {}),
        Object.keys(e).reduce(function (n, i) {
          return (n[i] = B(B({}, e[i]), t[i] || {})), n;
        }, {}),
      )
    : e;
}
function nE(e, t) {
  return t
    ? Object.keys(e).reduce(
        function (n, i) {
          return (n[i] = tE(e[i], t[i])), n;
        },
        B({}, e),
      )
    : e;
}
function sl(e) {
  return {
    create: function () {
      return {
        get: function (t) {
          return e[t];
        },
        set: function (t, n) {
          e[t] = n;
        },
      };
    },
  };
}
function iE(e) {
  return (
    e === void 0 && (e = { number: {}, dateTime: {}, pluralRules: {} }),
    {
      getNumberFormat: qt(
        function () {
          for (var t, n = [], i = 0; i < arguments.length; i++) n[i] = arguments[i];
          return new ((t = Intl.NumberFormat).bind.apply(t, Wt([void 0], n, !1)))();
        },
        { cache: sl(e.number), strategy: Qt.variadic },
      ),
      getDateTimeFormat: qt(
        function () {
          for (var t, n = [], i = 0; i < arguments.length; i++) n[i] = arguments[i];
          return new ((t = Intl.DateTimeFormat).bind.apply(t, Wt([void 0], n, !1)))();
        },
        { cache: sl(e.dateTime), strategy: Qt.variadic },
      ),
      getPluralRules: qt(
        function () {
          for (var t, n = [], i = 0; i < arguments.length; i++) n[i] = arguments[i];
          return new ((t = Intl.PluralRules).bind.apply(t, Wt([void 0], n, !1)))();
        },
        { cache: sl(e.pluralRules), strategy: Qt.variadic },
      ),
    }
  );
}
var Vf = (function () {
    function e(t, n, i, r) {
      n === void 0 && (n = e.defaultLocale);
      var o = this;
      if (
        ((this.formatterCache = { number: {}, dateTime: {}, pluralRules: {} }),
        (this.format = function (a) {
          var s = o.formatToParts(a);
          if (s.length === 1) return s[0].value;
          var l = s.reduce(function (c, u) {
            return (
              !c.length || u.type !== it.literal || typeof c[c.length - 1] != 'string'
                ? c.push(u.value)
                : (c[c.length - 1] += u.value),
              c
            );
          }, []);
          return l.length <= 1 ? l[0] || '' : l;
        }),
        (this.formatToParts = function (a) {
          return ta(o.ast, o.locales, o.formatters, o.formats, a, void 0, o.message);
        }),
        (this.resolvedOptions = function () {
          var a;
          return {
            locale:
              ((a = o.resolvedLocale) === null || a === void 0 ? void 0 : a.toString()) ||
              Intl.NumberFormat.supportedLocalesOf(o.locales)[0],
          };
        }),
        (this.getAst = function () {
          return o.ast;
        }),
        (this.locales = n),
        (this.resolvedLocale = e.resolveLocale(n)),
        typeof t == 'string')
      ) {
        if (((this.message = t), !e.__parse))
          throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
        this.ast = e.__parse(t, { ignoreTag: r == null ? void 0 : r.ignoreTag, locale: this.resolvedLocale });
      } else this.ast = t;
      if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
      (this.formats = nE(e.formats, i)), (this.formatters = (r && r.formatters) || iE(this.formatterCache));
    }
    return (
      Object.defineProperty(e, 'defaultLocale', {
        get: function () {
          return (
            e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale),
            e.memoizedDefaultLocale
          );
        },
        enumerable: !1,
        configurable: !0,
      }),
      (e.memoizedDefaultLocale = null),
      (e.resolveLocale = function (t) {
        if (!(typeof Intl.Locale > 'u')) {
          var n = Intl.NumberFormat.supportedLocalesOf(t);
          return n.length > 0 ? new Intl.Locale(n[0]) : new Intl.Locale(typeof t == 'string' ? t : t[0]);
        }
      }),
      (e.__parse = J0),
      (e.formats = {
        number: {
          integer: { maximumFractionDigits: 0 },
          currency: { style: 'currency' },
          percent: { style: 'percent' },
        },
        date: {
          short: { month: 'numeric', day: 'numeric', year: '2-digit' },
          medium: { month: 'short', day: 'numeric', year: 'numeric' },
          long: { month: 'long', day: 'numeric', year: 'numeric' },
          full: { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' },
        },
        time: {
          short: { hour: 'numeric', minute: 'numeric' },
          medium: { hour: 'numeric', minute: 'numeric', second: 'numeric' },
          long: { hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' },
          full: { hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' },
        },
      }),
      e
    );
  })(),
  tt;
(function (e) {
  (e.FORMAT_ERROR = 'FORMAT_ERROR'),
    (e.UNSUPPORTED_FORMATTER = 'UNSUPPORTED_FORMATTER'),
    (e.INVALID_CONFIG = 'INVALID_CONFIG'),
    (e.MISSING_DATA = 'MISSING_DATA'),
    (e.MISSING_TRANSLATION = 'MISSING_TRANSLATION');
})(tt || (tt = {}));
var gt = (function (e) {
    It(t, e);
    function t(n, i, r) {
      var o = this,
        a = r ? (r instanceof Error ? r : new Error(String(r))) : void 0;
      return (
        (o =
          e.call(
            this,
            '[@formatjs/intl Error '
              .concat(n, '] ')
              .concat(
                i,
                `
`,
              )
              .concat(
                a
                  ? `
`
                      .concat(
                        a.message,
                        `
`,
                      )
                      .concat(a.stack)
                  : '',
              ),
          ) || this),
        (o.code = n),
        typeof Error.captureStackTrace == 'function' && Error.captureStackTrace(o, t),
        o
      );
    }
    return t;
  })(Error),
  rE = (function (e) {
    It(t, e);
    function t(n, i) {
      return e.call(this, tt.UNSUPPORTED_FORMATTER, n, i) || this;
    }
    return t;
  })(gt),
  oE = (function (e) {
    It(t, e);
    function t(n, i) {
      return e.call(this, tt.INVALID_CONFIG, n, i) || this;
    }
    return t;
  })(gt),
  Op = (function (e) {
    It(t, e);
    function t(n, i) {
      return e.call(this, tt.MISSING_DATA, n, i) || this;
    }
    return t;
  })(gt),
  ku = (function (e) {
    It(t, e);
    function t(n, i, r) {
      return (
        e.call(
          this,
          tt.FORMAT_ERROR,
          ''
            .concat(
              n,
              `
Locale: `,
            )
            .concat(
              i,
              `
`,
            ),
          r,
        ) || this
      );
    }
    return t;
  })(gt),
  ll = (function (e) {
    It(t, e);
    function t(n, i, r, o) {
      var a =
        e.call(
          this,
          ''
            .concat(
              n,
              `
MessageID: `,
            )
            .concat(
              r == null ? void 0 : r.id,
              `
Default Message: `,
            )
            .concat(
              r == null ? void 0 : r.defaultMessage,
              `
Description: `,
            )
            .concat(
              r == null ? void 0 : r.description,
              `
`,
            ),
          i,
          o,
        ) || this;
      return (a.descriptor = r), a;
    }
    return t;
  })(ku),
  aE = (function (e) {
    It(t, e);
    function t(n, i) {
      var r =
        e.call(
          this,
          tt.MISSING_TRANSLATION,
          'Missing message: "'
            .concat(n.id, '" for locale "')
            .concat(i, '", using ')
            .concat(
              n.defaultMessage
                ? 'default message ('.concat(
                    typeof n.defaultMessage == 'string'
                      ? n.defaultMessage
                      : n.defaultMessage
                          .map(function (o) {
                            var a;
                            return (a = o.value) !== null && a !== void 0 ? a : JSON.stringify(o);
                          })
                          .join(),
                    ')',
                  )
                : 'id',
              ' as fallback.',
            ),
        ) || this;
      return (r.descriptor = n), r;
    }
    return t;
  })(gt);
function mi(e, t, n) {
  return (
    n === void 0 && (n = {}),
    t.reduce(function (i, r) {
      return r in e ? (i[r] = e[r]) : r in n && (i[r] = n[r]), i;
    }, {})
  );
}
var sE = function (e) {},
  lE = function (e) {},
  qf = {
    formats: {},
    messages: {},
    timeZone: void 0,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: !0,
    onError: sE,
    onWarn: lE,
  };
function Qf() {
  return { dateTime: {}, number: {}, message: {}, relativeTime: {}, pluralRules: {}, list: {}, displayNames: {} };
}
function Qn(e) {
  return {
    create: function () {
      return {
        get: function (t) {
          return e[t];
        },
        set: function (t, n) {
          e[t] = n;
        },
      };
    },
  };
}
function cE(e) {
  e === void 0 && (e = Qf());
  var t = Intl.RelativeTimeFormat,
    n = Intl.ListFormat,
    i = Intl.DisplayNames,
    r = qt(
      function () {
        for (var s, l = [], c = 0; c < arguments.length; c++) l[c] = arguments[c];
        return new ((s = Intl.DateTimeFormat).bind.apply(s, Wt([void 0], l, !1)))();
      },
      { cache: Qn(e.dateTime), strategy: Qt.variadic },
    ),
    o = qt(
      function () {
        for (var s, l = [], c = 0; c < arguments.length; c++) l[c] = arguments[c];
        return new ((s = Intl.NumberFormat).bind.apply(s, Wt([void 0], l, !1)))();
      },
      { cache: Qn(e.number), strategy: Qt.variadic },
    ),
    a = qt(
      function () {
        for (var s, l = [], c = 0; c < arguments.length; c++) l[c] = arguments[c];
        return new ((s = Intl.PluralRules).bind.apply(s, Wt([void 0], l, !1)))();
      },
      { cache: Qn(e.pluralRules), strategy: Qt.variadic },
    );
  return {
    getDateTimeFormat: r,
    getNumberFormat: o,
    getMessageFormat: qt(
      function (s, l, c, u) {
        return new Vf(
          s,
          l,
          c,
          B({ formatters: { getNumberFormat: o, getDateTimeFormat: r, getPluralRules: a } }, u || {}),
        );
      },
      { cache: Qn(e.message), strategy: Qt.variadic },
    ),
    getRelativeTimeFormat: qt(
      function () {
        for (var s = [], l = 0; l < arguments.length; l++) s[l] = arguments[l];
        return new (t.bind.apply(t, Wt([void 0], s, !1)))();
      },
      { cache: Qn(e.relativeTime), strategy: Qt.variadic },
    ),
    getPluralRules: a,
    getListFormat: qt(
      function () {
        for (var s = [], l = 0; l < arguments.length; l++) s[l] = arguments[l];
        return new (n.bind.apply(n, Wt([void 0], s, !1)))();
      },
      { cache: Qn(e.list), strategy: Qt.variadic },
    ),
    getDisplayNames: qt(
      function () {
        for (var s = [], l = 0; l < arguments.length; l++) s[l] = arguments[l];
        return new (i.bind.apply(i, Wt([void 0], s, !1)))();
      },
      { cache: Qn(e.displayNames), strategy: Qt.variadic },
    ),
  };
}
function Su(e, t, n, i) {
  var r = e && e[t],
    o;
  if ((r && (o = r[n]), o)) return o;
  i(new rE('No '.concat(t, ' format named: ').concat(n)));
}
function Bo(e, t) {
  return Object.keys(e).reduce(function (n, i) {
    return (n[i] = B({ timeZone: t }, e[i])), n;
  }, {});
}
function Lp(e, t) {
  var n = Object.keys(B(B({}, e), t));
  return n.reduce(function (i, r) {
    return (i[r] = B(B({}, e[r] || {}), t[r] || {})), i;
  }, {});
}
function Hp(e, t) {
  if (!t) return e;
  var n = Vf.formats;
  return B(B(B({}, n), e), {
    date: Lp(Bo(n.date, t), Bo(e.date || {}, t)),
    time: Lp(Bo(n.time, t), Bo(e.time || {}, t)),
  });
}
var vc = function (e, t, n, i, r) {
    var o = e.locale,
      a = e.formats,
      s = e.messages,
      l = e.defaultLocale,
      c = e.defaultFormats,
      u = e.fallbackOnEmptyString,
      m = e.onError,
      h = e.timeZone,
      v = e.defaultRichTextElements;
    n === void 0 && (n = { id: '' });
    var x = n.id,
      f = n.defaultMessage;
    Tf(
      !!x,
      '[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue',
    );
    var D = String(x),
      p = s && Object.prototype.hasOwnProperty.call(s, D) && s[D];
    if (Array.isArray(p) && p.length === 1 && p[0].type === me.literal) return p[0].value;
    if (!i && p && typeof p == 'string' && !v) return p.replace(/'\{(.*?)\}'/gi, '{$1}');
    if (((i = B(B({}, v), i || {})), (a = Hp(a, h)), (c = Hp(c, h)), !p)) {
      if (u === !1 && p === '') return p;
      if (((!f || (o && o.toLowerCase() !== l.toLowerCase())) && m(new aE(n, o)), f))
        try {
          var d = t.getMessageFormat(f, l, c, r);
          return d.format(i);
        } catch (g) {
          return (
            m(
              new ll(
                'Error formatting default message for: "'.concat(D, '", rendering default message verbatim'),
                o,
                n,
                g,
              ),
            ),
            typeof f == 'string' ? f : D
          );
        }
      return D;
    }
    try {
      var d = t.getMessageFormat(p, o, a, B({ formatters: t }, r || {}));
      return d.format(i);
    } catch (g) {
      m(
        new ll(
          'Error formatting message: "'.concat(D, '", using ').concat(f ? 'default message' : 'id', ' as fallback.'),
          o,
          n,
          g,
        ),
      );
    }
    if (f)
      try {
        var d = t.getMessageFormat(f, l, c, r);
        return d.format(i);
      } catch (g) {
        m(new ll('Error formatting the default message for: "'.concat(D, '", rendering message verbatim'), o, n, g));
      }
    return typeof p == 'string' ? p : typeof f == 'string' ? f : D;
  },
  Wf = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    'numberingSystem',
    'fractionalSecondDigits',
  ];
function as(e, t, n, i) {
  var r = e.locale,
    o = e.formats,
    a = e.onError,
    s = e.timeZone;
  i === void 0 && (i = {});
  var l = i.format,
    c = B(B({}, s && { timeZone: s }), l && Su(o, t, l, a)),
    u = mi(i, Wf, c);
  return (
    t === 'time' &&
      !u.hour &&
      !u.minute &&
      !u.second &&
      !u.timeStyle &&
      !u.dateStyle &&
      (u = B(B({}, u), { hour: 'numeric', minute: 'numeric' })),
    n(r, u)
  );
}
function uE(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = n[0],
    o = n[1],
    a = o === void 0 ? {} : o,
    s = typeof r == 'string' ? new Date(r || 0) : r;
  try {
    return as(e, 'date', t, a).format(s);
  } catch (l) {
    e.onError(new gt(tt.FORMAT_ERROR, 'Error formatting date.', l));
  }
  return String(s);
}
function dE(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = n[0],
    o = n[1],
    a = o === void 0 ? {} : o,
    s = typeof r == 'string' ? new Date(r || 0) : r;
  try {
    return as(e, 'time', t, a).format(s);
  } catch (l) {
    e.onError(new gt(tt.FORMAT_ERROR, 'Error formatting time.', l));
  }
  return String(s);
}
function pE(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = n[0],
    o = n[1],
    a = n[2],
    s = a === void 0 ? {} : a,
    l = e.timeZone,
    c = e.locale,
    u = e.onError,
    m = mi(s, Wf, l ? { timeZone: l } : {});
  try {
    return t(c, m).formatRange(r, o);
  } catch (h) {
    u(new gt(tt.FORMAT_ERROR, 'Error formatting date time range.', h));
  }
  return String(r);
}
function hE(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = n[0],
    o = n[1],
    a = o === void 0 ? {} : o,
    s = typeof r == 'string' ? new Date(r || 0) : r;
  try {
    return as(e, 'date', t, a).formatToParts(s);
  } catch (l) {
    e.onError(new gt(tt.FORMAT_ERROR, 'Error formatting date.', l));
  }
  return [];
}
function mE(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = n[0],
    o = n[1],
    a = o === void 0 ? {} : o,
    s = typeof r == 'string' ? new Date(r || 0) : r;
  try {
    return as(e, 'time', t, a).formatToParts(s);
  } catch (l) {
    e.onError(new gt(tt.FORMAT_ERROR, 'Error formatting time.', l));
  }
  return [];
}
var fE = ['style', 'type', 'fallback'];
function gE(e, t, n, i) {
  var r = e.locale,
    o = e.onError,
    a = Intl.DisplayNames;
  a ||
    o(
      new Gn(
        `Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`,
        en.MISSING_INTL_API,
      ),
    );
  var s = mi(i, fE);
  try {
    return t(r, s).of(n);
  } catch (l) {
    o(new gt(tt.FORMAT_ERROR, 'Error formatting display name.', l));
  }
}
var vE = ['type', 'style'],
  Fp = Date.now();
function _E(e) {
  return ''.concat(Fp, '_').concat(e, '_').concat(Fp);
}
function xE(e, t, n, i) {
  i === void 0 && (i = {});
  var r = Kf(e, t, n, i).reduce(function (o, a) {
    var s = a.value;
    return (
      typeof s != 'string' ? o.push(s) : typeof o[o.length - 1] == 'string' ? (o[o.length - 1] += s) : o.push(s), o
    );
  }, []);
  return r.length === 1 ? r[0] : r.length === 0 ? '' : r;
}
function Kf(e, t, n, i) {
  var r = e.locale,
    o = e.onError;
  i === void 0 && (i = {});
  var a = Intl.ListFormat;
  a ||
    o(
      new Gn(
        `Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`,
        en.MISSING_INTL_API,
      ),
    );
  var s = mi(i, vE);
  try {
    var l = {},
      c = n.map(function (u, m) {
        if (typeof u == 'object') {
          var h = _E(m);
          return (l[h] = u), h;
        }
        return String(u);
      });
    return t(r, s)
      .formatToParts(c)
      .map(function (u) {
        return u.type === 'literal' ? u : B(B({}, u), { value: l[u.value] || u.value });
      });
  } catch (u) {
    o(new gt(tt.FORMAT_ERROR, 'Error formatting list.', u));
  }
  return n;
}
var EE = ['type'];
function yE(e, t, n, i) {
  var r = e.locale,
    o = e.onError;
  i === void 0 && (i = {}),
    Intl.PluralRules ||
      o(
        new Gn(
          `Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`,
          en.MISSING_INTL_API,
        ),
      );
  var a = mi(i, EE);
  try {
    return t(r, a).select(n);
  } catch (s) {
    o(new ku('Error formatting plural.', r, s));
  }
  return 'other';
}
var AE = ['numeric', 'style'];
function wE(e, t, n) {
  var i = e.locale,
    r = e.formats,
    o = e.onError;
  n === void 0 && (n = {});
  var a = n.format,
    s = (!!a && Su(r, 'relative', a, o)) || {},
    l = mi(n, AE, s);
  return t(i, l);
}
function kE(e, t, n, i, r) {
  r === void 0 && (r = {}), i || (i = 'second');
  var o = Intl.RelativeTimeFormat;
  o ||
    e.onError(
      new Gn(
        `Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`,
        en.MISSING_INTL_API,
      ),
    );
  try {
    return wE(e, t, r).format(n, i);
  } catch (a) {
    e.onError(new ku('Error formatting relative time.', e.locale, a));
  }
  return String(n);
}
var SE = [
  'style',
  'currency',
  'currencyDisplay',
  'unit',
  'unitDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits',
  'compactDisplay',
  'currencyDisplay',
  'currencySign',
  'notation',
  'signDisplay',
  'unit',
  'unitDisplay',
  'numberingSystem',
];
function Xf(e, t, n) {
  var i = e.locale,
    r = e.formats,
    o = e.onError;
  n === void 0 && (n = {});
  var a = n.format,
    s = (a && Su(r, 'number', a, o)) || {},
    l = mi(n, SE, s);
  return t(i, l);
}
function bE(e, t, n, i) {
  i === void 0 && (i = {});
  try {
    return Xf(e, t, i).format(n);
  } catch (r) {
    e.onError(new gt(tt.FORMAT_ERROR, 'Error formatting number.', r));
  }
  return String(n);
}
function ME(e, t, n, i) {
  i === void 0 && (i = {});
  try {
    return Xf(e, t, i).formatToParts(n);
  } catch (r) {
    e.onError(new gt(tt.FORMAT_ERROR, 'Error formatting number.', r));
  }
  return [];
}
function TE(e) {
  var t = e ? e[Object.keys(e)[0]] : void 0;
  return typeof t == 'string';
}
function RE(e) {
  e.onWarn &&
    e.defaultRichTextElements &&
    TE(e.messages || {}) &&
    e.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.io/docs/getting-started/message-distribution`);
}
function PE(e, t) {
  var n = cE(t),
    i = B(B({}, qf), e),
    r = i.locale,
    o = i.defaultLocale,
    a = i.onError;
  return (
    r
      ? !Intl.NumberFormat.supportedLocalesOf(r).length && a
        ? a(
            new Op(
              'Missing locale data for locale: "'
                .concat(r, '" in Intl.NumberFormat. Using default locale: "')
                .concat(
                  o,
                  '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details',
                ),
            ),
          )
        : !Intl.DateTimeFormat.supportedLocalesOf(r).length &&
          a &&
          a(
            new Op(
              'Missing locale data for locale: "'
                .concat(r, '" in Intl.DateTimeFormat. Using default locale: "')
                .concat(
                  o,
                  '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details',
                ),
            ),
          )
      : (a &&
          a(
            new oE(
              '"locale" was not configured, using "'.concat(
                o,
                '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details',
              ),
            ),
          ),
        (i.locale = i.defaultLocale || 'en')),
    RE(i),
    B(B({}, i), {
      formatters: n,
      formatNumber: bE.bind(null, i, n.getNumberFormat),
      formatNumberToParts: ME.bind(null, i, n.getNumberFormat),
      formatRelativeTime: kE.bind(null, i, n.getRelativeTimeFormat),
      formatDate: uE.bind(null, i, n.getDateTimeFormat),
      formatDateToParts: hE.bind(null, i, n.getDateTimeFormat),
      formatTime: dE.bind(null, i, n.getDateTimeFormat),
      formatDateTimeRange: pE.bind(null, i, n.getDateTimeFormat),
      formatTimeToParts: mE.bind(null, i, n.getDateTimeFormat),
      formatPlural: yE.bind(null, i, n.getPluralRules),
      formatMessage: vc.bind(null, i, n),
      $t: vc.bind(null, i, n),
      formatList: xE.bind(null, i, n.getListFormat),
      formatListToParts: Kf.bind(null, i, n.getListFormat),
      formatDisplayName: gE.bind(null, i, n.getDisplayNames),
    })
  );
}
function bu(e) {
  Tf(e, '[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.');
}
var Zf = B(B({}, qf), { textComponent: $.exports.Fragment });
function CE(e) {
  return function (t) {
    return e($.exports.Children.toArray(t));
  };
}
function NE(e, t) {
  if (e === t) return !0;
  if (!e || !t) return !1;
  var n = Object.keys(e),
    i = Object.keys(t),
    r = n.length;
  if (i.length !== r) return !1;
  for (var o = 0; o < r; o++) {
    var a = n[o];
    if (e[a] !== t[a] || !Object.prototype.hasOwnProperty.call(t, a)) return !1;
  }
  return !0;
}
function IE(e) {
  return e.displayName || e.name || 'Component';
}
var Mu = $.exports.createContext(null),
  DE = Mu.Consumer,
  OE = Mu.Provider,
  LE = OE,
  HE = Mu;
function sr(e, t) {
  var n = t || {},
    i = n.intlPropName,
    r = i === void 0 ? 'intl' : i,
    o = n.forwardRef,
    a = o === void 0 ? !1 : o,
    s = n.enforceContext,
    l = s === void 0 ? !0 : s,
    c = function (u) {
      return E(DE, {
        children: function (m) {
          var h;
          l && bu(m);
          var v = ((h = {}), (h[r] = m), h);
          return E(e, { ...B({}, u, v, { ref: a ? u.forwardedRef : null }) });
        },
      });
    };
  return (
    (c.displayName = 'injectIntl('.concat(IE(e), ')')),
    (c.WrappedComponent = e),
    bp(
      a
        ? $.exports.forwardRef(function (u, m) {
            return E(c, { ...B({}, u, { forwardedRef: m }) });
          })
        : c,
      e,
    )
  );
}
function Yf() {
  var e = $.exports.useContext(HE);
  return bu(e), e;
}
var _c;
(function (e) {
  (e.formatDate = 'FormattedDate'),
    (e.formatTime = 'FormattedTime'),
    (e.formatNumber = 'FormattedNumber'),
    (e.formatList = 'FormattedList'),
    (e.formatDisplayName = 'FormattedDisplayName');
})(_c || (_c = {}));
var xc;
(function (e) {
  (e.formatDate = 'FormattedDateParts'),
    (e.formatTime = 'FormattedTimeParts'),
    (e.formatNumber = 'FormattedNumberParts'),
    (e.formatList = 'FormattedListParts');
})(xc || (xc = {}));
function eg(e) {
  var t = function (n) {
    var i = Yf(),
      r = n.value,
      o = n.children,
      a = gu(n, ['value', 'children']),
      s = typeof r == 'string' ? new Date(r || 0) : r,
      l = e === 'formatDate' ? i.formatDateToParts(s, a) : i.formatTimeToParts(s, a);
    return o(l);
  };
  return (t.displayName = xc[e]), t;
}
function po(e) {
  var t = function (n) {
    var i = Yf(),
      r = n.value,
      o = n.children,
      a = gu(n, ['value', 'children']),
      s = i[e](r, a);
    if (typeof o == 'function') return o(s);
    var l = i.textComponent || $.exports.Fragment;
    return E(l, { children: s });
  };
  return (t.displayName = _c[e]), t;
}
function cl(e) {
  return {
    locale: e.locale,
    timeZone: e.timeZone,
    fallbackOnEmptyString: e.fallbackOnEmptyString,
    formats: e.formats,
    textComponent: e.textComponent,
    messages: e.messages,
    defaultLocale: e.defaultLocale,
    defaultFormats: e.defaultFormats,
    onError: e.onError,
    onWarn: e.onWarn,
    wrapRichTextChunksInFragment: e.wrapRichTextChunksInFragment,
    defaultRichTextElements: e.defaultRichTextElements,
  };
}
function tg(e) {
  return (
    e &&
    Object.keys(e).reduce(function (t, n) {
      var i = e[n];
      return (t[n] = Jf(i) ? CE(i) : i), t;
    }, {})
  );
}
var jp = function (e, t, n, i) {
    for (var r = [], o = 4; o < arguments.length; o++) r[o - 4] = arguments[o];
    var a = tg(i),
      s = vc.apply(void 0, Wt([e, t, n, a], r, !1));
    return Array.isArray(s) ? $.exports.Children.toArray(s) : s;
  },
  zp = function (e, t) {
    var n = e.defaultRichTextElements,
      i = gu(e, ['defaultRichTextElements']),
      r = tg(n),
      o = PE(B(B(B({}, Zf), i), { defaultRichTextElements: r }), t),
      a = {
        locale: o.locale,
        timeZone: o.timeZone,
        fallbackOnEmptyString: o.fallbackOnEmptyString,
        formats: o.formats,
        defaultLocale: o.defaultLocale,
        defaultFormats: o.defaultFormats,
        messages: o.messages,
        onError: o.onError,
        defaultRichTextElements: r,
      };
    return B(B({}, o), { formatMessage: jp.bind(null, a, o.formatters), $t: jp.bind(null, a, o.formatters) });
  },
  FE = (function (e) {
    It(t, e);
    function t() {
      var n = (e !== null && e.apply(this, arguments)) || this;
      return (
        (n.cache = Qf()), (n.state = { cache: n.cache, intl: zp(cl(n.props), n.cache), prevConfig: cl(n.props) }), n
      );
    }
    return (
      (t.getDerivedStateFromProps = function (n, i) {
        var r = i.prevConfig,
          o = i.cache,
          a = cl(n);
        return NE(r, a) ? null : { intl: zp(a, o), prevConfig: a };
      }),
      (t.prototype.render = function () {
        return bu(this.state.intl), E(LE, { value: this.state.intl, children: this.props.children });
      }),
      (t.displayName = 'IntlProvider'),
      (t.defaultProps = Zf),
      t
    );
  })($.exports.PureComponent);
const jE = FE;
po('formatDate');
po('formatTime');
po('formatNumber');
po('formatList');
po('formatDisplayName');
eg('formatDate');
eg('formatTime');
async function zE(e) {
  const t = document.getElementById('microsite-header');
  if (t?.innerText.trim() === '') {
    let n = await fetch(`/assets/views/header.html?lang=${e}`);
    t.innerHTML = await n.text();
  }
}
async function BE(e) {
  if (document.getElementById('microsite-footer')?.innerText.trim() === '') {
    let n = await fetch(`/assets/views/footer.html?lang=${e}`);
    document.getElementById('microsite-footer').innerHTML = await n.text();
  }
}
async function UE() {}
const $E = {
    title: { id: 'nav.title', defaultMessage: 'AEM Headless Form developer portal' },
    home: { id: 'nav.home', defaultMessage: 'Home', description: 'Navigation label' },
    codePlayground: { id: 'nav.codePlayground', defaultMessage: 'Code playground', description: 'Navigation label' },
  },
  GE = { nav: $E },
  JE = {
    title: { id: 'error.title', defaultMessage: 'Oops! An error occurred.' },
    text: { id: 'error.text', defaultMessage: 'Sorry! Something went wrong. Please try again later.' },
  },
  VE = {
    title: {
      id: 'page.title',
      defaultMessage: 'AEM Headless CMS Developer Resources and Documentation | Adobe Experience Manager',
    },
    description: {
      id: 'page.description',
      defaultMessage:
        'Visit the AEM Headless CMS developer resources and documentation. Learn how to build next generation apps using headless CMS technologies in Experience Manager as a Cloud Service.',
    },
  },
  qE = '/static-assets/hero__video-placeholder.c304e282.png',
  QE = {
    product: {
      id: 'app.hero.solution',
      defaultMessage: 'Adobe Experience Manager Headless',
      description: 'Adobe product name',
    },
    title: { id: 'app.hero.title', defaultMessage: 'Start building with AEM Headless CMS' },
    text: {
      id: 'app.hero.text',
      defaultMessage:
        'Everything you need to learn about AEM headless CMS to build and ship better applications and faster experiences.',
    },
    cta: { id: 'app.hero.cta', defaultMessage: 'Watch how it works', description: 'Button label' },
    video: '339031',
    placeholderImage: qE,
  },
  WE = {
    title: { id: 'what_is_headless.title', defaultMessage: 'What is AEM Headless Form?' },
    text: {
      id: 'what_is_headless.text',
      defaultMessage:
        'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    },
  },
  KE = '/static-assets/journey.8369aa1a.png',
  XE = {
    image: KE,
    title: { id: 'new_developers.title', defaultMessage: 'For Developers on AEM Forms as a Cloud Service' },
    title_emphasis: { id: 'new_developers.title.emphasis', defaultMessage: 'NEW' },
    text: {
      id: 'new_developers.text',
      defaultMessage:
        'Learn to build engaging forms using Core Components and Headless Adaptive Forms on AEM Forms as a Cloud Service using this { guideLink }.',
    },
    text_guide_link: { id: 'new_developers.text.guide_link', defaultMessage: 'documentation' },
    links: [
      {
        id: 'new_to_aem_headless.links.0',
        defaultMessage: 'Read the guide ',
        link: 'https://experienceleague.adobe.com/en/docs/experience-manager-headless-adaptive-forms/using/tutorial/build-engaging-forms-using-core-components-and-headless-adaptive-forms-aem-forms-cloud-service',
      },
    ],
  },
  ZE = '/static-assets/5-steps.bf43c494.png',
  YE = {
    image: ZE,
    title: { id: 'experienced_developers.title', defaultMessage: 'For Developers on AEM 6.5 Forms' },
    title_emphasis: { id: 'experienced_developers.title.emphasis', defaultMessage: 'EXPERIENCED' },
    text: {
      id: 'experienced_developers.text1',
      defaultMessage: 'Learn to build Headless Forms on AEM 6.5 Forms using this { advancedDocumentation }.',
    },
    text_5_steps: { id: 'new_developers.text.5_steps', defaultMessage: '5 steps' },
    text_advanced_documentation: { id: 'new_developers.text.advanced_documentation', defaultMessage: 'documentation' },
    links: [],
  },
  ey = { title: { id: 'section_example_apps.title', defaultMessage: 'Example AEM Headless CMS apps' } },
  ty = '/static-assets/android.4c9b7e9f.webp',
  ny = {
    image: ty,
    title: { id: 'example_apps_android.title', defaultMessage: 'Android' },
    text: {
      id: 'example_apps_android.text',
      defaultMessage: 'An example Java Android app that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_android.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/android-app.html',
      },
    ],
  },
  iy = '/static-assets/ios.00440c07.webp',
  ry = {
    image: iy,
    title: { id: 'example_apps_ios.title', defaultMessage: 'iOS' },
    text: {
      id: 'example_apps_ios.text',
      defaultMessage: 'An example SwiftUI iOS app that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_ios.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/ios-swiftui-app.html',
      },
    ],
  },
  oy = '/static-assets/next-js.042d4a9d.webp',
  ay = {
    image: oy,
    title: { id: 'example_apps_next_js.title', defaultMessage: 'Next.js' },
    text: {
      id: 'example_apps_next_js.text',
      defaultMessage: 'An example Next.js application that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_next_js.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/next-js.html',
      },
    ],
  },
  sy = '/static-assets/node-js.f489114c.webp',
  ly = {
    image: sy,
    title: { id: 'example_apps_node-js.title', defaultMessage: 'Node.js' },
    text: {
      id: 'example_apps_node-js.text',
      defaultMessage: 'An example command-line Node.js application that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_node-js.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/server-to-server-app.html',
      },
    ],
  },
  cy = '/static-assets/react.bca24be6.webp',
  uy = {
    image: cy,
    title: { id: 'example_apps_react.title', defaultMessage: 'React' },
    text: {
      id: 'example_apps_react.text',
      defaultMessage: 'An example React application that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_react.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/react-app.html',
      },
    ],
  },
  dy = '/static-assets/web-component.d0252110.webp',
  py = {
    image: dy,
    title: { id: 'example_apps_web-component.title', defaultMessage: 'Web Component/JS' },
    text: {
      id: 'example_apps_web-component.text',
      defaultMessage: 'An example pure JavaScript Web Component that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_web-component.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/web-component.html',
      },
    ],
  },
  hy = { android: ny, ios: ry, next_js: ay, node_js: ly, react: uy, web_component: py },
  my = {
    title: { id: 'section_spa_editor.title', defaultMessage: 'Explore the AEM SPA Editor' },
    text: {
      id: 'section_spa_editor.text',
      defaultMessage:
        'The AEM SPA Editor provides a framework to develop React or Angular apps that can be updated in-context by marketers using the AEM authoring UI.',
    },
  },
  fy = '/static-assets/spa-editor.0cbf214d.png',
  gy = {
    image: fy,
    title: { id: 'spa_editor.title', defaultMessage: 'Manage a SPA in AEM' },
    text: {
      id: 'spa_editor.text',
      defaultMessage:
        'The AEM SPA Editor can be used to create a SPA whose components, routing, and views can be completely managed in AEM. The SPA Editor supports the React framework.',
    },
    links: [
      {
        id: 'spa_editor.links.0',
        defaultMessage: 'Start the React tutorial',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/spa-editor/react/overview.html',
      },
    ],
  },
  vy = {
    image: 'https://cdn.experienceleague.adobe.com/thumb/333181.jpg',
    title: { id: 'spa_editor_remote_spa.title', defaultMessage: 'Author a remote SPA' },
    text: {
      id: 'spa_editor_remote_spa.text',
      defaultMessage:
        "AEM's Remote SPA capabilities enables marketers to update targeted regions of a remotely hosted SPA.",
    },
    links: [
      {
        id: 'spa_editor_remote_spa.links.0',
        defaultMessage: 'Start the tutorial',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/spa-editor/remote-spa/overview.html',
      },
    ],
  },
  _y = {
    title: { id: 'section_developer_resources.title', defaultMessage: 'Documentation' },
    slug: 'advanced-documentation',
  },
  xy = {
    title: { id: 'technical_docs.sdks.title', defaultMessage: 'SDKs' },
    text: { id: 'technical_docs.sdks.text', defaultMessage: 'Use the SDKs to render the AEM Headless Adaptive Forms' },
    lists: [
      {
        links: [
          {
            id: 'technical_docs.sdks.section.javascript.links.0',
            defaultMessage: 'Definition interpret and rules executor for Headless Adaptive Forms',
            link: 'https://www.npmjs.com/package/@aemforms/af-core',
          },
          {
            id: 'technical_docs.sdks.section.javascript.links.1',
            defaultMessage: 'React Based renderer for Headless Adaptive Forms',
            link: 'https://www.npmjs.com/package/@aemforms/af-react-renderer',
          },
          {
            id: 'technical_docs.sdks.section.javascript.links.2',
            defaultMessage: 'React HTML5 Components For Headless Adaptive Forms',
            link: 'https://www.npmjs.com/package/@aemforms/af-react-vanilla-components',
          },
        ],
      },
    ],
  },
  Ey = {
    title: { id: 'technical_docs.apis.title', defaultMessage: 'APIs' },
    text: { id: 'technical_docs.apis.text', defaultMessage: 'Learn about AEM Forms HTTP APIs' },
    lists: [
      {
        links: [
          {
            id: 'technical_docs.apis.section.formsapis.links.0',
            defaultMessage: 'AEM Forms API (OpenAPI)',
            link: 'https://opensource.adobe.com/aem-forms-af-runtime/api/',
          },
        ],
      },
    ],
  },
  yy = {
    title: { id: 'technical_docs.how-to.title', defaultMessage: 'How-to guides' },
    text: {
      id: 'technical_docs.how-to.text',
      defaultMessage: 'Learn how to approach different use cases with AEM Headless.',
    },
    lists: [
      {
        title: { id: 'technical_docs.how-to.section.content', defaultMessage: 'Getting Started' },
        links: [
          {
            id: 'technical_docs.how-to.section.content.links.1',
            defaultMessage: 'How Headless adaptive form works?',
            link: 'https://experienceleague.adobe.com/en/docs/experience-manager-headless-adaptive-forms/using/architecture',
          },
          {
            id: 'technical_docs.how-to.section.content.links.2',
            defaultMessage: 'Create and preview a Headless Form using a React app',
            link: 'https://experienceleague.adobe.com/en/docs/experience-manager-headless-adaptive-forms/using/get-started/create-and-publish-a-headless-form',
          },
          {
            id: 'technical_docs.how-to.section.content.links.3',
            defaultMessage: 'Use a custom react library to render a headless form',
            link: 'https://experienceleague.adobe.com/en/docs/experience-manager-headless-adaptive-forms/using/get-started/use-google-material-ui-react-components-to-render-a-headless-form',
          },
          {
            id: 'technical_docs.how-to.section.content.links.4',
            defaultMessage: 'Create a Headless adaptive form using Adaptive Forms editor',
            link: 'https://experienceleague.adobe.com/en/docs/experience-manager-headless-adaptive-forms/using/authoring-headless-adaptive-forms/create-a-headless-adaptive-form',
          },
        ],
      },
      {
        title: { id: 'technical_docs.how-to.section.development', defaultMessage: 'Development' },
        links: [
          {
            id: 'technical_docs.how-to.section.development.links.0',
            defaultMessage: 'Storybook',
            link: 'https://opensource.adobe.com/aem-forms-af-runtime/storybook/?path=/story/adaptive-form-introduction--page',
          },
        ],
      },
    ],
  },
  Ay = { title: { id: 'section_get_involved.title', defaultMessage: 'Get involved!' } },
  wy = '/static-assets/book.5ff13042.png',
  ky = {
    icon: wy,
    title: { id: 'get_involved_blog.title', defaultMessage: 'Adobe Tech Blog' },
    text: { id: 'get_involved_blog.text', defaultMessage: 'Read the latest on our tech blog.' },
    links: [
      {
        id: 'get_involved_blog.links.0',
        defaultMessage: 'Read the blog',
        description: 'CTA button label',
        link: 'https://blog.developer.adobe.com/search?q=headless',
      },
    ],
  },
  Sy = '/static-assets/dicussion.5d531cb9.png',
  by = {
    icon: Sy,
    title: { id: 'get_involved_community.title', defaultMessage: 'Experience League Communities' },
    text: {
      id: 'get_involved_community.text',
      defaultMessage: 'Join our community and get answers to your questions.',
    },
    links: [
      {
        id: 'get_involved_community.links.0',
        defaultMessage: 'Join the conversation',
        description: 'CTA button label',
        link: 'https://experienceleaguecommunities.adobe.com/t5/adobe-experience-manager/ct-p/experience-manager-headless-community',
      },
    ],
  },
  My = {
    page: VE,
    hero: QE,
    what_is_headless: WE,
    new_developers: XE,
    experienced_developers: YE,
    section_developer_resources: _y,
    technical_docs: [xy, Ey, yy],
    section_example_apps: ey,
    example_apps: hy,
    section_get_involved: Ay,
    get_involved_blog: ky,
    get_involved_community: by,
    section_spa_editor: my,
    spa_editor: gy,
    spa_editor_remote_spa: vy,
  },
  Ty = {
    title: { id: 'code_index.title', defaultMessage: 'Code playground' },
    text: {
      id: 'code_index.text',
      defaultMessage: 'Experience AEM Headless Forms instantly with our example React apps!',
    },
    button_run_the_code: { id: 'code_index.button.run_the_code', defaultMessage: 'Run the code' },
    code: {
      'basic-react-app': {
        articleId: 'basic-react-app',
        codeId: 'basic-react-app-f3h6jx',
        type: 'codesandbox',
        title: { id: 'code_index.basic-react-app.title', defaultMessage: 'Basic React App' },
        description: {
          id: 'code_index.basic-react-app.description',
          defaultMessage: 'A React app for creating, fetching, and rendering JSON-based forms from AEM.',
        },
        longDescription: {
          id: 'code_index.basic-react-app.longDescription',
          defaultMessage: `This <a href='https://reactjs.org/'>React</a> app helps create JSON-based forms using AEM Headless Forms libraries and renders them with default components 

 This app: 
 - Fetches JSON forms from AEM 
 - Renders forms using default components 
 - Submits form data (<b>Submission is not supported on the developer portal. To test submissions, you can download and run the sample app locally. To do this, click Open Sandbox, expand NODEBOX, and then click the Download icon</b>)

 Click <a href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details.`,
        },
        tags: ['React'],
      },
      'react-app-with-custom-components': {
        articleId: 'react-app-with-custom-components',
        codeId: 'react-app-with-custom-components-l8sqpp',
        type: 'codesandbox',
        title: {
          id: 'code_index.react-app-with-custom-components.title',
          defaultMessage: 'React App with Custom Components',
        },
        description: {
          id: 'code_index.react-app-with-custom-components.description',
          defaultMessage:
            'A React app for creating JSON-based forms, fetching and rendering them from AEM, and building custom components.',
        },
        longDescription: {
          id: 'code_index.react-app-with-custom-components.longDescription',
          defaultMessage: `This <a href="https://reactjs.org/">React</a> app helps create JSON-based forms using AEM Headless Form libraries and renders forms with custom and default components. 

 This app: 
 - Fetches JSON forms from AEM 
 - Creates custom components 
 - Renders forms using custom and default components 
 - Submits form data (<b>Submission is not supported on the developer portal. To test submissions, you can download and run the sample app locally. To do this, click Open Sandbox, expand NODEBOX, and then click the Download icon</b>)

 Click <a href="https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md">here</a> for more details.`,
        },
        tags: ['React', 'Custom Components'],
      },
      'basic-react-native': {
        articleId: 'basic-react-native',
        codeId: 'suspicious-austin-sz8dcn',
        type: 'codesandbox',
        title: { id: 'code_index.basic-react-native.title', defaultMessage: 'Basic React Native App' },
        description: {
          id: 'code_index.basic-react-native.description',
          defaultMessage:
            'A React Native app for creating JSON-based forms, fetching them from AEM, and rendering in React Native.',
        },
        longDescription: {
          id: 'code_index.basic-react-native.longDescription',
          defaultMessage: `This <a href="https://reactnative.dev/">React Native</a> app helps create JSON-based forms using AEM Headless Form libraries and renders them with default components.  

 This app: 
 - Fetches JSON forms from AEM 
 - Creates Custom Components 
 - Renders forms using custom and default components 
 - Submits form data (<b>Submission is not supported on the developer portal. To test submissions, you can download and run the sample app locally. To do this, click Open Sandbox, expand NODEBOX, and then click the Download icon</b>)

 Click <a href="https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md">here</a> for more details.`,
        },
        tags: ['React', 'React Native'],
      },
      'react-app-with-material-ui-components': {
        articleId: 'react-app-with-material-ui-components',
        codeId: 'react-app-with-material-ui-yq5hm2',
        type: 'codesandbox',
        title: {
          id: 'code_index.react-app-with-material-ui-components.title',
          defaultMessage: 'React App with Material UI Components',
        },
        description: {
          id: 'code_index.react-app-with-material-ui-components.description',
          defaultMessage:
            'A React app for creating JSON-based forms, fetching them from AEM, rendering them in React, and building components with the Material-UI library.',
        },
        longDescription: {
          id: 'code_index.react-app-with-material-ui-components.longDescription',
          defaultMessage: `This <a href="https://reactjs.org/">React</a> app helps create JSON-based forms using AEM Headless Form libraries and renders them with Material-UI components. 

 This app: 
 - Fetches JSON forms from AEM 
 - Creates custom components using Material-UI 
 -Renders forms with the created components 
 - Submits form data (<b>Submission is not supported on the developer portal. To test submissions, you can download and run the sample app locally. To do this, click Open Sandbox, expand NODEBOX, and then click the Download icon</b>)

 Click <a href="https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md">here</a> for more details."`,
        },
        tags: ['React', 'Material UI', 'Custom Components'],
      },
      'react-app-with-nextjs': {
        articleId: 'react-app-with-nextjs',
        codeId: 'headless-worker-3yjxd8',
        type: 'devebox',
        title: { id: 'code_index.react-app-with-nextjs.title', defaultMessage: 'Basic Next.js App' },
        description: {
          id: 'code_index.react-app-with-nextjs.description',
          defaultMessage:
            'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them with React.',
        },
        longDescription: {
          id: 'code_index.react-app-with-nextjs.longDescription',
          defaultMessage: `This <a href="https://nextjs.org/">Next.js</a> app helps create JSON-based forms using AEM Headless Form libraries and renders forms with default components. 

 This app: 
 - Fetches JSON forms from AEM 
 - Renders forms using default components 
 - Submits form data (<b>Submission is not supported on the developer portal. To test submissions, you can download and run the sample app locally. To do this, click Open Sandbox, expand NODEBOX, and then click the Download icon</b>)

 Click <a href="https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md">here</a> for more details.`,
        },
        tags: ['React', 'next.js'],
      },
    },
  },
  Ry = {
    button_back: { id: 'code_by_id.button.back', defaultMessage: 'Back to code playground' },
    button_enter_widescreen: { id: 'code_by_id.button.enter_widescreen', defaultMessage: 'Enter widescreen mode' },
    button_exit_widescreen: { id: 'code_by_id.button.exit_widescreen', defaultMessage: 'Exit widescreen mode' },
  },
  ho = { common: GE, error: JE, home: My, code_index: Ty, code_by_id: Ry },
  mo = kc.createContext('en'),
  Py = mo.Provider;
function Ta({ to: e, children: t, ...n }) {
  const i = $x(),
    r = $.exports.useContext(mo);
  return E('span', {
    style: { cursor: 'pointer' },
    onClick: (a) => {
      a.preventDefault(), i({ pathname: `${e}`, search: '?lang=' + (r || 'en') });
    },
    ...n,
    children: t,
  });
}
function Cy(e) {
  const { formatMessage: t } = e.intl,
    n = ho,
    i = t(n.common.nav.title),
    r = t(n.common.nav.home),
    o = t(n.common.nav.codePlayground);
  return E('div', {
    className: 'nav',
    children: ae('div', {
      className: 'nav-wrapper',
      children: [
        E('div', { className: 'nav__title', children: i }),
        ae('ul', {
          className: 'nav__menu',
          children: [
            E('li', {
              className: 'nav__menu-item',
              children: E(Ta, { className: 'nav-link', to: '/index.html', children: r }),
            }),
            E('li', {
              className: 'nav__menu-item',
              children: E(Ta, { className: 'nav-link', to: '/developer/code.html', children: o }),
            }),
          ],
        }),
      ],
    }),
  });
}
const ss = sr(Cy);
function Ny(e) {
  return E('div', { className: 'cards', children: e.children });
}
const Iy = function (e) {
    return e.indexOf('//') === 0 || e.indexOf('http://') === 0 || e.indexOf('https://') === 0
      ? new URL(e)
      : new URL(e, 'https://experienceleague.adobe.com');
  },
  Dy = function (e) {
    return ['experienceleague.adobe.com'].includes(e.host);
  },
  ng = function (e, t) {
    let n = Iy(e);
    return Dy(n) && t && (n.searchParams.set('lang', t), (e = n.toString())), e;
  },
  ig = function (e, t) {
    return e && t;
  };
function Oy(e) {
  const t = $.exports.useContext(mo);
  return ig(e.text, e.link)
    ? E('a', {
        href: ng(e.link, t),
        'data-track': `${e.analyticsName}`,
        rel: 'noreferrer',
        target: '_blank',
        children: e.text,
      })
    : null;
}
function rg({ text: e, link: t, analyticsName: n, style: i, size: r, route: o }) {
  const a = $.exports.useContext(mo);
  function s(c, u, m, h, v) {
    return E('a', {
      href: ng(u, a),
      'data-track': m,
      rel: 'noreferrer',
      target: '_blank',
      className: `spectrum-Button spectrum-Button--${h || 'primary'} spectrum-Button--size${v || 'M'}`,
      children: E('span', { className: 'spectrum-Button-label', children: c }),
    });
  }
  function l(c, u, m, h, v) {
    return E(Ta, {
      to: u,
      'data-track': m,
      className: `spectrum-Button spectrum-Button--${h || 'primary'} spectrum-Button--size${v || 'M'}`,
      children: E('span', { className: 'spectrum-Button-label', children: c }),
    });
  }
  return ig(e, t) ? (o ? l(e, t, n, i, r) : s(e, t, n, i, r)) : null;
}
function Ly({ tags: e }) {
  return E('div', {
    className: 'code-tags is-margin-top-big is-margin-bottom-big buttons',
    children: e.map((t) => E('span', { className: 'button is-small', children: t }, t)),
  });
}
const Hy = '/static-assets/basic-react-app.50dd8b6a.png',
  Fy = '/static-assets/custom-component.c51955c6.png',
  jy = '/static-assets/react-native.79cc385b.png',
  zy = '/static-assets/next-js.ce8d444a.png',
  By = '/static-assets/material-ui.56010068.png',
  Uy = {
    'basic-react-app': Hy,
    'react-app-with-custom-components': Fy,
    'basic-react-native': jy,
    'react-app-with-material-ui-components': By,
    'react-app-with-nextjs': zy,
  };
function $y(e) {
  return ae('div', {
    className: 'card',
    style: { flexGrow: `${e.grow ? e.grow : 1}` },
    children: [
      E('img', { className: 'card__image', src: e.isRelativeImage ? Uy[e.id] : e.image, alt: e.title }),
      ae('div', {
        className: 'card__content',
        children: [
          E('h4', {
            className: 'card__title is-size-4 is-margin-bottom-big has-text-blackest is-extra-bold',
            children: e.title,
          }),
          e.tags && E(Ly, { tags: e.tags }),
          E('p', { className: 'card__text is-size-10 is-margin-bottom-big', children: e.text }),
          e.links &&
            E('div', {
              className: 'card__cta',
              children: e.links.map((t, n) =>
                E(rg, { text: t.text, link: t.link, route: t.route, analyticsName: `${e.title} - ${t.text}` }, n),
              ),
            }),
        ],
      }),
    ],
  });
}
function Gy(e) {
  const [t, n] = $.exports.useState(e.tabs[0].title);
  function i(r) {
    return t === r.title || !1;
  }
  return ae('div', {
    className: 'accordion',
    children: [
      E('div', { className: 'accordion__background' }),
      E('ul', {
        className: 'accordion__menu',
        children: e.tabs.map((r, o) =>
          E(
            'li',
            {
              className: `accordion__menu-item ${i(r) ? 'accordion__menu-item--active' : ''}`,
              onClick: () => n(r.title),
              children: r.title,
            },
            o,
          ),
        ),
      }),
      e.tabs.map((r, o) =>
        ae(
          'section',
          {
            className: `accordion__item ${i(r) ? 'accordion__item--active' : ''}`,
            children: [
              r.title
                ? E('div', {
                    className: `accordion__item-title ${i(r) ? 'accordion__item-title--active' : ''}`,
                    onClick: () => n(r.title),
                    children: r.title,
                  })
                : null,
              i(r) &&
                ae(
                  'div',
                  {
                    className: 'accordion__content accordion__content--active',
                    children: [
                      E('h4', { className: 'accordion__title', children: r.title }),
                      r.text && E('p', { children: r.text }),
                      E('div', {
                        className: 'accordion__lists',
                        children: r.lists.map((a, s) =>
                          ae(
                            'dl',
                            {
                              children: [
                                E('dt', { children: a.title }),
                                a.links.map((l, c) =>
                                  E(
                                    'dd',
                                    {
                                      children: E(Oy, {
                                        text: l.text,
                                        link: l.link,
                                        analyticsName: `Developer resources - ${l.text}`,
                                      }),
                                    },
                                    c,
                                  ),
                                ),
                              ],
                            },
                            s,
                          ),
                        ),
                      }),
                    ],
                  },
                  r.title,
                ),
            ],
          },
          o,
        ),
      ),
    ],
  });
}
function Jy(e) {
  return ae('div', {
    className: 'text-block text-block--center',
    children: [
      E('h2', {
        className: 'is-size-36 is-size-34-touch is-margin-bottom-big has-text-blackest is-extra-bold',
        children: e.title,
      }),
      E('p', { className: 'is-size-5 has-text-whitest is-margin-bottom-big ', children: e.text }),
    ],
  });
}
function Vy(e) {
  return E('h3', { className: 'has-text-weight-bold is-margin-bottom-big has-text-blackest', children: e.text });
}
function Bi(e) {
  return ae('section', {
    id: e.id,
    children: [
      e.title && E(Vy, { text: e.title }),
      e.text && E('p', { children: e.text }),
      (e.title || e.text) && e.children && E('div', { className: 'section__spacer' }),
      e.children && E('div', { className: 'section__row', children: e.children }),
    ],
  });
}
Bi.Gap = ({ children: e }) => E('div', { className: 'section__gap' });
Bi.RowBreak = ({ children: e }) => E('div', { className: 'section__row-break' });
function Bp(e) {
  var t;
  return ae('div', {
    className: 'box',
    style: { flexGrow: `${e.grow ? e.grow : 1}` },
    children: [
      E('img', { className: 'box__icon', src: e.icon, alt: e.title }),
      ae('div', {
        className: 'box__content',
        children: [
          E('h3', { className: 'is-size-4 has-text-blackest is-extra-bold', children: e.title }),
          E('p', { className: 'box__text is-size-10 has-text-whitest', children: e.text }),
          ((t = e.links) == null ? void 0 : t.length) &&
            e.links.map((n, i) => E(rg, { text: n.text, link: n.link, analyticsName: `${e.title} - ${n.text}` }, i)),
        ],
      }),
    ],
  });
}
function ls(e) {
  return E('div', { className: 'hero-stripe', children: E('div', { className: 'hero-stripe__inner' }) });
}
class qy {
  constructor(t) {
    Rs(this, 'formatMessage');
    this.formatMessage = t;
  }
  links(t) {
    return t.map((n) => ({ text: this.formatMessage(n), link: n.link }));
  }
  tabs(t) {
    return t.map((n) => ({
      title: n.title ? this.formatMessage(n.title) : null,
      text: this.formatMessage(n.text),
      lists: n.lists.map((i) => ({ title: i.title ? this.formatMessage(i.title) : null, links: this.links(i.links) })),
    }));
  }
  nav(t) {
    return t.map((n) => ({
      title: this.formatMessage(n.title),
      icon: n.icon,
      link: n.link,
      text: this.formatMessage(n.text),
      links: n.links.map((i) => ({ title: this.formatMessage(i), link: i.link })),
    }));
  }
  list(t) {
    return t.map((n) => this.formatMessage(n));
  }
}
function Up(e) {
  return ae('div', {
    className: 'welcome-box',
    style: { flexGrow: `${e.grow ? e.grow : 1}` },
    children: [
      E('h4', {
        className: 'welcome__title is-size-5 is-margin-bottom-big has-text-blackest is-bold',
        children: e.title,
      }),
      ae('div', {
        className: 'welcome-box__content',
        children: [
          E('p', { className: 'welcome__text is-size-10 is-margin-bottom-big', children: e.text }),
          E('img', { className: 'welcome-box__image', src: e.image, alt: e.title }),
        ],
      }),
    ],
  });
}
function Qy(e) {
  Object.keys(e).forEach((t) => {
    var o;
    const n = t,
      i = e[t],
      r = (o = document.head) == null ? void 0 : o.querySelector('meta[name="' + n + '"]');
    if (r) r.setAttribute('content', i), (r.dataset.microsite = !0);
    else {
      const a = document.createElement('meta');
      (a.name = n), (a.content = i), (a.dataset.microsite = !0), document.head.appendChild(a);
    }
  });
}
function Tu(e, t, n) {
  (e.title = t + ' | Adobe Experience Manager'), e.querySelector('meta[name="description"]').setAttribute('content', n);
}
const ue = ho;
function Wy(e) {
  const { formatMessage: t } = e.intl,
    n = new qy(t);
  return (
    $.exports.useState(e.intl.locale),
    Qy({
      role: 'Developer',
      level: 'Beginner, Intermediate, Advanced',
      'doc-type': 'Microsite',
      'feature-set': 'Experience Manager Forms, Experience Manager',
      solution: 'Experience Manager',
      'solution-title': 'Adobe Experience Manager',
      'sub-product': 'Experience Manager Forms',
      version: 'Cloud Service',
    }),
    Tu(document, t(ue.home.page.title), t(ue.home.page.description)),
    ae(di, {
      children: [
        E(ls, {}),
        E(ss, {}),
        E('div', {
          className: 'app__content--centered',
          children: ae(Bi, {
            children: [
              E(Jy, { title: t(ue.home.what_is_headless.title), text: t(ue.home.what_is_headless.text) }),
              E(Bi.RowBreak, {}),
              E(Up, {
                image: ue.home.new_developers.image,
                title: t(ue.home.new_developers.title, {
                  emphasis: E('strong', { children: t(ue.home.new_developers.title_emphasis) }),
                }),
                text: t(ue.home.new_developers.text, {
                  guideLink: E('a', {
                    target: '_blank',
                    rel: 'noreferrer',
                    href: 'https://experienceleague.adobe.com/en/docs/experience-manager-headless-adaptive-forms/using/tutorial/build-engaging-forms-using-core-components-and-headless-adaptive-forms-aem-forms-cloud-service',
                    children: t(ue.home.new_developers.text_guide_link),
                  }),
                }),
              }),
              E(Up, {
                image: ue.home.experienced_developers.image,
                title: t(ue.home.experienced_developers.title, {
                  emphasis: E('strong', { children: t(ue.home.experienced_developers.title_emphasis) }),
                }),
                text: t(ue.home.experienced_developers.text, {
                  fiveSteps: E('a', {
                    target: '_blank',
                    rel: 'noreferrer',
                    href: 'https://experienceleague.adobe.com/en/docs/experience-manager-headless-adaptive-forms/using/tutorial/build-engaging-forms-using-core-components-and-headless-adaptive-forms-on-aem-65-forms',
                    children: t(ue.home.experienced_developers.text_5_steps),
                  }),
                  advancedDocumentation: E('a', {
                    target: '_blank',
                    rel: 'noreferrer',
                    href: 'https://experienceleague.adobe.com/en/docs/experience-manager-headless-adaptive-forms/using/tutorial/build-engaging-forms-using-core-components-and-headless-adaptive-forms-on-aem-65-forms',
                    children: t(ue.home.experienced_developers.text_advanced_documentation),
                  }),
                  break: ae(di, { children: [E('br', {}), E('br', {})] }),
                }),
              }),
            ],
          }),
        }),
        ae('div', {
          className: 'app__content--centered',
          children: [
            E(Bi, {
              id: ue.home.section_developer_resources.slug,
              title: t(ue.home.section_developer_resources.title),
              children: E(Gy, { tabs: n.tabs(ue.home.technical_docs) }),
            }),
            ae(Bi, {
              title: t(ue.home.section_get_involved.title),
              children: [
                E(Bp, {
                  icon: ue.home.get_involved_blog.icon,
                  title: t(ue.home.get_involved_blog.title),
                  text: t(ue.home.get_involved_blog.text),
                  links: n.links(ue.home.get_involved_blog.links),
                }),
                E(Bp, {
                  icon: ue.home.get_involved_community.icon,
                  title: t(ue.home.get_involved_community.title),
                  text: t(ue.home.get_involved_community.text),
                  links: n.links(ue.home.get_involved_community.links),
                }),
              ],
            }),
          ],
        }),
      ],
    })
  );
}
const Ky = sr(Wy),
  Wn = ho;
function Xy(e) {
  const { formatMessage: t } = e.intl;
  $.exports.useContext(mo);
  const [n, i] = $.exports.useState(!1);
  return (
    n || (Tu(document, t(Wn.code_index.title), t(Wn.code_index.text)), Zy(), i(!0)),
    ae(di, {
      children: [
        E(ls, {}),
        E(ss, {}),
        ae('div', {
          className: 'app__content--centered',
          children: [
            E('h1', {
              className: 'is-extra-bold is-size-36 is-size-34-touch has-text-blackest',
              children: t(Wn.code_index.title),
            }),
            E('p', {
              className: 'is-size-18 has-text-weight-normal has-text-blackest',
              children: t(Wn.code_index.text),
            }),
            E('br', {}),
            E('br', {}),
            E(Ny, {
              children: Object.keys(Wn.code_index.code).map((r, o) => {
                let a = Wn.code_index.code[r];
                return E(
                  $y,
                  {
                    id: a.articleId,
                    image: a.image,
                    isRelativeImage: !0,
                    title: t(a.title),
                    text: t(a.description),
                    tags: a.tags,
                    links: [
                      { text: t(Wn.code_index.button_run_the_code), link: `/developer/code/${r}.html`, route: !0 },
                    ],
                  },
                  o,
                );
              }),
            }),
          ],
        }),
      ],
    })
  );
}
function Zy() {
  (window.adobeDataLayer = window.adobeDataLayer || []),
    window.adobeDataLayer.push({
      event: 'page loaded',
      user: window.adobeDataLayer.getState().user || {},
      web: {
        webPageDetails: {
          pageViews: { value: 1 },
          pageTitle: 'AEM Headless Adaptive Forms developer resources - Code playground',
          name: 'xl:microsite:landing:experience-manager:aem-headless-forms:code-playground',
          pageType: 'webpage',
          URL: 'https://experienceleague.adobe.com/developer/code.html',
          domain: 'experienceleague.adobe.com',
          server: void 0,
          siteSection: 'microsite',
          siteSubSection1: 'microsite',
          siteSubSection2: ' ',
          siteSubSection3: ' ',
        },
      },
    });
}
const Yy = sr(Xy);
function og() {
  return {
    async: !1,
    baseUrl: null,
    breaks: !1,
    extensions: null,
    gfm: !0,
    headerIds: !0,
    headerPrefix: '',
    highlight: null,
    langPrefix: 'language-',
    mangle: !0,
    pedantic: !1,
    renderer: null,
    sanitize: !1,
    sanitizer: null,
    silent: !1,
    smartLists: !1,
    smartypants: !1,
    tokenizer: null,
    walkTokens: null,
    xhtml: !1,
  };
}
let lr = og();
function eA(e) {
  lr = e;
}
const tA = /[&<>"']/,
  nA = /[&<>"']/g,
  iA = /[<>"']|&(?!#?\w+;)/,
  rA = /[<>"']|&(?!#?\w+;)/g,
  oA = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' },
  $p = (e) => oA[e];
function Le(e, t) {
  if (t) {
    if (tA.test(e)) return e.replace(nA, $p);
  } else if (iA.test(e)) return e.replace(rA, $p);
  return e;
}
const aA = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi;
function ag(e) {
  return e.replace(
    aA,
    (t, n) => (
      (n = n.toLowerCase()),
      n === 'colon'
        ? ':'
        : n.charAt(0) === '#'
          ? n.charAt(1) === 'x'
            ? String.fromCharCode(parseInt(n.substring(2), 16))
            : String.fromCharCode(+n.substring(1))
          : ''
    ),
  );
}
const sA = /(^|[^\[])\^/g;
function de(e, t) {
  (e = typeof e == 'string' ? e : e.source), (t = t || '');
  const n = {
    replace: (i, r) => ((r = r.source || r), (r = r.replace(sA, '$1')), (e = e.replace(i, r)), n),
    getRegex: () => new RegExp(e, t),
  };
  return n;
}
const lA = /[^\w:]/g,
  cA = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
function Gp(e, t, n) {
  if (e) {
    let i;
    try {
      i = decodeURIComponent(ag(n)).replace(lA, '').toLowerCase();
    } catch {
      return null;
    }
    if (i.indexOf('javascript:') === 0 || i.indexOf('vbscript:') === 0 || i.indexOf('data:') === 0) return null;
  }
  t && !cA.test(n) && (n = hA(t, n));
  try {
    n = encodeURI(n).replace(/%25/g, '%');
  } catch {
    return null;
  }
  return n;
}
const Uo = {},
  uA = /^[^:]+:\/*[^/]*$/,
  dA = /^([^:]+:)[\s\S]*$/,
  pA = /^([^:]+:\/*[^/]*)[\s\S]*$/;
function hA(e, t) {
  Uo[' ' + e] || (uA.test(e) ? (Uo[' ' + e] = e + '/') : (Uo[' ' + e] = na(e, '/', !0))), (e = Uo[' ' + e]);
  const n = e.indexOf(':') === -1;
  return t.substring(0, 2) === '//'
    ? n
      ? t
      : e.replace(dA, '$1') + t
    : t.charAt(0) === '/'
      ? n
        ? t
        : e.replace(pA, '$1') + t
      : e + t;
}
const Ra = { exec: function () {} };
function Bt(e) {
  let t = 1,
    n,
    i;
  for (; t < arguments.length; t++) {
    n = arguments[t];
    for (i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
  }
  return e;
}
function Jp(e, t) {
  const n = e.replace(/\|/g, (o, a, s) => {
      let l = !1,
        c = a;
      for (; --c >= 0 && s[c] === '\\'; ) l = !l;
      return l ? '|' : ' |';
    }),
    i = n.split(/ \|/);
  let r = 0;
  if ((i[0].trim() || i.shift(), i.length > 0 && !i[i.length - 1].trim() && i.pop(), i.length > t)) i.splice(t);
  else for (; i.length < t; ) i.push('');
  for (; r < i.length; r++) i[r] = i[r].trim().replace(/\\\|/g, '|');
  return i;
}
function na(e, t, n) {
  const i = e.length;
  if (i === 0) return '';
  let r = 0;
  for (; r < i; ) {
    const o = e.charAt(i - r - 1);
    if (o === t && !n) r++;
    else if (o !== t && n) r++;
    else break;
  }
  return e.slice(0, i - r);
}
function mA(e, t) {
  if (e.indexOf(t[1]) === -1) return -1;
  const n = e.length;
  let i = 0,
    r = 0;
  for (; r < n; r++)
    if (e[r] === '\\') r++;
    else if (e[r] === t[0]) i++;
    else if (e[r] === t[1] && (i--, i < 0)) return r;
  return -1;
}
function sg(e) {
  e &&
    e.sanitize &&
    !e.silent &&
    console.warn(
      'marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options',
    );
}
function Vp(e, t) {
  if (t < 1) return '';
  let n = '';
  for (; t > 1; ) t & 1 && (n += e), (t >>= 1), (e += e);
  return n + e;
}
function qp(e, t, n, i) {
  const r = t.href,
    o = t.title ? Le(t.title) : null,
    a = e[1].replace(/\\([\[\]])/g, '$1');
  if (e[0].charAt(0) !== '!') {
    i.state.inLink = !0;
    const s = { type: 'link', raw: n, href: r, title: o, text: a, tokens: i.inlineTokens(a) };
    return (i.state.inLink = !1), s;
  }
  return { type: 'image', raw: n, href: r, title: o, text: Le(a) };
}
function fA(e, t) {
  const n = e.match(/^(\s+)(?:```)/);
  if (n === null) return t;
  const i = n[1];
  return t
    .split(
      `
`,
    )
    .map((r) => {
      const o = r.match(/^\s+/);
      if (o === null) return r;
      const [a] = o;
      return a.length >= i.length ? r.slice(i.length) : r;
    }).join(`
`);
}
class Ru {
  constructor(t) {
    this.options = t || lr;
  }
  space(t) {
    const n = this.rules.block.newline.exec(t);
    if (n && n[0].length > 0) return { type: 'space', raw: n[0] };
  }
  code(t) {
    const n = this.rules.block.code.exec(t);
    if (n) {
      const i = n[0].replace(/^ {1,4}/gm, '');
      return {
        type: 'code',
        raw: n[0],
        codeBlockStyle: 'indented',
        text: this.options.pedantic
          ? i
          : na(
              i,
              `
`,
            ),
      };
    }
  }
  fences(t) {
    const n = this.rules.block.fences.exec(t);
    if (n) {
      const i = n[0],
        r = fA(i, n[3] || '');
      return { type: 'code', raw: i, lang: n[2] ? n[2].trim() : n[2], text: r };
    }
  }
  heading(t) {
    const n = this.rules.block.heading.exec(t);
    if (n) {
      let i = n[2].trim();
      if (/#$/.test(i)) {
        const r = na(i, '#');
        (this.options.pedantic || !r || / $/.test(r)) && (i = r.trim());
      }
      return { type: 'heading', raw: n[0], depth: n[1].length, text: i, tokens: this.lexer.inline(i) };
    }
  }
  hr(t) {
    const n = this.rules.block.hr.exec(t);
    if (n) return { type: 'hr', raw: n[0] };
  }
  blockquote(t) {
    const n = this.rules.block.blockquote.exec(t);
    if (n) {
      const i = n[0].replace(/^ *>[ \t]?/gm, '');
      return { type: 'blockquote', raw: n[0], tokens: this.lexer.blockTokens(i, []), text: i };
    }
  }
  list(t) {
    let n = this.rules.block.list.exec(t);
    if (n) {
      let i,
        r,
        o,
        a,
        s,
        l,
        c,
        u,
        m,
        h,
        v,
        x,
        f = n[1].trim();
      const D = f.length > 1,
        p = { type: 'list', raw: '', ordered: D, start: D ? +f.slice(0, -1) : '', loose: !1, items: [] };
      (f = D ? `\\d{1,9}\\${f.slice(-1)}` : `\\${f}`), this.options.pedantic && (f = D ? f : '[*+-]');
      const d = new RegExp(`^( {0,3}${f})((?:[	 ][^\\n]*)?(?:\\n|$))`);
      for (; t && ((x = !1), !(!(n = d.exec(t)) || this.rules.block.hr.test(t))); ) {
        if (
          ((i = n[0]),
          (t = t.substring(i.length)),
          (u = n[2].split(
            `
`,
            1,
          )[0]),
          (m = t.split(
            `
`,
            1,
          )[0]),
          this.options.pedantic
            ? ((a = 2), (v = u.trimLeft()))
            : ((a = n[2].search(/[^ ]/)), (a = a > 4 ? 1 : a), (v = u.slice(a)), (a += n[1].length)),
          (l = !1),
          !u &&
            /^ *$/.test(m) &&
            ((i +=
              m +
              `
`),
            (t = t.substring(m.length + 1)),
            (x = !0)),
          !x)
        ) {
          const y = new RegExp(`^ {0,${Math.min(3, a - 1)}}(?:[*+-]|\\d{1,9}[.)])((?: [^\\n]*)?(?:\\n|$))`),
            b = new RegExp(`^ {0,${Math.min(3, a - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
            C = new RegExp(`^ {0,${Math.min(3, a - 1)}}(?:\`\`\`|~~~)`),
            R = new RegExp(`^ {0,${Math.min(3, a - 1)}}#`);
          for (
            ;
            t &&
            ((h = t.split(
              `
`,
              1,
            )[0]),
            (u = h),
            this.options.pedantic && (u = u.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ')),
            !(C.test(u) || R.test(u) || y.test(u) || b.test(t)));

          ) {
            if (u.search(/[^ ]/) >= a || !u.trim())
              v +=
                `
` + u.slice(a);
            else if (!l)
              v +=
                `
` + u;
            else break;
            !l && !u.trim() && (l = !0),
              (i +=
                h +
                `
`),
              (t = t.substring(h.length + 1));
          }
        }
        p.loose || (c ? (p.loose = !0) : /\n *\n *$/.test(i) && (c = !0)),
          this.options.gfm &&
            ((r = /^\[[ xX]\] /.exec(v)), r && ((o = r[0] !== '[ ] '), (v = v.replace(/^\[[ xX]\] +/, '')))),
          p.items.push({ type: 'list_item', raw: i, task: !!r, checked: o, loose: !1, text: v }),
          (p.raw += i);
      }
      (p.items[p.items.length - 1].raw = i.trimRight()),
        (p.items[p.items.length - 1].text = v.trimRight()),
        (p.raw = p.raw.trimRight());
      const g = p.items.length;
      for (s = 0; s < g; s++) {
        (this.lexer.state.top = !1), (p.items[s].tokens = this.lexer.blockTokens(p.items[s].text, []));
        const y = p.items[s].tokens.filter((C) => C.type === 'space'),
          b = y.every((C) => {
            const R = C.raw.split('');
            let z = 0;
            for (const Y of R)
              if (
                (Y ===
                  `
` && (z += 1),
                z > 1)
              )
                return !0;
            return !1;
          });
        !p.loose && y.length && b && ((p.loose = !0), (p.items[s].loose = !0));
      }
      return p;
    }
  }
  html(t) {
    const n = this.rules.block.html.exec(t);
    if (n) {
      const i = {
        type: 'html',
        raw: n[0],
        pre: !this.options.sanitizer && (n[1] === 'pre' || n[1] === 'script' || n[1] === 'style'),
        text: n[0],
      };
      if (this.options.sanitize) {
        const r = this.options.sanitizer ? this.options.sanitizer(n[0]) : Le(n[0]);
        (i.type = 'paragraph'), (i.text = r), (i.tokens = this.lexer.inline(r));
      }
      return i;
    }
  }
  def(t) {
    const n = this.rules.block.def.exec(t);
    if (n)
      return (
        n[3] && (n[3] = n[3].substring(1, n[3].length - 1)),
        { type: 'def', tag: n[1].toLowerCase().replace(/\s+/g, ' '), raw: n[0], href: n[2], title: n[3] }
      );
  }
  table(t) {
    const n = this.rules.block.table.exec(t);
    if (n) {
      const i = {
        type: 'table',
        header: Jp(n[1]).map((r) => ({ text: r })),
        align: n[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        rows:
          n[3] && n[3].trim()
            ? n[3].replace(/\n[ \t]*$/, '').split(`
`)
            : [],
      };
      if (i.header.length === i.align.length) {
        i.raw = n[0];
        let r = i.align.length,
          o,
          a,
          s,
          l;
        for (o = 0; o < r; o++)
          /^ *-+: *$/.test(i.align[o])
            ? (i.align[o] = 'right')
            : /^ *:-+: *$/.test(i.align[o])
              ? (i.align[o] = 'center')
              : /^ *:-+ *$/.test(i.align[o])
                ? (i.align[o] = 'left')
                : (i.align[o] = null);
        for (r = i.rows.length, o = 0; o < r; o++) i.rows[o] = Jp(i.rows[o], i.header.length).map((c) => ({ text: c }));
        for (r = i.header.length, a = 0; a < r; a++) i.header[a].tokens = this.lexer.inline(i.header[a].text);
        for (r = i.rows.length, a = 0; a < r; a++)
          for (l = i.rows[a], s = 0; s < l.length; s++) l[s].tokens = this.lexer.inline(l[s].text);
        return i;
      }
    }
  }
  lheading(t) {
    const n = this.rules.block.lheading.exec(t);
    if (n)
      return {
        type: 'heading',
        raw: n[0],
        depth: n[2].charAt(0) === '=' ? 1 : 2,
        text: n[1],
        tokens: this.lexer.inline(n[1]),
      };
  }
  paragraph(t) {
    const n = this.rules.block.paragraph.exec(t);
    if (n) {
      const i =
        n[1].charAt(n[1].length - 1) ===
        `
`
          ? n[1].slice(0, -1)
          : n[1];
      return { type: 'paragraph', raw: n[0], text: i, tokens: this.lexer.inline(i) };
    }
  }
  text(t) {
    const n = this.rules.block.text.exec(t);
    if (n) return { type: 'text', raw: n[0], text: n[0], tokens: this.lexer.inline(n[0]) };
  }
  escape(t) {
    const n = this.rules.inline.escape.exec(t);
    if (n) return { type: 'escape', raw: n[0], text: Le(n[1]) };
  }
  tag(t) {
    const n = this.rules.inline.tag.exec(t);
    if (n)
      return (
        !this.lexer.state.inLink && /^<a /i.test(n[0])
          ? (this.lexer.state.inLink = !0)
          : this.lexer.state.inLink && /^<\/a>/i.test(n[0]) && (this.lexer.state.inLink = !1),
        !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(n[0])
          ? (this.lexer.state.inRawBlock = !0)
          : this.lexer.state.inRawBlock &&
            /^<\/(pre|code|kbd|script)(\s|>)/i.test(n[0]) &&
            (this.lexer.state.inRawBlock = !1),
        {
          type: this.options.sanitize ? 'text' : 'html',
          raw: n[0],
          inLink: this.lexer.state.inLink,
          inRawBlock: this.lexer.state.inRawBlock,
          text: this.options.sanitize ? (this.options.sanitizer ? this.options.sanitizer(n[0]) : Le(n[0])) : n[0],
        }
      );
  }
  link(t) {
    const n = this.rules.inline.link.exec(t);
    if (n) {
      const i = n[2].trim();
      if (!this.options.pedantic && /^</.test(i)) {
        if (!/>$/.test(i)) return;
        const a = na(i.slice(0, -1), '\\');
        if ((i.length - a.length) % 2 === 0) return;
      } else {
        const a = mA(n[2], '()');
        if (a > -1) {
          const l = (n[0].indexOf('!') === 0 ? 5 : 4) + n[1].length + a;
          (n[2] = n[2].substring(0, a)), (n[0] = n[0].substring(0, l).trim()), (n[3] = '');
        }
      }
      let r = n[2],
        o = '';
      if (this.options.pedantic) {
        const a = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(r);
        a && ((r = a[1]), (o = a[3]));
      } else o = n[3] ? n[3].slice(1, -1) : '';
      return (
        (r = r.trim()),
        /^</.test(r) && (this.options.pedantic && !/>$/.test(i) ? (r = r.slice(1)) : (r = r.slice(1, -1))),
        qp(
          n,
          {
            href: r && r.replace(this.rules.inline._escapes, '$1'),
            title: o && o.replace(this.rules.inline._escapes, '$1'),
          },
          n[0],
          this.lexer,
        )
      );
    }
  }
  reflink(t, n) {
    let i;
    if ((i = this.rules.inline.reflink.exec(t)) || (i = this.rules.inline.nolink.exec(t))) {
      let r = (i[2] || i[1]).replace(/\s+/g, ' ');
      if (((r = n[r.toLowerCase()]), !r || !r.href)) {
        const o = i[0].charAt(0);
        return { type: 'text', raw: o, text: o };
      }
      return qp(i, r, i[0], this.lexer);
    }
  }
  emStrong(t, n, i = '') {
    let r = this.rules.inline.emStrong.lDelim.exec(t);
    if (!r || (r[3] && i.match(/[\p{L}\p{N}]/u))) return;
    const o = r[1] || r[2] || '';
    if (!o || (o && (i === '' || this.rules.inline.punctuation.exec(i)))) {
      const a = r[0].length - 1;
      let s,
        l,
        c = a,
        u = 0;
      const m = r[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      for (m.lastIndex = 0, n = n.slice(-1 * t.length + a); (r = m.exec(n)) != null; ) {
        if (((s = r[1] || r[2] || r[3] || r[4] || r[5] || r[6]), !s)) continue;
        if (((l = s.length), r[3] || r[4])) {
          c += l;
          continue;
        } else if ((r[5] || r[6]) && a % 3 && !((a + l) % 3)) {
          u += l;
          continue;
        }
        if (((c -= l), c > 0)) continue;
        if (((l = Math.min(l, l + c + u)), Math.min(a, l) % 2)) {
          const v = t.slice(1, a + r.index + l);
          return { type: 'em', raw: t.slice(0, a + r.index + l + 1), text: v, tokens: this.lexer.inlineTokens(v) };
        }
        const h = t.slice(2, a + r.index + l - 1);
        return { type: 'strong', raw: t.slice(0, a + r.index + l + 1), text: h, tokens: this.lexer.inlineTokens(h) };
      }
    }
  }
  codespan(t) {
    const n = this.rules.inline.code.exec(t);
    if (n) {
      let i = n[2].replace(/\n/g, ' ');
      const r = /[^ ]/.test(i),
        o = /^ /.test(i) && / $/.test(i);
      return r && o && (i = i.substring(1, i.length - 1)), (i = Le(i, !0)), { type: 'codespan', raw: n[0], text: i };
    }
  }
  br(t) {
    const n = this.rules.inline.br.exec(t);
    if (n) return { type: 'br', raw: n[0] };
  }
  del(t) {
    const n = this.rules.inline.del.exec(t);
    if (n) return { type: 'del', raw: n[0], text: n[2], tokens: this.lexer.inlineTokens(n[2]) };
  }
  autolink(t, n) {
    const i = this.rules.inline.autolink.exec(t);
    if (i) {
      let r, o;
      return (
        i[2] === '@'
          ? ((r = Le(this.options.mangle ? n(i[1]) : i[1])), (o = 'mailto:' + r))
          : ((r = Le(i[1])), (o = r)),
        { type: 'link', raw: i[0], text: r, href: o, tokens: [{ type: 'text', raw: r, text: r }] }
      );
    }
  }
  url(t, n) {
    let i;
    if ((i = this.rules.inline.url.exec(t))) {
      let r, o;
      if (i[2] === '@') (r = Le(this.options.mangle ? n(i[0]) : i[0])), (o = 'mailto:' + r);
      else {
        let a;
        do (a = i[0]), (i[0] = this.rules.inline._backpedal.exec(i[0])[0]);
        while (a !== i[0]);
        (r = Le(i[0])), i[1] === 'www.' ? (o = 'http://' + r) : (o = r);
      }
      return { type: 'link', raw: i[0], text: r, href: o, tokens: [{ type: 'text', raw: r, text: r }] };
    }
  }
  inlineText(t, n) {
    const i = this.rules.inline.text.exec(t);
    if (i) {
      let r;
      return (
        this.lexer.state.inRawBlock
          ? (r = this.options.sanitize ? (this.options.sanitizer ? this.options.sanitizer(i[0]) : Le(i[0])) : i[0])
          : (r = Le(this.options.smartypants ? n(i[0]) : i[0])),
        { type: 'text', raw: i[0], text: r }
      );
    }
  }
}
const J = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: '^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))',
  def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: Ra,
  lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/,
};
J._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
J._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
J.def = de(J.def).replace('label', J._label).replace('title', J._title).getRegex();
J.bullet = /(?:[*+-]|\d{1,9}[.)])/;
J.listItemStart = de(/^( *)(bull) */)
  .replace('bull', J.bullet)
  .getRegex();
J.list = de(J.list)
  .replace(/bull/g, J.bullet)
  .replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))')
  .replace('def', '\\n+(?=' + J.def.source + ')')
  .getRegex();
J._tag =
  'address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul';
J._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
J.html = de(J.html, 'i')
  .replace('comment', J._comment)
  .replace('tag', J._tag)
  .replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/)
  .getRegex();
J.paragraph = de(J._paragraph)
  .replace('hr', J.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('|lheading', '')
  .replace('|table', '')
  .replace('blockquote', ' {0,3}>')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ')
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', J._tag)
  .getRegex();
J.blockquote = de(J.blockquote).replace('paragraph', J.paragraph).getRegex();
J.normal = Bt({}, J);
J.gfm = Bt({}, J.normal, {
  table:
    '^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)',
});
J.gfm.table = de(J.gfm.table)
  .replace('hr', J.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('blockquote', ' {0,3}>')
  .replace('code', ' {4}[^\\n]')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ')
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', J._tag)
  .getRegex();
J.gfm.paragraph = de(J._paragraph)
  .replace('hr', J.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('|lheading', '')
  .replace('table', J.gfm.table)
  .replace('blockquote', ' {0,3}>')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ')
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', J._tag)
  .getRegex();
J.pedantic = Bt({}, J.normal, {
  html: de(
    `^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`,
  )
    .replace('comment', J._comment)
    .replace(
      /tag/g,
      '(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b',
    )
    .getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: Ra,
  paragraph: de(J.normal._paragraph)
    .replace('hr', J.hr)
    .replace(
      'heading',
      ` *#{1,6} *[^
]`,
    )
    .replace('lheading', J.lheading)
    .replace('blockquote', ' {0,3}>')
    .replace('|fences', '')
    .replace('|list', '')
    .replace('|html', '')
    .getRegex(),
});
const j = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: Ra,
  tag: '^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>',
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: 'reflink|nolink(?!\\()',
  emStrong: {
    lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
    rDelimAst:
      /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[^*]+(?=[^*])|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
    rDelimUnd:
      /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/,
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: Ra,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^([\spunctuation])/,
};
j._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
j.punctuation = de(j.punctuation)
  .replace(/punctuation/g, j._punctuation)
  .getRegex();
j.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
j.escapedEmSt = /\\\*|\\_/g;
j._comment = de(J._comment).replace('(?:-->|$)', '-->').getRegex();
j.emStrong.lDelim = de(j.emStrong.lDelim).replace(/punct/g, j._punctuation).getRegex();
j.emStrong.rDelimAst = de(j.emStrong.rDelimAst, 'g').replace(/punct/g, j._punctuation).getRegex();
j.emStrong.rDelimUnd = de(j.emStrong.rDelimUnd, 'g').replace(/punct/g, j._punctuation).getRegex();
j._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
j._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
j._email =
  /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
j.autolink = de(j.autolink).replace('scheme', j._scheme).replace('email', j._email).getRegex();
j._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
j.tag = de(j.tag).replace('comment', j._comment).replace('attribute', j._attribute).getRegex();
j._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
j._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
j._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
j.link = de(j.link).replace('label', j._label).replace('href', j._href).replace('title', j._title).getRegex();
j.reflink = de(j.reflink).replace('label', j._label).replace('ref', J._label).getRegex();
j.nolink = de(j.nolink).replace('ref', J._label).getRegex();
j.reflinkSearch = de(j.reflinkSearch, 'g').replace('reflink', j.reflink).replace('nolink', j.nolink).getRegex();
j.normal = Bt({}, j);
j.pedantic = Bt({}, j.normal, {
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g,
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g,
  },
  link: de(/^!?\[(label)\]\((.*?)\)/)
    .replace('label', j._label)
    .getRegex(),
  reflink: de(/^!?\[(label)\]\s*\[([^\]]*)\]/)
    .replace('label', j._label)
    .getRegex(),
});
j.gfm = Bt({}, j.normal, {
  escape: de(j.escape).replace('])', '~|])').getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/,
});
j.gfm.url = de(j.gfm.url, 'i').replace('email', j.gfm._extended_email).getRegex();
j.breaks = Bt({}, j.gfm, {
  br: de(j.br).replace('{2,}', '*').getRegex(),
  text: de(j.gfm.text)
    .replace('\\b_', '\\b_| {2,}\\n')
    .replace(/\{2,\}/g, '*')
    .getRegex(),
});
function gA(e) {
  return e
    .replace(/---/g, '\u2014')
    .replace(/--/g, '\u2013')
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    .replace(/'/g, '\u2019')
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201C')
    .replace(/"/g, '\u201D')
    .replace(/\.{3}/g, '\u2026');
}
function Qp(e) {
  let t = '',
    n,
    i;
  const r = e.length;
  for (n = 0; n < r; n++)
    (i = e.charCodeAt(n)), Math.random() > 0.5 && (i = 'x' + i.toString(16)), (t += '&#' + i + ';');
  return t;
}
class gn {
  constructor(t) {
    (this.tokens = []),
      (this.tokens.links = Object.create(null)),
      (this.options = t || lr),
      (this.options.tokenizer = this.options.tokenizer || new Ru()),
      (this.tokenizer = this.options.tokenizer),
      (this.tokenizer.options = this.options),
      (this.tokenizer.lexer = this),
      (this.inlineQueue = []),
      (this.state = { inLink: !1, inRawBlock: !1, top: !0 });
    const n = { block: J.normal, inline: j.normal };
    this.options.pedantic
      ? ((n.block = J.pedantic), (n.inline = j.pedantic))
      : this.options.gfm && ((n.block = J.gfm), this.options.breaks ? (n.inline = j.breaks) : (n.inline = j.gfm)),
      (this.tokenizer.rules = n);
  }
  static get rules() {
    return { block: J, inline: j };
  }
  static lex(t, n) {
    return new gn(n).lex(t);
  }
  static lexInline(t, n) {
    return new gn(n).inlineTokens(t);
  }
  lex(t) {
    (t = t.replace(
      /\r\n|\r/g,
      `
`,
    )),
      this.blockTokens(t, this.tokens);
    let n;
    for (; (n = this.inlineQueue.shift()); ) this.inlineTokens(n.src, n.tokens);
    return this.tokens;
  }
  blockTokens(t, n = []) {
    this.options.pedantic
      ? (t = t.replace(/\t/g, '    ').replace(/^ +$/gm, ''))
      : (t = t.replace(/^( *)(\t+)/gm, (s, l, c) => l + '    '.repeat(c.length)));
    let i, r, o, a;
    for (; t; )
      if (
        !(
          this.options.extensions &&
          this.options.extensions.block &&
          this.options.extensions.block.some((s) =>
            (i = s.call({ lexer: this }, t, n)) ? ((t = t.substring(i.raw.length)), n.push(i), !0) : !1,
          )
        )
      ) {
        if ((i = this.tokenizer.space(t))) {
          (t = t.substring(i.raw.length)),
            i.raw.length === 1 && n.length > 0
              ? (n[n.length - 1].raw += `
`)
              : n.push(i);
          continue;
        }
        if ((i = this.tokenizer.code(t))) {
          (t = t.substring(i.raw.length)),
            (r = n[n.length - 1]),
            r && (r.type === 'paragraph' || r.type === 'text')
              ? ((r.raw +=
                  `
` + i.raw),
                (r.text +=
                  `
` + i.text),
                (this.inlineQueue[this.inlineQueue.length - 1].src = r.text))
              : n.push(i);
          continue;
        }
        if ((i = this.tokenizer.fences(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.heading(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.hr(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.blockquote(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.list(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.html(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.def(t))) {
          (t = t.substring(i.raw.length)),
            (r = n[n.length - 1]),
            r && (r.type === 'paragraph' || r.type === 'text')
              ? ((r.raw +=
                  `
` + i.raw),
                (r.text +=
                  `
` + i.raw),
                (this.inlineQueue[this.inlineQueue.length - 1].src = r.text))
              : this.tokens.links[i.tag] || (this.tokens.links[i.tag] = { href: i.href, title: i.title });
          continue;
        }
        if ((i = this.tokenizer.table(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.lheading(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if (((o = t), this.options.extensions && this.options.extensions.startBlock)) {
          let s = 1 / 0;
          const l = t.slice(1);
          let c;
          this.options.extensions.startBlock.forEach(function (u) {
            (c = u.call({ lexer: this }, l)), typeof c == 'number' && c >= 0 && (s = Math.min(s, c));
          }),
            s < 1 / 0 && s >= 0 && (o = t.substring(0, s + 1));
        }
        if (this.state.top && (i = this.tokenizer.paragraph(o))) {
          (r = n[n.length - 1]),
            a && r.type === 'paragraph'
              ? ((r.raw +=
                  `
` + i.raw),
                (r.text +=
                  `
` + i.text),
                this.inlineQueue.pop(),
                (this.inlineQueue[this.inlineQueue.length - 1].src = r.text))
              : n.push(i),
            (a = o.length !== t.length),
            (t = t.substring(i.raw.length));
          continue;
        }
        if ((i = this.tokenizer.text(t))) {
          (t = t.substring(i.raw.length)),
            (r = n[n.length - 1]),
            r && r.type === 'text'
              ? ((r.raw +=
                  `
` + i.raw),
                (r.text +=
                  `
` + i.text),
                this.inlineQueue.pop(),
                (this.inlineQueue[this.inlineQueue.length - 1].src = r.text))
              : n.push(i);
          continue;
        }
        if (t) {
          const s = 'Infinite loop on byte: ' + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(s);
            break;
          } else throw new Error(s);
        }
      }
    return (this.state.top = !0), n;
  }
  inline(t, n = []) {
    return this.inlineQueue.push({ src: t, tokens: n }), n;
  }
  inlineTokens(t, n = []) {
    let i,
      r,
      o,
      a = t,
      s,
      l,
      c;
    if (this.tokens.links) {
      const u = Object.keys(this.tokens.links);
      if (u.length > 0)
        for (; (s = this.tokenizer.rules.inline.reflinkSearch.exec(a)) != null; )
          u.includes(s[0].slice(s[0].lastIndexOf('[') + 1, -1)) &&
            (a =
              a.slice(0, s.index) +
              '[' +
              Vp('a', s[0].length - 2) +
              ']' +
              a.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (s = this.tokenizer.rules.inline.blockSkip.exec(a)) != null; )
      a =
        a.slice(0, s.index) +
        '[' +
        Vp('a', s[0].length - 2) +
        ']' +
        a.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (s = this.tokenizer.rules.inline.escapedEmSt.exec(a)) != null; )
      a = a.slice(0, s.index) + '++' + a.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
    for (; t; )
      if (
        (l || (c = ''),
        (l = !1),
        !(
          this.options.extensions &&
          this.options.extensions.inline &&
          this.options.extensions.inline.some((u) =>
            (i = u.call({ lexer: this }, t, n)) ? ((t = t.substring(i.raw.length)), n.push(i), !0) : !1,
          )
        ))
      ) {
        if ((i = this.tokenizer.escape(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.tag(t))) {
          (t = t.substring(i.raw.length)),
            (r = n[n.length - 1]),
            r && i.type === 'text' && r.type === 'text' ? ((r.raw += i.raw), (r.text += i.text)) : n.push(i);
          continue;
        }
        if ((i = this.tokenizer.link(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.reflink(t, this.tokens.links))) {
          (t = t.substring(i.raw.length)),
            (r = n[n.length - 1]),
            r && i.type === 'text' && r.type === 'text' ? ((r.raw += i.raw), (r.text += i.text)) : n.push(i);
          continue;
        }
        if ((i = this.tokenizer.emStrong(t, a, c))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.codespan(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.br(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.del(t))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if ((i = this.tokenizer.autolink(t, Qp))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if (!this.state.inLink && (i = this.tokenizer.url(t, Qp))) {
          (t = t.substring(i.raw.length)), n.push(i);
          continue;
        }
        if (((o = t), this.options.extensions && this.options.extensions.startInline)) {
          let u = 1 / 0;
          const m = t.slice(1);
          let h;
          this.options.extensions.startInline.forEach(function (v) {
            (h = v.call({ lexer: this }, m)), typeof h == 'number' && h >= 0 && (u = Math.min(u, h));
          }),
            u < 1 / 0 && u >= 0 && (o = t.substring(0, u + 1));
        }
        if ((i = this.tokenizer.inlineText(o, gA))) {
          (t = t.substring(i.raw.length)),
            i.raw.slice(-1) !== '_' && (c = i.raw.slice(-1)),
            (l = !0),
            (r = n[n.length - 1]),
            r && r.type === 'text' ? ((r.raw += i.raw), (r.text += i.text)) : n.push(i);
          continue;
        }
        if (t) {
          const u = 'Infinite loop on byte: ' + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(u);
            break;
          } else throw new Error(u);
        }
      }
    return n;
  }
}
class Pu {
  constructor(t) {
    this.options = t || lr;
  }
  code(t, n, i) {
    const r = (n || '').match(/\S*/)[0];
    if (this.options.highlight) {
      const o = this.options.highlight(t, r);
      o != null && o !== t && ((i = !0), (t = o));
    }
    return (
      (t =
        t.replace(/\n$/, '') +
        `
`),
      r
        ? '<pre><code class="' +
          this.options.langPrefix +
          Le(r, !0) +
          '">' +
          (i ? t : Le(t, !0)) +
          `</code></pre>
`
        : '<pre><code>' +
          (i ? t : Le(t, !0)) +
          `</code></pre>
`
    );
  }
  blockquote(t) {
    return `<blockquote>
${t}</blockquote>
`;
  }
  html(t) {
    return t;
  }
  heading(t, n, i, r) {
    if (this.options.headerIds) {
      const o = this.options.headerPrefix + r.slug(i);
      return `<h${n} id="${o}">${t}</h${n}>
`;
    }
    return `<h${n}>${t}</h${n}>
`;
  }
  hr() {
    return this.options.xhtml
      ? `<hr/>
`
      : `<hr>
`;
  }
  list(t, n, i) {
    const r = n ? 'ol' : 'ul',
      o = n && i !== 1 ? ' start="' + i + '"' : '';
    return (
      '<' +
      r +
      o +
      `>
` +
      t +
      '</' +
      r +
      `>
`
    );
  }
  listitem(t) {
    return `<li>${t}</li>
`;
  }
  checkbox(t) {
    return (
      '<input ' + (t ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> '
    );
  }
  paragraph(t) {
    return `<p>${t}</p>
`;
  }
  table(t, n) {
    return (
      n && (n = `<tbody>${n}</tbody>`),
      `<table>
<thead>
` +
        t +
        `</thead>
` +
        n +
        `</table>
`
    );
  }
  tablerow(t) {
    return `<tr>
${t}</tr>
`;
  }
  tablecell(t, n) {
    const i = n.header ? 'th' : 'td';
    return (
      (n.align ? `<${i} align="${n.align}">` : `<${i}>`) +
      t +
      `</${i}>
`
    );
  }
  strong(t) {
    return `<strong>${t}</strong>`;
  }
  em(t) {
    return `<em>${t}</em>`;
  }
  codespan(t) {
    return `<code>${t}</code>`;
  }
  br() {
    return this.options.xhtml ? '<br/>' : '<br>';
  }
  del(t) {
    return `<del>${t}</del>`;
  }
  link(t, n, i) {
    if (((t = Gp(this.options.sanitize, this.options.baseUrl, t)), t === null)) return i;
    let r = '<a href="' + Le(t) + '"';
    return n && (r += ' title="' + n + '"'), (r += '>' + i + '</a>'), r;
  }
  image(t, n, i) {
    if (((t = Gp(this.options.sanitize, this.options.baseUrl, t)), t === null)) return i;
    let r = `<img src="${t}" alt="${i}"`;
    return n && (r += ` title="${n}"`), (r += this.options.xhtml ? '/>' : '>'), r;
  }
  text(t) {
    return t;
  }
}
class lg {
  strong(t) {
    return t;
  }
  em(t) {
    return t;
  }
  codespan(t) {
    return t;
  }
  del(t) {
    return t;
  }
  html(t) {
    return t;
  }
  text(t) {
    return t;
  }
  link(t, n, i) {
    return '' + i;
  }
  image(t, n, i) {
    return '' + i;
  }
  br() {
    return '';
  }
}
class cg {
  constructor() {
    this.seen = {};
  }
  serialize(t) {
    return t
      .toLowerCase()
      .trim()
      .replace(/<[!\/a-z].*?>/gi, '')
      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '')
      .replace(/\s/g, '-');
  }
  getNextSafeSlug(t, n) {
    let i = t,
      r = 0;
    if (this.seen.hasOwnProperty(i)) {
      r = this.seen[t];
      do r++, (i = t + '-' + r);
      while (this.seen.hasOwnProperty(i));
    }
    return n || ((this.seen[t] = r), (this.seen[i] = 0)), i;
  }
  slug(t, n = {}) {
    const i = this.serialize(t);
    return this.getNextSafeSlug(i, n.dryrun);
  }
}
class Yt {
  constructor(t) {
    (this.options = t || lr),
      (this.options.renderer = this.options.renderer || new Pu()),
      (this.renderer = this.options.renderer),
      (this.renderer.options = this.options),
      (this.textRenderer = new lg()),
      (this.slugger = new cg());
  }
  static parse(t, n) {
    return new Yt(n).parse(t);
  }
  static parseInline(t, n) {
    return new Yt(n).parseInline(t);
  }
  parse(t, n = !0) {
    let i = '',
      r,
      o,
      a,
      s,
      l,
      c,
      u,
      m,
      h,
      v,
      x,
      f,
      D,
      p,
      d,
      g,
      y,
      b,
      C;
    const R = t.length;
    for (r = 0; r < R; r++) {
      if (
        ((v = t[r]),
        this.options.extensions &&
          this.options.extensions.renderers &&
          this.options.extensions.renderers[v.type] &&
          ((C = this.options.extensions.renderers[v.type].call({ parser: this }, v)),
          C !== !1 ||
            !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(
              v.type,
            )))
      ) {
        i += C || '';
        continue;
      }
      switch (v.type) {
        case 'space':
          continue;
        case 'hr': {
          i += this.renderer.hr();
          continue;
        }
        case 'heading': {
          i += this.renderer.heading(
            this.parseInline(v.tokens),
            v.depth,
            ag(this.parseInline(v.tokens, this.textRenderer)),
            this.slugger,
          );
          continue;
        }
        case 'code': {
          i += this.renderer.code(v.text, v.lang, v.escaped);
          continue;
        }
        case 'table': {
          for (m = '', u = '', s = v.header.length, o = 0; o < s; o++)
            u += this.renderer.tablecell(this.parseInline(v.header[o].tokens), { header: !0, align: v.align[o] });
          for (m += this.renderer.tablerow(u), h = '', s = v.rows.length, o = 0; o < s; o++) {
            for (c = v.rows[o], u = '', l = c.length, a = 0; a < l; a++)
              u += this.renderer.tablecell(this.parseInline(c[a].tokens), { header: !1, align: v.align[a] });
            h += this.renderer.tablerow(u);
          }
          i += this.renderer.table(m, h);
          continue;
        }
        case 'blockquote': {
          (h = this.parse(v.tokens)), (i += this.renderer.blockquote(h));
          continue;
        }
        case 'list': {
          for (x = v.ordered, f = v.start, D = v.loose, s = v.items.length, h = '', o = 0; o < s; o++)
            (d = v.items[o]),
              (g = d.checked),
              (y = d.task),
              (p = ''),
              d.task &&
                ((b = this.renderer.checkbox(g)),
                D
                  ? d.tokens.length > 0 && d.tokens[0].type === 'paragraph'
                    ? ((d.tokens[0].text = b + ' ' + d.tokens[0].text),
                      d.tokens[0].tokens &&
                        d.tokens[0].tokens.length > 0 &&
                        d.tokens[0].tokens[0].type === 'text' &&
                        (d.tokens[0].tokens[0].text = b + ' ' + d.tokens[0].tokens[0].text))
                    : d.tokens.unshift({ type: 'text', text: b })
                  : (p += b)),
              (p += this.parse(d.tokens, D)),
              (h += this.renderer.listitem(p, y, g));
          i += this.renderer.list(h, x, f);
          continue;
        }
        case 'html': {
          i += this.renderer.html(v.text);
          continue;
        }
        case 'paragraph': {
          i += this.renderer.paragraph(this.parseInline(v.tokens));
          continue;
        }
        case 'text': {
          for (h = v.tokens ? this.parseInline(v.tokens) : v.text; r + 1 < R && t[r + 1].type === 'text'; )
            (v = t[++r]),
              (h +=
                `
` + (v.tokens ? this.parseInline(v.tokens) : v.text));
          i += n ? this.renderer.paragraph(h) : h;
          continue;
        }
        default: {
          const z = 'Token with "' + v.type + '" type was not found.';
          if (this.options.silent) {
            console.error(z);
            return;
          } else throw new Error(z);
        }
      }
    }
    return i;
  }
  parseInline(t, n) {
    n = n || this.renderer;
    let i = '',
      r,
      o,
      a;
    const s = t.length;
    for (r = 0; r < s; r++) {
      if (
        ((o = t[r]),
        this.options.extensions &&
          this.options.extensions.renderers &&
          this.options.extensions.renderers[o.type] &&
          ((a = this.options.extensions.renderers[o.type].call({ parser: this }, o)),
          a !== !1 ||
            !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(o.type)))
      ) {
        i += a || '';
        continue;
      }
      switch (o.type) {
        case 'escape': {
          i += n.text(o.text);
          break;
        }
        case 'html': {
          i += n.html(o.text);
          break;
        }
        case 'link': {
          i += n.link(o.href, o.title, this.parseInline(o.tokens, n));
          break;
        }
        case 'image': {
          i += n.image(o.href, o.title, o.text);
          break;
        }
        case 'strong': {
          i += n.strong(this.parseInline(o.tokens, n));
          break;
        }
        case 'em': {
          i += n.em(this.parseInline(o.tokens, n));
          break;
        }
        case 'codespan': {
          i += n.codespan(o.text);
          break;
        }
        case 'br': {
          i += n.br();
          break;
        }
        case 'del': {
          i += n.del(this.parseInline(o.tokens, n));
          break;
        }
        case 'text': {
          i += n.text(o.text);
          break;
        }
        default: {
          const l = 'Token with "' + o.type + '" type was not found.';
          if (this.options.silent) {
            console.error(l);
            return;
          } else throw new Error(l);
        }
      }
    }
    return i;
  }
}
function V(e, t, n) {
  if (typeof e > 'u' || e === null) throw new Error('marked(): input parameter is undefined or null');
  if (typeof e != 'string')
    throw new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(e) + ', string expected');
  if ((typeof t == 'function' && ((n = t), (t = null)), (t = Bt({}, V.defaults, t || {})), sg(t), n)) {
    const r = t.highlight;
    let o;
    try {
      o = gn.lex(e, t);
    } catch (l) {
      return n(l);
    }
    const a = function (l) {
      let c;
      if (!l)
        try {
          t.walkTokens && V.walkTokens(o, t.walkTokens), (c = Yt.parse(o, t));
        } catch (u) {
          l = u;
        }
      return (t.highlight = r), l ? n(l) : n(null, c);
    };
    if (!r || r.length < 3 || (delete t.highlight, !o.length)) return a();
    let s = 0;
    V.walkTokens(o, function (l) {
      l.type === 'code' &&
        (s++,
        setTimeout(() => {
          r(l.text, l.lang, function (c, u) {
            if (c) return a(c);
            u != null && u !== l.text && ((l.text = u), (l.escaped = !0)), s--, s === 0 && a();
          });
        }, 0));
    }),
      s === 0 && a();
    return;
  }
  function i(r) {
    if (
      ((r.message += `
Please report this to https://github.com/markedjs/marked.`),
      t.silent)
    )
      return '<p>An error occurred:</p><pre>' + Le(r.message + '', !0) + '</pre>';
    throw r;
  }
  try {
    const r = gn.lex(e, t);
    if (t.walkTokens) {
      if (t.async)
        return Promise.all(V.walkTokens(r, t.walkTokens))
          .then(() => Yt.parse(r, t))
          .catch(i);
      V.walkTokens(r, t.walkTokens);
    }
    return Yt.parse(r, t);
  } catch (r) {
    i(r);
  }
}
V.options = V.setOptions = function (e) {
  return Bt(V.defaults, e), eA(V.defaults), V;
};
V.getDefaults = og;
V.defaults = lr;
V.use = function (...e) {
  const t = Bt({}, ...e),
    n = V.defaults.extensions || { renderers: {}, childTokens: {} };
  let i;
  e.forEach((r) => {
    if (
      (r.extensions &&
        ((i = !0),
        r.extensions.forEach((o) => {
          if (!o.name) throw new Error('extension name required');
          if (o.renderer) {
            const a = n.renderers ? n.renderers[o.name] : null;
            a
              ? (n.renderers[o.name] = function (...s) {
                  let l = o.renderer.apply(this, s);
                  return l === !1 && (l = a.apply(this, s)), l;
                })
              : (n.renderers[o.name] = o.renderer);
          }
          if (o.tokenizer) {
            if (!o.level || (o.level !== 'block' && o.level !== 'inline'))
              throw new Error("extension level must be 'block' or 'inline'");
            n[o.level] ? n[o.level].unshift(o.tokenizer) : (n[o.level] = [o.tokenizer]),
              o.start &&
                (o.level === 'block'
                  ? n.startBlock
                    ? n.startBlock.push(o.start)
                    : (n.startBlock = [o.start])
                  : o.level === 'inline' &&
                    (n.startInline ? n.startInline.push(o.start) : (n.startInline = [o.start])));
          }
          o.childTokens && (n.childTokens[o.name] = o.childTokens);
        })),
      r.renderer)
    ) {
      const o = V.defaults.renderer || new Pu();
      for (const a in r.renderer) {
        const s = o[a];
        o[a] = (...l) => {
          let c = r.renderer[a].apply(o, l);
          return c === !1 && (c = s.apply(o, l)), c;
        };
      }
      t.renderer = o;
    }
    if (r.tokenizer) {
      const o = V.defaults.tokenizer || new Ru();
      for (const a in r.tokenizer) {
        const s = o[a];
        o[a] = (...l) => {
          let c = r.tokenizer[a].apply(o, l);
          return c === !1 && (c = s.apply(o, l)), c;
        };
      }
      t.tokenizer = o;
    }
    if (r.walkTokens) {
      const o = V.defaults.walkTokens;
      t.walkTokens = function (a) {
        let s = [];
        return s.push(r.walkTokens.call(this, a)), o && (s = s.concat(o.call(this, a))), s;
      };
    }
    i && (t.extensions = n), V.setOptions(t);
  });
};
V.walkTokens = function (e, t) {
  let n = [];
  for (const i of e)
    switch (((n = n.concat(t.call(V, i))), i.type)) {
      case 'table': {
        for (const r of i.header) n = n.concat(V.walkTokens(r.tokens, t));
        for (const r of i.rows) for (const o of r) n = n.concat(V.walkTokens(o.tokens, t));
        break;
      }
      case 'list': {
        n = n.concat(V.walkTokens(i.items, t));
        break;
      }
      default:
        V.defaults.extensions && V.defaults.extensions.childTokens && V.defaults.extensions.childTokens[i.type]
          ? V.defaults.extensions.childTokens[i.type].forEach(function (r) {
              n = n.concat(V.walkTokens(i[r], t));
            })
          : i.tokens && (n = n.concat(V.walkTokens(i.tokens, t)));
    }
  return n;
};
V.parseInline = function (e, t) {
  if (typeof e > 'u' || e === null) throw new Error('marked.parseInline(): input parameter is undefined or null');
  if (typeof e != 'string')
    throw new Error(
      'marked.parseInline(): input parameter is of type ' + Object.prototype.toString.call(e) + ', string expected',
    );
  (t = Bt({}, V.defaults, t || {})), sg(t);
  try {
    const n = gn.lexInline(e, t);
    return t.walkTokens && V.walkTokens(n, t.walkTokens), Yt.parseInline(n, t);
  } catch (n) {
    if (
      ((n.message += `
Please report this to https://github.com/markedjs/marked.`),
      t.silent)
    )
      return '<p>An error occurred:</p><pre>' + Le(n.message + '', !0) + '</pre>';
    throw n;
  }
};
V.Parser = Yt;
V.parser = Yt.parse;
V.Renderer = Pu;
V.TextRenderer = lg;
V.Lexer = gn;
V.lexer = gn.lex;
V.Tokenizer = Ru;
V.Slugger = cg;
V.parse = V;
V.options;
V.setOptions;
V.use;
V.walkTokens;
V.parseInline;
Yt.parse;
gn.lex;
var ul = { exports: {} };
/*! @license DOMPurify 2.4.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.0/LICENSE */ var Wp;
function Kp() {
  return (
    Wp ||
      ((Wp = 1),
      (function (e, t) {
        (function (n, i) {
          e.exports = i();
        })(bg, function () {
          function n(A) {
            return (
              (n =
                typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol'
                  ? function (k) {
                      return typeof k;
                    }
                  : function (k) {
                      return k && typeof Symbol == 'function' && k.constructor === Symbol && k !== Symbol.prototype
                        ? 'symbol'
                        : typeof k;
                    }),
              n(A)
            );
          }
          function i(A, k) {
            return (
              (i =
                Object.setPrototypeOf ||
                function (L, G) {
                  return (L.__proto__ = G), L;
                }),
              i(A, k)
            );
          }
          function r() {
            if (typeof Reflect > 'u' || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == 'function') return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch {
              return !1;
            }
          }
          function o(A, k, N) {
            return (
              r()
                ? (o = Reflect.construct)
                : (o = function (G, ne, ce) {
                    var Je = [null];
                    Je.push.apply(Je, ne);
                    var Ie = Function.bind.apply(G, Je),
                      ct = new Ie();
                    return ce && i(ct, ce.prototype), ct;
                  }),
              o.apply(null, arguments)
            );
          }
          function a(A) {
            return s(A) || l(A) || c(A) || m();
          }
          function s(A) {
            if (Array.isArray(A)) return u(A);
          }
          function l(A) {
            if ((typeof Symbol < 'u' && A[Symbol.iterator] != null) || A['@@iterator'] != null) return Array.from(A);
          }
          function c(A, k) {
            if (A) {
              if (typeof A == 'string') return u(A, k);
              var N = Object.prototype.toString.call(A).slice(8, -1);
              if ((N === 'Object' && A.constructor && (N = A.constructor.name), N === 'Map' || N === 'Set'))
                return Array.from(A);
              if (N === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(N)) return u(A, k);
            }
          }
          function u(A, k) {
            (k == null || k > A.length) && (k = A.length);
            for (var N = 0, L = new Array(k); N < k; N++) L[N] = A[N];
            return L;
          }
          function m() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          var h = Object.hasOwnProperty,
            v = Object.setPrototypeOf,
            x = Object.isFrozen,
            f = Object.getPrototypeOf,
            D = Object.getOwnPropertyDescriptor,
            p = Object.freeze,
            d = Object.seal,
            g = Object.create,
            y = typeof Reflect < 'u' && Reflect,
            b = y.apply,
            C = y.construct;
          b ||
            (b = function (k, N, L) {
              return k.apply(N, L);
            }),
            p ||
              (p = function (k) {
                return k;
              }),
            d ||
              (d = function (k) {
                return k;
              }),
            C ||
              (C = function (k, N) {
                return o(k, a(N));
              });
          var R = re(Array.prototype.forEach),
            z = re(Array.prototype.pop),
            Y = re(Array.prototype.push),
            W = re(String.prototype.toLowerCase),
            Ne = re(String.prototype.match),
            Ae = re(String.prototype.replace),
            nt = re(String.prototype.indexOf),
            fi = re(String.prototype.trim),
            Te = re(RegExp.prototype.test),
            tn = O(TypeError);
          function re(A) {
            return function (k) {
              for (var N = arguments.length, L = new Array(N > 1 ? N - 1 : 0), G = 1; G < N; G++)
                L[G - 1] = arguments[G];
              return b(A, k, L);
            };
          }
          function O(A) {
            return function () {
              for (var k = arguments.length, N = new Array(k), L = 0; L < k; L++) N[L] = arguments[L];
              return C(A, N);
            };
          }
          function P(A, k, N) {
            (N = N || W), v && v(A, null);
            for (var L = k.length; L--; ) {
              var G = k[L];
              if (typeof G == 'string') {
                var ne = N(G);
                ne !== G && (x(k) || (k[L] = ne), (G = ne));
              }
              A[G] = !0;
            }
            return A;
          }
          function q(A) {
            var k = g(null),
              N;
            for (N in A) b(h, A, [N]) && (k[N] = A[N]);
            return k;
          }
          function ee(A, k) {
            for (; A !== null; ) {
              var N = D(A, k);
              if (N) {
                if (N.get) return re(N.get);
                if (typeof N.value == 'function') return re(N.value);
              }
              A = f(A);
            }
            function L(G) {
              return console.warn('fallback value for', G), null;
            }
            return L;
          }
          var ve = p([
              'a',
              'abbr',
              'acronym',
              'address',
              'area',
              'article',
              'aside',
              'audio',
              'b',
              'bdi',
              'bdo',
              'big',
              'blink',
              'blockquote',
              'body',
              'br',
              'button',
              'canvas',
              'caption',
              'center',
              'cite',
              'code',
              'col',
              'colgroup',
              'content',
              'data',
              'datalist',
              'dd',
              'decorator',
              'del',
              'details',
              'dfn',
              'dialog',
              'dir',
              'div',
              'dl',
              'dt',
              'element',
              'em',
              'fieldset',
              'figcaption',
              'figure',
              'font',
              'footer',
              'form',
              'h1',
              'h2',
              'h3',
              'h4',
              'h5',
              'h6',
              'head',
              'header',
              'hgroup',
              'hr',
              'html',
              'i',
              'img',
              'input',
              'ins',
              'kbd',
              'label',
              'legend',
              'li',
              'main',
              'map',
              'mark',
              'marquee',
              'menu',
              'menuitem',
              'meter',
              'nav',
              'nobr',
              'ol',
              'optgroup',
              'option',
              'output',
              'p',
              'picture',
              'pre',
              'progress',
              'q',
              'rp',
              'rt',
              'ruby',
              's',
              'samp',
              'section',
              'select',
              'shadow',
              'small',
              'source',
              'spacer',
              'span',
              'strike',
              'strong',
              'style',
              'sub',
              'summary',
              'sup',
              'table',
              'tbody',
              'td',
              'template',
              'textarea',
              'tfoot',
              'th',
              'thead',
              'time',
              'tr',
              'track',
              'tt',
              'u',
              'ul',
              'var',
              'video',
              'wbr',
            ]),
            Ut = p([
              'svg',
              'a',
              'altglyph',
              'altglyphdef',
              'altglyphitem',
              'animatecolor',
              'animatemotion',
              'animatetransform',
              'circle',
              'clippath',
              'defs',
              'desc',
              'ellipse',
              'filter',
              'font',
              'g',
              'glyph',
              'glyphref',
              'hkern',
              'image',
              'line',
              'lineargradient',
              'marker',
              'mask',
              'metadata',
              'mpath',
              'path',
              'pattern',
              'polygon',
              'polyline',
              'radialgradient',
              'rect',
              'stop',
              'style',
              'switch',
              'symbol',
              'text',
              'textpath',
              'title',
              'tref',
              'tspan',
              'view',
              'vkern',
            ]),
            lt = p([
              'feBlend',
              'feColorMatrix',
              'feComponentTransfer',
              'feComposite',
              'feConvolveMatrix',
              'feDiffuseLighting',
              'feDisplacementMap',
              'feDistantLight',
              'feFlood',
              'feFuncA',
              'feFuncB',
              'feFuncG',
              'feFuncR',
              'feGaussianBlur',
              'feImage',
              'feMerge',
              'feMergeNode',
              'feMorphology',
              'feOffset',
              'fePointLight',
              'feSpecularLighting',
              'feSpotLight',
              'feTile',
              'feTurbulence',
            ]),
            Jn = p([
              'animate',
              'color-profile',
              'cursor',
              'discard',
              'fedropshadow',
              'font-face',
              'font-face-format',
              'font-face-name',
              'font-face-src',
              'font-face-uri',
              'foreignobject',
              'hatch',
              'hatchpath',
              'mesh',
              'meshgradient',
              'meshpatch',
              'meshrow',
              'missing-glyph',
              'script',
              'set',
              'solidcolor',
              'unknown',
              'use',
            ]),
            vt = p([
              'math',
              'menclose',
              'merror',
              'mfenced',
              'mfrac',
              'mglyph',
              'mi',
              'mlabeledtr',
              'mmultiscripts',
              'mn',
              'mo',
              'mover',
              'mpadded',
              'mphantom',
              'mroot',
              'mrow',
              'ms',
              'mspace',
              'msqrt',
              'mstyle',
              'msub',
              'msup',
              'msubsup',
              'mtable',
              'mtd',
              'mtext',
              'mtr',
              'munder',
              'munderover',
            ]),
            _n = p([
              'maction',
              'maligngroup',
              'malignmark',
              'mlongdiv',
              'mscarries',
              'mscarry',
              'msgroup',
              'mstack',
              'msline',
              'msrow',
              'semantics',
              'annotation',
              'annotation-xml',
              'mprescripts',
              'none',
            ]),
            xn = p(['#text']),
            cr = p([
              'accept',
              'action',
              'align',
              'alt',
              'autocapitalize',
              'autocomplete',
              'autopictureinpicture',
              'autoplay',
              'background',
              'bgcolor',
              'border',
              'capture',
              'cellpadding',
              'cellspacing',
              'checked',
              'cite',
              'class',
              'clear',
              'color',
              'cols',
              'colspan',
              'controls',
              'controlslist',
              'coords',
              'crossorigin',
              'datetime',
              'decoding',
              'default',
              'dir',
              'disabled',
              'disablepictureinpicture',
              'disableremoteplayback',
              'download',
              'draggable',
              'enctype',
              'enterkeyhint',
              'face',
              'for',
              'headers',
              'height',
              'hidden',
              'high',
              'href',
              'hreflang',
              'id',
              'inputmode',
              'integrity',
              'ismap',
              'kind',
              'label',
              'lang',
              'list',
              'loading',
              'loop',
              'low',
              'max',
              'maxlength',
              'media',
              'method',
              'min',
              'minlength',
              'multiple',
              'muted',
              'name',
              'nonce',
              'noshade',
              'novalidate',
              'nowrap',
              'open',
              'optimum',
              'pattern',
              'placeholder',
              'playsinline',
              'poster',
              'preload',
              'pubdate',
              'radiogroup',
              'readonly',
              'rel',
              'required',
              'rev',
              'reversed',
              'role',
              'rows',
              'rowspan',
              'spellcheck',
              'scope',
              'selected',
              'shape',
              'size',
              'sizes',
              'span',
              'srclang',
              'start',
              'src',
              'srcset',
              'step',
              'style',
              'summary',
              'tabindex',
              'title',
              'translate',
              'type',
              'usemap',
              'valign',
              'value',
              'width',
              'xmlns',
              'slot',
            ]),
            Vn = p([
              'accent-height',
              'accumulate',
              'additive',
              'alignment-baseline',
              'ascent',
              'attributename',
              'attributetype',
              'azimuth',
              'basefrequency',
              'baseline-shift',
              'begin',
              'bias',
              'by',
              'class',
              'clip',
              'clippathunits',
              'clip-path',
              'clip-rule',
              'color',
              'color-interpolation',
              'color-interpolation-filters',
              'color-profile',
              'color-rendering',
              'cx',
              'cy',
              'd',
              'dx',
              'dy',
              'diffuseconstant',
              'direction',
              'display',
              'divisor',
              'dur',
              'edgemode',
              'elevation',
              'end',
              'fill',
              'fill-opacity',
              'fill-rule',
              'filter',
              'filterunits',
              'flood-color',
              'flood-opacity',
              'font-family',
              'font-size',
              'font-size-adjust',
              'font-stretch',
              'font-style',
              'font-variant',
              'font-weight',
              'fx',
              'fy',
              'g1',
              'g2',
              'glyph-name',
              'glyphref',
              'gradientunits',
              'gradienttransform',
              'height',
              'href',
              'id',
              'image-rendering',
              'in',
              'in2',
              'k',
              'k1',
              'k2',
              'k3',
              'k4',
              'kerning',
              'keypoints',
              'keysplines',
              'keytimes',
              'lang',
              'lengthadjust',
              'letter-spacing',
              'kernelmatrix',
              'kernelunitlength',
              'lighting-color',
              'local',
              'marker-end',
              'marker-mid',
              'marker-start',
              'markerheight',
              'markerunits',
              'markerwidth',
              'maskcontentunits',
              'maskunits',
              'max',
              'mask',
              'media',
              'method',
              'mode',
              'min',
              'name',
              'numoctaves',
              'offset',
              'operator',
              'opacity',
              'order',
              'orient',
              'orientation',
              'origin',
              'overflow',
              'paint-order',
              'path',
              'pathlength',
              'patterncontentunits',
              'patterntransform',
              'patternunits',
              'points',
              'preservealpha',
              'preserveaspectratio',
              'primitiveunits',
              'r',
              'rx',
              'ry',
              'radius',
              'refx',
              'refy',
              'repeatcount',
              'repeatdur',
              'restart',
              'result',
              'rotate',
              'scale',
              'seed',
              'shape-rendering',
              'specularconstant',
              'specularexponent',
              'spreadmethod',
              'startoffset',
              'stddeviation',
              'stitchtiles',
              'stop-color',
              'stop-opacity',
              'stroke-dasharray',
              'stroke-dashoffset',
              'stroke-linecap',
              'stroke-linejoin',
              'stroke-miterlimit',
              'stroke-opacity',
              'stroke',
              'stroke-width',
              'style',
              'surfacescale',
              'systemlanguage',
              'tabindex',
              'targetx',
              'targety',
              'transform',
              'transform-origin',
              'text-anchor',
              'text-decoration',
              'text-rendering',
              'textlength',
              'type',
              'u1',
              'u2',
              'unicode',
              'values',
              'viewbox',
              'visibility',
              'version',
              'vert-adv-y',
              'vert-origin-x',
              'vert-origin-y',
              'width',
              'word-spacing',
              'wrap',
              'writing-mode',
              'xchannelselector',
              'ychannelselector',
              'x',
              'x1',
              'x2',
              'xmlns',
              'y',
              'y1',
              'y2',
              'z',
              'zoomandpan',
            ]),
            gi = p([
              'accent',
              'accentunder',
              'align',
              'bevelled',
              'close',
              'columnsalign',
              'columnlines',
              'columnspan',
              'denomalign',
              'depth',
              'dir',
              'display',
              'displaystyle',
              'encoding',
              'fence',
              'frame',
              'height',
              'href',
              'id',
              'largeop',
              'length',
              'linethickness',
              'lspace',
              'lquote',
              'mathbackground',
              'mathcolor',
              'mathsize',
              'mathvariant',
              'maxsize',
              'minsize',
              'movablelimits',
              'notation',
              'numalign',
              'open',
              'rowalign',
              'rowlines',
              'rowspacing',
              'rowspan',
              'rspace',
              'rquote',
              'scriptlevel',
              'scriptminsize',
              'scriptsizemultiplier',
              'selection',
              'separator',
              'separators',
              'stretchy',
              'subscriptshift',
              'supscriptshift',
              'symmetric',
              'voffset',
              'width',
              'xmlns',
            ]),
            En = p(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']),
            vi = d(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
            fo = d(/<%[\w\W]*|[\w\W]*%>/gm),
            cs = d(/^data-[\-\w.\u00B7-\uFFFF]/),
            go = d(/^aria-[\-\w]+$/),
            ur = d(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
            us = d(/^(?:\w+script|data):/i),
            ds = d(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
            vo = d(/^html$/i),
            w = function () {
              return typeof window > 'u' ? null : window;
            },
            M = function (k, N) {
              if (n(k) !== 'object' || typeof k.createPolicy != 'function') return null;
              var L = null,
                G = 'data-tt-policy-suffix';
              N.currentScript && N.currentScript.hasAttribute(G) && (L = N.currentScript.getAttribute(G));
              var ne = 'dompurify' + (L ? '#' + L : '');
              try {
                return k.createPolicy(ne, {
                  createHTML: function (Je) {
                    return Je;
                  },
                  createScriptURL: function (Je) {
                    return Je;
                  },
                });
              } catch {
                return console.warn('TrustedTypes policy ' + ne + ' could not be created.'), null;
              }
            };
          function I() {
            var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : w(),
              k = function (_) {
                return I(_);
              };
            if (((k.version = '2.4.0'), (k.removed = []), !A || !A.document || A.document.nodeType !== 9))
              return (k.isSupported = !1), k;
            var N = A.document,
              L = A.document,
              G = A.DocumentFragment,
              ne = A.HTMLTemplateElement,
              ce = A.Node,
              Je = A.Element,
              Ie = A.NodeFilter,
              ct = A.NamedNodeMap,
              nn = ct === void 0 ? A.NamedNodeMap || A.MozNamedAttrMap : ct,
              _i = A.HTMLFormElement,
              yn = A.DOMParser,
              An = A.trustedTypes,
              we = Je.prototype,
              Ve = ee(we, 'cloneNode'),
              $t = ee(we, 'nextSibling'),
              xi = ee(we, 'childNodes'),
              Ei = ee(we, 'parentNode');
            if (typeof ne == 'function') {
              var dr = L.createElement('template');
              dr.content && dr.content.ownerDocument && (L = dr.content.ownerDocument);
            }
            var _t = M(An, N),
              pr = _t ? _t.createHTML('') : '',
              qe = L,
              bt = qe.implementation,
              hr = qe.createNodeIterator,
              ps = qe.createDocumentFragment,
              ug = qe.getElementsByTagName,
              dg = N.importNode,
              Cu = {};
            try {
              Cu = q(L).documentMode ? L.documentMode : {};
            } catch {}
            var Gt = {};
            k.isSupported = typeof Ei == 'function' && bt && typeof bt.createHTMLDocument < 'u' && Cu !== 9;
            var hs = vi,
              ms = fo,
              pg = cs,
              hg = go,
              mg = us,
              Nu = ds,
              fs = ur,
              De = null,
              Iu = P({}, [].concat(a(ve), a(Ut), a(lt), a(vt), a(xn))),
              ze = null,
              Du = P({}, [].concat(a(cr), a(Vn), a(gi), a(En))),
              Se = Object.seal(
                Object.create(null, {
                  tagNameCheck: { writable: !0, configurable: !1, enumerable: !0, value: null },
                  attributeNameCheck: { writable: !0, configurable: !1, enumerable: !0, value: null },
                  allowCustomizedBuiltInElements: { writable: !0, configurable: !1, enumerable: !0, value: !1 },
                }),
              ),
              mr = null,
              gs = null,
              Ou = !0,
              vs = !0,
              Lu = !1,
              yi = !1,
              qn = !1,
              _s = !1,
              xs = !1,
              Ai = !1,
              _o = !1,
              xo = !1,
              Hu = !0,
              Fu = !1,
              fg = 'user-content-',
              Es = !0,
              fr = !1,
              wi = {},
              ki = null,
              ju = P({}, [
                'annotation-xml',
                'audio',
                'colgroup',
                'desc',
                'foreignobject',
                'head',
                'iframe',
                'math',
                'mi',
                'mn',
                'mo',
                'ms',
                'mtext',
                'noembed',
                'noframes',
                'noscript',
                'plaintext',
                'script',
                'style',
                'svg',
                'template',
                'thead',
                'title',
                'video',
                'xmp',
              ]),
              zu = null,
              Bu = P({}, ['audio', 'video', 'img', 'source', 'image', 'track']),
              ys = null,
              Uu = P({}, [
                'alt',
                'class',
                'for',
                'id',
                'label',
                'name',
                'pattern',
                'placeholder',
                'role',
                'summary',
                'title',
                'value',
                'style',
                'xmlns',
              ]),
              As = 'http://www.w3.org/1998/Math/MathML',
              ws = 'http://www.w3.org/2000/svg',
              wn = 'http://www.w3.org/1999/xhtml',
              Eo = wn,
              ks = !1,
              Si,
              gg = ['application/xhtml+xml', 'text/html'],
              vg = 'text/html',
              Oe,
              bi = null,
              _g = L.createElement('form'),
              $u = function (_) {
                return _ instanceof RegExp || _ instanceof Function;
              },
              Ss = function (_) {
                (bi && bi === _) ||
                  ((!_ || n(_) !== 'object') && (_ = {}),
                  (_ = q(_)),
                  (Si = gg.indexOf(_.PARSER_MEDIA_TYPE) === -1 ? (Si = vg) : (Si = _.PARSER_MEDIA_TYPE)),
                  (Oe =
                    Si === 'application/xhtml+xml'
                      ? function (T) {
                          return T;
                        }
                      : W),
                  (De = 'ALLOWED_TAGS' in _ ? P({}, _.ALLOWED_TAGS, Oe) : Iu),
                  (ze = 'ALLOWED_ATTR' in _ ? P({}, _.ALLOWED_ATTR, Oe) : Du),
                  (ys = 'ADD_URI_SAFE_ATTR' in _ ? P(q(Uu), _.ADD_URI_SAFE_ATTR, Oe) : Uu),
                  (zu = 'ADD_DATA_URI_TAGS' in _ ? P(q(Bu), _.ADD_DATA_URI_TAGS, Oe) : Bu),
                  (ki = 'FORBID_CONTENTS' in _ ? P({}, _.FORBID_CONTENTS, Oe) : ju),
                  (mr = 'FORBID_TAGS' in _ ? P({}, _.FORBID_TAGS, Oe) : {}),
                  (gs = 'FORBID_ATTR' in _ ? P({}, _.FORBID_ATTR, Oe) : {}),
                  (wi = 'USE_PROFILES' in _ ? _.USE_PROFILES : !1),
                  (Ou = _.ALLOW_ARIA_ATTR !== !1),
                  (vs = _.ALLOW_DATA_ATTR !== !1),
                  (Lu = _.ALLOW_UNKNOWN_PROTOCOLS || !1),
                  (yi = _.SAFE_FOR_TEMPLATES || !1),
                  (qn = _.WHOLE_DOCUMENT || !1),
                  (Ai = _.RETURN_DOM || !1),
                  (_o = _.RETURN_DOM_FRAGMENT || !1),
                  (xo = _.RETURN_TRUSTED_TYPE || !1),
                  (xs = _.FORCE_BODY || !1),
                  (Hu = _.SANITIZE_DOM !== !1),
                  (Fu = _.SANITIZE_NAMED_PROPS || !1),
                  (Es = _.KEEP_CONTENT !== !1),
                  (fr = _.IN_PLACE || !1),
                  (fs = _.ALLOWED_URI_REGEXP || fs),
                  (Eo = _.NAMESPACE || wn),
                  _.CUSTOM_ELEMENT_HANDLING &&
                    $u(_.CUSTOM_ELEMENT_HANDLING.tagNameCheck) &&
                    (Se.tagNameCheck = _.CUSTOM_ELEMENT_HANDLING.tagNameCheck),
                  _.CUSTOM_ELEMENT_HANDLING &&
                    $u(_.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) &&
                    (Se.attributeNameCheck = _.CUSTOM_ELEMENT_HANDLING.attributeNameCheck),
                  _.CUSTOM_ELEMENT_HANDLING &&
                    typeof _.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == 'boolean' &&
                    (Se.allowCustomizedBuiltInElements = _.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements),
                  yi && (vs = !1),
                  _o && (Ai = !0),
                  wi &&
                    ((De = P({}, a(xn))),
                    (ze = []),
                    wi.html === !0 && (P(De, ve), P(ze, cr)),
                    wi.svg === !0 && (P(De, Ut), P(ze, Vn), P(ze, En)),
                    wi.svgFilters === !0 && (P(De, lt), P(ze, Vn), P(ze, En)),
                    wi.mathMl === !0 && (P(De, vt), P(ze, gi), P(ze, En))),
                  _.ADD_TAGS && (De === Iu && (De = q(De)), P(De, _.ADD_TAGS, Oe)),
                  _.ADD_ATTR && (ze === Du && (ze = q(ze)), P(ze, _.ADD_ATTR, Oe)),
                  _.ADD_URI_SAFE_ATTR && P(ys, _.ADD_URI_SAFE_ATTR, Oe),
                  _.FORBID_CONTENTS && (ki === ju && (ki = q(ki)), P(ki, _.FORBID_CONTENTS, Oe)),
                  Es && (De['#text'] = !0),
                  qn && P(De, ['html', 'head', 'body']),
                  De.table && (P(De, ['tbody']), delete mr.tbody),
                  p && p(_),
                  (bi = _));
              },
              Gu = P({}, ['mi', 'mo', 'mn', 'ms', 'mtext']),
              Ju = P({}, ['foreignobject', 'desc', 'title', 'annotation-xml']),
              xg = P({}, ['title', 'style', 'font', 'a', 'script']),
              yo = P({}, Ut);
            P(yo, lt), P(yo, Jn);
            var bs = P({}, vt);
            P(bs, _n);
            var Eg = function (_) {
                var T = Ei(_);
                (!T || !T.tagName) && (T = { namespaceURI: wn, tagName: 'template' });
                var H = W(_.tagName),
                  ie = W(T.tagName);
                return _.namespaceURI === ws
                  ? T.namespaceURI === wn
                    ? H === 'svg'
                    : T.namespaceURI === As
                      ? H === 'svg' && (ie === 'annotation-xml' || Gu[ie])
                      : Boolean(yo[H])
                  : _.namespaceURI === As
                    ? T.namespaceURI === wn
                      ? H === 'math'
                      : T.namespaceURI === ws
                        ? H === 'math' && Ju[ie]
                        : Boolean(bs[H])
                    : _.namespaceURI === wn
                      ? (T.namespaceURI === ws && !Ju[ie]) || (T.namespaceURI === As && !Gu[ie])
                        ? !1
                        : !bs[H] && (xg[H] || !yo[H])
                      : !1;
              },
              rn = function (_) {
                Y(k.removed, { element: _ });
                try {
                  _.parentNode.removeChild(_);
                } catch {
                  try {
                    _.outerHTML = pr;
                  } catch {
                    _.remove();
                  }
                }
              },
              Ms = function (_, T) {
                try {
                  Y(k.removed, { attribute: T.getAttributeNode(_), from: T });
                } catch {
                  Y(k.removed, { attribute: null, from: T });
                }
                if ((T.removeAttribute(_), _ === 'is' && !ze[_]))
                  if (Ai || _o)
                    try {
                      rn(T);
                    } catch {}
                  else
                    try {
                      T.setAttribute(_, '');
                    } catch {}
              },
              Vu = function (_) {
                var T, H;
                if (xs) _ = '<remove></remove>' + _;
                else {
                  var ie = Ne(_, /^[\r\n\t ]+/);
                  H = ie && ie[0];
                }
                Si === 'application/xhtml+xml' &&
                  (_ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + _ + '</body></html>');
                var ut = _t ? _t.createHTML(_) : _;
                if (Eo === wn)
                  try {
                    T = new yn().parseFromString(ut, Si);
                  } catch {}
                if (!T || !T.documentElement) {
                  T = bt.createDocument(Eo, 'template', null);
                  try {
                    T.documentElement.innerHTML = ks ? '' : ut;
                  } catch {}
                }
                var Qe = T.body || T.documentElement;
                return (
                  _ && H && Qe.insertBefore(L.createTextNode(H), Qe.childNodes[0] || null),
                  Eo === wn ? ug.call(T, qn ? 'html' : 'body')[0] : qn ? T.documentElement : Qe
                );
              },
              qu = function (_) {
                return hr.call(_.ownerDocument || _, _, Ie.SHOW_ELEMENT | Ie.SHOW_COMMENT | Ie.SHOW_TEXT, null, !1);
              },
              yg = function (_) {
                return (
                  _ instanceof _i &&
                  (typeof _.nodeName != 'string' ||
                    typeof _.textContent != 'string' ||
                    typeof _.removeChild != 'function' ||
                    !(_.attributes instanceof nn) ||
                    typeof _.removeAttribute != 'function' ||
                    typeof _.setAttribute != 'function' ||
                    typeof _.namespaceURI != 'string' ||
                    typeof _.insertBefore != 'function')
                );
              },
              gr = function (_) {
                return n(ce) === 'object'
                  ? _ instanceof ce
                  : _ && n(_) === 'object' && typeof _.nodeType == 'number' && typeof _.nodeName == 'string';
              },
              on = function (_, T, H) {
                !Gt[_] ||
                  R(Gt[_], function (ie) {
                    ie.call(k, T, H, bi);
                  });
              },
              Qu = function (_) {
                var T;
                if ((on('beforeSanitizeElements', _, null), yg(_) || Te(/[\u0080-\uFFFF]/, _.nodeName)))
                  return rn(_), !0;
                var H = Oe(_.nodeName);
                if (
                  (on('uponSanitizeElement', _, { tagName: H, allowedTags: De }),
                  (_.hasChildNodes() &&
                    !gr(_.firstElementChild) &&
                    (!gr(_.content) || !gr(_.content.firstElementChild)) &&
                    Te(/<[/\w]/g, _.innerHTML) &&
                    Te(/<[/\w]/g, _.textContent)) ||
                    (H === 'select' && Te(/<template/i, _.innerHTML)))
                )
                  return rn(_), !0;
                if (!De[H] || mr[H]) {
                  if (
                    !mr[H] &&
                    Ku(H) &&
                    ((Se.tagNameCheck instanceof RegExp && Te(Se.tagNameCheck, H)) ||
                      (Se.tagNameCheck instanceof Function && Se.tagNameCheck(H)))
                  )
                    return !1;
                  if (Es && !ki[H]) {
                    var ie = Ei(_) || _.parentNode,
                      ut = xi(_) || _.childNodes;
                    if (ut && ie)
                      for (var Qe = ut.length, Be = Qe - 1; Be >= 0; --Be) ie.insertBefore(Ve(ut[Be], !0), $t(_));
                  }
                  return rn(_), !0;
                }
                return (_ instanceof Je && !Eg(_)) ||
                  ((H === 'noscript' || H === 'noembed') && Te(/<\/no(script|embed)/i, _.innerHTML))
                  ? (rn(_), !0)
                  : (yi &&
                      _.nodeType === 3 &&
                      ((T = _.textContent),
                      (T = Ae(T, hs, ' ')),
                      (T = Ae(T, ms, ' ')),
                      _.textContent !== T && (Y(k.removed, { element: _.cloneNode() }), (_.textContent = T))),
                    on('afterSanitizeElements', _, null),
                    !1);
              },
              Wu = function (_, T, H) {
                if (Hu && (T === 'id' || T === 'name') && (H in L || H in _g)) return !1;
                if (!(vs && !gs[T] && Te(pg, T))) {
                  if (!(Ou && Te(hg, T))) {
                    if (!ze[T] || gs[T]) {
                      if (
                        !(
                          (Ku(_) &&
                            ((Se.tagNameCheck instanceof RegExp && Te(Se.tagNameCheck, _)) ||
                              (Se.tagNameCheck instanceof Function && Se.tagNameCheck(_))) &&
                            ((Se.attributeNameCheck instanceof RegExp && Te(Se.attributeNameCheck, T)) ||
                              (Se.attributeNameCheck instanceof Function && Se.attributeNameCheck(T)))) ||
                          (T === 'is' &&
                            Se.allowCustomizedBuiltInElements &&
                            ((Se.tagNameCheck instanceof RegExp && Te(Se.tagNameCheck, H)) ||
                              (Se.tagNameCheck instanceof Function && Se.tagNameCheck(H))))
                        )
                      )
                        return !1;
                    } else if (!ys[T]) {
                      if (!Te(fs, Ae(H, Nu, ''))) {
                        if (
                          !(
                            (T === 'src' || T === 'xlink:href' || T === 'href') &&
                            _ !== 'script' &&
                            nt(H, 'data:') === 0 &&
                            zu[_]
                          )
                        ) {
                          if (!(Lu && !Te(mg, Ae(H, Nu, '')))) {
                            if (H) return !1;
                          }
                        }
                      }
                    }
                  }
                }
                return !0;
              },
              Ku = function (_) {
                return _.indexOf('-') > 0;
              },
              Xu = function (_) {
                var T, H, ie, ut;
                on('beforeSanitizeAttributes', _, null);
                var Qe = _.attributes;
                if (Qe) {
                  var Be = { attrName: '', attrValue: '', keepAttr: !0, allowedAttributes: ze };
                  for (ut = Qe.length; ut--; ) {
                    T = Qe[ut];
                    var Ao = T,
                      We = Ao.name,
                      Ts = Ao.namespaceURI;
                    if (
                      ((H = We === 'value' ? T.value : fi(T.value)),
                      (ie = Oe(We)),
                      (Be.attrName = ie),
                      (Be.attrValue = H),
                      (Be.keepAttr = !0),
                      (Be.forceKeepAttr = void 0),
                      on('uponSanitizeAttribute', _, Be),
                      (H = Be.attrValue),
                      !Be.forceKeepAttr && (Ms(We, _), !!Be.keepAttr))
                    ) {
                      if (Te(/\/>/i, H)) {
                        Ms(We, _);
                        continue;
                      }
                      yi && ((H = Ae(H, hs, ' ')), (H = Ae(H, ms, ' ')));
                      var Zu = Oe(_.nodeName);
                      if (Wu(Zu, ie, H)) {
                        if (
                          (Fu && (ie === 'id' || ie === 'name') && (Ms(We, _), (H = fg + H)),
                          _t && n(An) === 'object' && typeof An.getAttributeType == 'function' && !Ts)
                        )
                          switch (An.getAttributeType(Zu, ie)) {
                            case 'TrustedHTML':
                              H = _t.createHTML(H);
                              break;
                            case 'TrustedScriptURL':
                              H = _t.createScriptURL(H);
                              break;
                          }
                        try {
                          Ts ? _.setAttributeNS(Ts, We, H) : _.setAttribute(We, H), z(k.removed);
                        } catch {}
                      }
                    }
                  }
                  on('afterSanitizeAttributes', _, null);
                }
              },
              Ag = function U(_) {
                var T,
                  H = qu(_);
                for (on('beforeSanitizeShadowDOM', _, null); (T = H.nextNode()); )
                  on('uponSanitizeShadowNode', T, null), !Qu(T) && (T.content instanceof G && U(T.content), Xu(T));
                on('afterSanitizeShadowDOM', _, null);
              };
            return (
              (k.sanitize = function (U) {
                var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
                  T,
                  H,
                  ie,
                  ut,
                  Qe;
                if (((ks = !U), ks && (U = '<!-->'), typeof U != 'string' && !gr(U))) {
                  if (typeof U.toString != 'function') throw tn('toString is not a function');
                  if (((U = U.toString()), typeof U != 'string')) throw tn('dirty is not a string, aborting');
                }
                if (!k.isSupported) {
                  if (n(A.toStaticHTML) === 'object' || typeof A.toStaticHTML == 'function') {
                    if (typeof U == 'string') return A.toStaticHTML(U);
                    if (gr(U)) return A.toStaticHTML(U.outerHTML);
                  }
                  return U;
                }
                if ((_s || Ss(_), (k.removed = []), typeof U == 'string' && (fr = !1), fr)) {
                  if (U.nodeName) {
                    var Be = Oe(U.nodeName);
                    if (!De[Be] || mr[Be]) throw tn('root node is forbidden and cannot be sanitized in-place');
                  }
                } else if (U instanceof ce)
                  (T = Vu('<!---->')),
                    (H = T.ownerDocument.importNode(U, !0)),
                    (H.nodeType === 1 && H.nodeName === 'BODY') || H.nodeName === 'HTML' ? (T = H) : T.appendChild(H);
                else {
                  if (!Ai && !yi && !qn && U.indexOf('<') === -1) return _t && xo ? _t.createHTML(U) : U;
                  if (((T = Vu(U)), !T)) return Ai ? null : xo ? pr : '';
                }
                T && xs && rn(T.firstChild);
                for (var Ao = qu(fr ? U : T); (ie = Ao.nextNode()); )
                  (ie.nodeType === 3 && ie === ut) ||
                    Qu(ie) ||
                    (ie.content instanceof G && Ag(ie.content), Xu(ie), (ut = ie));
                if (((ut = null), fr)) return U;
                if (Ai) {
                  if (_o) for (Qe = ps.call(T.ownerDocument); T.firstChild; ) Qe.appendChild(T.firstChild);
                  else Qe = T;
                  return ze.shadowroot && (Qe = dg.call(N, Qe, !0)), Qe;
                }
                var We = qn ? T.outerHTML : T.innerHTML;
                return (
                  qn &&
                    De['!doctype'] &&
                    T.ownerDocument &&
                    T.ownerDocument.doctype &&
                    T.ownerDocument.doctype.name &&
                    Te(vo, T.ownerDocument.doctype.name) &&
                    (We =
                      '<!DOCTYPE ' +
                      T.ownerDocument.doctype.name +
                      `>
` +
                      We),
                  yi && ((We = Ae(We, hs, ' ')), (We = Ae(We, ms, ' '))),
                  _t && xo ? _t.createHTML(We) : We
                );
              }),
              (k.setConfig = function (U) {
                Ss(U), (_s = !0);
              }),
              (k.clearConfig = function () {
                (bi = null), (_s = !1);
              }),
              (k.isValidAttribute = function (U, _, T) {
                bi || Ss({});
                var H = Oe(U),
                  ie = Oe(_);
                return Wu(H, ie, T);
              }),
              (k.addHook = function (U, _) {
                typeof _ == 'function' && ((Gt[U] = Gt[U] || []), Y(Gt[U], _));
              }),
              (k.removeHook = function (U) {
                if (Gt[U]) return z(Gt[U]);
              }),
              (k.removeHooks = function (U) {
                Gt[U] && (Gt[U] = []);
              }),
              (k.removeAllHooks = function () {
                Gt = {};
              }),
              k
            );
          }
          var Q = I();
          return Q;
        });
      })(ul)),
    ul.exports
  );
}
var vA = window.DOMPurify || (window.DOMPurify = Kp().default || Kp());
function _A({ type: e, codeId: t, enterWidescreenModeButtonLabel: n, exitWidescreenModeButtonLabel: i }) {
  const r = $.exports.useRef(null),
    [o, a] = $.exports.useState(!1);
  let s = i;
  return (
    o || (s = n),
    E(di, {
      children: ae('div', {
        ref: r,
        className: o
          ? 'app__content--full-width code-ide--codesandbox code-ide code-ide--full-width'
          : 'code-ide code-ide--codesandbox code-ide--centered',
        children: [
          E('button', {
            className:
              'code-ide__widescreen-mode-button spectrum-Button spectrum-Button--primary spectrum-Button--sizeM',
            onClick: () => {
              a(!o), r.current.scrollIntoView();
            },
            children: s,
          }),
          xA({ codeId: t, type: e }),
        ],
      }),
    })
  );
}
function xA({ type: e, codeId: t }) {
  const n = e === 'devebox' ? `https://codesandbox.io/p/devbox/${t}` : `https://codesandbox.io/embed/${t}?preview=1`;
  return E('iframe', {
    src: n,
    className: 'code-ide__embed code-ide__embed--codesandboxio',
    allow:
      'accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking',
    sandbox: 'allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts',
  });
}
function EA(e) {
  const { formatMessage: t } = e.intl,
    n = ho,
    [i, r] = $.exports.useState(!1);
  let { id: o } = Gx(),
    a = n.code_index.code[o];
  Tu(document, t(a.title), t(a.description)), V.use({ renderer: yA });
  let s = vA.sanitize(V.parse(t(a.longDescription)));
  return (
    i || (AA(o), r(!0)),
    ae(di, {
      children: [
        E(ls, {}),
        E(ss, {}),
        ae('div', {
          className: 'app__content--centered',
          children: [
            ae(Ta, {
              className: 'code-by-ide__back-link',
              to: '/developer/code.html',
              children: ['\u2039 ', t(n.code_by_id.button_back)],
            }),
            E('div', {
              id: 'container',
              style: { marginTop: '2rem' },
              children: E('div', { 'data-id': 'main', dangerouslySetInnerHTML: { __html: s } }),
            }),
          ],
        }),
        E(_A, {
          type: a.type,
          codeId: a.codeId,
          enterWidescreenModeButtonLabel: t(n.code_by_id.button_enter_widescreen),
          exitWidescreenModeButtonLabel: t(n.code_by_id.button_exit_widescreen),
        }),
      ],
    })
  );
}
const yA = {
  heading(e, t) {
    return t === 1
      ? `<h1 class='is-extra-bold is-size-36 is-size-34-touch has-text-blackest'>${e}</h1>`
      : `<h${t}>{text}</h$>`;
  },
};
function AA(e) {
  (window.adobeDataLayer = window.adobeDataLayer || []),
    window.adobeDataLayer.push({
      event: 'page loaded',
      user: window.adobeDataLayer.getState().user || {},
      web: {
        webPageDetails: {
          pageViews: { value: 1 },
          pageTitle: `AEM Headless Adaptive Forms developer resources - Code playground - ${e}`,
          name: `xl:microsite:landing:experience-manager:aem-headless-forms:code-playground:${e}`,
          pageType: 'webpage',
          URL: `https://experienceleague.adobe.com/code/${e}`,
          domain: 'experienceleague.adobe.com',
          server: void 0,
          siteSection: 'microsite',
          siteSubSection1: 'microsite',
          siteSubSection2: ' ',
          siteSubSection3: ' ',
        },
      },
    });
}
const wA = sr(EA),
  Xp = ho;
function kA(e) {
  const { formatMessage: t } = e.intl;
  return ae(di, {
    children: [
      E(ls, {}),
      E(ss, {}),
      ae('div', {
        className: 'app__content--centered',
        children: [
          E('h1', {
            className: 'is-extra-bold is-size-36 is-size-34-touch has-text-blackest',
            children: t(Xp.error.title),
          }),
          E('p', {
            className: 'is-size-18 has-text-weight-normal has-text-blackest',
            style: { marginBottom: '400px' },
            children: t(Xp.error.text),
          }),
        ],
      }),
    ],
  });
}
const dl = sr(kA);
function SA(e) {
  const [t, n] = $.exports.useState(e.intl.locale),
    i = n0(
      [
        { path: '/index.html', element: E(Ky, {}), errorElement: E(dl, {}) },
        { path: '/developer/code.html', element: E(Yy, {}), errorElement: E(dl, {}) },
        { path: '/developer/code/:id.html', element: E(wA, {}), errorElement: E(dl, {}) },
      ],
      { basename: '/' },
    );
  return (
    $.exports.useEffect(() => {
      async function r() {
        await zE(t), await BE(t), await UE();
      }
      r();
    }, [t]),
    E('div', { className: 'app', children: E(Zx, { router: i }) })
  );
}
const bA = sr(SA),
  MA = {
    'app.hero.cta': 'Watch how it works',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      'Everything you need to learn about AEM headless CMS to build and ship better applications and faster experiences.',
    'app.hero.title': 'Start building with AEM Headless CMS',
    'code_by_id.button.back': 'Back to code playground',
    'code_by_id.button.enter_widescreen': 'Enter widescreen mode',
    'code_by_id.button.exit_widescreen': 'Exit widescreen mode',
    'code_index.button.run_the_code': 'Run the code',
    'code_index.text': 'Test drive AEM Headless Form in seconds using example React apps!',
    'code_index.title': 'Code playground',
    'community.links.0': 'Join the discussion',
    'community.text':
      'Discuss, ask questions and get answers about AEM Headless with the entire AEM developer community on Experience League Communities.',
    'community.title': 'Join the discussion',
    'error.text': 'Sorry! Something went wrong. Please try again later.',
    'error.title': 'Oops! An error occurred.',
    'example_apps_android.links.0': 'View the app',
    'example_apps_android.text': 'An example Java Android app that consumes content from AEM Headless APIs.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'View the app',
    'example_apps_ios.text': 'An example SwiftUI iOS app that consumes content from AEM Headless APIs.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'View the app',
    'example_apps_next_js.text': 'An example Next.js application that consumes content from AEM Headless APIs.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'View the app',
    'example_apps_node-js.text':
      'An example command-line Node.js application that consumes content from AEM Headless APIs.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'View the app',
    'example_apps_react.text': 'An example React application that consumes content from AEM Headless APIs.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'View the app',
    'example_apps_web-component.text':
      'An example pure JavaScript Web Component that consumes content from AEM Headless APIs.',
    'example_apps_web-component.title': 'Web Component/JS',
    'experienced_developers.text1':
      'Learn to build Headless Forms on AEM 6.5 Forms using this { advancedDocumentation }.',
    'experienced_developers.title': 'For Developers on AEM 6.5 Forms',
    'experienced_developers.title.emphasis': 'EXPERIENCED',
    'get_involved_blog.links.0': 'Read the blog',
    'get_involved_blog.text': 'Read the latest on our tech blog.',
    'get_involved_blog.title': 'Adobe Tech Blog',
    'get_involved_community.links.0': 'Join the conversation',
    'get_involved_community.text': 'Join our community and get answers to your questions.',
    'get_involved_community.title': 'Experience League Communities',
    'nav.codePlayground': 'Code playground',
    'nav.home': 'Home',
    'nav.title': 'AEM Headless Form developer portal',
    'new_developers.text': 'Learn to build Headless Forms on AEM Forms as a Cloud Service using this { guideLink }.',
    'new_developers.text.5_steps': '5 steps',
    'new_developers.text.advanced_documentation': 'documentation',
    'new_developers.text.guide_link': 'documentation',
    'new_developers.title': 'For Developers on AEM Forms as a Cloud Service',
    'new_developers.title.emphasis': 'NEW',
    'new_to_aem_headless.links.0': 'Read the guide',
    'page.description':
      'Visit the AEM Headless CMS developer resources and documentation. Learn how to build next generation apps using headless CMS technologies in Experience Manager as a Cloud Service.',
    'page.title': 'AEM Headless CMS Developer Resources and Documentation | Adobe Experience Manager',
    'quick_setup.links.0': 'Quick setup for Cloud Service',
    'quick_setup.links.1': 'Quick setup for local AEM SDK',
    'quick_setup.text': 'Setup and test drive AEM Headless in minutes using an example React app.',
    'quick_setup.title': 'Quick setup',
    'section_developer_resources.title': 'Documentation',
    'section_example_apps.title': 'Example AEM Headless CMS apps',
    'section_get_involved.title': 'Get involved!',
    'section_spa_editor.text':
      'The AEM SPA Editor provides a framework to develop React or Angular apps that can be updated in-context by marketers using the AEM authoring UI.',
    'section_spa_editor.title': 'Explore the AEM SPA Editor',
    'spa_editor.links.0': 'Start the React tutorial',
    'spa_editor.text':
      'The AEM SPA Editor can be used to create a SPA whose components, routing, and views can be completely managed in AEM. The SPA Editor supports the React framework.',
    'spa_editor.title': 'Manage a SPA in AEM',
    'spa_editor_remote_spa.links.0': 'Start the tutorial',
    'spa_editor_remote_spa.text':
      "AEM's Remote SPA capabilities enables marketers to update targeted regions of a remotely hosted SPA.",
    'spa_editor_remote_spa.title': 'Author a remote SPA',
    'technical_docs.apis.section.formsapis': 'AEM Forms HTTP APIs',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms API (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL APIs',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.1': 'Sample GraphQL queries',
    'technical_docs.apis.section.relatedhttpapis': 'Related HTTP APIs',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP API',
    'technical_docs.apis.text': 'Learn about AEM Forms HTTP APIs',
    'technical_docs.apis.title': 'APIs',
    'technical_docs.documentation.section.contentfragments': 'Content Fragments',
    'technical_docs.documentation.section.contentfragments.links.0': 'Enabling Contents Fragments',
    'technical_docs.documentation.section.contentfragments.links.1': 'Content Fragment Models',
    'technical_docs.documentation.section.contentfragments.links.2': 'Managing Content Fragments',
    'technical_docs.documentation.section.contentfragments.links.3': 'Variations',
    'technical_docs.documentation.section.contentfragments.links.4': 'Associated content',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadata',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Structure tree',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON preview',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Headless Adaptive Forms',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM endpoint',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Enabling a GraphQL endpoint',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Publishing a GraphQL endpoint',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Persisted queries',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Publish Persisted queries',
    'technical_docs.documentation.text':
      "View Adobe Experience Manager as a Cloud Services documentation for the complete description of AEM's capabilities and configurations.",
    'technical_docs.documentation.title': 'Additional documentation',
    'technical_docs.how-to.section.content': 'Getting Started',
    'technical_docs.how-to.section.content.links.0': 'Rich Text',
    'technical_docs.how-to.section.content.links.1': 'How Headless adaptive form works?',
    'technical_docs.how-to.section.content.links.2': 'Create and preview a Headless Form using a React app',
    'technical_docs.how-to.section.content.links.3': 'Use a custom react library to render a headless form',
    'technical_docs.how-to.section.content.links.4': 'Create a Headless adaptive form using Adaptive Forms editor',
    'technical_docs.how-to.section.deployment': 'Deployment',
    'technical_docs.how-to.section.deployment.links.0': 'Single-page app',
    'technical_docs.how-to.section.deployment.links.1': 'Web component',
    'technical_docs.how-to.section.deployment.links.2': 'Mobile',
    'technical_docs.how-to.section.deployment.links.3': 'Server-to-server',
    'technical_docs.how-to.section.development': 'Development',
    'technical_docs.how-to.section.development.links.0': 'Storybook',
    'technical_docs.how-to.section.development.links.1': 'Install GraphiQL IDE on AEM 6.5',
    'technical_docs.how-to.text': 'Learn how to approach different use cases with AEM Headless.',
    'technical_docs.how-to.title': 'How-to guides',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': 'React Based renderer for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.2': 'React HTML5 Components For Headless Adaptive Forms',
    'technical_docs.sdks.text': 'Use the SDKs to render the AEM Headless Adaptive Forms',
    'technical_docs.sdks.title': 'SDKs',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'AEM 6.5 GraphiQL installation guide',
    'technical_docs.tools.text': "Explore AEM's headless developer tools.",
    'technical_docs.tools.title': 'Tools',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating, fetching, and rendering JSON-based forms from AEM.',
    'code_index.basic-react-app.longDescription': `This <a href='https://reactjs.org/'>React</a> app helps create JSON-based forms using AEM Headless Forms libraries and renders them with default components 

 This app: 
 - Fetches JSON forms from AEM 
 - Renders forms using default components 
 - Submits form data (<b>Submission is not supported on the developer portal. To test submissions, you can download and run the sample app locally. To do this, click Open Sandbox, expand NODEBOX, and then click the Download icon</b>)

 Click <a href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details.`,
    'code_index.react-app-with-custom-components.title': 'React App with Custom Components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching and rendering them from AEM, and building custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a href='https://reactjs.org/'>React</a> app helps create JSON-based forms using AEM Headless Form libraries and renders forms with custom and default components. 

 This app: 
 - Fetches JSON forms from AEM 
 - Creates custom components 
 - Renders forms using custom and default components 
 - Submits form data (<b>Submission is not supported on the developer portal. To test submissions, you can download and run the sample app locally. To do this, click Open Sandbox, expand NODEBOX, and then click the Download icon</b>)

 Click <a href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details.`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them with React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a href='https://nextjs.org/'>Next.js</a> app helps create JSON-based forms using AEM Headless Form libraries and renders forms with default components. 

 This app: 
 - Fetches JSON forms from AEM 
 - Renders forms using default components 
 - Submits form data (<b>Submission is not supported on the developer portal. To test submissions, you can download and run the sample app locally. To do this, click Open Sandbox, expand NODEBOX, and then click the Download icon</b>)

 Click <a href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details.`,
    'code_index.react-app-with-material-ui-components.title': 'React App with Material UI Components',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching them from AEM, rendering them in React, and building components with the Material-UI library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submits form data (<b>Submission is not supported on the developer portal. To test submissions, you can download and run the sample app locally. To do this, click Open Sandbox, expand NODEBOX, and then click the Download icon</b>)

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React Native app for creating JSON-based forms, fetching them from AEM, and rendering in React Native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React Native</a> app helps create JSON-based forms using AEM Headless Form libraries and renders them with default components.  

 This app: 
 - Fetches JSON forms from AEM 
 - Creates Custom Components 
 - Renders forms using custom and default components 
 - Submits form data (<b>Submission is not supported on the developer portal. To test submissions, you can download and run the sample app locally. To do this, click Open Sandbox, expand NODEBOX, and then click the Download icon</b>)

 Click <a href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details.`,
  },
  TA = {
    'app.hero.cta': 'Funktionsweise ansehen',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      'Alles, was Sie \xFCber AEM Headless CMS wissen m\xFCssen, damit Sie bessere Programme und schnellere Erlebnisse erstellen und versenden k\xF6nnen.',
    'app.hero.title': 'Erste Schritte bei der Entwicklung mit AEM Headless CMS',
    'code_by_id.button.back': 'Zur\xFCck zum Code Playground',
    'code_by_id.button.enter_widescreen': 'Breitbildmodus starten',
    'code_by_id.button.exit_widescreen': 'Breitbildmodus beenden',
    'code_index.button.run_the_code': 'Code ausf\xFChren',
    'code_index.text': 'Testen Sie AEM Headless CMS in wenigen Sekunden mithilfe von JavaScript-Beispielanwendungen!',
    'code_index.title': 'Code Playground',
    'community.links.0': 'Teil der Community werden',
    'community.text':
      'Diskutieren Sie mit AEM-Entwicklern in den Experience League-Communities \xFCber AEM Headless, stellen Sie Fragen und erhalten Sie Antworten.',
    'community.title': 'Teil der Community werden',
    'error.text': 'Ein Problem ist aufgetreten. Versuchen Sie es sp\xE4ter erneut.',
    'error.title': 'Hoppla! Ein Fehler ist aufgetreten.',
    'example_apps_android.links.0': 'Programm zeigen',
    'example_apps_android.text':
      'Ein Beispiel f\xFCr eine Java-Android-Mobile-App, die Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'Programm zeigen',
    'example_apps_ios.text':
      'Ein Beispiel f\xFCr eine SwiftUI-iOS-Mobile-App, die Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Programm zeigen',
    'example_apps_next_js.text': 'Ein Beispiel f\xFCr ein Next.js-Programm, das Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Anwendung zeigen',
    'example_apps_node-js.text':
      'Ein Beispiel f\xFCr eine Node.js-Befehlszeilenanwendung, die Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'Programm zeigen',
    'example_apps_react.text': 'Ein Beispiel f\xFCr ein React-Programm, das Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Anwendung zeigen',
    'example_apps_web-component.text':
      'Ein Beispiel f\xFCr eine reine JavaScript-Web-Komponente, die Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_web-component.title': 'Web-Komponente/JS',
    'experienced_developers.text1':
      'In { fiveSteps} erfahren Sie, wie Sie Erlebnisse mit AEM erstellen, verwalten und bereitstellen. { break } Bereits absolviert? Dann nutzen Sie unsere { advancedDocumentation }.',
    'experienced_developers.title': 'F\xDCR { emphasis } AEM HEADLESS CMS-ENTWICKELNDE',
    'experienced_developers.title.emphasis': 'ERFAHREN',
    'get_involved_blog.links.0': 'Blog lesen',
    'get_involved_blog.text': 'Die neuesten Informationen finden Sie in unserem Tech Blog.',
    'get_involved_blog.title': 'Adobe Tech Blog',
    'get_involved_community.links.0': 'Jetzt mitreden',
    'get_involved_community.text': 'Treten Sie unserer Community bei und erhalten Sie Antworten auf Ihre Fragen.',
    'get_involved_community.title': 'Experience League-Communities',
    'nav.codePlayground': 'Code Playground',
    'nav.home': 'Startseite',
    'nav.title': 'AEM Headless Form developer portal',
    'new_developers.text':
      'Lesen Sie dieses { guideLink }, um mehr \xFCber die Headless-CMS-Funktionen von AEM und ihre Nutzung in einem Headless-Entwicklungsprojekt zu erfahren.',
    'new_developers.text.5_steps': 'F\xFCnf Schritte',
    'new_developers.text.advanced_documentation': 'erweiterte Dokumentation',
    'new_developers.text.guide_link': '-Handbuch',
    'new_developers.title': 'F\xDCR ENTWICKELNDE { emphasis } F\xDCR AEM HEADLESS CMS',
    'new_developers.title.emphasis': 'NEU',
    'new_to_aem_headless.links.0': 'Anleitung lesen',
    'page.description':
      'Besuchen Sie die Ressourcen und Dokumenation f\xFCr Entwickelnde f\xFCr AEM Headless CMS. Erfahren Sie, wie Sie mit den Technologien f\xFCr Headless-CMS in Experience Manager as a Cloud Service Anwendungen der n\xE4chsten Generation entwickeln.',
    'page.title': 'AEM Headless CMS Developer - Ressourcen und Dokumentation | Adobe Experience Manager',
    'quick_setup.links.0': 'Schnelles Setup f\xFCr Cloud Service',
    'quick_setup.links.1': 'Schnelles Setup f\xFCr lokales AEM SDK',
    'quick_setup.text':
      'Richten Sie AEM Headless ein und testen Sie es in wenigen Minuten anhand eines React-Beispielprogramms.',
    'quick_setup.title': 'Schnell-Setup',
    'section_developer_resources.title': 'Erweiterte Dokumentation',
    'section_example_apps.title': 'Beispielanwendungen f\xFCr AEM Headless CMS',
    'section_get_involved.title': 'Seien Sie dabei!',
    'section_spa_editor.text':
      'Der AEM-SPA-Editor bietet ein Framework f\xFCr die Entwicklung von React- oder Angular-Programmen, die von Marketern \xFCber die AEM-Authoring-Benutzeroberfl\xE4che aktualisiert werden k\xF6nnen.',
    'section_spa_editor.title': 'Lernen Sie den AEM-SPA-Editor kennen',
    'spa_editor.links.0': 'React-Tutorial starten',
    'spa_editor.text':
      'Mit dem AEM-SPA-Editor k\xF6nnen Sie eine SPA erstellen, deren Komponenten, Routing und Ansichten vollst\xE4ndig in AEM verwaltet werden k\xF6nnen. Der SPA-Editor unterst\xFCtzt das React-Framework.',
    'spa_editor.title': 'Verwalten einer SPA in AEM',
    'spa_editor_remote_spa.links.0': 'Tutorial starten',
    'spa_editor_remote_spa.text':
      'Mit den Remote-SPA-Funktionen von AEM k\xF6nnen Marketer bestimmte Bereiche einer remote gehosteten SPA aktualisieren.',
    'spa_editor_remote_spa.title': 'Erstellen einer Remote-SPA',
    'technical_docs.apis.section.formsapis': 'AEM Forms-HTTP-APIs',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms-API (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL-APIs',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL-API',
    'technical_docs.apis.section.graphqlapis.links.1': 'Beispiele f\xFCr GraphQL-Abfragen',
    'technical_docs.apis.section.relatedhttpapis': 'Zugeh\xF6rige HTTP-APIs',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM\xA0Assets-HTTP-API',
    'technical_docs.apis.text':
      'Lernen Sie die GraphQL-APIs von AEM kennen und erfahren Sie, wie Sie Abfragen und HTTP-Anfragen erstellen.',
    'technical_docs.apis.title': 'APIs',
    'technical_docs.documentation.section.contentfragments': 'Inhaltsfragmente',
    'technical_docs.documentation.section.contentfragments.links.0': 'Aktivieren von Inhaltsfragmenten',
    'technical_docs.documentation.section.contentfragments.links.1': 'Inhaltsfragmentmodelle',
    'technical_docs.documentation.section.contentfragments.links.2': 'Verwalten von Inhaltsfragmenten',
    'technical_docs.documentation.section.contentfragments.links.3': 'Varianten',
    'technical_docs.documentation.section.contentfragments.links.4': 'Zugeh\xF6rige Inhalte',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadaten',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Strukturbaum',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON-Vorschau',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Adaptive Headless-Formulare',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL-AEM-Endpunkt',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Aktivieren eines GraphQL-Endpunkts',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Ver\xF6ffentlichen eines GraphQL-Endpunkts',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Persistente Abfragen',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Ver\xF6ffentlichen von persistenten Abfragen',
    'technical_docs.documentation.text':
      'Die vollst\xE4ndige Beschreibung der Funktionen und Konfigurationen von AEM finden Sie in der Dokumentation zu Adobe Experience Manager as a Cloud Service.',
    'technical_docs.documentation.title': 'Zus\xE4tzliche Dokumentation',
    'technical_docs.how-to.section.content': 'Inhalt',
    'technical_docs.how-to.section.content.links.0': 'Rich-Text',
    'technical_docs.how-to.section.content.links.1': 'Bilder',
    'technical_docs.how-to.section.content.links.2': 'Lokalisierter Inhalt',
    'technical_docs.how-to.section.content.links.3': 'Gro\xDFe Ergebnissets',
    'technical_docs.how-to.section.content.links.4': 'Vorschau',
    'technical_docs.how-to.section.deployment': 'Implementierung',
    'technical_docs.how-to.section.deployment.links.0': 'Single Page Applications',
    'technical_docs.how-to.section.deployment.links.1': 'Web-Komponente',
    'technical_docs.how-to.section.deployment.links.2': 'Mobilger\xE4t',
    'technical_docs.how-to.section.deployment.links.3': 'Server-zu-Server',
    'technical_docs.how-to.section.development': 'Entwicklung',
    'technical_docs.how-to.section.development.links.0': 'AEM Headless-SDK',
    'technical_docs.how-to.section.development.links.1': 'Installieren von GraphiQL IDE unter AEM 6.5',
    'technical_docs.how-to.text':
      'Erfahren Sie, wie Sie unterschiedliche Anwendungsf\xE4lle mit AEM Headless l\xF6sen k\xF6nnen.',
    'technical_docs.how-to.title': 'Handb\xFCcher',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java-SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': 'Server-seitiges JS-SDK',
    'technical_docs.sdks.section.javascript.links.2': 'NPM-Modul jwt-auth',
    'technical_docs.sdks.text': 'Verwenden Sie AEM Headless-SDKs, um mit AEM Headless-APIs zu interagieren.',
    'technical_docs.sdks.title': 'SDKs',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'Installationsleitfaden f\xFCr AEM 6.5 GraphiQL',
    'technical_docs.tools.text': 'Erkunden Sie die Headless-Entwickler-Tools von AEM.',
    'technical_docs.tools.title': 'Tools',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, and rendering them in React.',
    'code_index.basic-react-app.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details`,
    'code_index.react-app-with-custom-components.title': 'React App with custom components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using custom and default components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components
+ Renders the form using Custom and default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them in React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a  href='https://nextjs.org/'>Next.js</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details`,
    'code_index.react-app-with-material-ui-components.title': 'React App with material ui component',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating components using material ui library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React native app for creating JSON-based forms, fetching forms from AEM, and rendering them in react native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React native</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-native-app/README.md'>here</a> for more details`,
  },
  RA = {
    'app.hero.cta': 'Ver c\xF3mo funciona',
    'app.hero.solution': 'Adobe Experience Manager sin encabezado',
    'app.hero.text':
      'Todo lo que necesita saber sobre el CMS\xA0descentralizado de AEM para crear y ofrecer mejores aplicaciones y experiencias m\xE1s r\xE1pidas.',
    'app.hero.title': 'Empezar a crear con CMS sin encabezado de AEM',
    'code_by_id.button.back': 'Volver a Code Playground',
    'code_by_id.button.enter_widescreen': 'Entrar en el modo de pantalla panor\xE1mica',
    'code_by_id.button.exit_widescreen': 'Salir del modo de pantalla panor\xE1mica',
    'code_index.button.run_the_code': 'Ejecutar c\xF3digo',
    'code_index.text': 'Test drive AEM Headless Form in seconds using example React apps!',
    'code_index.title': 'Code Playground',
    'community.links.0': 'Unirse al debate',
    'community.text':
      'Participe en debates, haga preguntas y obtenga respuestas sobre AEM Headless con toda la comunidad de desarrolladores de AEM en Experience League Communities.',
    'community.title': 'Unirse al debate',
    'error.text': 'Se ha producido un error. Int\xE9ntelo de nuevo m\xE1s tarde.',
    'error.title': '\xA1Vaya! Se ha producido un error.',
    'example_apps_android.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_android.text':
      'Una aplicaci\xF3n Java Android de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_ios.text':
      'Una aplicaci\xF3n iOS SwiftUI de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_next_js.text':
      'Una aplicaci\xF3n Next.js de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_node-js.text':
      'Una aplicaci\xF3n Node.js de l\xEDnea de comandos de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_react.text': 'Una aplicaci\xF3n React de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_web-component.text':
      'Un componente web de JavaScript puro de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_web-component.title': 'Componente web/JS',
    'experienced_developers.text1':
      'Siga { fiveSteps} para crear, gestionar y ofrecer experiencias con AEM. { break } \xBFYa ha terminado? Consulte nuestra { advancedDocumentation }.',
    'experienced_developers.title': 'PARA { emphasis } DESARROLLADORES DE CMS SIN ENCABEZADO DE AEM',
    'experienced_developers.title.emphasis': 'EXPERIMENTADO',
    'get_involved_blog.links.0': 'Leer el blog',
    'get_involved_blog.text': 'Lea las \xFAltimas novedades en nuestro blog sobre tecnolog\xEDa.',
    'get_involved_blog.title': 'Blog de Adobe Tech',
    'get_involved_community.links.0': '\xDAnase a la conversaci\xF3n',
    'get_involved_community.text': '\xDAnase a nuestra comunidad y reciba respuesta a sus preguntas.',
    'get_involved_community.title': 'Experience League Communities',
    'nav.codePlayground': 'Code Playground',
    'nav.home': 'P\xE1gina principal',
    'nav.title': 'AEM Headless Form developer portal',
    'new_developers.text':
      'Consulte esta { guideLink } para aprender m\xE1s sobre las funciones CMS sin encabezado de AEM y c\xF3mo aprovecharlas en un proyecto de desarrollo sin encabezado.',
    'new_developers.text.5_steps': '5\xA0pasos',
    'new_developers.text.advanced_documentation': 'documentaci\xF3n avanzada',
    'new_developers.text.guide_link': 'gu\xEDa',
    'new_developers.title': 'PARA LOS DESARROLLADORES { emphasis } PARA CMS SIN ENCABEZADO DE AEM',
    'new_developers.title.emphasis': 'NUEVO',
    'new_to_aem_headless.links.0': 'Leer la gu\xEDa',
    'page.description':
      'Visite la documentaci\xF3n y los recursos para desarrolladores de CMS sin encabezado de AEM. Aprenda a crear aplicaciones de pr\xF3xima generaci\xF3n usando las tecnolog\xEDas CMS en Experience Manager as a Cloud Service.',
    'page.title': 'Documentaci\xF3n y recursos para desarrolladores de CMS sin encabezado | Adobe Experience Manager',
    'quick_setup.links.0': 'Configuraci\xF3n r\xE1pida de Cloud Service',
    'quick_setup.links.1': 'Configuraci\xF3n r\xE1pida de AEM SDK local',
    'quick_setup.text':
      'Configure y pruebe AEM Headless en cuesti\xF3n de minutos con una aplicaci\xF3n React de ejemplo.',
    'quick_setup.title': 'Configuraci\xF3n r\xE1pida',
    'section_developer_resources.title': 'Documentaci\xF3n avanzada',
    'section_example_apps.title': 'Aplicaciones CMS sin encabezado de AEM de ejemplo',
    'section_get_involved.title': '\xA1Empiece ya!',
    'section_spa_editor.text':
      'El Editor de SPA de AEM proporciona un marco de trabajo para desarrollar aplicaciones React o Angular que los responsables de marketing puedan actualizar en contexto mediante la interfaz de usuario de creaci\xF3n de AEM.',
    'section_spa_editor.title': 'Explorar el Editor de SPA de AEM',
    'spa_editor.links.0': 'Iniciar el tutorial de React',
    'spa_editor.text':
      'El Editor de SPA de AEM se puede utilizar para crear una SPA cuyos componentes, enrutamiento y vistas se puedan gestionar completamente en AEM. El Editor de SPA admite indistintamente marcos de trabajo de React.',
    'spa_editor.title': 'Administrar una SPA en AEM',
    'spa_editor_remote_spa.links.0': 'Iniciar el tutorial',
    'spa_editor_remote_spa.text':
      'Las prestaciones de SPA remotas de AEM permiten a los responsables de marketing actualizar regiones espec\xEDficas de una SPA alojada de forma remota.',
    'spa_editor_remote_spa.title': 'Crear una SPA remota',
    'technical_docs.apis.section.formsapis': 'API HTTP de AEM Forms',
    'technical_docs.apis.section.formsapis.links.0': 'API de AEM Forms (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'API de GraphQL',
    'technical_docs.apis.section.graphqlapis.links.0': 'API de GraphQL',
    'technical_docs.apis.section.graphqlapis.links.1': 'Consultas GraphQL de ejemplo',
    'technical_docs.apis.section.relatedhttpapis': 'API HTTP relacionadas',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'API HTTP de AEM Assets',
    'technical_docs.apis.text':
      'Obtenga informaci\xF3n acerca de las API de GraphQL de AEM y sobre c\xF3mo crear consultas y solicitudes HTTP.',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': 'Fragmentos de contenido',
    'technical_docs.documentation.section.contentfragments.links.0': 'Activaci\xF3n de fragmentos de contenido',
    'technical_docs.documentation.section.contentfragments.links.1': 'Modelos de fragmento de contenido',
    'technical_docs.documentation.section.contentfragments.links.2': 'Administrar fragmentos de contenido',
    'technical_docs.documentation.section.contentfragments.links.3': 'Variaciones',
    'technical_docs.documentation.section.contentfragments.links.4': 'Contenido asociado',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadatos',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\xC1rbol de estructura',
    'technical_docs.documentation.section.contentfragments.links.8': 'Vista previa de JSON',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Formularios adaptables descentralizados',
    'technical_docs.documentation.section.graphqlaemendpoint': 'Punto final GraphQL de AEM',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Activaci\xF3n de un punto final GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Publicaci\xF3n de un punto final GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Consultas persistentes',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Publicar consultas persistentes',
    'technical_docs.documentation.text':
      'Consulte la documentaci\xF3n de Adobe Experience Manager as a Cloud Service para obtener una descripci\xF3n completa de las prestaciones y configuraciones de AEM.',
    'technical_docs.documentation.title': 'Documentaci\xF3n adicional',
    'technical_docs.how-to.section.content': 'Contenido',
    'technical_docs.how-to.section.content.links.0': 'Texto enriquecido',
    'technical_docs.how-to.section.content.links.1': 'Im\xE1genes',
    'technical_docs.how-to.section.content.links.2': 'Contenido localizado',
    'technical_docs.how-to.section.content.links.3': 'Conjuntos grandes de resultados',
    'technical_docs.how-to.section.content.links.4': 'Previsualizar',
    'technical_docs.how-to.section.deployment': 'Implementaci\xF3n',
    'technical_docs.how-to.section.deployment.links.0': 'Aplicaci\xF3n de p\xE1gina \xFAnica',
    'technical_docs.how-to.section.deployment.links.1': 'Componente web',
    'technical_docs.how-to.section.deployment.links.2': 'M\xF3vil',
    'technical_docs.how-to.section.deployment.links.3': 'Servidor a servidor',
    'technical_docs.how-to.section.development': 'Desarrollo',
    'technical_docs.how-to.section.development.links.0': 'SDK de AEM Headless',
    'technical_docs.how-to.section.development.links.1': 'Instalar GraphiQL IDE en AEM 6.5',
    'technical_docs.how-to.text': 'C\xF3mo enfocar diferentes casos de uso con AEM Headless.',
    'technical_docs.how-to.title': 'Gu\xEDas paso a paso',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': 'JS SDK del lado del servidor',
    'technical_docs.sdks.section.javascript.links.2': 'M\xF3dulo jwt-auth npm',
    'technical_docs.sdks.text': 'Utilice el SDK de AEM Headless para interactuar con las API de AEM Headless.',
    'technical_docs.sdks.title': 'SDK',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'IDE de GraphiQL',
    'technical_docs.tools.section.graphiql.links.1': 'Gu\xEDa de instalaci\xF3n de GraphiQL en AEM\xA06.5',
    'technical_docs.tools.text': 'Explore las herramientas de desarrollo para entornos headless de AEM.',
    'technical_docs.tools.title': 'Herramientas',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, and rendering them in React.',
    'code_index.basic-react-app.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details`,
    'code_index.react-app-with-custom-components.title': 'React App with custom components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using custom and default components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components
+ Renders the form using Custom and default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them in React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a  href='https://nextjs.org/'>Next.js</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details`,
    'code_index.react-app-with-material-ui-components.title': 'React App with material ui component',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating components using material ui library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React native app for creating JSON-based forms, fetching forms from AEM, and rendering them in react native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React native</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-native-app/README.md'>here</a> for more details`,
  },
  PA = {
    'app.hero.cta': 'D\xE9couvrir son fonctionnement',
    'app.hero.solution': 'Adobe\xA0Experience\xA0Manager d\xE9coupl\xE9',
    'app.hero.text':
      'Tout ce que vous devez savoir sur le syst\xE8me de gestion de contenu d\u2019AEM Headless pour cr\xE9er et offrir de meilleures applications et des exp\xE9riences plus rapides.',
    'app.hero.title': 'Commencez \xE0 cr\xE9er avec le CMS AEM d\xE9coupl\xE9',
    'code_by_id.button.back': 'Revenir \xE0 l\u2019aire de codage',
    'code_by_id.button.enter_widescreen': 'Passer en mode Grand \xE9cran',
    'code_by_id.button.exit_widescreen': 'Quitter le mode Grand \xE9cran',
    'code_index.button.run_the_code': 'Ex\xE9cuter le code',
    'code_index.text': 'Test drive AEM Headless Form in seconds using example React apps!',
    'code_index.title': 'Aire de codage',
    'community.links.0': 'Rejoindre la discussion',
    'community.text':
      "Discutez, posez des questions et obtenez des r\xE9ponses \xE0 propos d'AEM\xA0Headless aupr\xE8s de toute la communaut\xE9 de d\xE9veloppeurs AEM dans les Communaut\xE9s Experience League.",
    'community.title': 'Rejoindre la discussion',
    'error.text': 'Une erreur s\u2019est produite. R\xE9essayez ult\xE9rieurement.',
    'error.title': 'Une erreur s\u2019est produite.',
    'example_apps_android.links.0': "Afficher l'application",
    'example_apps_android.text':
      "Un exemple d'application Android Java qui utilise du contenu des API AEM\xA0Headless.",
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': "Afficher l'application",
    'example_apps_ios.text': "Un exemple d'application iOS\xA0SwiftUI qui utilise du contenu des API AEM\xA0Headless.",
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Afficher l\u2019application',
    'example_apps_next_js.text':
      'Un exemple d\u2019application Next.js qui utilise du contenu des API AEM\xA0Headless.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Afficher l\u2019application',
    'example_apps_node-js.text':
      'Exemple d\u2019application de ligne de commande Node.js qui utilise du contenu provenant des API AEM\xA0Headless.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': "Afficher l'application",
    'example_apps_react.text': "Un exemple d'application React qui utilise du contenu des API AEM\xA0Headless.",
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Afficher l\u2019application',
    'example_apps_web-component.text':
      'Un exemple de composant Web JavaScript pur qui utilise du contenu provenant des API d\xE9coupl\xE9es AEM.',
    'example_apps_web-component.title': 'Composants et JS Web',
    'experienced_developers.text1':
      'Suivez { fiveSteps} pour cr\xE9er, g\xE9rer et diffuser des exp\xE9riences \xE0 l\u2019aide d\u2019AEM. { break } Vous avez d\xE9j\xE0 termin\xE9\xA0? Acc\xE9dez \xE0 notre { advancedDocumentation }.',
    'experienced_developers.title': 'POUR LES D\xC9VELOPPEURS { emphasis } DU CMS AEM D\xC9COUPL\xC9',
    'experienced_developers.title.emphasis': 'EXP\xC9RIMENT\xC9S',
    'get_involved_blog.links.0': 'Lire le blog',
    'get_involved_blog.text': 'Lisez les derni\xE8res informations sur notre blog technologique.',
    'get_involved_blog.title': 'Adobe Tech Blog',
    'get_involved_community.links.0': 'Rejoindre la conversation',
    'get_involved_community.text': 'Rejoignez notre communaut\xE9 et obtenez des r\xE9ponses \xE0 vos questions.',
    'get_involved_community.title': 'Communaut\xE9s Experience\xA0League',
    'nav.codePlayground': 'Aire de codage',
    'nav.home': 'Accueil',
    'nav.title': 'AEM Headless Form developer portal',
    'new_developers.text':
      'Lisez ce guide { guideLink } pour d\xE9couvrir les fonctionnalit\xE9s du syst\xE8me de gestion de contenu headless d\u2019AEM et comment les utiliser dans un projet de d\xE9veloppement headless.',
    'new_developers.text.5_steps': '5\xA0\xE9tapes',
    'new_developers.text.advanced_documentation': 'Documentation avanc\xE9e',
    'new_developers.text.guide_link': 'guide',
    'new_developers.title': 'POUR LES { emphasis } D\xC9VELOPPEURS DU CMS AEM D\xC9COUPL\xC9',
    'new_developers.title.emphasis': 'NOUVEAU',
    'new_to_aem_headless.links.0': 'Lire le guide',
    'page.description':
      'Consultez la documentation et les ressources pour les d\xE9veloppeurs du CMS AEM d\xE9coupl\xE9. D\xE9couvrez comment cr\xE9er des applications de nouvelle g\xE9n\xE9ration en utilisant les technologies du CMS d\xE9coupl\xE9 dans Experience Manager as a Cloud Service.',
    'page.title': 'Ressources et documentation du d\xE9veloppeur CMS d\xE9coupl\xE9 AEM | Adobe Experience Manager',
    'quick_setup.links.0': 'Installation rapide pour Cloud\xA0Service',
    'quick_setup.links.1': 'Installation rapide pour un SDK AEM local',
    'quick_setup.text':
      "Configurez et testez AEM\xA0Headless en quelques minutes \xE0 l'aide d'un exemple d'appli React.",
    'quick_setup.title': 'Configuration rapide',
    'section_developer_resources.title': 'Documentation avanc\xE9e',
    'section_example_apps.title': 'Exemples d\u2019applications de CMS AEM d\xE9coupl\xE9',
    'section_get_involved.title': 'Participez\xA0!',
    'section_spa_editor.text':
      "L'\xC9diteur de SPA AEM fournit un cadre pour d\xE9velopper des applications React ou Angular pouvant \xEAtre mises \xE0 jour en contexte par les sp\xE9cialistes du marketing gr\xE2ce \xE0 l'interface utilisateur de cr\xE9ation AEM.",
    'section_spa_editor.title': 'Explorer l\u2019\xC9diteur de SPA AEM',
    'spa_editor.links.0': 'D\xE9marrer le tutoriel React',
    'spa_editor.text':
      'L\u2019\xC9diteur de SPA AEM peut \xEAtre utilis\xE9 pour cr\xE9er un SPA dont les composants, le routage et l\u2019affichage sont enti\xE8rement g\xE9r\xE9s dans AEM. L\u2019\xC9diteur de SPA AEM prend en charge le framework React.',
    'spa_editor.title': 'G\xE9rer un SPA dans AEM',
    'spa_editor_remote_spa.links.0': 'D\xE9marrer le tutoriel',
    'spa_editor_remote_spa.text':
      'Les capacit\xE9s de SPA \xE0 distance d\u2019AEM donnent aux sp\xE9cialistes du marketing la possibilit\xE9 de mettre \xE0 jour des r\xE9gions cibl\xE9es d\u2019un SPA h\xE9berg\xE9 \xE0 distance. ',
    'spa_editor_remote_spa.title': 'Cr\xE9er un SPA distant',
    'technical_docs.apis.section.formsapis': 'API HTTP AEM\xA0Forms',
    'technical_docs.apis.section.formsapis.links.0': 'API AEM\xA0Forms (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'Les API GraphQL',
    'technical_docs.apis.section.graphqlapis.links.0': 'API GraphQL',
    'technical_docs.apis.section.graphqlapis.links.1': 'Exemples de requ\xEAtes GraphQL',
    'technical_docs.apis.section.relatedhttpapis': 'API HTTP connexes',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'API HTTP AEM Assets',
    'technical_docs.apis.text':
      "D\xE9couvrez les API GraphQL d'AEM et comment construire des requ\xEAtes en g\xE9n\xE9ral, et des requ\xEAtes HTTP en particulier.",
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': 'Fragments de contenu',
    'technical_docs.documentation.section.contentfragments.links.0': 'Activation des fragments de contenu',
    'technical_docs.documentation.section.contentfragments.links.1': 'Mod\xE8les de fragment de contenu',
    'technical_docs.documentation.section.contentfragments.links.2': 'Gestion des fragments de contenu',
    'technical_docs.documentation.section.contentfragments.links.3': 'Variations',
    'technical_docs.documentation.section.contentfragments.links.4': 'Contenu associ\xE9',
    'technical_docs.documentation.section.contentfragments.links.5': 'M\xE9tadonn\xE9es',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Arborescence de la structure',
    'technical_docs.documentation.section.contentfragments.links.8': 'Pr\xE9visualisation JSON',
    'technical_docs.documentation.section.forms': 'AEM\xA0Forms',
    'technical_docs.documentation.section.forms.links.0': 'Formulaires adaptatifs headless',
    'technical_docs.documentation.section.graphqlaemendpoint': 'Point d\u2019entr\xE9e AEM de GraphQL ',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': "Activation d'un point d\u2019entr\xE9e GraphQL",
    'technical_docs.documentation.section.graphqlaemendpoint.links.1':
      "Publication d'un point d\u2019entr\xE9e GraphQL",
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Requ\xEAtes persistantes',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Publier des requ\xEAtes persistantes',
    'technical_docs.documentation.text':
      "Consultez la documentation d'Adobe\xA0Experience\xA0Manager as a Cloud\xA0Service pour obtenir une description compl\xE8te des fonctionnalit\xE9s et configurations d'AEM.",
    'technical_docs.documentation.title': 'Documentation suppl\xE9mentaire',
    'technical_docs.how-to.section.content': 'Contenu',
    'technical_docs.how-to.section.content.links.0': 'Texte enrichi',
    'technical_docs.how-to.section.content.links.1': 'Images',
    'technical_docs.how-to.section.content.links.2': 'Contenu localis\xE9',
    'technical_docs.how-to.section.content.links.3': 'Ensembles de r\xE9sultats volumineux',
    'technical_docs.how-to.section.content.links.4': 'Aper\xE7u',
    'technical_docs.how-to.section.deployment': 'D\xE9ploiement',
    'technical_docs.how-to.section.deployment.links.0': 'Application monopage',
    'technical_docs.how-to.section.deployment.links.1': 'Composant web',
    'technical_docs.how-to.section.deployment.links.2': 'Mobile',
    'technical_docs.how-to.section.deployment.links.3': 'De serveur \xE0 serveur',
    'technical_docs.how-to.section.development': 'D\xE9veloppement',
    'technical_docs.how-to.section.development.links.0': 'SDK d\xE9coupl\xE9 AEM',
    'technical_docs.how-to.section.development.links.1': 'Installer GraphiQL IDE sur AEM\xA06.5',
    'technical_docs.how-to.text':
      'D\xE9couvrez comment faire face \xE0 diff\xE9rents cas d\u2019utilisation du d\xE9couplage AEM.',
    'technical_docs.how-to.title': 'Guides pratiques',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'SDK Java',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': 'SDK JS c\xF4t\xE9 serveur',
    'technical_docs.sdks.section.javascript.links.2': 'Module npm jwt-auth',
    'technical_docs.sdks.text': 'Utilisation des SDK AEM\xA0Headless pour interagir avec les API AEM\xA0Headless.',
    'technical_docs.sdks.title': 'Kits de d\xE9veloppement logiciel (SDK)',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'Guide d\u2019installation AEM 6.5 GraphiQL',
    'technical_docs.tools.text': "D\xE9couvrir les outils de d\xE9veloppement d\xE9coupl\xE9s d'AEM",
    'technical_docs.tools.title': 'Outils',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, and rendering them in React.',
    'code_index.basic-react-app.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details`,
    'code_index.react-app-with-custom-components.title': 'React App with custom components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using custom and default components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components
+ Renders the form using Custom and default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them in React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a  href='https://nextjs.org/'>Next.js</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details`,
    'code_index.react-app-with-material-ui-components.title': 'React App with material ui component',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating components using material ui library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React native app for creating JSON-based forms, fetching forms from AEM, and rendering them in react native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React native</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-native-app/README.md'>here</a> for more details`,
  },
  CA = {
    'app.hero.cta': 'Guarda come funziona',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      'Tutto sul CMS di AEM Headless per creare e pubblicare applicazioni migliori ed esperienze pi\xF9 veloci.',
    'app.hero.title': 'Inizia a sviluppare con AEM Headless CMS',
    'code_by_id.button.back': 'Torna al playground per codice',
    'code_by_id.button.enter_widescreen': 'Passa alla modalit\xE0 widescreen',
    'code_by_id.button.exit_widescreen': 'Esci dalla modalit\xE0 widescreen',
    'code_index.button.run_the_code': 'Esegui il codice',
    'code_index.text': 'Test drive AEM Headless Form in seconds using example React apps!',
    'code_index.title': 'Playground per codice',
    'community.links.0': 'Partecipa alla discussione',
    'community.text':
      'Partecipa alla community di sviluppatori AEM in Experience League Communities: contribuisci alle discussioni, pubblica le tue domande e ricevi risposte su AEM Headless.',
    'community.title': 'Partecipa alla discussione',
    'error.text': 'Si \xE8 verificato un errore. Riprova pi\xF9 tardi.',
    'error.title': 'Si \xE8 verificato un errore.',
    'example_apps_android.links.0': 'Guarda l\u2019app',
    'example_apps_android.text':
      'Esempio di un\u2019app Java per Android che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'Guarda l\u2019app',
    'example_apps_ios.text': 'Esempio di un\u2019app SwiftUI per iOS che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Guarda l\u2019app',
    'example_apps_next_js.text':
      'Esempio di un\u2019applicazione Next.js che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Guarda l\u2019app',
    'example_apps_node-js.text':
      'Esempio di applicazione Node.js a riga di comando che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'Guarda l\u2019app',
    'example_apps_react.text':
      'Esempio di un\u2019applicazione React che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Guarda l\u2019app',
    'example_apps_web-component.text':
      'Esempio di componente web puramente basato su JavaScript che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_web-component.title': 'Componente web/JS',
    'experienced_developers.text1':
      'Segui { fiveSteps} per creare, gestire e consegnare esperienze utilizzando AEM. { break } Lo hai gi\xE0 fatto? passa alla { advancedDocumentation }.',
    'experienced_developers.title': 'PER { emphasis } SVILUPPATORI AEM HEADLESS CMS',
    'experienced_developers.title.emphasis': 'ESPERTI',
    'get_involved_blog.links.0': 'Leggi il blog',
    'get_involved_blog.text': 'Leggi le ultime novit\xE0 sul nostro blog tecnico.',
    'get_involved_blog.title': 'Blog tecnico di Adobe',
    'get_involved_community.links.0': 'Partecipa alla conversazione',
    'get_involved_community.text': 'Partecipa alla nostra community e trova le risposte alle tue domande.',
    'get_involved_community.title': 'Community Experience League',
    'nav.codePlayground': 'Playground per codice',
    'nav.home': 'Home',
    'nav.title': 'AEM Headless Form developer portal',
    'new_developers.text':
      'Leggi questa { guideLink } per scoprire le funzioni CMS headless di AEM e come sfruttarle in un progetto di sviluppo headless.',
    'new_developers.text.5_steps': '5 passaggi',
    'new_developers.text.advanced_documentation': 'documentazione avanzata',
    'new_developers.text.guide_link': 'guida',
    'new_developers.title': 'PER SVILUPPATORI { emphasis } IN AEM HEADLESS CMS',
    'new_developers.title.emphasis': 'NUOVO',
    'new_to_aem_headless.links.0': 'Leggi la guida',
    'page.description':
      'Visita le risorse e la documentazione di AEM Headless CMS per sviluppatori. Scopri come creare app di nuova generazione con le tecnologie CMS in Experience Manager as a Cloud Service.',
    'page.title': 'AEM Risorse e documentazione per sviluppatori CMS Headless | Adobe Experience Manager',
    'quick_setup.links.0': 'Impostazione rapida per Cloud Service',
    'quick_setup.links.1': 'Impostazione rapida per AEM SDK locale',
    'quick_setup.text': 'Imposta e prova AEM Headless in pochi minuti con un\u2019app React di esempio.',
    'quick_setup.title': 'Impostazione rapida',
    'section_developer_resources.title': 'Documentazione avanzata',
    'section_example_apps.title': 'Esempi di app AEM Headless CMS',
    'section_get_involved.title': 'Partecipa anche tu!',
    'section_spa_editor.text':
      'L\u2019editor per applicazioni a pagina singola (SPA) di AEM fornisce un pratico framework per lo sviluppo di app React o Angular che possono essere aggiornate direttamente nel loro contesto dagli esperti marketing utilizzando l\u2019interfaccia di authoring di AEM.',
    'section_spa_editor.title': 'Scopri l\u2019editor SPA di AEM',
    'spa_editor.links.0': 'Avvia il tutorial React',
    'spa_editor.text':
      'Con l\u2019editor per applicazioni a pagina singola (SPA) di AEM puoi creare una SPA con componenti, indirizzamenti e viste che potrai gestire interamente in AEM. L\u2019editor SPA supporta il framework React.',
    'spa_editor.title': 'Gestisci una SPA in AEM',
    'spa_editor_remote_spa.links.0': 'Avvia il tutorial',
    'spa_editor_remote_spa.text':
      'Le funzionalit\xE0 di AEM per applicazioni a pagina singola (SPA) remote consentono agli esperti di marketing di aggiornare specifiche aree di una SPA gestita in remoto.',
    'spa_editor_remote_spa.title': 'Crea una SPA remota',
    'technical_docs.apis.section.formsapis': 'API HTTP di AEM Forms',
    'technical_docs.apis.section.formsapis.links.0': 'API di AEM Forms (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'API di GraphQL',
    'technical_docs.apis.section.graphqlapis.links.0': 'API GraphQL',
    'technical_docs.apis.section.graphqlapis.links.1': 'Query GraphQL di esempio',
    'technical_docs.apis.section.relatedhttpapis': 'API HTTP correlate',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'API HTTP per AEM Assets',
    'technical_docs.apis.text': 'Scopri le API GraphQL di AEM e come creare query e richieste HTTP.',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': 'Frammenti di contenuto',
    'technical_docs.documentation.section.contentfragments.links.0': 'Abilitazione dei frammenti di contenuto',
    'technical_docs.documentation.section.contentfragments.links.1': 'Modelli per frammenti di contenuto',
    'technical_docs.documentation.section.contentfragments.links.2': 'Gestione dei frammenti di contenuto',
    'technical_docs.documentation.section.contentfragments.links.3': 'Varianti',
    'technical_docs.documentation.section.contentfragments.links.4': 'Contenuti associati',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadati',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Struttura ad albero',
    'technical_docs.documentation.section.contentfragments.links.8': 'Anteprima JSON',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Moduli adattivi headless',
    'technical_docs.documentation.section.graphqlaemendpoint': 'Endpoint GraphQL in AEM',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Abilitazione di un endpoint GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Pubblicazione di un endpoint GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Query persistenti',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Pubblicare query persistenti',
    'technical_docs.documentation.text':
      'Consulta la documentazione di Adobe Experience Manager as a Cloud Service per una descrizione completa delle funzionalit\xE0 e delle configurazioni di AEM.',
    'technical_docs.documentation.title': 'Documentazione aggiuntiva',
    'technical_docs.how-to.section.content': 'Contenuto',
    'technical_docs.how-to.section.content.links.0': 'Testo formattato',
    'technical_docs.how-to.section.content.links.1': 'Immagini',
    'technical_docs.how-to.section.content.links.2': 'Contenuti localizzati',
    'technical_docs.how-to.section.content.links.3': 'Grandi set di risultati',
    'technical_docs.how-to.section.content.links.4': 'Anteprima',
    'technical_docs.how-to.section.deployment': 'Implementazione',
    'technical_docs.how-to.section.deployment.links.0': 'App a pagina singola',
    'technical_docs.how-to.section.deployment.links.1': 'Componente web',
    'technical_docs.how-to.section.deployment.links.2': 'Mobile',
    'technical_docs.how-to.section.deployment.links.3': 'Server-to-server',
    'technical_docs.how-to.section.development': 'Sviluppo',
    'technical_docs.how-to.section.development.links.0': 'SDK di AEM Headless',
    'technical_docs.how-to.section.development.links.1': 'Installa GraphiQL IDE in AEM 6.5',
    'technical_docs.how-to.text': 'Scopri come affrontare diversi casi d\u2019uso con AEM Headless.',
    'technical_docs.how-to.title': 'Guide pratiche',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'SDK Java',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': 'SDK JS lato server',
    'technical_docs.sdks.section.javascript.links.2': 'Modulo npm jwt-auth',
    'technical_docs.sdks.text': 'Utilizza gli SDK di AEM Headless per interagire con le API di AEM Headless.',
    'technical_docs.sdks.title': 'SDK',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'IDE GraphiQL',
    'technical_docs.tools.section.graphiql.links.1': 'Guida all\u2019installazione di AEM 6.5 GraphiQL',
    'technical_docs.tools.text': 'Scopri gli strumenti di sviluppo headless di AEM.',
    'technical_docs.tools.title': 'Strumenti',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, and rendering them in React.',
    'code_index.basic-react-app.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details`,
    'code_index.react-app-with-custom-components.title': 'React App with custom components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using custom and default components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components
+ Renders the form using Custom and default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them in React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a  href='https://nextjs.org/'>Next.js</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details`,
    'code_index.react-app-with-material-ui-components.title': 'React App with material ui component',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating components using material ui library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React native app for creating JSON-based forms, fetching forms from AEM, and rendering them in react native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React native</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-native-app/README.md'>here</a> for more details`,
  },
  NA = {
    'app.hero.cta': '\u4ED5\u7D44\u307F\u3092\u898B\u308B',
    'app.hero.solution': 'Adobe Experience Manager \u30D8\u30C3\u30C9\u30EC\u30B9',
    'app.hero.text':
      'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u306B\u3064\u3044\u3066\u3001\u3088\u308A\u512A\u308C\u305F\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3067\u3088\u308A\u9AD8\u901F\u306A\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u69CB\u7BC9\u3057\u3066\u63D0\u4F9B\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u3053\u3068\u3092\u3059\u3079\u3066\u5B66\u3073\u307E\u3059\u3002',
    'app.hero.title': 'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u3067\u69CB\u7BC9\u3092\u958B\u59CB',
    'code_by_id.button.back': '\u30B3\u30FC\u30C9\u30D7\u30EC\u30FC\u30B0\u30E9\u30A6\u30F3\u30C9\u306B\u623B\u308B',
    'code_by_id.button.enter_widescreen':
      '\u30EF\u30A4\u30C9\u30B9\u30AF\u30EA\u30FC\u30F3\u30E2\u30FC\u30C9\u306B\u30A8\u30F3\u30C8\u30EA',
    'code_by_id.button.exit_widescreen':
      '\u30EF\u30A4\u30C9\u30B9\u30AF\u30EA\u30FC\u30F3\u30E2\u30FC\u30C9\u3092\u7D42\u4E86',
    'code_index.button.run_the_code': '\u30B3\u30FC\u30C9\u3092\u5B9F\u884C',
    'code_index.text': 'Test drive AEM Headless Form in seconds using example React apps!',
    'code_index.title': '\u30B3\u30FC\u30C9\u30D7\u30EC\u30FC\u30B0\u30E9\u30A6\u30F3\u30C9',
    'community.links.0': '\u30C7\u30A3\u30B9\u30AB\u30C3\u30B7\u30E7\u30F3\u306B\u53C2\u52A0',
    'community.text':
      'Experience League \u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u3059\u3079\u3066\u306E AEM \u958B\u767A\u8005\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u3067\u3001AEM Headless \u306B\u3064\u3044\u3066\u8A71\u3057\u5408\u3063\u305F\u308A\u3001\u8CEA\u554F\u3057\u305F\u308A\u3001\u56DE\u7B54\u3092\u5F97\u305F\u308A\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002',
    'community.title': '\u30C7\u30A3\u30B9\u30AB\u30C3\u30B7\u30E7\u30F3\u306B\u53C2\u52A0',
    'error.text':
      '\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u5F8C\u3067\u3082\u3046\u4E00\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'error.title': '\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002',
    'example_apps_android.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_android.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B Java Android \u30A2\u30D7\u30EA\u306E\u4F8B\u3002',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_ios.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B SwiftUI iOS \u30A2\u30D7\u30EA\u306E\u4F8B\u3002',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_next_js.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B Next.js \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u4F8B\u3002',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_node-js.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B\u30B3\u30DE\u30F3\u30C9\u30E9\u30A4\u30F3 Node.js \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u4F8B\u3002',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_react.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B React \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u4F8B\u3002',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_web-component.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B\u7D14\u7C8B\u306A JavaScript Web \u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8\u306E\u4F8B\u3002',
    'example_apps_web-component.title': 'Web \u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8/JS',
    'experienced_developers.text1':
      'AEM \u3092\u4F7F\u7528\u3057\u3066\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u4F5C\u6210\u3001\u7BA1\u7406\u3001\u914D\u4FE1\u3059\u308B\u305F\u3081\u306E { fiveSteps} \u3092\u5B9F\u884C\u3057\u307E\u3059\u3002 { break } \u3059\u3067\u306B\u5B8C\u4E86\u3057\u3066\u3044\u307E\u3059\u304B\u3002 { advancedDocumentation } \u306B\u79FB\u52D5\u3057\u307E\u3059\u3002',
    'experienced_developers.title':
      '{ emphasis } AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u958B\u767A\u8005\u5411\u3051',
    'experienced_developers.title.emphasis': '\u4F53\u9A13\u6E08',
    'get_involved_blog.links.0': '\u30D6\u30ED\u30B0\u3092\u8AAD\u3080',
    'get_involved_blog.text':
      '\u6280\u8853\u30D6\u30ED\u30B0\u3067\u6700\u65B0\u60C5\u5831\u3092\u304A\u8AAD\u307F\u304F\u3060\u3055\u3044\u3002',
    'get_involved_blog.title': '\u30A2\u30C9\u30D3\u306E\u6280\u8853\u30D6\u30ED\u30B0',
    'get_involved_community.links.0': '\u4F1A\u8A71\u306B\u53C2\u52A0\u3059\u308B',
    'get_involved_community.text':
      '\u79C1\u305F\u3061\u306E\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306B\u53C2\u52A0\u3057\u3066\u3001\u3054\u4E0D\u660E\u306A\u70B9\u3092\u89E3\u6C7A\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'get_involved_community.title': 'Experience League \u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u30FC',
    'nav.codePlayground': '\u30B3\u30FC\u30C9\u30D7\u30EC\u30FC\u30B0\u30E9\u30A6\u30F3\u30C9',
    'nav.home': '\u30DB\u30FC\u30E0',
    'nav.title': 'AEM Headless Form developer portal',
    'new_developers.text':
      '\u3053\u306E { guideLink } \u3092\u8AAD\u3093\u3067\u3001AEM \u306E\u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u6A5F\u80FD\u3068\u3001\u30D8\u30C3\u30C9\u30EC\u30B9\u958B\u767A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u6D3B\u7528\u3059\u308B\u65B9\u6CD5\u306B\u3064\u3044\u3066\u5B66\u3073\u307E\u3059\u3002',
    'new_developers.text.5_steps': '5 \u3064\u306E\u30B9\u30C6\u30C3\u30D7',
    'new_developers.text.advanced_documentation': '\u8A73\u7D30\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8',
    'new_developers.text.guide_link': '\u30AC\u30A4\u30C9',
    'new_developers.title':
      '\u958B\u767A\u8005\u5411\u3051 { emphasis } AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u306B\u79FB\u52D5',
    'new_developers.title.emphasis': '\u65B0\u898F',
    'new_to_aem_headless.links.0': '\u30AC\u30A4\u30C9\u3092\u8AAD\u3080',
    'page.description':
      'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u958B\u767A\u8005\u5411\u3051\u30EA\u30BD\u30FC\u30B9\u304A\u3088\u3073\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002Experience Manager as a Cloud Service \u306E\u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3092\u4F7F\u7528\u3057\u3066\u3001\u6B21\u4E16\u4EE3\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u69CB\u7BC9\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3057\u3087\u3046\u3002',
    'page.title':
      'AEM\u30D8\u30C3\u30C9\u30EC\u30B9CMS\u958B\u767A\u8005\u5411\u3051\u30EA\u30BD\u30FC\u30B9\u304A\u3088\u3073\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8 | Adobe Experience Manager',
    'quick_setup.links.0': 'Cloud Service \u306E\u30AF\u30A4\u30C3\u30AF\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7',
    'quick_setup.links.1':
      '\u30ED\u30FC\u30AB\u30EB AEM SDK \u306E\u30AF\u30A4\u30C3\u30AF\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7',
    'quick_setup.text':
      'React \u30A2\u30D7\u30EA\u306E\u30B5\u30F3\u30D7\u30EB\u3092\u4F7F\u7528\u3057\u3066\u3001\u6570\u5206\u3067 AEM Headless \u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u304A\u3088\u3073\u30C6\u30B9\u30C8\u3057\u307E\u3059\u3002',
    'quick_setup.title': '\u30AF\u30A4\u30C3\u30AF\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7',
    'section_developer_resources.title': '\u8A73\u7D30\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8',
    'section_example_apps.title': 'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u30A2\u30D7\u30EA\u306E\u4F8B',
    'section_get_involved.title': '\u53C2\u52A0\u3057\u307E\u3057\u3087\u3046\u3002',
    'section_spa_editor.text':
      'AEM SPA \u30A8\u30C7\u30A3\u30BF\u30FC\u306F\u3001React \u30A2\u30D7\u30EA\u307E\u305F\u306F Angular \u30A2\u30D7\u30EA\u3092\u958B\u767A\u3059\u308B\u305F\u3081\u306E\u30D5\u30EC\u30FC\u30E0\u30EF\u30FC\u30AF\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002\u30DE\u30FC\u30B1\u30BF\u30FC\u306F\u3001\u305D\u308C\u3089\u306E\u30A2\u30D7\u30EA\u3092\u3001AEM \u30AA\u30FC\u30B5\u30EA\u30F3\u30B0 UI \u3092\u4F7F\u7528\u3057\u3066\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u5185\u3067\u66F4\u65B0\u3067\u304D\u307E\u3059\u3002',
    'section_spa_editor.title': 'AEM SPA \u30A8\u30C7\u30A3\u30BF\u30FC\u306E\u5B66\u7FD2',
    'spa_editor.links.0': 'React \u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3092\u958B\u59CB',
    'spa_editor.text':
      'AEM SPA \u30A8\u30C7\u30A3\u30BF\u30FC\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001AEM \u3067\u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8\u3001\u30EB\u30FC\u30C6\u30A3\u30F3\u30B0\u3001\u8868\u793A\u3092\u5B8C\u5168\u306B\u5236\u5FA1\u3067\u304D\u308B SPA \u3092\u4F5C\u6210\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002SPA \u30A8\u30C7\u30A3\u30BF\u30FC\u306F\u3001React \u306E\u30D5\u30EC\u30FC\u30E0\u30EF\u30FC\u30AF\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002',
    'spa_editor.title': 'AEM \u3067 SPA \u3092\u7BA1\u7406',
    'spa_editor_remote_spa.links.0': '\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3092\u958B\u59CB',
    'spa_editor_remote_spa.text':
      'AEM \u306E\u30EA\u30E2\u30FC\u30C8 SPA \u6A5F\u80FD\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30DE\u30FC\u30B1\u30BF\u30FC\u306F\u3001\u30EA\u30E2\u30FC\u30C8\u3067\u30DB\u30B9\u30C8\u3055\u308C\u305F SPA \u306E\u5BFE\u8C61\u9818\u57DF\u3092\u66F4\u65B0\u3067\u304D\u307E\u3059\u3002',
    'spa_editor_remote_spa.title': '\u30EA\u30E2\u30FC\u30C8 SPA \u3092\u30AA\u30FC\u30B5\u30EA\u30F3\u30B0',
    'technical_docs.apis.section.formsapis': 'AEM Forms HTTP API',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms API\uFF08OpenAPI\uFF09',
    'technical_docs.apis.section.graphqlapis': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.1': '\u30B5\u30F3\u30D7\u30EB GraphQL \u30AF\u30A8\u30EA',
    'technical_docs.apis.section.relatedhttpapis': '\u95A2\u9023\u3059\u308B HTTP API',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP API',
    'technical_docs.apis.text':
      'AEM \u306E GraphQL API \u3068\u3001\u30AF\u30A8\u30EA\u304A\u3088\u3073 HTTP \u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u69CB\u6210\u65B9\u6CD5\u306B\u3064\u3044\u3066\u5B66\u7FD2\u3057\u307E\u3059\u3002',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments':
      '\u30B3\u30F3\u30C6\u30F3\u30C4\u30D5\u30E9\u30B0\u30E1\u30F3\u30C8',
    'technical_docs.documentation.section.contentfragments.links.0':
      '\u30B3\u30F3\u30C6\u30F3\u30C4\u30D5\u30E9\u30B0\u30E1\u30F3\u30C8\u306E\u6709\u52B9\u5316',
    'technical_docs.documentation.section.contentfragments.links.1':
      '\u30B3\u30F3\u30C6\u30F3\u30C4\u30D5\u30E9\u30B0\u30E1\u30F3\u30C8\u30E2\u30C7\u30EB',
    'technical_docs.documentation.section.contentfragments.links.2':
      '\u30B3\u30F3\u30C6\u30F3\u30C4\u30D5\u30E9\u30B0\u30E1\u30F3\u30C8\u306E\u7BA1\u7406',
    'technical_docs.documentation.section.contentfragments.links.3': '\u30D0\u30EA\u30A8\u30FC\u30B7\u30E7\u30F3',
    'technical_docs.documentation.section.contentfragments.links.4': '\u95A2\u9023\u30B3\u30F3\u30C6\u30F3\u30C4',
    'technical_docs.documentation.section.contentfragments.links.5': '\u30E1\u30BF\u30C7\u30FC\u30BF',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\u69CB\u9020\u30C4\u30EA\u30FC',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON \u30D7\u30EC\u30D3\u30E5\u30FC',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0':
      '\u30D8\u30C3\u30C9\u30EC\u30B9\u30A2\u30C0\u30D7\u30C6\u30A3\u30D6\u30D5\u30A9\u30FC\u30E0',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM \u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0':
      'GraphQL \u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u306E\u6709\u52B9\u5316',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1':
      'GraphQL \u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u306E\u516C\u958B',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': '\u6C38\u7D9A\u30AF\u30A8\u30EA',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3':
      '\u6C38\u7D9A\u30AF\u30A8\u30EA\u3092\u516C\u958B',
    'technical_docs.documentation.text':
      'AEM \u306E\u6A5F\u80FD\u304A\u3088\u3073\u8A2D\u5B9A\u306B\u3064\u3044\u3066\u8A73\u3057\u304F\u306F\u3001Adobe Experience Manager as a Cloud Service \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'technical_docs.documentation.title': '\u8FFD\u52A0\u306E\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8',
    'technical_docs.how-to.section.content': '\u30B3\u30F3\u30C6\u30F3\u30C4',
    'technical_docs.how-to.section.content.links.0': '\u30EA\u30C3\u30C1\u30C6\u30AD\u30B9\u30C8',
    'technical_docs.how-to.section.content.links.1': '\u753B\u50CF',
    'technical_docs.how-to.section.content.links.2':
      '\u30ED\u30FC\u30AB\u30E9\u30A4\u30BA\u3055\u308C\u305F\u30B3\u30F3\u30C6\u30F3\u30C4',
    'technical_docs.how-to.section.content.links.3': '\u5927\u304D\u306A\u7D50\u679C\u30BB\u30C3\u30C8',
    'technical_docs.how-to.section.content.links.4': '\u30D7\u30EC\u30D3\u30E5\u30FC',
    'technical_docs.how-to.section.deployment': '\u30C7\u30D7\u30ED\u30A4\u30E1\u30F3\u30C8',
    'technical_docs.how-to.section.deployment.links.0':
      '\u5358\u4E00\u30DA\u30FC\u30B8\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3',
    'technical_docs.how-to.section.deployment.links.1': 'Web \u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8',
    'technical_docs.how-to.section.deployment.links.2': '\u30E2\u30D0\u30A4\u30EB',
    'technical_docs.how-to.section.deployment.links.3': '\u30B5\u30FC\u30D0\u30FC\u30C4\u30FC\u30B5\u30FC\u30D0\u30FC',
    'technical_docs.how-to.section.development': '\u958B\u767A',
    'technical_docs.how-to.section.development.links.0': 'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 SDK',
    'technical_docs.how-to.section.development.links.1':
      'AEM 6.5 \u306B GraphiQL IDE \u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB',
    'technical_docs.how-to.text':
      'AEM Headless \u3092\u4F7F\u7528\u3057\u305F\u7570\u306A\u308B\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u306E\u30A2\u30D7\u30ED\u30FC\u30C1\u306E\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002',
    'technical_docs.how-to.title': '\u30CF\u30A6\u30C4\u30FC\u30AC\u30A4\u30C9',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': '\u30B5\u30FC\u30D0\u30FC\u30B5\u30A4\u30C9 JS SDK',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm \u30E2\u30B8\u30E5\u30FC\u30EB',
    'technical_docs.sdks.text':
      'Storybook \u3092\u4F7F\u7528\u3057\u3066\u3001AEM Headless API \u3068\u3084\u308A\u53D6\u308A\u3057\u307E\u3059\u3002',
    'technical_docs.sdks.title': 'SDK',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1':
      'AEM 6.5 GraphiQL \u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u30AC\u30A4\u30C9',
    'technical_docs.tools.text':
      'AEM \u306E\u30D8\u30C3\u30C9\u30EC\u30B9\u958B\u767A\u8005\u30C4\u30FC\u30EB\u306B\u3064\u3044\u3066\u5B66\u7FD2\u3057\u307E\u3059\u3002',
    'technical_docs.tools.title': '\u30C4\u30FC\u30EB',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, and rendering them in React.',
    'code_index.basic-react-app.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details`,
    'code_index.react-app-with-custom-components.title': 'React App with custom components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using custom and default components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components
+ Renders the form using Custom and default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them in React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a  href='https://nextjs.org/'>Next.js</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details`,
    'code_index.react-app-with-material-ui-components.title': 'React App with material ui component',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating components using material ui library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React native app for creating JSON-based forms, fetching forms from AEM, and rendering them in react native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React native</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-native-app/README.md'>here</a> for more details`,
  },
  IA = {
    'app.hero.cta': '\uC791\uB3D9\uD558\uB294 \uBC95 \uC54C\uC544\uBCF4\uAE30',
    'app.hero.solution': 'Adobe Experience Manager \uD5E4\uB4DC\uB9AC\uC2A4',
    'app.hero.text':
      '\uBCF4\uB2E4 \uC6B0\uC218\uD55C \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uACFC \uBE60\uB978 \uACBD\uD5D8\uC744 \uC791\uC131, \uBC30\uD3EC\uD558\uAE30 \uC704\uD574 AEM\uC758 \uD5E4\uB4DC\uB9AC\uC2A4 CMS\uC5D0 \uB300\uD574 \uC54C\uC544 \uB450\uC5B4\uC57C \uD560 \uBAA8\uB4E0 \uB0B4\uC6A9\uC744 \uB2E4\uB8F9\uB2C8\uB2E4.',
    'app.hero.title': 'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS\uB85C \uBE4C\uB4DC \uC2DC\uC791',
    'code_by_id.button.back': '\uCF54\uB4DC \uB180\uC774\uD130\uB85C \uB3CC\uC544\uAC00\uAE30',
    'code_by_id.button.enter_widescreen': '\uB113\uC740 \uD654\uBA74 \uBAA8\uB4DC \uC2DC\uC791',
    'code_by_id.button.exit_widescreen': '\uB113\uC740 \uD654\uBA74 \uBAA8\uB4DC \uC885\uB8CC',
    'code_index.button.run_the_code': '\uCF54\uB4DC \uC2E4\uD589',
    'code_index.text': 'Test drive AEM Headless Form in seconds using example React apps!',
    'code_index.title': '\uCF54\uB4DC \uB180\uC774\uD130',
    'community.links.0': '\uB300\uD654 \uCC38\uC5EC\uD558\uAE30',
    'community.text':
      'Experience League \uCEE4\uBBA4\uB2C8\uD2F0\uC5D0 \uC788\uB294 AEM \uAC1C\uBC1C\uC790 \uCEE4\uBBA4\uB2C8\uD2F0\uC5D0\uC11C AEM \uD5E4\uB4DC\uB9AC\uC2A4\uC5D0 \uB300\uD574 \uB300\uD654\uD558\uACE0, \uC9C8\uBB38\uD558\uACE0, \uB2F5\uBCC0\uC744 \uC5BB\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'community.title': '\uB300\uD654 \uCC38\uC5EC\uD558\uAE30',
    'error.text':
      '\uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.',
    'error.title': '\uC774\uB7F0! \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.',
    'example_apps_android.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_android.text':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 API\uC5D0\uC11C \uCEE8\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 Android \uC571 \uC608\uC2DC',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_ios.text':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 API\uC5D0\uC11C \uCEE8\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 SwiftUI iOS \uC571 \uC608\uC2DC',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_next_js.text':
      'AEM Headless API\uC758 \uCF58\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 Next.js \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC758 \uC608\uC2DC\uC785\uB2C8\uB2E4.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_node-js.text':
      'AEM Headless API\uC758 \uCF58\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 \uBA85\uB839\uC904 Node.js \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC758 \uC608\uC2DC\uC785\uB2C8\uB2E4.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_react.text':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 API\uC5D0\uC11C \uCEE8\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 React \uC560\uD50C\uB9AC\uCF00\uC774\uC158 \uC608\uC2DC',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_web-component.text':
      'AEM Headless API\uC758 \uCF58\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 \uC21C\uC218 JavaScript \uC6F9 \uAD6C\uC131 \uC694\uC18C\uC758 \uC608\uC2DC\uC785\uB2C8\uB2E4.',
    'example_apps_web-component.title': '\uC6F9 \uAD6C\uC131 \uC694\uC18C/JS',
    'experienced_developers.text1':
      'AEM\uC744 \uC0AC\uC6A9\uD558\uC5EC \uACBD\uD5D8\uC744 \uB9CC\uB4E4\uACE0 \uAD00\uB9AC\uD558\uBA70 \uAC8C\uC7AC\uD558\uB294 { fiveSteps}\uB97C \uC9C4\uD589\uD574 \uBCF4\uC138\uC694. { break } \uC774\uBBF8 \uC644\uB8CC\uD558\uC168\uB098\uC694? \uADF8\uB807\uB2E4\uBA74 { advancedDocumentation }\uB3C4 \uD655\uC778\uD558\uC138\uC694.',
    'experienced_developers.title': '\uB300\uC0C1: { emphasis } AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS \uAC1C\uBC1C\uC790',
    'experienced_developers.title.emphasis': '\uC219\uB828',
    'get_involved_blog.links.0': '\uBE14\uB85C\uADF8 \uC77D\uAE30',
    'get_involved_blog.text':
      'Adobe \uAE30\uC220 \uBE14\uB85C\uADF8\uC5D0\uC11C \uCD5C\uC2E0 \uC815\uBCF4\uB97C \uD655\uC778\uD558\uC138\uC694.',
    'get_involved_blog.title': 'Adobe \uAE30\uC220 \uBE14\uB85C\uADF8',
    'get_involved_community.links.0': '\uB300\uD654 \uCC38\uC5EC',
    'get_involved_community.text':
      '\uCEE4\uBBA4\uB2C8\uD2F0\uC5D0 \uAC00\uC785\uD558\uC5EC \uC9C8\uBB38\uC5D0 \uB300\uD55C \uB2F5\uBCC0\uC744 \uD655\uC778\uD558\uC138\uC694.',
    'get_involved_community.title': 'Experience League \uCEE4\uBBA4\uB2C8\uD2F0',
    'nav.codePlayground': '\uCF54\uB4DC \uB180\uC774\uD130',
    'nav.home': '\uD648',
    'nav.title': 'AEM Headless Form developer portal',
    'new_developers.text':
      '\uC774 { guideLink }\uC5D0\uC11C AEM\uC758 headless CMS \uAE30\uB2A5\uACFC \uC774\uB97C \uD5E4\uB4DC\uB9AC\uC2A4 \uAC1C\uBC1C \uD504\uB85C\uC81D\uD2B8\uC5D0 \uD65C\uC6A9\uD558\uB294 \uBC29\uBC95\uC744 \uC54C\uC544\uBCF4\uC138\uC694.',
    'new_developers.text.5_steps': '\uB2E4\uC12F \uB2E8\uACC4',
    'new_developers.text.advanced_documentation': '\uACE0\uAE09 \uC124\uBA85\uC11C',
    'new_developers.text.guide_link': '\uC548\uB0B4\uC11C',
    'new_developers.title': '\uB300\uC0C1: AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS { emphasis } \uAC1C\uBC1C\uC790',
    'new_developers.title.emphasis': '\uC2E0\uADDC',
    'new_to_aem_headless.links.0': '\uAC00\uC774\uB4DC \uC77D\uAE30',
    'page.description':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS \uAC1C\uBC1C\uC790 \uB9AC\uC18C\uC2A4 \uBC0F \uC124\uBA85\uC11C\uB97C \uBC29\uBB38\uD558\uC138\uC694. Experience Manager as a Cloud Service\uC5D0\uC11C \uD5E4\uB4DC\uB9AC\uC2A4 CMS \uAE30\uC220\uC744 \uC0AC\uC6A9\uD558\uC5EC \uCC28\uC138\uB300 \uC571\uC744 \uBE4C\uB4DC\uD558\uB294 \uBC29\uBC95\uC744 \uC54C\uC544\uBCF4\uC138\uC694.',
    'page.title':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS \uAC1C\uBC1C\uC790 \uB9AC\uC18C\uC2A4 \uBC0F \uC124\uBA85\uC11C | Adobe Experience Manager',
    'quick_setup.links.0': 'Cloud Service \uBE60\uB974\uAC8C \uC124\uC815\uD558\uAE30',
    'quick_setup.links.1': '\uB85C\uCEEC AEM SDK \uBE60\uB974\uAC8C \uC124\uC815\uD558\uAE30',
    'quick_setup.text':
      'React \uC571\uC744 \uC774\uC6A9\uD574 \uB2E8 \uBA87 \uBD84\uB9CC\uC5D0 AEM \uD5E4\uB4DC\uB9AC\uC2A4 \uC124\uCE58 \uBC0F \uD14C\uC2A4\uD2B8 \uB4DC\uB77C\uC774\uBE0C',
    'quick_setup.title': '\uBE60\uB978 \uC124\uCE58',
    'section_developer_resources.title': '\uACE0\uAE09 \uC124\uBA85\uC11C',
    'section_example_apps.title': 'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS \uC571 \uC608\uC2DC',
    'section_get_involved.title': '\uCC38\uC5EC\uD574 \uBCF4\uC138\uC694!',
    'section_spa_editor.text':
      'AEM SPA \uD3B8\uC9D1\uAE30\uC758 \uD504\uB808\uC784\uC6CC\uD06C\uC5D0\uC11C\uB294 \uB9C8\uCF00\uD130\uAC00 AEM\uC5D0\uC11C \uC791\uC131\uD55C UI\uB97C \uC774\uC6A9\uD574 \uCEE8\uD14D\uC2A4\uD2B8 \uB0B4\uC5D0 \uC5C5\uB370\uC774\uD2B8\uD560 \uC218 \uC788\uB294 React\uB098 Angular \uC571\uC744 \uB9CC\uB4E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'section_spa_editor.title': 'AEM SPA \uD3B8\uC9D1\uAE30 \uC54C\uC544\uBCF4\uAE30',
    'spa_editor.links.0': 'React \uD29C\uD1A0\uB9AC\uC5BC \uC2DC\uC791\uD558\uAE30',
    'spa_editor.text':
      'AEM SPA \uD3B8\uC9D1\uAE30\uB294 SPA\uB97C \uC0DD\uC131\uD558\uB294\uB370 \uC0AC\uC6A9\uB429\uB2C8\uB2E4. SPA\uC758 \uAD6C\uC131\uC694\uC18C, \uB77C\uC6B0\uD305, \uBCF4\uAE30\uB294 AEM\uC5D0\uC11C \uC644\uC804\uD788 \uAD00\uB9AC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. SPA \uD3B8\uC9D1\uAE30\uB294 React \uD504\uB808\uC784\uC6CC\uD06C\uB97C \uC9C0\uC6D0\uD569\uB2C8\uB2E4.',
    'spa_editor.title': 'AEM\uC5D0\uC11C SPA \uAD00\uB9AC\uD558\uAE30',
    'spa_editor_remote_spa.links.0': '\uD29C\uD1A0\uB9AC\uC5BC \uC2DC\uC791\uD558\uAE30',
    'spa_editor_remote_spa.text':
      'AEM\uC758 Remote SPA \uAE30\uB2A5\uC744 \uD1B5\uD574 \uB9C8\uCF00\uD130\uB294 \uC6D0\uACA9\uC73C\uB85C \uD638\uC2A4\uD305\uB41C SPA\uC758 \uD0C0\uAC9F \uC9C0\uC5ED\uC744 \uC5C5\uB370\uC774\uD2B8\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'spa_editor_remote_spa.title': '\uC6D0\uACA9 SPA \uC791\uC131',
    'technical_docs.apis.section.formsapis': 'AEM Forms HTTP API',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms API(OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL APIs',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.1': '\uC0D8\uD50C GraphQL \uCFFC\uB9AC',
    'technical_docs.apis.section.relatedhttpapis': '\uAD00\uB828\uB41C HTTP API',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP API',
    'technical_docs.apis.text':
      'AEM\uC758 GraphQL API\uC640 \uCFFC\uB9AC \uBC0F HTTP \uC694\uCCAD \uB9CC\uB4DC\uB294 \uBC29\uBC95 \uC54C\uC544\uBCF4\uAE30',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': '\uCF58\uD150\uCE20 \uC870\uAC01',
    'technical_docs.documentation.section.contentfragments.links.0':
      '\uCEE8\uD150\uCE20 \uC870\uAC01 \uD65C\uC131\uD654',
    'technical_docs.documentation.section.contentfragments.links.1': '\uCF58\uD150\uCE20 \uC870\uAC01 \uBAA8\uB378',
    'technical_docs.documentation.section.contentfragments.links.2': '\uCF58\uD150\uCE20 \uC870\uAC01 \uAD00\uB9AC',
    'technical_docs.documentation.section.contentfragments.links.3': '\uBCC0\uD615',
    'technical_docs.documentation.section.contentfragments.links.4': '\uAD00\uB828 \uCEE8\uD150\uCE20',
    'technical_docs.documentation.section.contentfragments.links.5': '\uBA54\uD0C0\uB370\uC774\uD130',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\uAD6C\uC870 \uD2B8\uB9AC',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON \uBBF8\uB9AC \uBCF4\uAE30',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': '\uD5E4\uB4DC\uB9AC\uC2A4 \uC801\uC751\uD615 \uC591\uC2DD',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM \uC5D4\uB4DC\uD3EC\uC778\uD2B8',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0':
      'GraphQL \uC5D4\uB4DC\uD3EC\uC778\uD2B8 \uD65C\uC131\uD654',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1':
      'GraphQL \uC5D4\uB4DC\uD3EC\uC778\uD2B8 \uAC8C\uC2DC',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': '\uC9C0\uC18D\uD615 \uCFFC\uB9AC',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': '\uC601\uC18D\uD654 \uCFFC\uB9AC \uAC8C\uC2DC',
    'technical_docs.documentation.text':
      'AEM\uC758 \uC804\uCCB4 \uAE30\uB2A5\uACFC \uAD6C\uD604 \uC124\uBA85\uC744 \uBCF4\uB824\uBA74 Adobe Experience Manager as a Cloud Service \uC124\uBA85\uC11C\uB97C \uBCF4\uC138\uC694.',
    'technical_docs.documentation.title': '\uCD94\uAC00 \uC124\uBA85\uC11C',
    'technical_docs.how-to.section.content': '\uCF58\uD150\uCE20',
    'technical_docs.how-to.section.content.links.0': '\uB9AC\uCE58 \uD14D\uC2A4\uD2B8',
    'technical_docs.how-to.section.content.links.1': '\uC774\uBBF8\uC9C0',
    'technical_docs.how-to.section.content.links.2': '\uC9C0\uC5ED\uD654 \uCF58\uD150\uCE20',
    'technical_docs.how-to.section.content.links.3': '\uB300\uADDC\uBAA8 \uACB0\uACFC \uC9D1\uD569',
    'technical_docs.how-to.section.content.links.4': '\uBBF8\uB9AC\uBCF4\uAE30',
    'technical_docs.how-to.section.deployment': '\uBC30\uD3EC',
    'technical_docs.how-to.section.deployment.links.0': '\uB2E8\uC77C \uD398\uC774\uC9C0 \uC571',
    'technical_docs.how-to.section.deployment.links.1': '\uC6F9 \uAD6C\uC131 \uC694\uC18C',
    'technical_docs.how-to.section.deployment.links.2': '\uBAA8\uBC14\uC77C',
    'technical_docs.how-to.section.deployment.links.3': '\uC11C\uBC84 \uD22C \uC11C\uBC84',
    'technical_docs.how-to.section.development': '\uAC1C\uBC1C',
    'technical_docs.how-to.section.development.links.0': 'Storybook',
    'technical_docs.how-to.section.development.links.1': 'AEM 6.5\uC5D0 GraphiQL IDE \uC124\uCE58',
    'technical_docs.how-to.text':
      'AEM Headless\uC758 \uB2E4\uC591\uD55C \uC0AC\uC6A9 \uC0AC\uB840\uC5D0 \uC811\uADFC\uD558\uB294 \uBC29\uBC95\uC744 \uC54C\uC544\uBD05\uB2C8\uB2E4.',
    'technical_docs.how-to.title': '\uBC29\uBC95 \uC548\uB0B4\uC11C',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': '\uC11C\uBC84 \uCE21 JS SDK',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm \uBAA8\uB4C8',
    'technical_docs.sdks.text':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 SDK\uB97C \uC774\uC6A9\uD574 AEM \uD5E4\uB4DC\uB9AC\uC2A4 API\uC640 \uC0C1\uD638\uC791\uC6A9\uD558\uAE30',
    'technical_docs.sdks.title': 'SDKs',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'AEM 6.5 GraphiQL \uC124\uCE58 \uAC00\uC774\uB4DC',
    'technical_docs.tools.text':
      'AEM\uC758 \uD5E4\uB4DC\uB9AC\uC2A4 \uAC1C\uBC1C\uC790 \uB3C4\uAD6C \uC54C\uC544\uBCF4\uAE30',
    'technical_docs.tools.title': '\uB3C4\uAD6C',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, and rendering them in React.',
    'code_index.basic-react-app.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details`,
    'code_index.react-app-with-custom-components.title': 'React App with custom components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using custom and default components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components
+ Renders the form using Custom and default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them in React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a  href='https://nextjs.org/'>Next.js</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details`,
    'code_index.react-app-with-material-ui-components.title': 'React App with material ui component',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating components using material ui library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React native app for creating JSON-based forms, fetching forms from AEM, and rendering them in react native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React native</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-native-app/README.md'>here</a> for more details`,
  },
  DA = {
    'app.hero.cta': 'Zie hoe het werkt',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      'Alles wat u moet leren over AEM Headless CMS om betere applicaties en snellere ervaringen te kunnen samenstellen en leveren.',
    'app.hero.title': 'Begin met het ontwikkelen van AEM Headless CMS',
    'code_by_id.button.back': 'Terug naar code playground',
    'code_by_id.button.enter_widescreen': 'Breedbeeldmodus activeren',
    'code_by_id.button.exit_widescreen': 'Breedbeeldmodus afsluiten',
    'code_index.button.run_the_code': 'De code uitvoeren',
    'code_index.text': 'Test drive AEM Headless Form in seconds using example React apps!',
    'code_index.title': 'Code playground',
    'community.links.0': 'Deelnemen aan de discussie',
    'community.text':
      'Doe mee aan discussies en stel vragen over AEM Headless op Experience League Communities en krijg antwoorden van de gehele AEM-ontwikkelaarscommunity.',
    'community.title': 'Deelnemen aan de discussie',
    'error.text': 'Er is iets fout gegaan. Probeer het later opnieuw.',
    'error.title': 'Er is een fout opgetreden.',
    'example_apps_android.links.0': 'De app bekijken',
    'example_apps_android.text': "Voorbeeld van een Java Android-app die content gebruikt van AEM Headless-API's.",
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'De app bekijken',
    'example_apps_ios.text': "Voorbeeld van een SwiftUI iOS-app die content gebruikt van AEM Headless-API's.",
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'De app bekijken',
    'example_apps_next_js.text': "Voorbeeld van een Next.js-applicatie die content gebruikt van AEM Headless-API's.",
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'De app bekijken',
    'example_apps_node-js.text':
      "Voorbeeld van een command-line Node.js-applicatie die content gebruikt van AEM Headless-API's.",
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'De app bekijken',
    'example_apps_react.text': "Voorbeeld van een React-app die content gebruikt van AEM Headless-API's.",
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'De app bekijken',
    'example_apps_web-component.text':
      "Voorbeeld van een zuivere JavaScript-webcomponent die content gebruikt van AEM Headless-API's.",
    'example_apps_web-component.title': 'Webcomponent/JS',
    'experienced_developers.text1':
      'Doorloop { fiveSteps} voor het maken, beheren en leveren van ervaringen met AEM. { break } Al klaar? Ga dan naar de { advancedDocumentation }.',
    'experienced_developers.title': 'VOOR { emphasis } AEM HEADLESS CMS-ONTWIKKELAARS',
    'experienced_developers.title.emphasis': 'ERVAREN',
    'get_involved_blog.links.0': 'De blog lezen',
    'get_involved_blog.text': 'Lees al het nieuws in onze tech blog.',
    'get_involved_blog.title': 'Adobe Tech Blog',
    'get_involved_community.links.0': 'Praat mee',
    'get_involved_community.text': 'Word lid van onze community en vind antwoorden op uw vragen.',
    'get_involved_community.title': 'Experience League Communities',
    'nav.codePlayground': 'Code playground',
    'nav.home': 'Startpagina',
    'nav.title': 'AEM Headless Form developer portal',
    'new_developers.text':
      'In { guideLink } vindt u meer informatie over de Headless CMS-functies van AEM en over het gebruik ervan in een Headless-ontwikkelingsproject.',
    'new_developers.text.5_steps': '5 stappen',
    'new_developers.text.advanced_documentation': 'documentatie voor geavanceerde gebruikers',
    'new_developers.text.guide_link': 'handleiding',
    'new_developers.title': 'VOOR ONTWIKKELAARS { emphasis } NAAR AEM HEADLESS CMS',
    'new_developers.title.emphasis': 'NIEUW',
    'new_to_aem_headless.links.0': 'De gids lezen',
    'page.description':
      'Bezoek de AEM Headless CMS-resources en -documentatie voor ontwikkelaars. Ontdek hoe u apps van de volgende generatie kunt ontwikkelen met behulp van Headless CMS-technologie\xEBn in Experience Manager as a Cloud Service.',
    'page.title': 'Informatiebronnen en documentatie voor headless CMS-ontwikkelaars AEM | Adobe Experience Manager',
    'quick_setup.links.0': 'Snelle set-up voor Cloud Service',
    'quick_setup.links.1': 'Snelle set-up voor lokale AEM SDK',
    'quick_setup.text': 'Installeer en test AEM Headless binnen enkele minuten met behulp van een React-voorbeeldapp.',
    'quick_setup.title': 'Snelle installatie',
    'section_developer_resources.title': 'Documentatie voor geavanceerde gebruikers',
    'section_example_apps.title': 'Voorbeeld van AEM Headless CMS-apps',
    'section_get_involved.title': 'Doe mee.',
    'section_spa_editor.text':
      'De AEM SPA Editor biedt een ontwikkelkader voor React- of Angular-apps die in-context kunnen worden bijgewerkt door marketeers met gebruik van de AEM-ontwerpinterface.',
    'section_spa_editor.title': 'De AEM SPA Editor verkennen',
    'spa_editor.links.0': 'React-tutorial starten',
    'spa_editor.text':
      'Met de AEM SPA Editor kunt u een SPA maken waarvan de componenten, routering en weergaven volledig kunnen worden beheerd in AEM. De SPA Editor biedt ondersteuning voor het React-kader.',
    'spa_editor.title': 'Een SPA beheren in AEM',
    'spa_editor_remote_spa.links.0': 'Tutorial starten',
    'spa_editor_remote_spa.text':
      "Met de externe SPA-capaciteiten van AEM kunnen marketeers de getargete regio's van een extern gehoste SPA bijwerken.",
    'spa_editor_remote_spa.title': 'Een externe SPA ontwerpen',
    'technical_docs.apis.section.formsapis': "AEM Forms HTTP-API's",
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms-API (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': "GraphQL-API's",
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL-API',
    'technical_docs.apis.section.graphqlapis.links.1': "Voorbeeldquery's van GraphQL",
    'technical_docs.apis.section.relatedhttpapis': "Verwante HTTP-API's",
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP-API',
    'technical_docs.apis.text':
      "Leer van alles over de GraphQL-API's van AEM en over hoe u query's and HTTP-aanvragen opstelt.",
    'technical_docs.apis.title': "API's",
    'technical_docs.documentation.section.contentfragments': 'Contentfragmenten',
    'technical_docs.documentation.section.contentfragments.links.0': 'Contentfragmenten inschakelen',
    'technical_docs.documentation.section.contentfragments.links.1': 'Modellen van contentfragmenten',
    'technical_docs.documentation.section.contentfragments.links.2': 'Contentfragmenten beheren',
    'technical_docs.documentation.section.contentfragments.links.3': 'Variaties',
    'technical_docs.documentation.section.contentfragments.links.4': 'Gekoppelde content',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadata',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Boomstructuur',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON-voorvertoning',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Headless Adaptive Forms',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM-eindpunt',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Een GraphQL-eindpunt inschakelen',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Een GraphQL-eindpunt publiceren',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': "Permanente query's",
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': "Standhoudende query's publiceren",
    'technical_docs.documentation.text':
      'Raadpleeg de documentatie van Adobe Experience Manager as a Cloud Service voor een volledige beschrijving van de mogelijkheden en configuraties van AEM.',
    'technical_docs.documentation.title': 'Aanvullende documentatie',
    'technical_docs.how-to.section.content': 'Content',
    'technical_docs.how-to.section.content.links.0': 'Rich Text',
    'technical_docs.how-to.section.content.links.1': 'Afbeeldingen',
    'technical_docs.how-to.section.content.links.2': 'Gelokaliseerde content',
    'technical_docs.how-to.section.content.links.3': 'Grote resultatensets',
    'technical_docs.how-to.section.content.links.4': 'Voorvertoning',
    'technical_docs.how-to.section.deployment': 'Implementatie',
    'technical_docs.how-to.section.deployment.links.0': 'Single-page application',
    'technical_docs.how-to.section.deployment.links.1': 'Webcomponent',
    'technical_docs.how-to.section.deployment.links.2': 'Mobiel',
    'technical_docs.how-to.section.deployment.links.3': 'Server-naar-server',
    'technical_docs.how-to.section.development': 'Ontwikkeling',
    'technical_docs.how-to.section.development.links.0': 'Storybook',
    'technical_docs.how-to.section.development.links.1': 'GraphiQL IDE installeren op AEM 6.5',
    'technical_docs.how-to.text': "Leer hoe u verschillende gebruiksscenario's aanpakt met AEM Headless.",
    'technical_docs.how-to.title': 'Instructiegidsen',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java-SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': 'JS-SDK aan serverzijde',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm-module',
    'technical_docs.sdks.text': "Storybook's gebruiken voor interactie met AEM Headless-API's.",
    'technical_docs.sdks.title': "SDK's",
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'AEM 6.5 GraphiQL-installatiegids',
    'technical_docs.tools.text': 'Ontdek de AEM Headless-tools voor ontwikkelaars.',
    'technical_docs.tools.title': 'Tools',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, and rendering them in React.',
    'code_index.basic-react-app.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details`,
    'code_index.react-app-with-custom-components.title': 'React App with custom components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using custom and default components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components
+ Renders the form using Custom and default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them in React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a  href='https://nextjs.org/'>Next.js</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details`,
    'code_index.react-app-with-material-ui-components.title': 'React App with material ui component',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating components using material ui library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React native app for creating JSON-based forms, fetching forms from AEM, and rendering them in react native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React native</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-native-app/README.md'>here</a> for more details`,
  },
  OA = {
    'app.hero.cta': 'Veja como ele funciona',
    'app.hero.solution': 'Headless do Adobe Experience Manager',
    'app.hero.text':
      'Tudo o que voc\xEA precisa aprender sobre o AEM Headless CMS para criar e enviar melhores aplicativos e experi\xEAncias mais r\xE1pidas.',
    'app.hero.title': 'Comece a criar com o CMS headless do AEM',
    'code_by_id.button.back': 'Voltar ao playground de c\xF3digo',
    'code_by_id.button.enter_widescreen': 'Entrar no modo widescreen',
    'code_by_id.button.exit_widescreen': 'Sair do modo widescreen',
    'code_index.button.run_the_code': 'Executar o c\xF3digo',
    'code_index.text': 'Test drive AEM Headless Form in seconds using example React apps!',
    'code_index.title': 'Playground de c\xF3digo',
    'community.links.0': 'Participar da conversa',
    'community.text':
      'Converse, fa\xE7a perguntas e receba respostas sobre o AEM Headless com toda a comunidade de desenvolvedores do AEM nas Experience League Communities.',
    'community.title': 'Participar da conversa',
    'error.text': 'Algo deu errado. Tente novamente mais tarde.',
    'error.title': 'Ops, ocorreu um erro.',
    'example_apps_android.links.0': 'Ver o aplicativo',
    'example_apps_android.text':
      'Um exemplo de aplicativo Android Java que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'Ver o aplicativo',
    'example_apps_ios.text':
      'Um exemplo de aplicativo SwiftUI para iOS que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Ver o aplicativo',
    'example_apps_next_js.text': 'Um exemplo de aplicativo Next.js que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Ver o aplicativo',
    'example_apps_node-js.text':
      'Um exemplo de aplicativo de Node.js da linha de comando que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'Ver o aplicativo',
    'example_apps_react.text': 'Um exemplo de aplicativo React que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Ver o aplicativo',
    'example_apps_web-component.text':
      'Um exemplo puro de Componente da Web do JavaScript que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_web-component.title': 'Componente da Web/JS',
    'experienced_developers.text1':
      'Siga os { fiveSteps} para criar, gerenciar e fornecer experi\xEAncias usando o AEM. { break } Tudo pronto? Acesse nossa { advancedDocumentation }.',
    'experienced_developers.title': 'PARA { emphasis } DESENVOLVEDORES DO CMS HEADLESS DO AEM',
    'experienced_developers.title.emphasis': 'COM EXPERI\xCANCIA',
    'get_involved_blog.links.0': 'Ler o blog',
    'get_involved_blog.text': 'Leia as novidades em nosso blog de tecnologia.',
    'get_involved_blog.title': 'Blog de tecnologia da Adobe',
    'get_involved_community.links.0': 'Participar da conversa',
    'get_involved_community.text': 'Junte-se a nossa comunidade e tire suas d\xFAvidas.',
    'get_involved_community.title': 'Comunidades da Experience League',
    'nav.codePlayground': 'Playground de c\xF3digo',
    'nav.home': 'In\xEDcio',
    'nav.title': 'AEM Headless Form developer portal',
    'new_developers.text':
      'Leia este { guideLink } para aprender sobre os recursos do AEM Headless CMS e como aproveit\xE1-los em um projeto de desenvolvimento de Headless.',
    'new_developers.text.5_steps': '5 etapas',
    'new_developers.text.advanced_documentation': 'documenta\xE7\xE3o avan\xE7ada',
    'new_developers.text.guide_link': 'guia',
    'new_developers.title': 'PARA DESENVOLVEDORES { emphasis } PARA CMS HEADLESS DO AEM',
    'new_developers.title.emphasis': 'NOVO',
    'new_to_aem_headless.links.0': 'Ler o guia',
    'page.description':
      'Visite os recursos e a documenta\xE7\xE3o do desenvolvedor do CMS headless do AEM. Saiba como criar aplicativos de \xFAltima gera\xE7\xE3o usando tecnologias CMS headless no Experience Manager como Cloud Service.',
    'page.title': 'AEM Recursos e documenta\xE7\xE3o do desenvolvedor do CMS headless | Adobe Experience Manager',
    'quick_setup.links.0': 'Configura\xE7\xE3o r\xE1pida do Cloud Service',
    'quick_setup.links.1': 'Configura\xE7\xE3o r\xE1pida para SDK local do AEM',
    'quick_setup.text': 'Configure e experimente o AEM Headless em poucos minutos com um exemplo do aplicativo React',
    'quick_setup.title': 'Configura\xE7\xE3o r\xE1pida',
    'section_developer_resources.title': 'Documenta\xE7\xE3o avan\xE7ada',
    'section_example_apps.title': 'Exemplo de aplicativos do CMS headless do AEM',
    'section_get_involved.title': 'Envolva-se!',
    'section_spa_editor.text':
      'O Editor de aplicativo de p\xE1gina \xFAnica (SPA) do AEM oferece uma estrutura para desenvolver aplicativos React ou Angular que podem ser atualizados no contexto por profissionais de marketing que usam a UI de cria\xE7\xE3o do AEM.',
    'section_spa_editor.title': 'Explore o Editor de SPA do AEM',
    'spa_editor.links.0': 'Iniciar o tutorial sobre o React',
    'spa_editor.text':
      'O Editor de SPA do AEM pode ser usado para criar um SPA com componentes, roteamento e exibi\xE7\xF5es que podem ser gerenciados completamente no AEM. O Editor de SPA \xE9 compat\xEDvel com a estrutura React.',
    'spa_editor.title': 'Gerencie um SPA no AEM',
    'spa_editor_remote_spa.links.0': 'Iniciar o tutorial',
    'spa_editor_remote_spa.text':
      'Os recursos de SPA remoto do AEM permite que os profissionais de marketing atualizem regi\xF5es segmentadas de um SPA hospedado remotamente.',
    'spa_editor_remote_spa.title': 'Crie um SPA remoto',
    'technical_docs.apis.section.formsapis': 'APIs HTTP do AEM Forms',
    'technical_docs.apis.section.formsapis.links.0': 'API do AEM Forms (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'APIs do GraphQL',
    'technical_docs.apis.section.graphqlapis.links.0': 'API do GraphQL',
    'technical_docs.apis.section.graphqlapis.links.1': 'Amostra de consultas do GraphQL',
    'technical_docs.apis.section.relatedhttpapis': 'APIs HTTP relacionadas',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'API HTTP do AEM Assets',
    'technical_docs.apis.text':
      'Conhe\xE7a as APIs GraphQL do AEM e veja como criar consultas e solicita\xE7\xF5es HTTP.',
    'technical_docs.apis.title': 'APIs',
    'technical_docs.documentation.section.contentfragments': 'Fragmentos de conte\xFAdo',
    'technical_docs.documentation.section.contentfragments.links.0': 'Habilita\xE7\xE3o de fragmentos de conte\xFAdo',
    'technical_docs.documentation.section.contentfragments.links.1': 'Modelos de fragmentos do conte\xFAdo',
    'technical_docs.documentation.section.contentfragments.links.2': 'Gerenciamento dos fragmentos de conte\xFAdo',
    'technical_docs.documentation.section.contentfragments.links.3': 'Varia\xE7\xF5es',
    'technical_docs.documentation.section.contentfragments.links.4': 'Conte\xFAdo associado',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadados',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\xC1rvore de estrutura',
    'technical_docs.documentation.section.contentfragments.links.8': 'Pr\xE9-visualiza\xE7\xE3o do JSON',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Headless Adaptive Forms',
    'technical_docs.documentation.section.graphqlaemendpoint': 'Endpoint AEM do GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Ativa\xE7\xE3o de um endpoint do GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Publica\xE7\xE3o de um endpoint do GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Consultas persistentes',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Publicar consultas persistentes',
    'technical_docs.documentation.text':
      'Veja a documenta\xE7\xE3o do Adobe Experience Manager as a Cloud Service para uma descri\xE7\xE3o completa dos recursos e das configura\xE7\xF5es do AEM.',
    'technical_docs.documentation.title': 'Documenta\xE7\xE3o adicional',
    'technical_docs.how-to.section.content': 'Conte\xFAdo',
    'technical_docs.how-to.section.content.links.0': 'Rich text',
    'technical_docs.how-to.section.content.links.1': 'Imagens',
    'technical_docs.how-to.section.content.links.2': 'Conte\xFAdo localizado',
    'technical_docs.how-to.section.content.links.3': 'Conjuntos grandes de resultados',
    'technical_docs.how-to.section.content.links.4': 'Visualizar',
    'technical_docs.how-to.section.deployment': 'Implanta\xE7\xE3o',
    'technical_docs.how-to.section.deployment.links.0': 'Aplicativo com uma \xFAnica p\xE1gina',
    'technical_docs.how-to.section.deployment.links.1': 'Componente da Web',
    'technical_docs.how-to.section.deployment.links.2': 'M\xF3vel',
    'technical_docs.how-to.section.deployment.links.3': 'Servidor para servidor',
    'technical_docs.how-to.section.development': 'Desenvolvimento',
    'technical_docs.how-to.section.development.links.0': 'SDK do AEM Headless',
    'technical_docs.how-to.section.development.links.1': 'Instalar o GraphiQL IDE no AEM 6.5',
    'technical_docs.how-to.text': 'Aprenda como abordar diferentes casos de uso com o AEM Headless.',
    'technical_docs.how-to.title': 'Guias de instru\xE7\xF5es',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': 'SDK do JS do lado do servidor',
    'technical_docs.sdks.section.javascript.links.2': 'M\xF3dulo jwt-auth npm',
    'technical_docs.sdks.text': 'Use os SDKs do AEM Headless para interagir com as APIs do AEM Headless.',
    'technical_docs.sdks.title': 'SDKs',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'IDE GraphiQL',
    'technical_docs.tools.section.graphiql.links.1': 'Guia de instala\xE7\xE3o do AEM 6.5 GraphiQL',
    'technical_docs.tools.text': 'Explore ferramentas de desenvolvedor de headless do AEM.',
    'technical_docs.tools.title': 'Ferramentas',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, and rendering them in React.',
    'code_index.basic-react-app.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details`,
    'code_index.react-app-with-custom-components.title': 'React App with custom components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using custom and default components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components
+ Renders the form using Custom and default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them in React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a  href='https://nextjs.org/'>Next.js</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details`,
    'code_index.react-app-with-material-ui-components.title': 'React App with material ui component',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating components using material ui library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React native app for creating JSON-based forms, fetching forms from AEM, and rendering them in react native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React native</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-native-app/README.md'>here</a> for more details`,
  },
  LA = {
    'app.hero.cta': 'Se hur det fungerar',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      'Allt du beh\xF6ver l\xE4ra dig om AEM headless CMS f\xF6r att bygga och leverera b\xE4ttre appar och snabbare upplevelser.',
    'app.hero.title': 'B\xF6rja bygga med AEM Headless CMS',
    'code_by_id.button.back': 'Tillbaka till kodningssandl\xE5dan',
    'code_by_id.button.enter_widescreen': '\xD6ppna bredbildsl\xE4ge',
    'code_by_id.button.exit_widescreen': 'St\xE4ng bredbildsl\xE4ge',
    'code_index.button.run_the_code': 'K\xF6r koden',
    'code_index.text': 'Test drive AEM Headless Form in seconds using example React apps!',
    'code_index.title': 'Kodningssandl\xE5da',
    'community.links.0': 'G\xE5 med i diskussionen',
    'community.text':
      'Diskutera, fr\xE5ga och f\xE5 svar om AEM Headless tillsammans med hela AEM-utvecklargemenskapen i Experience Leagues communityer.',
    'community.title': 'G\xE5 med i diskussionen',
    'error.text': 'N\xE5got gick tyv\xE4rr fel. F\xF6rs\xF6k igen senare.',
    'error.title': 'Hoppsan! Ett fel uppstod.',
    'example_apps_android.links.0': 'Visa appen',
    'example_apps_android.text': 'En exempel-Java Android-app som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless-API:er.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'Visa appen',
    'example_apps_ios.text': 'En exempel-SwiftUI iOS-app som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless-API:er.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Visa appen',
    'example_apps_next_js.text':
      'Ett exempel p\xE5 en Next.js-app som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless API:er.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Visa appen',
    'example_apps_node-js.text':
      'En exempelkommandorad f\xF6r Node.js-applikation som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless-API:er.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'Visa appen',
    'example_apps_react.text': 'En exempel-React-app som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless-API:er.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Visa appen',
    'example_apps_web-component.text':
      'En exempel p\xE5 en ren JavaScript-webbkomponent som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless-API:er.',
    'example_apps_web-component.title': 'Webbkomponent/JS',
    'experienced_developers.text1':
      'G\xE5 igenom { fiveSteps} n\xE4r du vill skapa, hantera och leverera upplevelser med AEM. { break } Har du redan gjort det? G\xE5 till { advancedDocumentation }.',
    'experienced_developers.title': 'F\xD6R { emphasis } AEM HEADLESS CMS-UTVECKLARE',
    'experienced_developers.title.emphasis': 'ERFAREN',
    'get_involved_blog.links.0': 'L\xE4s bloggen',
    'get_involved_blog.text': 'L\xE4s det senaste p\xE5 v\xE5r teknikblogg.',
    'get_involved_blog.title': 'Adobes teknikblogg',
    'get_involved_community.links.0': 'Delta i konversationen',
    'get_involved_community.text': 'G\xE5 med i v\xE5r community och f\xE5 svar p\xE5 dina fr\xE5gor.',
    'get_involved_community.title': 'Experience League Communities',
    'nav.codePlayground': 'Kodningssandl\xE5da',
    'nav.home': 'Hem',
    'nav.title': 'AEM Headless Form developer portal',
    'new_developers.text':
      'L\xE4s den h\xE4r { guideLink } n\xE4r du vill veta mer om headless CMS-funktioner i AEM och hur du anv\xE4nder dem n\xE4r du utvecklar ett headless-projekt.',
    'new_developers.text.5_steps': '5 steg',
    'new_developers.text.advanced_documentation': 'avancerad dokumentation',
    'new_developers.text.guide_link': 'v\xE4gledning',
    'new_developers.title': 'F\xD6R UTVECKLARE { emphasis } AV AEM HEADLESS CMS',
    'new_developers.title.emphasis': 'NYTT',
    'new_to_aem_headless.links.0': 'L\xE4s v\xE4gledningen',
    'page.description':
      'G\xE5 till resurserna och dokumentationen f\xF6r AEM Headless CMS-utvecklare. L\xE4s mer om hur du bygger n\xE4sta generations appar med hj\xE4lp av headless CMS-tekniker i Experience Manager as a Cloud Service.',
    'page.title': 'Resurser och dokumentation f\xF6r AEM Headless CMS Developer | Adobe Experience Manager',
    'quick_setup.links.0': 'Snabb konfigurering f\xF6r molntj\xE4nst',
    'quick_setup.links.1': 'Snabb konfigurering f\xF6r lokal AEM SDK',
    'quick_setup.text': 'Installera och testk\xF6r AEM Headless p\xE5 n\xE5gra minuter med en exempel-React-app.',
    'quick_setup.title': 'Snabbinstallation',
    'section_developer_resources.title': 'Avancerad dokumentation',
    'section_example_apps.title': 'Exempel p\xE5 AEM Headless CMS-appar',
    'section_get_involved.title': 'Engagera dig!',
    'section_spa_editor.text':
      'AEM SPA-redigeraren erbjuder ett ramverk f\xF6r utveckling av React- eller Angular-appar som marknadsf\xF6rare kan uppdatera i det aktuella sammanhanget med AEM-redigeringsgr\xE4nssnittet.',
    'section_spa_editor.title': 'Utforska AEM SPA-redigeraren',
    'spa_editor.links.0': 'Starta React-v\xE4gledningen',
    'spa_editor.text':
      'AEM SPA-redigeraren kan anv\xE4ndas till att skapa ett SPA vars komponenter, dirigering och vyer kan hanteras helt och h\xE5llet i AEM. SPA-redigeraren st\xF6der ramverket React.',
    'spa_editor.title': 'Hantera ett SPA i AEM',
    'spa_editor_remote_spa.links.0': 'Starta v\xE4gledningen',
    'spa_editor_remote_spa.text':
      'AEM:s Remote SPA-funktioner ger marknadsf\xF6rare m\xF6jlighet att uppdatera utvalda regioner hos ett fj\xE4rrhyst SPA.',
    'spa_editor_remote_spa.title': 'F\xF6rfatta ett fj\xE4rr-SPA',
    'technical_docs.apis.section.formsapis': 'HTTP-API:er f\xF6r AEM Forms',
    'technical_docs.apis.section.formsapis.links.0': 'API f\xF6r AEM Forms (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL-API:er',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL-API',
    'technical_docs.apis.section.graphqlapis.links.1': 'Sampla GraphQL-fr\xE5gor',
    'technical_docs.apis.section.relatedhttpapis': 'Relaterade HTTP-API:er',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP-API',
    'technical_docs.apis.text':
      'L\xE4s om AEM:s GraphQL-API:er och hur du konstruerar fr\xE5gor och HTTP-f\xF6rfr\xE5gningar.',
    'technical_docs.apis.title': 'API:er',
    'technical_docs.documentation.section.contentfragments': 'Inneh\xE5llsfragment',
    'technical_docs.documentation.section.contentfragments.links.0': 'Aktivera inneh\xE5llsfragment',
    'technical_docs.documentation.section.contentfragments.links.1': 'Modeller f\xF6r inneh\xE5llsfragment',
    'technical_docs.documentation.section.contentfragments.links.2': 'Hantera inneh\xE5llsfragment',
    'technical_docs.documentation.section.contentfragments.links.3': 'Variationer',
    'technical_docs.documentation.section.contentfragments.links.4': 'Associerat inneh\xE5ll',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadata',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Strukturtr\xE4d',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON-f\xF6rhandsgranskning',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Anpassningsbara headless-formul\xE4r',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM-slutpunkt',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Aktivera en GraphQL-slutpunkt',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Publicera en GraphQL-slutpunkt',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Best\xE4ndiga fr\xE5gor',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Publicera best\xE4ndiga fr\xE5gor',
    'technical_docs.documentation.text':
      'Visa Adobe Experience Manager as a Cloud Services-dokumentation f\xF6r hela beskrivningen av AEM:s funktioner och konfigurationer.',
    'technical_docs.documentation.title': 'Ytterligare dokumentation',
    'technical_docs.how-to.section.content': 'Inneh\xE5ll',
    'technical_docs.how-to.section.content.links.0': 'RTF',
    'technical_docs.how-to.section.content.links.1': 'Bilder',
    'technical_docs.how-to.section.content.links.2': 'Lokaliserat inneh\xE5ll',
    'technical_docs.how-to.section.content.links.3': 'Stora resultatupps\xE4ttningar',
    'technical_docs.how-to.section.content.links.4': 'F\xF6rhandsgranskning',
    'technical_docs.how-to.section.deployment': 'Distribution',
    'technical_docs.how-to.section.deployment.links.0': 'Ensidig app',
    'technical_docs.how-to.section.deployment.links.1': 'Webbkomponent',
    'technical_docs.how-to.section.deployment.links.2': 'Mobil',
    'technical_docs.how-to.section.deployment.links.3': 'Server-till-server',
    'technical_docs.how-to.section.development': 'Utveckling',
    'technical_docs.how-to.section.development.links.0': 'Storybook',
    'technical_docs.how-to.section.development.links.1': 'Installera GraphiQL IDE p\xE5 AEM 6.5',
    'technical_docs.how-to.text': 'L\xE4s om hur du kan hantera olika anv\xE4ndningar med AEM Headless.',
    'technical_docs.how-to.title': 'G\xF6r s\xE5 h\xE4r-guider',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': 'JS SDK p\xE5 serversidam',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm modul',
    'technical_docs.sdks.text': 'Anv\xE4nd AEM Headless-SDK:er f\xF6r att interagera med AEM Headless-API:er.',
    'technical_docs.sdks.title': 'SDK:er',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'Installationsv\xE4gledning f\xF6r AEM 6.5 GraphiQL',
    'technical_docs.tools.text': 'Utforska AEM:s utvecklingsverktyg f\xF6r headless',
    'technical_docs.tools.title': 'Verktyg',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, and rendering them in React.',
    'code_index.basic-react-app.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details`,
    'code_index.react-app-with-custom-components.title': 'React App with custom components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using custom and default components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components
+ Renders the form using Custom and default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them in React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a  href='https://nextjs.org/'>Next.js</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details`,
    'code_index.react-app-with-material-ui-components.title': 'React App with material ui component',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating components using material ui library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React native app for creating JSON-based forms, fetching forms from AEM, and rendering them in react native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React native</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-native-app/README.md'>here</a> for more details`,
  },
  HA = {
    'app.hero.cta': '\u89C2\u770B\u5B83\u662F\u5982\u4F55\u8FD0\u4F5C\u7684',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      '\u4E86\u89E3\u901A\u8FC7 AEM Headless CMS \u6784\u5EFA\u548C\u6295\u653E\u66F4\u597D\u7684\u5E94\u7528\u7A0B\u5E8F\u548C\u66F4\u5FEB\u7684\u4F53\u9A8C\u6240\u9700\u7684\u4E00\u5207\u3002',
    'app.hero.title': '\u5F00\u59CB\u4F7F\u7528 AEM Headless CMS \u6784\u5EFA',
    'code_by_id.button.back': '\u8FD4\u56DE\u4EE3\u7801\u5E7F\u573A',
    'code_by_id.button.enter_widescreen': '\u8FDB\u5165\u5BBD\u5C4F\u6A21\u5F0F',
    'code_by_id.button.exit_widescreen': '\u9000\u51FA\u5BBD\u5C4F\u6A21\u5F0F',
    'code_index.button.run_the_code': '\u8FD0\u884C\u4EE3\u7801',
    'code_index.text': 'Test drive AEM Headless Form in seconds using example React apps!',
    'code_index.title': '\u4EE3\u7801\u5E7F\u573A',
    'community.links.0': '\u52A0\u5165\u8BA8\u8BBA',
    'community.text':
      '\u5728 Experience League Communities \u4E0A\u4E0E\u6574\u4E2A AEM \u5F00\u53D1\u4EBA\u5458\u793E\u533A\u8BA8\u8BBA\u3001\u63D0\u95EE\u5E76\u83B7\u5F97\u6709\u5173 AEM Headless \u7684\u95EE\u9898\u89E3\u7B54\u3002',
    'community.title': '\u52A0\u5165\u8BA8\u8BBA',
    'error.text': '\u62B1\u6B49\uFF01\u51FA\u73B0\u9519\u8BEF\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002',
    'error.title': '\u54CE\u5440\uFF01\u51FA\u73B0\u9519\u8BEF\u3002',
    'example_apps_android.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_android.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684 Java Android \u5E94\u7528\u793A\u4F8B\u3002',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_ios.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684 SwiftUI iOS \u5E94\u7528\u793A\u4F8B\u3002',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_next_js.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684 Next.js \u5E94\u7528\u7A0B\u5E8F\u793A\u4F8B\u3002',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_node-js.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684\u547D\u4EE4\u884C Node.js \u5E94\u7528\u7A0B\u5E8F\u793A\u4F8B\u3002',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_react.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684 React \u5E94\u7528\u7A0B\u5E8F\u793A\u4F8B\u3002',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_web-component.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684\u7EAF JavaScript Web \u7EC4\u4EF6\u793A\u4F8B\u3002',
    'example_apps_web-component.title': 'Web \u7EC4\u4EF6/JS',
    'experienced_developers.text1':
      '\u901A\u8FC7 { fiveSteps} \u4F7F\u7528 AEM \u521B\u5EFA\u3001\u7BA1\u7406\u548C\u6295\u653E\u4F53\u9A8C\u3002{ break } \u5DF2\u7ECF\u5B8C\u6210\u4E86\uFF1F\u8BF7\u8BBF\u95EE\u6211\u4EEC\u7684 { advancedDocumentation }\u3002',
    'experienced_developers.title': '\u9762\u5411 { emphasis } AEM HEADLESS CMS \u5F00\u53D1\u4EBA\u5458',
    'experienced_developers.title.emphasis': '\u6709\u7ECF\u9A8C\u7684',
    'get_involved_blog.links.0': '\u9605\u8BFB\u535A\u5BA2',
    'get_involved_blog.text':
      '\u5728\u6211\u4EEC\u7684\u6280\u672F\u535A\u5BA2\u4E0A\u9605\u8BFB\u6700\u65B0\u6D88\u606F\u3002',
    'get_involved_blog.title': 'Adobe \u6280\u672F\u535A\u5BA2',
    'get_involved_community.links.0': '\u52A0\u5165\u5BF9\u8BDD',
    'get_involved_community.text':
      '\u52A0\u5165\u6211\u4EEC\u7684\u793E\u533A\u5E76\u4E3A\u60A8\u7684\u95EE\u9898\u627E\u5230\u7B54\u6848\u3002',
    'get_involved_community.title': 'Experience League \u793E\u533A',
    'nav.codePlayground': '\u4EE3\u7801\u5E7F\u573A',
    'nav.home': '\u4E3B\u9875',
    'nav.title': 'AEM Headless CMS \u5F00\u53D1\u4EBA\u5458\u95E8\u6237',
    'new_developers.text':
      '\u9605\u8BFB\u6B64 { guideLink } \u4EE5\u4E86\u89E3 AEM \u7684\u65E0\u5934 CMS \u529F\u80FD\u4EE5\u53CA\u5982\u4F55\u5728\u65E0\u5934\u5F00\u53D1\u9879\u76EE\u4E2D\u5229\u7528\u8FD9\u4E9B\u529F\u80FD\u3002',
    'new_developers.text.5_steps': '5 \u4E2A\u6B65\u9AA4',
    'new_developers.text.advanced_documentation': '\u9AD8\u7EA7\u6587\u6863',
    'new_developers.text.guide_link': '\u6307\u5357',
    'new_developers.title': '\u9762\u5411 { emphasis } AEM HEADLESS CMS \u7684\u5F00\u53D1\u4EBA\u5458',
    'new_developers.title.emphasis': '\u65B0\u7684',
    'new_to_aem_headless.links.0': '\u9605\u8BFB\u6307\u5357',
    'page.description':
      '\u8BBF\u95EE AEM Headless CMS \u5F00\u53D1\u4EBA\u5458\u8D44\u6E90\u548C\u6587\u6863\u3002\u4E86\u89E3\u5982\u4F55\u4F7F\u7528 Experience Manager as a Cloud Service \u4E2D\u7684\u65E0\u5934 CMS \u6280\u672F\u6784\u5EFA\u4E0B\u4E00\u4EE3\u5E94\u7528\u7A0B\u5E8F\u3002',
    'page.title': 'AEM Headless CMS\u5F00\u53D1\u4EBA\u5458\u8D44\u6E90\u548C\u6587\u6863 | Adobe Experience Manager',
    'quick_setup.links.0': '\u4E91\u670D\u52A1\u7684\u5FEB\u901F\u8BBE\u7F6E',
    'quick_setup.links.1': '\u672C\u5730 AEM SDK \u7684\u5FEB\u901F\u8BBE\u7F6E',
    'quick_setup.text':
      '\u4F7F\u7528 React \u5E94\u7528\u7A0B\u5E8F\u793A\u4F8B\uFF0C\u5728\u51E0\u5206\u949F\u5185\u8BBE\u7F6E\u548C\u6D4B\u8BD5 AEM Headless\u3002',
    'quick_setup.title': '\u5FEB\u901F\u8BBE\u7F6E',
    'section_developer_resources.title': '\u9AD8\u7EA7\u6587\u6863',
    'section_example_apps.title': 'AEM Headless CMS \u5E94\u7528\u7A0B\u5E8F\u793A\u4F8B',
    'section_get_involved.title': '\u53C2\u4E0E\u5176\u4E2D\uFF01',
    'section_spa_editor.text':
      'AEM SPA \u7F16\u8F91\u5668\u63D0\u4F9B\u4E86\u4E00\u4E2A\u7528\u6765\u5F00\u53D1 React \u6216 Angular \u5E94\u7528\u7A0B\u5E8F\u7684\u6846\u67B6\uFF0C\u8425\u9500\u4EBA\u5458\u53EF\u4EE5\u4F7F\u7528 AEM \u521B\u4F5C UI \u5728\u4E0A\u4E0B\u6587\u4E2D\u66F4\u65B0\u8FD9\u4E9B\u5E94\u7528\u7A0B\u5E8F\u3002',
    'section_spa_editor.title': '\u63A2\u7D22 AEM SPA \u7F16\u8F91\u5668',
    'spa_editor.links.0': '\u5F00\u59CB React \u6559\u7A0B',
    'spa_editor.text':
      'AEM SPA \u7F16\u8F91\u5668\u53EF\u7528\u4E8E\u521B\u5EFA\u5176\u7EC4\u4EF6\u3001\u8DEF\u7531\u548C\u89C6\u56FE\u53EF\u5B8C\u5168\u5728 AEM \u4E2D\u7BA1\u7406\u7684 SPA\u3002SPA \u7F16\u8F91\u5668\u652F\u6301 React \u6846\u67B6\u3002',
    'spa_editor.title': '\u5728 AEM \u4E2D\u7BA1\u7406 SPA',
    'spa_editor_remote_spa.links.0': '\u5F00\u59CB\u6559\u7A0B',
    'spa_editor_remote_spa.text':
      '\u5229\u7528 AEM \u7684\u8FDC\u7A0B SPA \u529F\u80FD\uFF0C\u8425\u9500\u4EBA\u5458\u80FD\u591F\u66F4\u65B0\u8FDC\u7A0B\u6258\u7BA1 SPA \u7684\u76EE\u6807\u533A\u57DF\u3002',
    'spa_editor_remote_spa.title': '\u7F16\u5199\u8FDC\u7A0B SPA',
    'technical_docs.apis.section.formsapis': 'AEM Forms HTTP API',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms API (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.1': 'GraphQL \u67E5\u8BE2\u6837\u672C',
    'technical_docs.apis.section.relatedhttpapis': '\u76F8\u5173 HTTP API',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP API',
    'technical_docs.apis.text':
      '\u4E86\u89E3 AEM \u7684 GraphQL API \u4EE5\u53CA\u5982\u4F55\u6784\u5EFA\u67E5\u8BE2\u548C HTTP \u8BF7\u6C42\u3002',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': '\u5185\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.0': '\u542F\u7528\u5185\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.1': '\u5185\u5BB9\u7247\u6BB5\u6A21\u578B',
    'technical_docs.documentation.section.contentfragments.links.2': '\u7BA1\u7406\u5185\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.3': '\u53D8\u5316',
    'technical_docs.documentation.section.contentfragments.links.4': '\u76F8\u5173\u5185\u5BB9',
    'technical_docs.documentation.section.contentfragments.links.5': '\u5143\u6570\u636E',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\u7ED3\u6784\u6811',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON \u9884\u89C8',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Headless \u81EA\u9002\u5E94\u8868\u5355',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM \u7AEF\u70B9',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': '\u542F\u7528 GraphQL \u7AEF\u70B9',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': '\u53D1\u5E03 GraphQL \u7AEF\u70B9',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': '\u6301\u7EED\u67E5\u8BE2',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': '\u53D1\u5E03\u6301\u4E45\u67E5\u8BE2',
    'technical_docs.documentation.text':
      '\u67E5\u770B Adobe Experience Manager as a Cloud Service \u6587\u6863\uFF0C\u4E86\u89E3 AEM \u529F\u80FD\u548C\u914D\u7F6E\u7684\u5B8C\u6574\u63CF\u8FF0\u3002',
    'technical_docs.documentation.title': '\u5176\u4ED6\u6587\u6863',
    'technical_docs.how-to.section.content': '\u5185\u5BB9',
    'technical_docs.how-to.section.content.links.0': '\u5BCC\u6587\u672C',
    'technical_docs.how-to.section.content.links.1': '\u56FE\u50CF',
    'technical_docs.how-to.section.content.links.2': '\u672C\u5730\u5316\u5185\u5BB9',
    'technical_docs.how-to.section.content.links.3': '\u5927\u578B\u7ED3\u679C\u96C6',
    'technical_docs.how-to.section.content.links.4': '\u9884\u89C8',
    'technical_docs.how-to.section.deployment': '\u90E8\u7F72',
    'technical_docs.how-to.section.deployment.links.0': '\u5355\u9875\u5E94\u7528',
    'technical_docs.how-to.section.deployment.links.1': 'Web \u7EC4\u4EF6',
    'technical_docs.how-to.section.deployment.links.2': '\u79FB\u52A8\u8BBE\u5907',
    'technical_docs.how-to.section.deployment.links.3': '\u670D\u52A1\u5668\u5230\u670D\u52A1\u5668',
    'technical_docs.how-to.section.development': '\u5F00\u53D1',
    'technical_docs.how-to.section.development.links.0': 'Storybook',
    'technical_docs.how-to.section.development.links.1': '\u5728 AEM 6.5 \u4E0A\u5B89\u88C5 GraphiQL IDE',
    'technical_docs.how-to.text':
      '\u4E86\u89E3\u5982\u4F55\u4F7F\u7528 AEM Headless \u5904\u7406\u4E0D\u540C\u7684\u7528\u4F8B\u3002',
    'technical_docs.how-to.title': '\u64CD\u4F5C\u6307\u5357',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': '\u670D\u52A1\u5668\u7AEF JS SDK',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm \u6A21\u5757',
    'technical_docs.sdks.text': '\u4F7F\u7528 Storybook \u4E0E AEM Headless API \u4EA4\u4E92\u3002',
    'technical_docs.sdks.title': 'SDK',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'AEM 6.5 GraphiQL \u5B89\u88C5\u6307\u5357',
    'technical_docs.tools.text': '\u63A2\u7D22 AEM \u7684\u65E0\u5934\u5F00\u53D1\u4EBA\u5458\u5DE5\u5177\u3002',
    'technical_docs.tools.title': '\u5DE5\u5177',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, and rendering them in React.',
    'code_index.basic-react-app.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details`,
    'code_index.react-app-with-custom-components.title': 'React App with custom components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using custom and default components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components
+ Renders the form using Custom and default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them in React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a  href='https://nextjs.org/'>Next.js</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details`,
    'code_index.react-app-with-material-ui-components.title': 'React App with material ui component',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating components using material ui library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React native app for creating JSON-based forms, fetching forms from AEM, and rendering them in react native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React native</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-native-app/README.md'>here</a> for more details`,
  },
  FA = {
    'app.hero.cta': '\u89C0\u770B\u904B\u4F5C\u65B9\u5F0F',
    'app.hero.solution': 'Adobe Experience Manager \u7121\u5468\u908A',
    'app.hero.text':
      '\u95DC\u65BC\u5B78\u7FD2 AEM headless CMS \u4EE5\u5EFA\u7ACB\u548C\u63D0\u4EA4\u66F4\u7CBE\u5F69\u7684\u61C9\u7528\u7A0B\u5F0F\u548C\u66F4\u5FEB\u901F\u7684\u9AD4\u9A57\u6240\u9700\u7684\u4E00\u5207\u5167\u5BB9\u3002',
    'app.hero.title': '\u958B\u59CB\u4F7F\u7528 AEM \u7121\u5468\u908A CMS',
    'code_by_id.button.back': '\u8FD4\u56DE\u7A0B\u5F0F\u78BC\u6E2C\u8A66\u7DB2',
    'code_by_id.button.enter_widescreen': '\u9032\u5165\u5BEC\u7192\u5E55\u6A21\u5F0F',
    'code_by_id.button.exit_widescreen': '\u9000\u51FA\u5BEC\u7192\u5E55\u6A21\u5F0F',
    'code_index.button.run_the_code': '\u57F7\u884C\u7A0B\u5F0F\u78BC',
    'code_index.text': 'Test drive AEM Headless Form in seconds using example React apps!',
    'code_index.title': '\u7A0B\u5F0F\u78BC\u6E2C\u8A66\u7DB2',
    'community.links.0': '\u52A0\u5165\u8A0E\u8AD6',
    'community.text':
      '\u85C9\u52A9 Experience League \u793E\u7FA4\u4E0A\u7684 AEM \u958B\u767C\u4EBA\u54E1\u793E\u7FA4\uFF0C\u5C31 AEM Headless \u76F8\u95DC\u554F\u984C\u5C55\u958B\u8A0E\u8AD6\u3001\u54A8\u8A62\u4EE5\u53CA\u7372\u53D6\u89E3\u7B54\u3002',
    'community.title': '\u52A0\u5165\u8A0E\u8AD6',
    'error.text': '\u62B1\u6B49\uFF0C\u767C\u751F\u932F\u8AA4\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002',
    'error.title': '\u7CDF\u7CD5\uFF01\u767C\u751F\u932F\u8AA4\u3002',
    'example_apps_android.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_android.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684 Java Android \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u3002',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_ios.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684 SwiftUI iOS \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u3002',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_next_js.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684 Next.js \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u3002',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_node-js.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684\u6307\u4EE4\u5217 Node.js \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u3002',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_react.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684 React \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u3002',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_web-component.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684\u7D14 JavaScript Web \u5143\u4EF6\u7BC4\u4F8B\u3002',
    'example_apps_web-component.title': 'Web \u5143\u4EF6/JS',
    'experienced_developers.text1':
      '\u700F\u89BD\u4F7F\u7528 AEM \u5EFA\u7ACB\u3001\u7BA1\u7406\u548C\u4EA4\u4ED8\u9AD4\u9A57\u7684 { fiveSteps}\u3002{ break } \u5982\u679C\u5DF2\u5B8C\u6210\uFF0C\u8ACB\u524D\u5F80\u700F\u89BD\u6211\u5011\u7684 { advancedDocumentation }\u3002',
    'experienced_developers.title':
      '\u9069\u7528\u65BC { emphasis } AEM \u7121\u5468\u908A CMS \u958B\u767C\u4EBA\u54E1',
    'experienced_developers.title.emphasis': '\u7D93\u9A57\u8C50\u5BCC\u7684',
    'get_involved_blog.links.0': '\u95B1\u8B80\u90E8\u843D\u683C',
    'get_involved_blog.text':
      '\u95B1\u8B80\u6211\u5011\u7684\u6280\u8853\u90E8\u843D\u683C\u4E0A\u7684\u6700\u65B0\u8CC7\u8A0A\u3002',
    'get_involved_blog.title': 'Adobe \u6280\u8853\u90E8\u843D\u683C',
    'get_involved_community.links.0': '\u52A0\u5165\u6703\u8A71',
    'get_involved_community.text':
      '\u52A0\u5165\u6211\u5011\u7684\u793E\u7FA4\uFF0C\u7372\u53D6\u554F\u984C\u7684\u7B54\u6848\u3002',
    'get_involved_community.title': 'Experience League \u793E\u7FA4',
    'nav.codePlayground': '\u7A0B\u5F0F\u78BC\u6E2C\u8A66\u7DB2',
    'nav.home': '\u9996\u9801',
    'nav.title': 'AEM Headless Form developer portal',
    'new_developers.text':
      '\u95B1\u8B80\u6B64 { guideLink }\uFF0C\u4E86\u89E3 AEM \u7684\u7121\u5468\u908A CMS \u529F\u80FD\uFF0C\u4EE5\u53CA\u5982\u4F55\u5728\u7121\u5468\u908A\u958B\u767C\u5C08\u6848\u4E2D\u52A0\u4EE5\u5229\u7528\u3002',
    'new_developers.text.5_steps': '5 \u500B\u6B65\u9A5F',
    'new_developers.text.advanced_documentation': '\u9032\u968E\u6587\u4EF6',
    'new_developers.text.guide_link': '\u6307\u5357',
    'new_developers.title': '\u9069\u7528\u65BC { emphasis } AEM \u7121\u5468\u908A CMS \u958B\u767C\u4EBA\u54E1',
    'new_developers.title.emphasis': '\u65B0',
    'new_to_aem_headless.links.0': '\u95B1\u8B80\u6307\u5357',
    'page.description':
      '\u9020\u8A2A AEM \u7121\u5468\u908A CMS \u958B\u767C\u4EBA\u54E1\u8CC7\u6E90\u8207\u6587\u4EF6\u3002\u4E86\u89E3\u5982\u4F55\u4F7F\u7528 Experience Manager as a Cloud Service \u4E2D\u7684\u7121\u5468\u908A CMS \u6280\u8853\u5EFA\u7F6E\u4E0B\u4E00\u4EE3\u61C9\u7528\u7A0B\u5F0F\u3002',
    'page.title': 'AEM Headless CMS\u958B\u767C\u4EBA\u54E1\u8CC7\u6E90\u548C\u6A94\u6848 | Adobe Experience Manager',
    'quick_setup.links.0': 'Cloud Service \u7684\u5FEB\u901F\u8A2D\u5B9A',
    'quick_setup.links.1': '\u672C\u6A5F AEM SDK \u7684\u5FEB\u901F\u8A2D\u5B9A',
    'quick_setup.text':
      '\u4F7F\u7528 React \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u6578\u5206\u9418\u5167\u8A2D\u5B9A\u548C\u8A66\u904B\u884C AEM Headless',
    'quick_setup.title': '\u5FEB\u901F\u8A2D\u5B9A',
    'section_developer_resources.title': '\u9032\u968E\u6587\u4EF6',
    'section_example_apps.title': 'AEM \u7121\u5468\u908A CMS \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B',
    'section_get_involved.title': '\u5FEB\u4F86\u53C3\u8207\uFF01',
    'section_spa_editor.text':
      'AEM SPA Editor \u63D0\u4F9B\u958B\u767C React \u6216 Angular \u61C9\u7528\u7A0B\u5F0F\u7684\u6846\u67B6\uFF0C\u884C\u92B7\u4EBA\u54E1\u53EF\u4EE5\u4F7F\u7528 AEM \u88FD\u4F5C UI \u5728\u60C5\u5883\u4E2D\u66F4\u65B0 React \u6216 Angular \u61C9\u7528\u7A0B\u5F0F\u3002',
    'section_spa_editor.title': '\u63A2\u7D22 AEM SPA Editor',
    'spa_editor.links.0': '\u958B\u59CB\u5B78\u7FD2 React \u6559\u5B78\u8AB2\u7A0B',
    'spa_editor.text':
      'AEM SPA Editor \u53EF\u7528\u65BC\u5EFA\u7ACB\u4E00\u500B SPA\uFF0C\u4E26\u4E14\u53EF\u4EE5\u5728 AEM \u4E2D\u5168\u9762\u7BA1\u7406\u8A72 SPA \u7684\u5143\u4EF6\u3001\u8DEF\u7531\u4EE5\u53CA\u6AA2\u8996\u3002SPA Editor \u652F\u63F4 React \u6846\u67B6\u3002',
    'spa_editor.title': '\u7BA1\u7406 AEM \u4E2D\u7684 SPA',
    'spa_editor_remote_spa.links.0': '\u958B\u59CB\u5B78\u7FD2\u6559\u5B78\u8AB2\u7A0B',
    'spa_editor_remote_spa.text':
      'AEM \u7684\u9060\u8DDD SPA \u529F\u80FD\u652F\u6301\u884C\u92B7\u4EBA\u54E1\u66F4\u65B0\u9060\u8DDD\u8A17\u7BA1\u7684 SPA \u7684\u76EE\u6A19\u5340\u57DF\u3002',
    'spa_editor_remote_spa.title': '\u88FD\u4F5C\u9060\u8DDD SPA',
    'technical_docs.apis.section.formsapis': 'AEM Forms HTTP API',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms API (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.1': 'GraphQL \u67E5\u8A62\u7BC4\u4F8B',
    'technical_docs.apis.section.relatedhttpapis': '\u76F8\u95DC\u7684 HTTP API',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP API',
    'technical_docs.apis.text':
      '\u77AD\u89E3 AEM \u7684 GraphQL API \u4EE5\u53CA\u5982\u4F55\u5EFA\u69CB\u67E5\u8A62\u548C HTTP \u8ACB\u6C42\u3002',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': '\u5167\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.0': '\u958B\u555F\u5167\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.1': '\u5167\u5BB9\u7247\u6BB5\u6A21\u578B',
    'technical_docs.documentation.section.contentfragments.links.2': '\u7BA1\u7406\u5167\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.3': '\u8B8A\u9AD4',
    'technical_docs.documentation.section.contentfragments.links.4': '\u76F8\u95DC\u5167\u5BB9',
    'technical_docs.documentation.section.contentfragments.links.5': '\u4E2D\u7E7C\u8CC7\u6599',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\u7D50\u69CB\u6A39',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON \u9810\u89BD',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Headless Adaptive Forms',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM \u7AEF\u9EDE',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': '\u555F\u7528 GraphQL \u7AEF\u9EDE',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': '\u767C\u4F48 GraphQL \u7AEF\u9EDE',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': '\u4FDD\u5B58\u7684\u67E5\u8A62',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': '\u767C\u4F48\u6C38\u7E8C\u67E5\u8A62',
    'technical_docs.documentation.text':
      '\u6AA2\u8996 Adobe Experience Manager as a Cloud Services \u6587\u4EF6\uFF0C\u7372\u53D6 AEM \u7684\u529F\u80FD\u548C\u8A2D\u5B9A\u7684\u5B8C\u6574\u8AAA\u660E\u3002',
    'technical_docs.documentation.title': '\u5176\u4ED6\u6587\u4EF6',
    'technical_docs.how-to.section.content': '\u5167\u5BB9',
    'technical_docs.how-to.section.content.links.0': 'Rich Text',
    'technical_docs.how-to.section.content.links.1': '\u5F71\u50CF',
    'technical_docs.how-to.section.content.links.2': '\u672C\u5730\u5316\u7684\u5167\u5BB9',
    'technical_docs.how-to.section.content.links.3': '\u5927\u578B\u7D50\u679C\u96C6',
    'technical_docs.how-to.section.content.links.4': '\u9810\u89BD',
    'technical_docs.how-to.section.deployment': '\u90E8\u7F72',
    'technical_docs.how-to.section.deployment.links.0': '\u55AE\u4E00\u9801\u9762\u61C9\u7528\u7A0B\u5F0F',
    'technical_docs.how-to.section.deployment.links.1': 'Web \u5143\u4EF6',
    'technical_docs.how-to.section.deployment.links.2': '\u884C\u52D5',
    'technical_docs.how-to.section.deployment.links.3': '\u4F3A\u670D\u5668\u5C0D\u4F3A\u670D\u5668',
    'technical_docs.how-to.section.development': '\u958B\u767C',
    'technical_docs.how-to.section.development.links.0': 'Storybook',
    'technical_docs.how-to.section.development.links.1': '\u5728 AEM 6.5 \u4E0A\u5B89\u88DD GraphiQL IDE',
    'technical_docs.how-to.text':
      '\u4E86\u89E3\u5982\u4F55\u85C9\u52A9 AEM Headless \u8655\u7406\u4E0D\u540C\u7684\u4F7F\u7528\u6848\u4F8B\u3002',
    'technical_docs.how-to.title': '\u4F7F\u7528\u65B9\u6CD5\u6307\u5357',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0':
      'Definition interpret and rules executor for Headless Adaptive Forms',
    'technical_docs.sdks.section.javascript.links.1': '\u4F3A\u670D\u5668\u7AEF JS SDK',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm \u6A21\u7D44',
    'technical_docs.sdks.text': '\u4F7F\u7528 Storybook \u8207 AEM Headless API \u4E92\u52D5\u3002',
    'technical_docs.sdks.title': 'SDK',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'AEM 6.5 GraphiQL \u5B89\u88DD\u6307\u5357',
    'technical_docs.tools.text': '\u63A2\u7D22 AEM \u4E2D\u7684\u7121 UI \u958B\u767C\u4EBA\u54E1\u5DE5\u5177\u3002',
    'technical_docs.tools.title': '\u5DE5\u5177',
    'what_is_headless.text':
      'Adobe Experience Manager (AEM) Headless Adaptive Forms is a solution for creating and managing headless web forms within the Adobe Experience Manager platform. This feature enables organizations to create, publish, and manage interactive forms that can be accessed and interacted with through APIs, rather than through a traditional graphical user interface.',
    'what_is_headless.title': 'What is AEM Headless Form?',
    'code_index.basic-react-app.title': 'Basic React App',
    'code_index.basic-react-app.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, and rendering them in React.',
    'code_index.basic-react-app.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-apps/README.md'>here</a> for more details`,
    'code_index.react-app-with-custom-components.title': 'React App with custom components',
    'code_index.react-app-with-custom-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating custom components.',
    'code_index.react-app-with-custom-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using custom and default components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components
+ Renders the form using Custom and default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-custom-components/README.md'>here</a> for more details`,
    'code_index.react-app-with-nextjs.title': 'Basic Next.js App',
    'code_index.react-app-with-nextjs.description':
      'A Next.js app for creating JSON-based forms, fetching them from AEM, and rendering them in React.',
    'code_index.react-app-with-nextjs.longDescription': `This <a  href='https://nextjs.org/'>Next.js</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-nextjs/README.md'>here</a> for more details`,
    'code_index.react-app-with-material-ui-components.title': 'React App with material ui component',
    'code_index.react-app-with-material-ui-components.description':
      'A React app for creating JSON-based forms, fetching forms from AEM, rendering them in React, and creating components using material ui library.',
    'code_index.react-app-with-material-ui-components.longDescription': `This <a  href='https://reactjs.org/'>React</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering form using material ui components.

This code:

+ Fetches a JSON form from AEM
+ Create custom components using material ui
+ Renders the form using created components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/react-app-with-material-ui-components/README.md'>here</a> for more details`,
    'code_index.basic-react-native.title': 'Basic React Native App',
    'code_index.basic-react-native.description':
      'A React native app for creating JSON-based forms, fetching forms from AEM, and rendering them in react native.',
    'code_index.basic-react-native.longDescription': `This <a href='https://reactnative.dev/'>React native</a> app which will help to create JSON based forms using AEM Headless Form libraries and rendering  form using default components.

This code:

+ Fetches a JSON form from AEM
+ Renders the form using default components
+ Submit the form data.

Click <a  href='https://github.com/adobe/aem-forms-headless-components/blob/main/examples/basic-react-native-app/README.md'>here</a> for more details`,
  },
  jA = 'modulepreload',
  zA = function (e) {
    return '/' + e;
  },
  Zp = {},
  BA = function (t, n, i) {
    if (!n || n.length === 0) return t();
    const r = document.getElementsByTagName('link');
    return Promise.all(
      n.map((o) => {
        if (((o = zA(o)), o in Zp)) return;
        Zp[o] = !0;
        const a = o.endsWith('.css'),
          s = a ? '[rel="stylesheet"]' : '';
        if (i)
          for (let u = r.length - 1; u >= 0; u--) {
            const m = r[u];
            if (m.href === o && (!a || m.rel === 'stylesheet')) return;
          }
        else if (document.querySelector(`link[href="${o}"]${s}`)) return;
        const c = document.createElement('link');
        if (
          ((c.rel = a ? 'stylesheet' : jA),
          a || ((c.as = 'script'), (c.crossOrigin = '')),
          (c.href = o),
          document.head.appendChild(c),
          a)
        )
          return new Promise((u, m) => {
            c.addEventListener('load', u),
              c.addEventListener('error', () => m(new Error(`Unable to preload CSS for ${o}`)));
          });
      }),
    ).then(() => t());
  },
  UA = (e) => {
    e &&
      e instanceof Function &&
      BA(() => import('./web-vitals.c993bc77.js'), []).then(
        ({ getCLS: t, getFID: n, getFCP: i, getLCP: r, getTTFB: o }) => {
          t(e), n(e), i(e), r(e), o(e);
        },
      );
  };
class $A {
  constructor(t) {
    Rs(this, 'windowLocation');
    this.windowLocation = t;
  }
  getLanguage() {
    let t = 'en';
    return (
      (t = document.getElementsByTagName('html')[0].getAttribute('lang') || 'en'), t.indexOf('<') === 0 && (t = 'en'), t
    );
  }
}
const GA = {
    de: TA,
    en: MA,
    fr: PA,
    ko: IA,
    es: RA,
    ja: NA,
    it: CA,
    nl: DA,
    'pt-BR': OA,
    sv: LA,
    'zh-Hans': HA,
    'zh-Hant': FA,
  },
  pl = new $A(window.location).getLanguage(),
  JA = document.getElementById('microsite-root'),
  VA = cf(JA);
VA.render(
  E(kc.StrictMode, {
    children: E(jE, { locale: pl, messages: GA[pl], children: E(Py, { value: pl, children: E(bA, {}) }) }),
  }),
);
UA();
